/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 31);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function validate(binding) {
  if (typeof binding.value !== 'function') {
    console.warn('[Vue-click-outside:] provided expression', binding.expression, 'is not a function.')
    return false
  }

  return true
}

function isPopup(popupItem, elements) {
  if (!popupItem || !elements)
    return false

  for (var i = 0, len = elements.length; i < len; i++) {
    try {
      if (popupItem.contains(elements[i])) {
        return true
      }
      if (elements[i].contains(popupItem)) {
        return false
      }
    } catch(e) {
      return false
    }
  }

  return false
}

function isServer(vNode) {
  return typeof vNode.componentInstance !== 'undefined' && vNode.componentInstance.$isServer
}

exports = module.exports = {
  bind: function (el, binding, vNode) {
    if (!validate(binding)) return

    // Define Handler and cache it on the element
    function handler(e) {
      if (!vNode.context) return

      // some components may have related popup item, on which we shall prevent the click outside event handler.
      var elements = e.path || (e.composedPath && e.composedPath())
      elements && elements.length > 0 && elements.unshift(e.target)

      if (el.contains(e.target) || isPopup(vNode.context.popupItem, elements)) return

      el.__vueClickOutside__.callback(e)
    }

    // add Event Listeners
    el.__vueClickOutside__ = {
      handler: handler,
      callback: binding.value
    }
    const clickHandler = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
    !isServer(vNode) && document.addEventListener(clickHandler, handler)
  },

  update: function (el, binding) {
    if (validate(binding)) el.__vueClickOutside__.callback = binding.value
  },

  unbind: function (el, binding, vNode) {
    // Remove Event Listeners
    const clickHandler = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
    !isServer(vNode) && el.__vueClickOutside__ && document.removeEventListener(clickHandler, el.__vueClickOutside__.handler)
    delete el.__vueClickOutside__
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(40)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      propsdata: [{
        account: this.$cookies.get("account"),
        verified: this.$cookies.get("verified"),
        email: '',
        name: '',
        password: '',
        unique_id: '',
        paid: '',
        cancel_at_period_end: '',
        canceled: '',
        cargado: false,
        path: '',
        logo_slug: '',
        logos: [],
        loading_logos: false,
        logos_cargados: false,
        sidebar_mobile: false
      }],
      cancelTokenSource: null
    };
  },

  methods: {
    update: function update() {
      var _this = this;

      this.propsdata[0]['loading_logos'] = true;
      this.propsdata[0]['logos_cargados'] = false;
      this.propsdata[0]['path'] = this.$route.path;
      this.propsdata[0]['logo_slug'] = this.$route.name;
      if (this.propsdata[0]['logo_slug'] === 'index' || this.propsdata[0]['logo_slug'] === 'bookmarked-logos') {
        if (this.propsdata[0]['logo_slug'] === 'bookmarked-logos') {
          var bookmarked_value = 'yes';
        } else {
          var bookmarked_value = '';
        }
        // Cancel the previous request, if it exists
        if (this.cancelTokenSource) {
          this.cancelTokenSource.cancel('Request canceled');
        }

        // Create a new cancel token source
        this.cancelTokenSource = axios.CancelToken.source();

        // Make the Axios request with the new cancel token
        axios.post('/dashboard/cargar-logos.php', {
          bookmarked: bookmarked_value
        }, {
          cancelToken: this.cancelTokenSource.token
        }).then(function (response) {
          _this.propsdata[0]['logos'] = response.data;
          _this.propsdata[0]['loading_logos'] = false;
          _this.propsdata[0]['logos_cargados'] = true;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    togglesidebar: function togglesidebar() {
      if (this.propsdata[0]['sidebar_mobile']) {
        this.propsdata[0]['sidebar_mobile'] = false;
      } else {
        this.propsdata[0]['sidebar_mobile'] = true;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // To remove the sessionstorage item when loading dashboard
    sessionStorage.removeItem('last_id_visitors_progress');
    //get stats from user
    if (!this.propsdata[0]['account']) {
      //no esta logueado
      window.location.replace("https://logo.app/login");
    } else if (!this.propsdata[0]['verified']) {
      //no esta verificado
      axios.post('/dashboard/enviar-verificacion.php', {}).then(function (response) {
        _this2.propsdata[0]['email'] = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    } else {
      axios.post('/dashboard/status.php', {}).then(function (response) {
        _this2.propsdata[0]['email'] = response.data[0].email;
        _this2.propsdata[0]['name'] = response.data[0].name;
        _this2.propsdata[0]['password'] = response.data[0].password;
        _this2.propsdata[0]['unique_id'] = response.data[0].unique_id;
        _this2.propsdata[0]['paid'] = response.data[0].paid;
        _this2.propsdata[0]['cancel_at_period_end'] = response.data[0].cancel_at_period_end;
        _this2.propsdata[0]['canceled'] = response.data[0].canceled;
        _this2.propsdata[0]['cargado'] = true;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      toggle: false
    };
  },

  methods: {
    menu: function menu() {
      if (!this.toggle) {
        this.toggle = true;
      } else {
        this.toggle = false;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {};
  },

  methods: {},
  mounted: function mounted() {},

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {};
  },

  methods: {},
  mounted: function mounted() {},

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      timenow: Date.now(),
      sure: false,
      numerosure: '',
      edit: false,
      numeroedit: '',
      logo_preview: 0,
      modal_duplicate: false,
      numeroduplicate: '',
      duplicate_error: false,
      duplicating_logo: false,
      cargado: false
    };
  },

  methods: {
    el_sure: function el_sure(num) {
      if (this.sure) {
        this.sure = false;
      } else {
        this.sure = true;
      }
      this.numerosure = num;
    },
    delete_draft: function delete_draft(num) {
      axios.post('/dashboard/delete-draft.php', {
        unique_id: this.propsdata[0].logos[num].unique_id
      });
      this.propsdata[0].logos.splice(num, 1);
      if (this.propsdata[0].logos.length === 0) {
        this.propsdata[0].logos = null;
      }
      this.sure = false;
      this.numerosure = '';
    },
    lapicito: function lapicito(num) {
      if (this.edit) {
        this.edit = false;
      } else {
        this.edit = true;
      }
      this.numeroedit = num;
    },
    hide: function hide() {
      this.edit = false;
      if (this.propsdata[0].logos[this.numeroedit].titulo == '') {
        this.propsdata[0].logos[this.numeroedit].titulo = 'Untitled';
      }
      this.numeroedit = '';
    },
    edittitulo: function edittitulo(num) {
      axios.post('/dashboard/edit-titulo.php', {
        unique_id: this.propsdata[0].logos[num].unique_id,
        titulo: this.propsdata[0].logos[num].titulo
      });
    },
    logo_number: function logo_number(num) {
      this.logo_preview = num;
    },
    show_duplicate_modal: function show_duplicate_modal(num) {
      this.modal_duplicate = true;
      this.numeroduplicate = num;
    },
    hide_duplicate_modal: function hide_duplicate_modal() {
      this.modal_duplicate = false;
      this.numeroduplicate = '';
    },
    duplicate_logo: function duplicate_logo() {
      var _this = this;

      this.duplicate_error = false;
      this.duplicating_logo = true;
      axios.post('/dashboard/duplicate-logo.php', {
        unique_id: this.propsdata[0].logos[this.numeroduplicate].unique_id
      }).then(function (response) {
        if (response.data == 'try again') {
          _this.duplicate_error = true;
          _this.duplicating_logo = false;
        } else {
          //add the duplicated logo to the logos array
          _this.propsdata[0].logos.unshift(response.data);
          _this.modal_duplicate = false;
          _this.duplicating_logo = false;
          // smooth scroll to the top of the page
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    this.$emit('updatepath');
  },

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      timenow: Date.now(),
      sure: false,
      numerosure: '',
      sure2: false,
      numerosure2: '',
      edit: false,
      numeroedit: '',
      logo_preview: 0,
      modal_duplicate: false,
      numeroduplicate: '',
      duplicate_error: false,
      duplicating_logo: false,
      cargado: false
    };
  },

  methods: {
    el_sure: function el_sure(num) {
      if (this.sure) {
        this.sure = false;
      } else {
        this.sure = true;
      }
      this.numerosure = num;
    },
    delete_draft: function delete_draft(num) {
      axios.post('/dashboard/delete-draft.php', {
        unique_id: this.propsdata[0].logos[num].unique_id
      });
      this.propsdata[0].logos.splice(num, 1);
      if (this.propsdata[0].logos.length === 0) {
        this.propsdata[0].logos = null;
      }
      this.sure = false;
      this.numerosure = '';
    },
    el_sure2: function el_sure2(num) {
      if (this.sure2) {
        this.sure2 = false;
      } else {
        this.sure2 = true;
      }
      this.numerosure2 = num;
    },
    move_to_my_logos: function move_to_my_logos(num) {
      axios.post('/dashboard/move-to-my-logos.php', {
        unique_id: this.propsdata[0].logos[num].unique_id
      });
      this.propsdata[0].logos.splice(num, 1);
      if (this.propsdata[0].logos.length === 0) {
        this.propsdata[0].logos = null;
      }
      this.sure2 = false;
      this.numerosure2 = '';
    },
    lapicito: function lapicito(num) {
      if (this.edit) {
        this.edit = false;
      } else {
        this.edit = true;
      }
      this.numeroedit = num;
    },
    hide: function hide() {
      this.edit = false;
      if (this.propsdata[0].logos[this.numeroedit].titulo == '') {
        this.propsdata[0].logos[this.numeroedit].titulo = 'Untitled';
      }
      this.numeroedit = '';
    },
    edittitulo: function edittitulo(num) {
      axios.post('/dashboard/edit-titulo.php', {
        unique_id: this.propsdata[0].logos[num].unique_id,
        titulo: this.propsdata[0].logos[num].titulo
      });
    },
    logo_number: function logo_number(num) {
      this.logo_preview = num;
    },
    show_duplicate_modal: function show_duplicate_modal(num) {
      this.modal_duplicate = true;
      this.numeroduplicate = num;
    },
    hide_duplicate_modal: function hide_duplicate_modal() {
      this.modal_duplicate = false;
      this.numeroduplicate = '';
    },
    duplicate_logo: function duplicate_logo() {
      var _this = this;

      this.duplicate_error = false;
      this.duplicating_logo = true;
      axios.post('/dashboard/duplicate-logo.php', {
        unique_id: this.propsdata[0].logos[this.numeroduplicate].unique_id
      }).then(function (response) {
        if (response.data == 'try again') {
          _this.duplicate_error = true;
          _this.duplicating_logo = false;
        } else {
          //add the duplicated logo to the logos array
          _this.propsdata[0].logos.unshift(response.data);
          _this.modal_duplicate = false;
          _this.duplicating_logo = false;
          // smooth scroll to the top of the page
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    this.$emit('updatepath');
  },

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['propsdata'],
    data: function data() {
        return {
            loading_logos: true,
            timenow: Date.now(),
            logos: []
        };
    },

    methods: {
        load_logos: function load_logos() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.propsdata[0].paid === '')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return new Promise(function (resolve) {
                                    return setTimeout(resolve, 100);
                                });

                            case 3:
                                _context.next = 0;
                                break;

                            case 5:
                                axios.post('/dashboard/cargar-logos-unique-id.php', {}).then(function (response) {
                                    _this.logos = response.data;
                                    if (response.data === null || response.data.length <= 0) {
                                        //check if user has logos
                                        _this.step = '2';
                                    }
                                    _this.loading_logos = false;
                                }).catch(function (error) {
                                    console.log(error);
                                });

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    mounted: function mounted() {
        this.$emit('updateprops');
        this.load_logos();
    },

    // do not forget this section
    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      timenow: Date.now(),
      loading: true,
      logo_unique_id: '',
      logo: [],
      gradients: {
        '1': {
          'css': 'linear-gradient(rgb(23, 234, 217) 0%, rgb(96, 120, 234) 100%)',
          'svg': '<linearGradient id="gradient-1" x1="49.99999999999999%" y1="0%" x2="50.00000000000001%" y2="100%"><stop offset="0.00" stop-color="#17ead9"></stop><stop offset="1.00" stop-color="#6078eb"></stop></linearGradient>'
        },
        '2': {
          'css': 'linear-gradient(to top, #09203f 0%, #537895 100%)',
          'svg': '<linearGradient id="gradient-2" x1="0%" y1="100%" x2="0%" y2="0%">       <stop offset="0%" stop-color="#09203f" />       <stop offset="100%" stop-color="#537895" />     </linearGradient>'
        },
        '3': {
          'css': 'linear-gradient(to right, rgb(182, 244, 146), rgb(51, 139, 147))',
          'svg': '<linearGradient id="gradient-3" x1="0%" y1="0%" x2="100%" y2="0%">       <stop offset="0%" stop-color="rgb(182, 244, 146)" />       <stop offset="100%" stop-color="rgb(51, 139, 147)" />     </linearGradient>'
        },
        '4': {
          'css': 'radial-gradient( circle farthest-corner at 10% 20%,  rgba(14,174,87,1) 0%, rgba(12,116,117,1) 90% )',
          'svg': '<radialGradient id="gradient-4" cx="10%" cy="20%" r="100%" fx="10%" fy="20%">       <stop offset="0%" stop-color="rgba(14, 174, 87, 1)" />       <stop offset="90%" stop-color="rgba(12, 116, 117, 1)" />     </radialGradient>'
        },
        '5': {
          'css': 'linear-gradient(90deg, rgb(242, 112, 156) 0%, rgb(255, 148, 114) 100%)',
          'svg': '<linearGradient id="gradient-5" x1="0%" y1="50.00000000000001%" x2="100%" y2="49.99999999999999%"><stop offset="0.00" stop-color="#f2709c"></stop><stop offset="1.00" stop-color="#ff9472"></stop></linearGradient>'
        },
        '6': {
          'css': 'linear-gradient(90deg, rgb(240, 11, 81) 0%, rgb(115, 0, 98) 100%)',
          'svg': '<linearGradient id="gradient-6" x1="0%" y1="50.00000000000001%" x2="100%" y2="49.99999999999999%"><stop offset="0.00" stop-color="#f00b51"></stop><stop offset="1.00" stop-color="#730062"></stop></linearGradient>'
        },
        '7': {
          'css': 'linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%)',
          'svg': '<linearGradient id="gradient-7" x1="0%" y1="100%" x2="0%" y2="0%">       <stop offset="0%" stop-color="#a18cd1" />       <stop offset="100%" stop-color="#fbc2eb" />     </linearGradient>'
        },
        '8': {
          'css': 'linear-gradient(to right, #ad5389, #3c1053)',
          'svg': '<linearGradient id="gradient-8" x1="0%" y1="0%" x2="100%" y2="0%">       <stop offset="0%" stop-color="#ad5389" />       <stop offset="100%" stop-color="#3c1053" />     </linearGradient>'
        },
        '9': {
          'css': 'radial-gradient( circle 860px at 11.8% 33.5%,  rgba(240,30,92,1) 0%, rgba(244,49,74,1) 30.5%, rgba(249,75,37,1) 56.1%, rgba(250,88,19,1) 75.6%, rgba(253,102,2,1) 100.2% )',
          'svg': '<radialGradient id="gradient-9" cx="11.8%" cy="33.5%" r="860px">       <stop offset="0%" stop-color="rgba(240, 30, 92, 1)" />       <stop offset="30.5%" stop-color="rgba(244, 49, 74, 1)" />       <stop offset="56.1%" stop-color="rgba(249, 75, 37, 1)" />       <stop offset="75.6%" stop-color="rgba(250, 88, 19, 1)" />       <stop offset="100.2%" stop-color="rgba(253, 102, 2, 1)" />     </radialGradient>'
        },
        '10': {
          'css': 'radial-gradient( circle farthest-corner at 50.4% 50.5%,  rgba(251,32,86,1) 0%, rgba(135,2,35,1) 90% )',
          'svg': '<radialGradient id="gradient-10" cx="50.4%" cy="50.5%" r="100%" fx="50.4%" fy="50.5%">       <stop offset="0%" stop-color="rgba(251, 32, 86, 1)" />       <stop offset="90%" stop-color="rgba(135, 2, 35, 1)" />     </radialGradient>'
        },
        '11': {
          'css': 'radial-gradient(489px at 49.3% 46.6%, rgb(255, 214, 126) 0%, rgb(253, 200, 0) 100.2%)',
          'svg': '<radialGradient id="gradient-11" cx="49.3%" cy="46.6%" r="489px">       <stop offset="0%" stop-color="rgb(255, 214, 126)" />       <stop offset="100.2%" stop-color="rgb(253, 200, 0)" />     </radialGradient>'
        },
        '12': {
          'css': 'linear-gradient( 109.6deg,  rgba(255,115,68,1) 11.2%, rgba(244,255,32,1) 100.6% )',
          'svg': '<linearGradient id="gradient-12" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(255, 115, 68, 1)" />       <stop offset="100.6%" stop-color="rgba(244, 255, 32, 1)" />     </linearGradient>'
        },
        '13': {
          'css': 'linear-gradient( 90.5deg,  rgba(255,207,139,0.50) 1.1%, rgba(255,207,139,1) 81.3% )',
          'svg': '<linearGradient id="gradient-13" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(90.5, 0.5, 0.5)">       <stop offset="1.1%" stop-color="rgba(255, 207, 139, 0.50)" />       <stop offset="81.3%" stop-color="rgba(255, 207, 139, 1)" />     </linearGradient>'
        },
        '14': {
          'css': 'linear-gradient( 109.6deg,  rgba(162,2,63,1) 11.2%, rgba(231,62,68,1) 53.6%, rgba(255,129,79,1) 91.1% )',
          'svg': '<linearGradient id="gradient-14" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(162, 2, 63, 1)" />       <stop offset="53.6%" stop-color="rgba(231, 62, 68, 1)" />       <stop offset="91.1%" stop-color="rgba(255, 129, 79, 1)" />     </linearGradient>'
        },
        '15': {
          'css': 'radial-gradient( circle farthest-corner at 10% 20%,  rgba(0,95,104,1) 0%, rgba(15,156,168,1) 90% )',
          'svg': '<radialGradient id="gradient-15" cx="10%" cy="20%" r="100%" fx="10%" fy="20%">       <stop offset="0%" stop-color="rgba(0, 95, 104, 1)" />       <stop offset="90%" stop-color="rgba(15, 156, 168, 1)" />     </radialGradient>'
        },
        '16': {
          'css': 'linear-gradient( 113.3deg,  rgba(134,209,228,1) -1.8%, rgba(60,80,115,1) 86.4% )',
          'svg': '<linearGradient id="gradient-16" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(113.3, 0.5, 0.5)">       <stop offset="-1.8%" stop-color="rgba(134, 209, 228, 1)" />       <stop offset="86.4%" stop-color="rgba(60, 80, 115, 1)" />     </linearGradient>'
        },
        '17': {
          'css': 'linear-gradient( 76.3deg,  rgba(44,62,78,1) 12.6%, rgba(69,103,131,1) 82.8% )',
          'svg': '<linearGradient id="gradient-17" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(76.3, 0.5, 0.5)">       <stop offset="12.6%" stop-color="rgba(44, 62, 78, 1)" />       <stop offset="82.8%" stop-color="rgba(69, 103, 131, 1)" />     </linearGradient>'
        },
        '18': {
          'css': 'linear-gradient( 109.6deg,  rgba(20,30,48,1) 11.2%, rgba(36,59,85,1) 91.1% )',
          'svg': '<linearGradient id="gradient-18" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(20, 30, 48, 1)" />       <stop offset="91.1%" stop-color="rgba(36, 59, 85, 1)" />     </linearGradient>'
        },
        '19': {
          'css': 'linear-gradient(90deg, #905e25 0%, #f5ec8b 50%, #905e36 100%)',
          'svg': '<linearGradient id="gradient-19"><stop stop-color="#905e25" offset="0"></stop><stop stop-color="#f5ec8b" offset="0.5"></stop><stop stop-color="#905e36" offset="1"></stop></linearGradient>'
        },
        '20': {
          'css': 'linear-gradient(90deg, #616162 0%, #e6e7e9 50%, #616162 100%)',
          'svg': '<linearGradient id="gradient-20"><stop stop-color="#616162" offset="0"></stop><stop stop-color="#e6e7e9" offset="0.5"></stop><stop stop-color="#616162" offset="1"></stop></linearGradient>'
        },
        '21': {
          'css': 'linear-gradient(to right, #834f3a 0%, #dba174 50%, #834F3A 100%)',
          'svg': '<linearGradient id="gradient-21"><stop stop-color="#834f3a" offset="0"></stop><stop stop-color="#dba174" offset="0.5"></stop><stop stop-color="#834F3A" offset="1"></stop></linearGradient>'
        }
      },
      files: {},
      retry_axios: 1
    };
  },

  methods: {
    downloadSvgFile: function downloadSvgFile(svg_code, file_name) {
      // Get the SVG code string from svg_code
      var svgCode = svg_code;

      // Create a Blob from the SVG code
      var blob = new Blob([svgCode], { type: 'image/svg+xml' });

      // Create a URL for the Blob
      var url = URL.createObjectURL(blob);

      // Create a temporary link element
      var downloadLink = document.createElement('a');

      // Set the download attribute with a filename
      downloadLink.download = file_name + '.svg';

      // Set the href attribute to the Blob URL
      downloadLink.href = url;

      // Append the link to the document body (required for Firefox)
      document.body.appendChild(downloadLink);

      // Programmatically click the link to trigger the download
      downloadLink.click();

      // Clean up by removing the link and revoking the Blob URL
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    },
    downloadPngFile: function downloadPngFile(svg_code, file_name) {
      if (file_name !== 'Website-Favicon-Color' && file_name !== 'Website-Favicon-Black' && file_name !== 'Website-Favicon-White') {
        // File name does not contain favicon
        var width = 1000; // Default size of image set to 1000x1000
        var height = 1000; // Default size of image set to 1000x1000
      } else {
        // File name contains favicon
        var width = 128; // Default size of favicon set to 128x128
        var height = 128; // Default size of favicon set to 128x128
      }

      // Create an image element
      var img = new Image();

      // Create a Blob from the SVG code
      var blob = new Blob([svg_code], { type: 'image/svg+xml' });

      // Create a URL for the Blob
      var url = URL.createObjectURL(blob);

      // Set the image source to the Blob URL
      img.src = url;

      // Wait for the image to load
      img.onload = function () {
        // Create a canvas element
        var canvas = document.createElement('canvas');

        // Set the canvas dimensions to the desired size
        canvas.width = width;
        canvas.height = height;

        // Draw the image onto the canvas with the specified dimensions
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Convert the canvas to a data URL in PNG format
        var pngUrl = canvas.toDataURL('image/png');

        // Create a temporary link element
        var downloadLink = document.createElement('a');

        // Set the download attribute with a filename
        downloadLink.download = file_name + '.png';

        // Set the href attribute to the PNG data URL
        downloadLink.href = pngUrl;

        // Append the link to the document body (required for Firefox)
        document.body.appendChild(downloadLink);

        // Programmatically click the link to trigger the download
        downloadLink.click();

        // Clean up by removing the link and revoking the Blob URL
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(url);
      };
    },
    setHighResColorLogo: function setHighResColorLogo() {
      // Get the SVG code string from this.logo.svg
      var svgCode = this.logo.svg;
      // Save SVG code string
      this.files.high_res_color_logo_svgcode = svgCode;
      // Encode the SVG code to Base64
      var base64Svg = btoa(encodeURIComponent(svgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      }));
      // Create the data URL for the background image
      this.files.high_res_color_logo_base64 = 'data:image/svg+xml;base64,' + base64Svg;
    },
    setHighResBlackAndWhite: function setHighResBlackAndWhite() {
      // Get the SVG code string from this.logo.svg
      var svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      var parser = new DOMParser();
      var svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <rect> element with data-name="background" and set it to white
      var backgroundRect = svgDocument.querySelector('rect[data-name="background"]');
      if (backgroundRect) {
        backgroundRect.setAttribute('fill', '#FFFFFF');
      }

      // Find the <g> element with data-name="container"
      var container = svgDocument.querySelector('g[data-name="container"]');

      var applyDefaultColors = true;

      if (container) {
        // Check the container_num
        var containerNumMatch = container.getAttribute('data').match(/container_num:(\d+)/);
        var containerNum = containerNumMatch ? containerNumMatch[1] : null;

        // Containers that have background
        if (containerNum === '2' || containerNum === '3' || containerNum === '6' || containerNum === '8' || containerNum === '10' || containerNum === '12' || containerNum === '13' || containerNum === '15' || containerNum === '17') {
          // Set the container color to black
          container.setAttribute('fill', '#000000');

          if (this.logo.which_container === 'only_icon') {
            // Find the <g> elements for icon, and monogram and set them to white
            var elementsToChange = svgDocument.querySelectorAll('g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(function (element) {
              element.setAttribute('fill', '#FFFFFF');
            });
            // Find the <g> elements for business name and slogan and set them to black
            var elementsToChange2 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
            elementsToChange2.forEach(function (element) {
              element.setAttribute('fill', '#000000');
            });
          } else {
            // Find the <g> elements for business name, slogan, icon, and monogram and set them to white
            var _elementsToChange = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"]');
            _elementsToChange.forEach(function (element) {
              element.setAttribute('fill', '#FFFFFF');
            });
          }

          applyDefaultColors = false; // Don't apply default colors if container_num is 6
        }
      }

      // Apply default colors if the container doesn't exist or if container_num is not 6
      if (applyDefaultColors) {
        // Set business name, slogan, icon, monogram, and container to black if they exist
        var _elementsToChange2 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"], g[data-name="container"]');
        _elementsToChange2.forEach(function (element) {
          element.setAttribute('fill', '#000000');
        });
      }

      // Serialize the modified SVG back to a string
      var serializer = new XMLSerializer();
      var modifiedSvgCode = serializer.serializeToString(svgDocument);

      // Save SVG code string
      this.files.high_res_black_white_svgcode = modifiedSvgCode;

      // Encode the SVG code to Base64
      var base64Svg = btoa(encodeURIComponent(modifiedSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      }));

      // Save the base64 encoded SVG into files.high_res_color_logo_black_white_conditional_base64
      this.files.high_res_black_white_base64 = 'data:image/svg+xml;base64,' + base64Svg;
    },
    setHighResWhiteAndBlack: function setHighResWhiteAndBlack() {
      // Get the SVG code string from this.logo.svg
      var svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      var parser = new DOMParser();
      var svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <rect> element with data-name="background" and set it to black
      var backgroundRect = svgDocument.querySelector('rect[data-name="background"]');
      if (backgroundRect) {
        backgroundRect.setAttribute('fill', '#000000');
      }

      // Find the <g> element with data-name="container"
      var container = svgDocument.querySelector('g[data-name="container"]');

      var applyDefaultColors = true;

      if (container) {
        // Check the container_num
        var containerNumMatch = container.getAttribute('data').match(/container_num:(\d+)/);
        var containerNum = containerNumMatch ? containerNumMatch[1] : null;

        // Containers that have background
        if (containerNum === '2' || containerNum === '3' || containerNum === '6' || containerNum === '8' || containerNum === '10' || containerNum === '12' || containerNum === '13' || containerNum === '15' || containerNum === '17') {
          // Set the container color to white
          container.setAttribute('fill', '#FFFFFF');

          if (this.logo.which_container === 'only_icon') {
            // Find the <g> elements for icon, and monogram and set them to black
            var elementsToChange = svgDocument.querySelectorAll('g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(function (element) {
              element.setAttribute('fill', '#000000');
            });
            // Find the <g> elements for business name and slogan and set them to white
            var elementsToChange2 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
            elementsToChange2.forEach(function (element) {
              element.setAttribute('fill', '#FFFFFF');
            });
          } else {
            // Find the <g> elements for business name, slogan, icon, and monogram and set them to black
            var _elementsToChange3 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"]');
            _elementsToChange3.forEach(function (element) {
              element.setAttribute('fill', '#000000');
            });
          }

          applyDefaultColors = false; // Don't apply default colors if container_num is 6
        }
      }

      // Apply default colors if the container doesn't exist or if container_num is not 6
      if (applyDefaultColors) {
        // Set business name, slogan, icon, monogram, and container to white if they exist
        var _elementsToChange4 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"], g[data-name="container"]');
        _elementsToChange4.forEach(function (element) {
          element.setAttribute('fill', '#FFFFFF');
        });
      }

      // Serialize the modified SVG back to a string
      var serializer = new XMLSerializer();
      var modifiedSvgCode = serializer.serializeToString(svgDocument);

      // Save SVG code string
      this.files.high_res_white_black_svgcode = modifiedSvgCode;

      // Encode the SVG code to Base64
      var base64Svg = btoa(encodeURIComponent(modifiedSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      }));

      // Save the base64 encoded SVG into files.high_res_color_logo_black_white_conditional_base64
      this.files.high_res_white_black_base64 = 'data:image/svg+xml;base64,' + base64Svg;
    },
    setHighResColorLogoTransparentBackground: function setHighResColorLogoTransparentBackground() {
      // Get the SVG code string from this.logo.svg
      var svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      var parser = new DOMParser();
      var svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <rect> element with data-name="background"
      var backgroundRect = svgDocument.querySelector('rect[data-name="background"]');

      // Set the fill attribute to 'none' or 'transparent'
      if (backgroundRect) {
        backgroundRect.setAttribute('fill', 'none');
      }

      // Serialize the modified SVG back to a string
      var serializer = new XMLSerializer();
      var modifiedSvgCode = serializer.serializeToString(svgDocument);

      // Save SVG code string
      this.files.high_res_color_logo_transparent_bg_svgcode = modifiedSvgCode;

      // Encode the SVG code to Base64
      var base64Svg = btoa(encodeURIComponent(modifiedSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      }));

      // Save the base64 encoded SVG into files.high_res_color_logo_transparent_bg
      this.files.high_res_color_logo_transparent_bg_base64 = 'data:image/svg+xml;base64,' + base64Svg;
    },
    setHighResBlackTransparentBackground: function setHighResBlackTransparentBackground() {
      // Get the SVG code string from this.logo.svg
      var svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      var parser = new DOMParser();
      var svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <rect> element with data-name="background"
      var backgroundRect = svgDocument.querySelector('rect[data-name="background"]');

      // Set the fill attribute to 'none' or 'transparent'
      if (backgroundRect) {
        backgroundRect.setAttribute('fill', 'none');
      }

      // Find the <g> element with data-name="container"
      var container = svgDocument.querySelector('g[data-name="container"]');

      var applyDefaultColors = true;

      if (container) {
        // Check the container_num
        var containerNumMatch = container.getAttribute('data').match(/container_num:(\d+)/);
        var containerNum = containerNumMatch ? containerNumMatch[1] : null;

        // Containers that have background
        if (containerNum === '2' || containerNum === '3' || containerNum === '6' || containerNum === '8' || containerNum === '10' || containerNum === '12' || containerNum === '13' || containerNum === '15' || containerNum === '17') {
          // Set the container color to black
          container.setAttribute('fill', '#000000');

          if (this.logo.which_container === 'only_icon') {
            // Find the <g> elements for icon, and monogram and set them to white
            var elementsToChange = svgDocument.querySelectorAll('g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(function (element) {
              element.setAttribute('fill', '#FFFFFF');
            });
            // Find the <g> elements for business name and slogan and set them to black
            var elementsToChange2 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
            elementsToChange2.forEach(function (element) {
              element.setAttribute('fill', '#000000');
            });
          } else {
            // Find the <g> elements for business name, slogan, icon, and monogram and set them to white
            var _elementsToChange5 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"]');
            _elementsToChange5.forEach(function (element) {
              element.setAttribute('fill', '#FFFFFF');
            });
          }

          applyDefaultColors = false; // Don't apply default colors if container_num is 6
        }
      }

      // Apply default colors if the container doesn't exist or if container_num is not 6
      if (applyDefaultColors) {
        // Set business name, slogan, icon, monogram, and container to black if they exist
        var _elementsToChange6 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"], g[data-name="container"]');
        _elementsToChange6.forEach(function (element) {
          element.setAttribute('fill', '#000000');
        });
      }

      // Serialize the modified SVG back to a string
      var serializer = new XMLSerializer();
      var modifiedSvgCode = serializer.serializeToString(svgDocument);

      // Save SVG code string
      this.files.high_res_black_transparent_bg_svgcode = modifiedSvgCode;

      // Encode the SVG code to Base64
      var base64Svg = btoa(encodeURIComponent(modifiedSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      }));

      // Save the base64 encoded SVG into files.high_res_color_logo_black_white_conditional_base64
      this.files.high_res_black_transparent_bg_base64 = 'data:image/svg+xml;base64,' + base64Svg;
    },
    setHighResWhiteTransparentBackground: function setHighResWhiteTransparentBackground() {
      // Get the SVG code string from this.logo.svg
      var svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      var parser = new DOMParser();
      var svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <rect> element with data-name="background"
      var backgroundRect = svgDocument.querySelector('rect[data-name="background"]');

      // Set the fill attribute to 'none' or 'transparent'
      if (backgroundRect) {
        backgroundRect.setAttribute('fill', 'none');
      }

      // Find the <g> element with data-name="container"
      var container = svgDocument.querySelector('g[data-name="container"]');

      var applyDefaultColors = true;

      if (container) {
        // Check the container_num
        var containerNumMatch = container.getAttribute('data').match(/container_num:(\d+)/);
        var containerNum = containerNumMatch ? containerNumMatch[1] : null;

        // Containers that have background
        if (containerNum === '2' || containerNum === '3' || containerNum === '6' || containerNum === '8' || containerNum === '10' || containerNum === '12' || containerNum === '13' || containerNum === '15' || containerNum === '17') {
          // Set the container color to white
          container.setAttribute('fill', '#FFFFFF');

          if (this.logo.which_container === 'only_icon') {
            // Find the <g> elements for icon, and monogram and set them to black
            var elementsToChange = svgDocument.querySelectorAll('g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(function (element) {
              element.setAttribute('fill', '#000000');
            });
            // Find the <g> elements for business name and slogan and set them to white
            var elementsToChange2 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
            elementsToChange2.forEach(function (element) {
              element.setAttribute('fill', '#FFFFFF');
            });
          } else {
            // Find the <g> elements for business name, slogan, icon, and monogram and set them to black
            var _elementsToChange7 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"]');
            _elementsToChange7.forEach(function (element) {
              element.setAttribute('fill', '#000000');
            });
          }

          applyDefaultColors = false; // Don't apply default colors if container_num is 6
        }
      }

      // Apply default colors if the container doesn't exist or if container_num is not 6
      if (applyDefaultColors) {
        // Set business name, slogan, icon, monogram, and container to black if they exist
        var _elementsToChange8 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"], g[data-name="container"]');
        _elementsToChange8.forEach(function (element) {
          element.setAttribute('fill', '#FFFFFF');
        });
      }

      // Serialize the modified SVG back to a string
      var serializer = new XMLSerializer();
      var modifiedSvgCode = serializer.serializeToString(svgDocument);

      // Save SVG code string
      this.files.high_res_white_transparent_bg_svgcode = modifiedSvgCode;

      // Encode the SVG code to Base64
      var base64Svg = btoa(encodeURIComponent(modifiedSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      }));

      // Save the base64 encoded SVG into files.high_res_color_logo_black_white_conditional_base64
      this.files.high_res_white_transparent_bg_base64 = 'data:image/svg+xml;base64,' + base64Svg;
    },
    setFaviconOriginalColor: function setFaviconOriginalColor() {
      // Get the SVG code string from this.logo.svg
      var svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      var parser = new DOMParser();
      var svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <g> element with data-name="icon" or "monogram"
      var iconElement = svgDocument.querySelector('[data-name="icon"], [data-name="monogram"]');

      if (iconElement) {
        // Remove the transform attribute from the <g> element
        iconElement.removeAttribute('transform');

        // Create a new SVG document to store only the filtered elements
        var newSvgDocument = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        newSvgDocument.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        newSvgDocument.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        newSvgDocument.setAttribute("width", "400");
        newSvgDocument.setAttribute("height", "400");
        newSvgDocument.setAttribute("viewBox", "0 0 400 400");

        // Check if there is a <defs> element in the original SVG
        var defsElement = svgDocument.querySelector('defs');
        if (defsElement) {
          // Clone the <defs> element and append it to the new SVG document
          newSvgDocument.appendChild(defsElement.cloneNode(true));
        }

        // Append the modified <g> element to the new SVG document
        newSvgDocument.appendChild(iconElement.cloneNode(true));

        // Serialize the new SVG document back to a string
        var serializer = new XMLSerializer();
        var filteredSvgCode = serializer.serializeToString(newSvgDocument);

        // Save the filtered SVG code string
        this.files.favicon_original_color_svgcode = filteredSvgCode;

        // Encode the SVG code to Base64
        var base64Svg = btoa(encodeURIComponent(filteredSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
          return String.fromCharCode('0x' + p1);
        }));

        // Save the base64 encoded SVG into files.favicon_original_color_base64
        this.files.favicon_original_color_base64 = 'data:image/svg+xml;base64,' + base64Svg;

        // Load the SVG into the offscreen container
        var container = document.getElementById('svgContainer-edit');
        container.innerHTML = this.files.favicon_original_color_svgcode;

        // Access the <svg> element inside the container
        var svgElement = container.querySelector('svg');

        // Access the <g> element with data-name="icon" or "monogram"
        var finalIconElement = svgElement.querySelector('g[data-name="icon"], g[data-name="monogram"]');

        if (finalIconElement) {
          // Get the bounding box of the <g> element
          var boundingBox = finalIconElement.getBBox();
          var iconWidth = boundingBox.width;
          var iconHeight = boundingBox.height;

          // Calculate the scale factor to make the icon fit within 90% of the viewBox
          var scaleFactor = Math.min(0.9 * 400 / iconWidth, 0.9 * 400 / iconHeight);

          // Calculate translation to center the icon within the viewBox
          var translateX = (400 - iconWidth * scaleFactor) / 2 - boundingBox.x * scaleFactor;
          var translateY = (400 - iconHeight * scaleFactor) / 2 - boundingBox.y * scaleFactor;

          // Apply the transformation to the <g> element to scale and center it
          finalIconElement.setAttribute('transform', 'translate(' + translateX + ', ' + translateY + ') scale(' + scaleFactor + ')');

          // Serialize the modified SVG back to a string
          var updatedSvgCode = serializer.serializeToString(svgElement);

          // Update the SVG and Base64 with the transformed icon
          this.files.favicon_original_color_svgcode = updatedSvgCode;
          this.files.favicon_original_color_base64 = 'data:image/svg+xml;base64,' + btoa(encodeURIComponent(updatedSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode('0x' + p1);
          }));

          // Create black favicon
          // Change the color of the icon to black
          finalIconElement.querySelectorAll('path').forEach(function (path) {
            path.setAttribute('fill', '#000000'); // Set fill to black
          });

          // Serialize the modified SVG back to a string
          var updatedSvgCodeBlack = serializer.serializeToString(svgElement);

          // Save the black version of the SVG and its Base64
          this.files.favicon_black_svgcode = updatedSvgCodeBlack;
          this.files.favicon_black_base64 = 'data:image/svg+xml;base64,' + btoa(encodeURIComponent(updatedSvgCodeBlack).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode('0x' + p1);
          }));

          // Create white favicon
          // Change the color of the icon to white
          finalIconElement.querySelectorAll('path').forEach(function (path) {
            path.setAttribute('fill', '#FFFFFF'); // Set fill to white
          });

          // Serialize the modified SVG back to a string
          var updatedSvgCodeWhite = serializer.serializeToString(svgElement);

          // Save the white version of the SVG and its Base64
          this.files.favicon_white_svgcode = updatedSvgCodeWhite;
          this.files.favicon_white_base64 = 'data:image/svg+xml;base64,' + btoa(encodeURIComponent(updatedSvgCodeWhite).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode('0x' + p1);
          }));

          // Log the final width and height to the console
          // console.log(`Final Icon/Monogram Width: ${iconWidth}, Final Icon/Monogram Height: ${iconHeight}`);
        } else {
          console.error("Final <g> element with data-name='icon' or 'monogram' not found.");
        }
      } else {
        console.error("Icon or Monogram not found in SVG.");
      }
    },
    setIconOnly: function setIconOnly() {
      // Get the SVG code string from this.logo.svg
      var svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      var parser = new DOMParser();
      var svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <g> element with data-name="icon" or "monogram"
      var iconElement = svgDocument.querySelector('[data-name="icon"], [data-name="monogram"]');

      if (iconElement) {
        // Remove the transform attribute from the <g> element
        iconElement.removeAttribute('transform');

        // Create a new SVG document to store only the filtered elements
        var newSvgDocument = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        newSvgDocument.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        newSvgDocument.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        newSvgDocument.setAttribute("width", "400");
        newSvgDocument.setAttribute("height", "400");
        newSvgDocument.setAttribute("viewBox", "0 0 400 400");

        // Check if there is a <defs> element in the original SVG
        var defsElement = svgDocument.querySelector('defs');
        if (defsElement) {
          // Clone the <defs> element and append it to the new SVG document
          newSvgDocument.appendChild(defsElement.cloneNode(true));
        }

        // Append the modified <g> element to the new SVG document
        newSvgDocument.appendChild(iconElement.cloneNode(true));

        // Serialize the new SVG document back to a string
        var serializer = new XMLSerializer();
        var filteredSvgCode = serializer.serializeToString(newSvgDocument);

        // Save the filtered SVG code string
        this.files.icononly_original_color_svgcode = filteredSvgCode;

        // Encode the SVG code to Base64
        var base64Svg = btoa(encodeURIComponent(filteredSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
          return String.fromCharCode('0x' + p1);
        }));

        // Save the base64 encoded SVG into files.icononly_original_color_base64
        this.files.icononly_original_color_base64 = 'data:image/svg+xml;base64,' + base64Svg;

        // Load the SVG into the offscreen container
        var container = document.getElementById('svgContainer-edit');
        container.innerHTML = this.files.icononly_original_color_svgcode;

        // Access the <svg> element inside the container
        var svgElement = container.querySelector('svg');

        // Access the <g> element with data-name="icon" or "monogram"
        var finalIconElement = svgElement.querySelector('g[data-name="icon"], g[data-name="monogram"]');

        if (finalIconElement) {
          // Get the bounding box of the <g> element
          var boundingBox = finalIconElement.getBBox();
          var iconWidth = boundingBox.width;
          var iconHeight = boundingBox.height;

          // Calculate the scale factor to make the icon fit within 80% of the viewBox
          var scaleFactor = Math.min(0.9 * 400 / iconWidth, 0.8 * 400 / iconHeight);

          // Calculate translation to center the icon within the viewBox
          var translateX = (400 - iconWidth * scaleFactor) / 2 - boundingBox.x * scaleFactor;
          var translateY = (400 - iconHeight * scaleFactor) / 2 - boundingBox.y * scaleFactor;

          // Apply the transformation to the <g> element to scale and center it
          finalIconElement.setAttribute('transform', 'translate(' + translateX + ', ' + translateY + ') scale(' + scaleFactor + ')');

          // Serialize the modified SVG back to a string
          var updatedSvgCode = serializer.serializeToString(svgElement);

          // Update the SVG and Base64 with the transformed icon
          this.files.icononly_original_color_svgcode = updatedSvgCode;
          this.files.icononly_original_color_base64 = 'data:image/svg+xml;base64,' + btoa(encodeURIComponent(updatedSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode('0x' + p1);
          }));

          // Create black favicon
          // Change the color of the icon to black
          finalIconElement.querySelectorAll('path').forEach(function (path) {
            path.setAttribute('fill', '#000000'); // Set fill to black
          });

          // Serialize the modified SVG back to a string
          var updatedSvgCodeBlack = serializer.serializeToString(svgElement);

          // Save the black version of the SVG and its Base64
          this.files.icononly_black_svgcode = updatedSvgCodeBlack;
          this.files.icononly_black_base64 = 'data:image/svg+xml;base64,' + btoa(encodeURIComponent(updatedSvgCodeBlack).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode('0x' + p1);
          }));

          // Create white favicon
          // Change the color of the icon to white
          finalIconElement.querySelectorAll('path').forEach(function (path) {
            path.setAttribute('fill', '#FFFFFF'); // Set fill to white
          });

          // Serialize the modified SVG back to a string
          var updatedSvgCodeWhite = serializer.serializeToString(svgElement);

          // Save the white version of the SVG and its Base64
          this.files.icononly_white_svgcode = updatedSvgCodeWhite;
          this.files.icononly_white_base64 = 'data:image/svg+xml;base64,' + btoa(encodeURIComponent(updatedSvgCodeWhite).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode('0x' + p1);
          }));

          // Log the final width and height to the console
          // console.log(`Final Icon/Monogram Width: ${iconWidth}, Final Icon/Monogram Height: ${iconHeight}`);
        } else {
          console.error("Final <g> element with data-name='icon' or 'monogram' not found.");
        }
      } else {
        console.error("Icon or Monogram not found in SVG.");
      }
    },
    setBusinessNameAndSloganOnly: function setBusinessNameAndSloganOnly() {
      // Get the SVG code string from this.logo.svg
      var svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      var parser = new DOMParser();
      var svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Remove the container and icon elements
      var backgroundElement = svgDocument.querySelector('[data-name="background"]');
      var containerElement = svgDocument.querySelector('[data-name="container"]');
      var iconElement = svgDocument.querySelector('[data-name="icon"]');
      var monogramElement = svgDocument.querySelector('[data-name="monogram"]');
      if (backgroundElement) {
        backgroundElement.remove();
      }
      if (containerElement) {
        containerElement.remove();
      }
      if (iconElement) {
        iconElement.remove();
      }
      if (monogramElement) {
        monogramElement.remove();
      }

      // Find the <g> elements with data-name="business_name" and "slogan"
      var businessNameElement = svgDocument.querySelector('[data-name="business_name"]');
      var sloganElement = svgDocument.querySelector('[data-name="slogan"]');

      if (businessNameElement || sloganElement) {
        // Create a new <g> element to group business_name and slogan
        var combinedGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
        combinedGroup.setAttribute("data-name", "business_name_slogan_group");

        if (businessNameElement) {
          combinedGroup.appendChild(businessNameElement.cloneNode(true));
          businessNameElement.remove();
        }

        if (sloganElement) {
          combinedGroup.appendChild(sloganElement.cloneNode(true));
          sloganElement.remove();
        }

        // Append the new group to the SVG document
        svgDocument.documentElement.appendChild(combinedGroup);

        // Load the SVG into the offscreen container to get the bounding box
        var container = document.getElementById('svgContainer-edit');
        container.innerHTML = new XMLSerializer().serializeToString(svgDocument);

        // Access the <svg> element inside the container
        var svgElement = container.querySelector('svg');

        // Access the new <g> element containing business_name and slogan
        var finalGroupElement = svgElement.querySelector('g[data-name="business_name_slogan_group"]');

        if (finalGroupElement) {
          // Get the bounding box of the combined group
          var boundingBox = finalGroupElement.getBBox();
          var combinedWidth = boundingBox.width;
          var combinedHeight = boundingBox.height;

          // Calculate the translation needed to center the group within the viewBox
          var translateX = (400 - combinedWidth) / 2 - boundingBox.x;
          var translateY = (400 - combinedHeight) / 2 - boundingBox.y;

          // Apply the transformation to the <g> element to center it
          var existingTransform = finalGroupElement.getAttribute('transform') || '';
          finalGroupElement.setAttribute('transform', existingTransform + ' translate(' + translateX + ', ' + translateY + ')');

          // Log the combined width and height to the console
          // console.log(`Combined Business Name and Slogan Width: ${combinedWidth}, Combined Height: ${combinedHeight}`);
        }

        // Serialize the modified SVG back to a string
        var serializer = new XMLSerializer();
        var updatedSvgCode = serializer.serializeToString(svgElement);

        // Update the SVG and Base64 with the transformed icon
        this.files.only_business_slogan_svgcode = updatedSvgCode;
        this.files.only_business_slogan_base64 = 'data:image/svg+xml;base64,' + btoa(encodeURIComponent(updatedSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
          return String.fromCharCode('0x' + p1);
        }));

        // Create black favicon
        // Set business name, slogan to black if they exist
        var elementsToChange = svgElement.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
        elementsToChange.forEach(function (element) {
          element.setAttribute('fill', '#000000');
        });

        // Serialize the modified SVG back to a string
        var updatedSvgCodeBlack = serializer.serializeToString(svgElement);

        // Save the black version of the SVG and its Base64
        this.files.only_business_slogan_black_svgcode = updatedSvgCodeBlack;
        this.files.only_business_slogan_black_base64 = 'data:image/svg+xml;base64,' + btoa(encodeURIComponent(updatedSvgCodeBlack).replace(/%([0-9A-F]{2})/g, function (match, p1) {
          return String.fromCharCode('0x' + p1);
        }));

        // Create white favicon
        // Set business name, white to black if they exist
        var elementsToChange2 = svgElement.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
        elementsToChange2.forEach(function (element) {
          element.setAttribute('fill', '#FFFFFF');
        });

        // Serialize the modified SVG back to a string
        var updatedSvgCodeWhite = serializer.serializeToString(svgElement);

        // Save the white version of the SVG and its Base64
        this.files.only_business_slogan_white_svgcode = updatedSvgCodeWhite;
        this.files.only_business_slogan_white_base64 = 'data:image/svg+xml;base64,' + btoa(encodeURIComponent(updatedSvgCodeWhite).replace(/%([0-9A-F]{2})/g, function (match, p1) {
          return String.fromCharCode('0x' + p1);
        }));
      } else {
        console.error("Business Name or Slogan not found in SVG.");
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.logo_unique_id = this.$route.params.logo_unique_id;
    this.$emit('updatepath');
    axios.post('/dashboard/get-logo-data.php', {
      unique_id: this.logo_unique_id
    }).then(function (response) {
      if (response.data === 'volver a intentar el axios para cargar formdata' && _this.retry_axios <= 3) {
        _this.retry_axios = _this.retry_axios + 1;
        _this.propsdata[0].saving_logo = false;
        _this.choose_logo(object);
      } else if (response.data === 'logo not found') {
        _this.$router.push('/dashboard/get-logo-files/'); //redirect to select brand
      } else {
        _this.retry_axios = 1;
        _this.logo = response.data;
        _this.setHighResColorLogo();
        _this.setHighResBlackAndWhite();
        _this.setHighResWhiteAndBlack();
        _this.setHighResColorLogoTransparentBackground();
        _this.setHighResBlackTransparentBackground();
        _this.setHighResWhiteTransparentBackground();
        _this.setFaviconOriginalColor();
        _this.setIconOnly();
        _this.setBusinessNameAndSloganOnly();
        _this.loading = false;
      }
    }).catch(function (error) {
      console.log(error);
      this.retry_axios = 1;
    });
  },

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['propsdata'],
    data: function data() {
        return {
            loading_logos: true,
            timenow: Date.now(),
            logos: []
        };
    },

    methods: {
        load_logos: function load_logos() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.propsdata[0].paid === '')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return new Promise(function (resolve) {
                                    return setTimeout(resolve, 100);
                                });

                            case 3:
                                _context.next = 0;
                                break;

                            case 5:
                                axios.post('/dashboard/cargar-logos-unique-id.php', {}).then(function (response) {
                                    _this.logos = response.data;
                                    if (response.data === null || response.data.length <= 0) {
                                        //check if user has logos
                                        _this.step = '2';
                                    }
                                    _this.loading_logos = false;
                                }).catch(function (error) {
                                    console.log(error);
                                });

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    mounted: function mounted() {
        this.$emit('updateprops');
        this.load_logos();
    },

    // do not forget this section
    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      timenow: Date.now(),
      loading: true,
      logo_unique_id: '',
      logo: [],
      gradients: {
        '1': {
          'css': 'linear-gradient(rgb(23, 234, 217) 0%, rgb(96, 120, 234) 100%)',
          'svg': '<linearGradient id="gradient-1" x1="49.99999999999999%" y1="0%" x2="50.00000000000001%" y2="100%"><stop offset="0.00" stop-color="#17ead9"></stop><stop offset="1.00" stop-color="#6078eb"></stop></linearGradient>'
        },
        '2': {
          'css': 'linear-gradient(to top, #09203f 0%, #537895 100%)',
          'svg': '<linearGradient id="gradient-2" x1="0%" y1="100%" x2="0%" y2="0%">       <stop offset="0%" stop-color="#09203f" />       <stop offset="100%" stop-color="#537895" />     </linearGradient>'
        },
        '3': {
          'css': 'linear-gradient(to right, rgb(182, 244, 146), rgb(51, 139, 147))',
          'svg': '<linearGradient id="gradient-3" x1="0%" y1="0%" x2="100%" y2="0%">       <stop offset="0%" stop-color="rgb(182, 244, 146)" />       <stop offset="100%" stop-color="rgb(51, 139, 147)" />     </linearGradient>'
        },
        '4': {
          'css': 'radial-gradient( circle farthest-corner at 10% 20%,  rgba(14,174,87,1) 0%, rgba(12,116,117,1) 90% )',
          'svg': '<radialGradient id="gradient-4" cx="10%" cy="20%" r="100%" fx="10%" fy="20%">       <stop offset="0%" stop-color="rgba(14, 174, 87, 1)" />       <stop offset="90%" stop-color="rgba(12, 116, 117, 1)" />     </radialGradient>'
        },
        '5': {
          'css': 'linear-gradient(90deg, rgb(242, 112, 156) 0%, rgb(255, 148, 114) 100%)',
          'svg': '<linearGradient id="gradient-5" x1="0%" y1="50.00000000000001%" x2="100%" y2="49.99999999999999%"><stop offset="0.00" stop-color="#f2709c"></stop><stop offset="1.00" stop-color="#ff9472"></stop></linearGradient>'
        },
        '6': {
          'css': 'linear-gradient(90deg, rgb(240, 11, 81) 0%, rgb(115, 0, 98) 100%)',
          'svg': '<linearGradient id="gradient-6" x1="0%" y1="50.00000000000001%" x2="100%" y2="49.99999999999999%"><stop offset="0.00" stop-color="#f00b51"></stop><stop offset="1.00" stop-color="#730062"></stop></linearGradient>'
        },
        '7': {
          'css': 'linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%)',
          'svg': '<linearGradient id="gradient-7" x1="0%" y1="100%" x2="0%" y2="0%">       <stop offset="0%" stop-color="#a18cd1" />       <stop offset="100%" stop-color="#fbc2eb" />     </linearGradient>'
        },
        '8': {
          'css': 'linear-gradient(to right, #ad5389, #3c1053)',
          'svg': '<linearGradient id="gradient-8" x1="0%" y1="0%" x2="100%" y2="0%">       <stop offset="0%" stop-color="#ad5389" />       <stop offset="100%" stop-color="#3c1053" />     </linearGradient>'
        },
        '9': {
          'css': 'radial-gradient( circle 860px at 11.8% 33.5%,  rgba(240,30,92,1) 0%, rgba(244,49,74,1) 30.5%, rgba(249,75,37,1) 56.1%, rgba(250,88,19,1) 75.6%, rgba(253,102,2,1) 100.2% )',
          'svg': '<radialGradient id="gradient-9" cx="11.8%" cy="33.5%" r="860px">       <stop offset="0%" stop-color="rgba(240, 30, 92, 1)" />       <stop offset="30.5%" stop-color="rgba(244, 49, 74, 1)" />       <stop offset="56.1%" stop-color="rgba(249, 75, 37, 1)" />       <stop offset="75.6%" stop-color="rgba(250, 88, 19, 1)" />       <stop offset="100.2%" stop-color="rgba(253, 102, 2, 1)" />     </radialGradient>'
        },
        '10': {
          'css': 'radial-gradient( circle farthest-corner at 50.4% 50.5%,  rgba(251,32,86,1) 0%, rgba(135,2,35,1) 90% )',
          'svg': '<radialGradient id="gradient-10" cx="50.4%" cy="50.5%" r="100%" fx="50.4%" fy="50.5%">       <stop offset="0%" stop-color="rgba(251, 32, 86, 1)" />       <stop offset="90%" stop-color="rgba(135, 2, 35, 1)" />     </radialGradient>'
        },
        '11': {
          'css': 'radial-gradient(489px at 49.3% 46.6%, rgb(255, 214, 126) 0%, rgb(253, 200, 0) 100.2%)',
          'svg': '<radialGradient id="gradient-11" cx="49.3%" cy="46.6%" r="489px">       <stop offset="0%" stop-color="rgb(255, 214, 126)" />       <stop offset="100.2%" stop-color="rgb(253, 200, 0)" />     </radialGradient>'
        },
        '12': {
          'css': 'linear-gradient( 109.6deg,  rgba(255,115,68,1) 11.2%, rgba(244,255,32,1) 100.6% )',
          'svg': '<linearGradient id="gradient-12" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(255, 115, 68, 1)" />       <stop offset="100.6%" stop-color="rgba(244, 255, 32, 1)" />     </linearGradient>'
        },
        '13': {
          'css': 'linear-gradient( 90.5deg,  rgba(255,207,139,0.50) 1.1%, rgba(255,207,139,1) 81.3% )',
          'svg': '<linearGradient id="gradient-13" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(90.5, 0.5, 0.5)">       <stop offset="1.1%" stop-color="rgba(255, 207, 139, 0.50)" />       <stop offset="81.3%" stop-color="rgba(255, 207, 139, 1)" />     </linearGradient>'
        },
        '14': {
          'css': 'linear-gradient( 109.6deg,  rgba(162,2,63,1) 11.2%, rgba(231,62,68,1) 53.6%, rgba(255,129,79,1) 91.1% )',
          'svg': '<linearGradient id="gradient-14" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(162, 2, 63, 1)" />       <stop offset="53.6%" stop-color="rgba(231, 62, 68, 1)" />       <stop offset="91.1%" stop-color="rgba(255, 129, 79, 1)" />     </linearGradient>'
        },
        '15': {
          'css': 'radial-gradient( circle farthest-corner at 10% 20%,  rgba(0,95,104,1) 0%, rgba(15,156,168,1) 90% )',
          'svg': '<radialGradient id="gradient-15" cx="10%" cy="20%" r="100%" fx="10%" fy="20%">       <stop offset="0%" stop-color="rgba(0, 95, 104, 1)" />       <stop offset="90%" stop-color="rgba(15, 156, 168, 1)" />     </radialGradient>'
        },
        '16': {
          'css': 'linear-gradient( 113.3deg,  rgba(134,209,228,1) -1.8%, rgba(60,80,115,1) 86.4% )',
          'svg': '<linearGradient id="gradient-16" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(113.3, 0.5, 0.5)">       <stop offset="-1.8%" stop-color="rgba(134, 209, 228, 1)" />       <stop offset="86.4%" stop-color="rgba(60, 80, 115, 1)" />     </linearGradient>'
        },
        '17': {
          'css': 'linear-gradient( 76.3deg,  rgba(44,62,78,1) 12.6%, rgba(69,103,131,1) 82.8% )',
          'svg': '<linearGradient id="gradient-17" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(76.3, 0.5, 0.5)">       <stop offset="12.6%" stop-color="rgba(44, 62, 78, 1)" />       <stop offset="82.8%" stop-color="rgba(69, 103, 131, 1)" />     </linearGradient>'
        },
        '18': {
          'css': 'linear-gradient( 109.6deg,  rgba(20,30,48,1) 11.2%, rgba(36,59,85,1) 91.1% )',
          'svg': '<linearGradient id="gradient-18" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(20, 30, 48, 1)" />       <stop offset="91.1%" stop-color="rgba(36, 59, 85, 1)" />     </linearGradient>'
        },
        '19': {
          'css': 'linear-gradient(90deg, #905e25 0%, #f5ec8b 50%, #905e36 100%)',
          'svg': '<linearGradient id="gradient-19"><stop stop-color="#905e25" offset="0"></stop><stop stop-color="#f5ec8b" offset="0.5"></stop><stop stop-color="#905e36" offset="1"></stop></linearGradient>'
        },
        '20': {
          'css': 'linear-gradient(90deg, #616162 0%, #e6e7e9 50%, #616162 100%)',
          'svg': '<linearGradient id="gradient-20"><stop stop-color="#616162" offset="0"></stop><stop stop-color="#e6e7e9" offset="0.5"></stop><stop stop-color="#616162" offset="1"></stop></linearGradient>'
        },
        '21': {
          'css': 'linear-gradient(to right, #834f3a 0%, #dba174 50%, #834F3A 100%)',
          'svg': '<linearGradient id="gradient-21"><stop stop-color="#834f3a" offset="0"></stop><stop stop-color="#dba174" offset="0.5"></stop><stop stop-color="#834F3A" offset="1"></stop></linearGradient>'
        }
      },
      files: {},
      retry_axios: 1
    };
  },

  methods: {
    downloadSvgFile: function downloadSvgFile(svg_code, file_name) {
      // Get the SVG code string from svg_code
      var svgCode = svg_code;

      // Create a Blob from the SVG code
      var blob = new Blob([svgCode], { type: 'image/svg+xml' });

      // Create a URL for the Blob
      var url = URL.createObjectURL(blob);

      // Create a temporary link element
      var downloadLink = document.createElement('a');

      // Set the download attribute with a filename
      downloadLink.download = file_name + '.svg';

      // Set the href attribute to the Blob URL
      downloadLink.href = url;

      // Append the link to the document body (required for Firefox)
      document.body.appendChild(downloadLink);

      // Programmatically click the link to trigger the download
      downloadLink.click();

      // Clean up by removing the link and revoking the Blob URL
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    },
    downloadPngFile: function downloadPngFile(svg_code, file_name) {
      // Create a DOM parser to parse the SVG code
      var parser = new DOMParser();
      var svgDocument = parser.parseFromString(svg_code, "image/svg+xml");

      // Get the width and height from the SVG element
      var svgElement = svgDocument.documentElement;
      var width = parseInt(svgElement.getAttribute('width'), 10);
      var height = parseInt(svgElement.getAttribute('height'), 10);

      // Create an image element
      var img = new Image();

      // Create a Blob from the SVG code
      var blob = new Blob([svg_code], { type: 'image/svg+xml' });

      // Create a URL for the Blob
      var url = URL.createObjectURL(blob);

      // Set the image source to the Blob URL
      img.src = url;

      // Wait for the image to load
      img.onload = function () {
        // Create a canvas element
        var canvas = document.createElement('canvas');

        // Set the canvas dimensions to the SVG's dimensions
        canvas.width = width;
        canvas.height = height;

        // Draw the image onto the canvas with the specified dimensions
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Convert the canvas to a data URL in PNG format
        var pngUrl = canvas.toDataURL('image/png');

        // Create a temporary link element
        var downloadLink = document.createElement('a');

        // Set the download attribute with a filename
        downloadLink.download = file_name + '.png';

        // Set the href attribute to the PNG data URL
        downloadLink.href = pngUrl;

        // Append the link to the document body (required for Firefox)
        document.body.appendChild(downloadLink);

        // Programmatically click the link to trigger the download
        downloadLink.click();

        // Clean up by removing the link and revoking the Blob URL
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(url);
      };
    },
    setNewSvgSizes: function setNewSvgSizes() {
      var _this = this;

      // Get the SVG code string from this.logo.svg
      var svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      var parser = new DOMParser();
      var svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Get the original SVG element's viewBox
      var originalSvgElement = svgDocument.documentElement;
      var originalViewBox = originalSvgElement.getAttribute("viewBox");

      // Extract original width and height from viewBox (assuming it's in the format "0 0 width height")

      var _originalViewBox$spli = originalViewBox.split(" ").map(Number),
          _originalViewBox$spli2 = _slicedToArray(_originalViewBox$spli, 4),
          originalWidth = _originalViewBox$spli2[2],
          originalHeight = _originalViewBox$spli2[3];

      // Array of size configurations for different platforms


      var sizeConfigs = [{ name: 'instagram_profile_photo', width: 1000, height: 1000 }, { name: 'instagram_story_photo', width: 1080, height: 1920 }, { name: 'instagram_post_photo', width: 1080, height: 1080 }, { name: 'facebook_cover_image', width: 2460, height: 936 }, { name: 'facebook_profile_photo', width: 1500, height: 1500 }, { name: 'x_header_photo', width: 1500, height: 500 }, { name: 'x_profile_photo', width: 800, height: 800 }, { name: 'linkedin_cover_image', width: 1584, height: 396 }, { name: 'linkedin_profile_photo', width: 1200, height: 1200 }, { name: 'youtube_channel_art', width: 2048, height: 1152 }, { name: 'youtube_profile_photo', width: 800, height: 800 }, { name: 'tiktok_profile_photo', width: 800, height: 800 }, { name: 'etsy_cover_image', width: 2990, height: 747 }, { name: 'etsy_profile_photo', width: 800, height: 800 }, { name: 'etsy_shop_photo', width: 1520, height: 200 }, { name: 'pinterest_profile_photo', width: 720, height: 720 }, { name: 'pinterest_cover_image', width: 1200, height: 1200 }, { name: 'whatsapp_profile_photo', width: 1000, height: 1000 }];

      // Loop through each size configuration
      sizeConfigs.forEach(function (config) {
        // Create a new SVG document with the desired dimensions
        var newSvgDocument = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        newSvgDocument.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        newSvgDocument.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        newSvgDocument.setAttribute("width", config.width);
        newSvgDocument.setAttribute("height", config.height);
        newSvgDocument.setAttribute("viewBox", '0 0 ' + config.width + ' ' + config.height);

        // Locate the <rect> element for the background (if it exists)
        var backgroundRect = svgDocument.querySelector('rect[data-name="background"]');

        // Append the <rect> element to the new SVG document if it exists
        if (backgroundRect) {
          newSvgDocument.appendChild(backgroundRect.cloneNode(true));
        }

        // Calculate the translation values to center the original SVG content
        var translateX = (config.width - originalWidth) / 2;
        var translateY = (config.height - originalHeight) / 2;

        // Create a new <g> element to apply the translation
        var groupElement = document.createElementNS("http://www.w3.org/2000/svg", "g");
        groupElement.setAttribute("transform", 'translate(' + translateX + ', ' + translateY + ')');

        // Clone the original SVG's children (excluding the <rect>) into the new group element
        Array.from(svgDocument.documentElement.children).forEach(function (child) {
          if (child !== backgroundRect) {
            groupElement.appendChild(child.cloneNode(true));
          }
        });

        // Append the group element to the new SVG document
        newSvgDocument.appendChild(groupElement);

        // Add the new SVG to the DOM, but keep it hidden
        var container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.left = '-9999px'; // Hide it offscreen
        document.body.appendChild(container);

        container.appendChild(newSvgDocument);

        // Access the <g> element that wraps the logo content and calculate its bounding box
        var logoGroupElement = newSvgDocument.querySelector('g');
        if (logoGroupElement) {
          var boundingBox = logoGroupElement.getBBox();
          var logoWidth = boundingBox.width;
          var logoHeight = boundingBox.height;

          // Log the width and height of the logo
          // console.log(`Logo Width: ${logoWidth}, Logo Height: ${logoHeight}`);

          // Apply the scaling to make the logo 70% of the new SVG size
          var scaleFactor = Math.min(0.7 * config.width / logoWidth, 0.7 * config.height / logoHeight);
          var scaledTranslateX = (config.width - logoWidth * scaleFactor) / 2 - boundingBox.x * scaleFactor;
          var scaledTranslateY = (config.height - logoHeight * scaleFactor) / 2 - boundingBox.y * scaleFactor;
          logoGroupElement.setAttribute('transform', 'translate(' + scaledTranslateX + ', ' + scaledTranslateY + ') scale(' + scaleFactor + ')');
        }

        // Serialize the new SVG document back to a string
        var serializer = new XMLSerializer();
        var updatedSvgCode = serializer.serializeToString(newSvgDocument);

        // Save the updated SVG code string
        _this.files[config.name + '_svgcode'] = updatedSvgCode;

        // Encode the updated SVG code to Base64
        var base64Svg = btoa(encodeURIComponent(updatedSvgCode).replace(/%([0-9A-F]{2})/g, function (match, p1) {
          return String.fromCharCode('0x' + p1);
        }));

        // Save the base64 encoded SVG into corresponding files object
        _this.files[config.name + '_base64'] = 'data:image/svg+xml;base64,' + base64Svg;

        // Clean up the DOM by removing the offscreen container
        document.body.removeChild(container);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.logo_unique_id = this.$route.params.logo_unique_id;
    this.$emit('updatepath');
    axios.post('/dashboard/get-logo-data.php', {
      unique_id: this.logo_unique_id
    }).then(function (response) {
      if (response.data === 'volver a intentar el axios para cargar formdata' && _this2.retry_axios <= 3) {
        _this2.retry_axios = _this2.retry_axios + 1;
        _this2.propsdata[0].saving_logo = false;
        _this2.choose_logo(object);
      } else if (response.data === 'logo not found') {
        _this2.$router.push('/dashboard/get-profiles-and-covers/'); //redirect to select brand
      } else {
        _this2.retry_axios = 1;
        _this2.logo = response.data;
        _this2.setNewSvgSizes();
        _this2.loading = false;
      }
    }).catch(function (error) {
      console.log(error);
      this.retry_axios = 1;
    });
  },

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      hey: ''
    };
  },

  methods: {},
  mounted: function mounted() {
    this.$emit('updatepath');
  },

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['propsdata'],
    data: function data() {
        return {
            timenow: Date.now(),
            loading_business_cards: true,
            business_cards: [],
            dropdown: 'closed',
            business_card_to_delete: ''
        };
    },

    methods: {
        downloadSvgFile: function downloadSvgFile(unique_id) {
            // Get the front SVG element by ID
            var svgFrontElement = document.getElementById('svgFront-' + unique_id);

            // Check if the front SVG element exists
            if (svgFrontElement) {
                // Clone the SVG element to avoid altering the original
                var svgFrontClone = svgFrontElement.cloneNode(true);

                // Remove the preserveAspectRatio attribute
                svgFrontClone.removeAttribute("preserveAspectRatio");

                // Add width and height attributes
                svgFrontClone.setAttribute("width", "500");
                svgFrontClone.setAttribute("height", "250");

                // Get the SVG code as a string
                var svgFrontCode = svgFrontClone.outerHTML;

                // Create a Blob from the SVG code
                var blobFront = new Blob([svgFrontCode], { type: 'image/svg+xml' });

                // Create a URL for the Blob
                var urlFront = URL.createObjectURL(blobFront);

                // Create a temporary link element
                var downloadLinkFront = document.createElement('a');

                // Set the download attribute with a filename for the front SVG
                downloadLinkFront.download = 'business-card-front-' + unique_id + '.svg';

                // Set the href attribute to the Blob URL
                downloadLinkFront.href = urlFront;

                // Append the link to the document body (required for Firefox)
                document.body.appendChild(downloadLinkFront);

                // Programmatically click the link to trigger the download
                downloadLinkFront.click();

                // Clean up by removing the link and revoking the Blob URL
                document.body.removeChild(downloadLinkFront);
                URL.revokeObjectURL(urlFront);
            } else {
                console.error('SVG element with ID svgFront-' + unique_id + ' not found.');
            }

            // Get the back SVG element by ID
            var svgBackElement = document.getElementById('svgBack-' + unique_id);

            // Check if the back SVG element exists
            if (svgBackElement) {
                // Clone the SVG element to avoid altering the original
                var svgBackClone = svgBackElement.cloneNode(true);

                // Remove the preserveAspectRatio attribute
                svgBackClone.removeAttribute("preserveAspectRatio");

                // Add width and height attributes
                svgBackClone.setAttribute("width", "500");
                svgBackClone.setAttribute("height", "250");

                // Get the SVG code as a string
                var svgBackCode = svgBackClone.outerHTML;

                // Create a Blob from the SVG code
                var blobBack = new Blob([svgBackCode], { type: 'image/svg+xml' });

                // Create a URL for the Blob
                var urlBack = URL.createObjectURL(blobBack);

                // Create a temporary link element
                var downloadLinkBack = document.createElement('a');

                // Set the download attribute with a filename for the back SVG
                downloadLinkBack.download = 'business-card-back-' + unique_id + '.svg';

                // Set the href attribute to the Blob URL
                downloadLinkBack.href = urlBack;

                // Append the link to the document body (required for Firefox)
                document.body.appendChild(downloadLinkBack);

                // Programmatically click the link to trigger the download
                downloadLinkBack.click();

                // Clean up by removing the link and revoking the Blob URL
                document.body.removeChild(downloadLinkBack);
                URL.revokeObjectURL(urlBack);
            } else {
                console.error('SVG element with ID svgBack-' + unique_id + ' not found.');
            }
        },
        downloadPngFile: function downloadPngFile(unique_id) {
            // Helper function to download SVG as PNG
            var downloadSvgAsPng = function downloadSvgAsPng(svgElement, fileName, width, height) {
                if (svgElement) {
                    // Clone the SVG element to avoid altering the original
                    var svgClone = svgElement.cloneNode(true);

                    // Remove the preserveAspectRatio attribute
                    svgClone.removeAttribute("preserveAspectRatio");

                    // Add width and height attributes
                    svgClone.setAttribute("width", "500");
                    svgClone.setAttribute("height", "250");

                    // Get the SVG code as a string
                    var svgCode = svgClone.outerHTML;

                    // Create an image element
                    var img = new Image();

                    // Create a Blob from the SVG code
                    var blob = new Blob([svgCode], { type: 'image/svg+xml' });

                    // Create a URL for the Blob
                    var url = URL.createObjectURL(blob);

                    // Set the image source to the Blob URL
                    img.src = url;

                    // Wait for the image to load
                    img.onload = function () {
                        // Create a canvas element
                        var canvas = document.createElement('canvas');

                        // Set the canvas dimensions to the desired size
                        canvas.width = width;
                        canvas.height = height;

                        // Draw the image onto the canvas with the specified dimensions
                        var ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);

                        // Convert the canvas to a data URL in PNG format
                        var pngUrl = canvas.toDataURL('image/png');

                        // Create a temporary link element
                        var downloadLink = document.createElement('a');

                        // Set the download attribute with a filename
                        downloadLink.download = fileName;

                        // Set the href attribute to the PNG data URL
                        downloadLink.href = pngUrl;

                        // Append the link to the document body (required for Firefox)
                        document.body.appendChild(downloadLink);

                        // Programmatically click the link to trigger the download
                        downloadLink.click();

                        // Clean up by removing the link and revoking the Blob URL
                        document.body.removeChild(downloadLink);
                        URL.revokeObjectURL(url);
                    };
                } else {
                    console.error('SVG element with ID ' + fileName + ' not found.');
                }
            };

            // Set default dimensions for business card
            var width = 1000;
            var height = 500;

            // Download the front SVG as PNG
            var svgFrontElement = document.getElementById('svgFront-' + unique_id);
            downloadSvgAsPng(svgFrontElement, 'business-card-front-' + unique_id + '.png', width, height);

            // Download the back SVG as PNG
            var svgBackElement = document.getElementById('svgBack-' + unique_id);
            downloadSvgAsPng(svgBackElement, 'business-card-back-' + unique_id + '.png', width, height);
        },
        downloadPdfFile: function downloadPdfFile(unique_id) {
            var jsPDF = window.jspdf.jsPDF;

            // Assuming your SVG dimensions are known

            var width = 500; // Width of your SVG content
            var height = 250; // Height of your SVG content

            // Create a new jsPDF instance with custom size
            var doc = new jsPDF({
                orientation: 'landscape',
                unit: 'pt', // Points, since we're specifying exact sizes
                format: [width, height] // Set the PDF size to match the SVG dimensions
            });

            var svg2pdfFunc = window.svg2pdf.default || window.svg2pdf.svg2pdf;

            // Convert and add the first page
            var svgPage1 = document.getElementById('svgFront-' + unique_id);
            if (svgPage1) {
                // Clone the SVG element to avoid altering the original
                var svgPage1Clone = svgPage1.cloneNode(true);

                // Remove the preserveAspectRatio attribute
                svgPage1Clone.removeAttribute("preserveAspectRatio");

                // Add width and height attributes
                svgPage1Clone.setAttribute("width", "500");
                svgPage1Clone.setAttribute("height", "250");

                svg2pdfFunc(svgPage1Clone, doc, {
                    xOffset: 0,
                    yOffset: 0,
                    scale: 1 // Scale at 1 ensures it fits perfectly
                }).then(function () {
                    // Add a new page with the same dimensions
                    doc.addPage([width, height]);

                    // Convert and add the second page
                    var svgPage2 = document.getElementById('svgBack-' + unique_id);
                    if (svgPage2) {
                        // Clone the SVG element to avoid altering the original
                        var svgPage2Clone = svgPage2.cloneNode(true);

                        // Remove the preserveAspectRatio attribute
                        svgPage2Clone.removeAttribute("preserveAspectRatio");

                        // Add width and height attributes
                        svgPage2Clone.setAttribute("width", "500");
                        svgPage2Clone.setAttribute("height", "250");

                        svg2pdfFunc(svgPage2Clone, doc, {
                            xOffset: 0,
                            yOffset: 0,
                            scale: 1
                        }).then(function () {
                            // Save the PDF with a unique filename
                            doc.save("business-card-" + unique_id + ".pdf");
                        }).catch(function (error) {
                            console.error('Error converting second page:', error);
                            console.log('There was an issue generating the second page of the PDF. Please try again.');
                        });
                    } else {
                        console.error('SVG element with ID svgBack-' + unique_id + ' not found.');
                    }
                }).catch(function (error) {
                    console.error('Error converting first page:', error);
                    console.log('There was an issue generating the first page of the PDF. Please try again.');
                });
            } else {
                console.error('SVG element with ID svgFront-' + unique_id + ' not found.');
            }
        },
        calculateFontSize: function calculateFontSize(text, initialFontSize) {
            if (this.business_cards[0].template === '1') {
                var maxTextWidth = 230; // Maximum width for the text elements
            } else if (this.business_cards[0].template === '2') {
                var maxTextWidth = 255; // Maximum width for the text elements
            } else if (this.business_cards[0].template === '3') {
                var maxTextWidth = 180; // Maximum width for the text elements
            }
            var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            var tempText = document.createElementNS("http://www.w3.org/2000/svg", "text");
            tempText.setAttribute("font-family", "Arial");
            tempText.setAttribute("font-size", initialFontSize);
            tempText.textContent = text;
            svg.appendChild(tempText);
            document.body.appendChild(svg);

            var textWidth = tempText.getBBox().width;
            document.body.removeChild(svg);

            if (textWidth > maxTextWidth) {
                return initialFontSize * maxTextWidth / textWidth;
            } else {
                return initialFontSize;
            }
        },
        calculateGroupTransform: function calculateGroupTransform(index) {
            var _this = this;

            this.$nextTick(function () {
                var group = _this.$refs['textGroup-' + index][0];
                if (group) {
                    var svgHeight = 250;
                    var bbox = group.getBBox();
                    var offsetY = (svgHeight - bbox.height) / 2 - bbox.y;
                    group.setAttribute('transform', 'translate(0, ' + offsetY + ')');
                }
            });

            // Return a neutral or default value to avoid issues
            return 'translate(0, 0)';
        },
        getYPosition: function getYPosition(index, field) {
            var business_card = this.business_cards[index];
            var yPosition = 0;

            if (field === 'name') {
                return yPosition;
            }

            if (field === 'role') {
                if (business_card.name) {
                    yPosition += 30;
                }
                return yPosition;
            }

            if (field === 'phone') {
                if (business_card.name) {
                    yPosition += 30;
                }
                if (business_card.role) {
                    yPosition += 50;
                }
                return yPosition;
            }

            if (field === 'email') {
                if (business_card.name) {
                    yPosition += 30;
                }
                if (business_card.role) {
                    yPosition += 50;
                }
                if (business_card.phone) {
                    yPosition += 25;
                }
                return yPosition;
            }

            if (field === 'website') {
                if (business_card.name) {
                    yPosition += 30;
                }
                if (business_card.role) {
                    yPosition += 50;
                }
                if (business_card.phone) {
                    yPosition += 25;
                }
                if (business_card.email) {
                    yPosition += 25;
                }
                return yPosition;
            }

            if (field === 'address') {
                if (business_card.name) {
                    yPosition += 30;
                }
                if (business_card.role) {
                    yPosition += 50;
                }
                if (business_card.phone) {
                    yPosition += 25;
                }
                if (business_card.email) {
                    yPosition += 25;
                }
                if (business_card.website) {
                    yPosition += 25;
                }
                return yPosition;
            }

            return yPosition;
        },
        open_dropdown: function open_dropdown(index) {
            this.dropdown = index;
        },
        close_dropdown: function close_dropdown() {
            this.dropdown = 'closed';
        },
        open_modal_delete: function open_modal_delete(index) {
            this.business_card_to_delete = index;
        },
        close_modal_delete: function close_modal_delete() {
            this.business_card_to_delete = '';
        },
        delete_business_card: function delete_business_card() {
            axios.post('/dashboard/delete-business-card.php', {
                unique_id: this.business_cards[this.business_card_to_delete].unique_id
            });
            this.business_cards.splice(this.business_card_to_delete, 1);
            if (this.business_cards.length === 0) {
                this.business_cards = null;
            }
            this.business_card_to_delete = '';
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$emit('updatepath');
        axios.post('/dashboard/cargar-business-cards.php', {}).then(function (response) {
            _this2.business_cards = response.data;
            _this2.loading_business_cards = false;
        }).catch(function (error) {
            console.log(error);
        });
    },

    // do not forget this section
    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['propsdata'],
    data: function data() {
        return {
            loading_logos: true,
            timenow: Date.now(),
            step: '1',
            logos: [],
            logo_unique_id: '',
            logo_paid_svglogos_s3: '',
            template: '',
            creating_business_card: false,
            retry_axios: 1
        };
    },

    methods: {
        load_logos: function load_logos() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.propsdata[0].paid === '')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return new Promise(function (resolve) {
                                    return setTimeout(resolve, 100);
                                });

                            case 3:
                                _context.next = 0;
                                break;

                            case 5:
                                if (_this.propsdata[0].paid === 'yes') {
                                    axios.post('/dashboard/cargar-logos-unique-id.php', {}).then(function (response) {
                                        _this.logos = response.data;
                                        _this.loading_logos = false;
                                    }).catch(function (error) {
                                        console.log(error);
                                    });
                                } else {
                                    _this.$router.push('/dashboard/business-cards'); //redirect to business cards
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        back: function back() {
            if (this.step === '1') {
                this.$router.push('/dashboard/business-cards'); //redirect to business cards
            } else if (this.step === '2') {
                this.step = '1';
            }
        },
        choose_logo: function choose_logo(unique_id, paid_svglogos_s3) {
            this.logo_unique_id = unique_id;
            this.logo_paid_svglogos_s3 = paid_svglogos_s3;
            this.step = '2';
        },
        choose_template: function choose_template(num) {
            if (!this.creating_business_card) {
                this.creating_business_card = true;
                this.template = num;
                this.save_business_card();
            }
        },
        save_business_card: function save_business_card() {
            var _this2 = this;

            axios.post('/dashboard/save-business-card.php', {
                logo_unique_id: this.logo_unique_id,
                template: this.template,
                name: 'John Doe',
                role: 'CEO',
                email: 'hello@website.com',
                phone: '555 555-5555',
                website: 'www.mybrand.com',
                address: '123 Main Street Los Angeles',
                background_color: '#ffffff',
                name_color: '#000000',
                role_color: '#000000',
                phone_color: '#000000',
                email_color: '#000000',
                website_color: '#3f83f8',
                address_color: '#000000'
            }).then(function (response) {
                if (response.data === 'volver a intentar el axios para cargar formdata' && _this2.retry_axios <= 3) {
                    _this2.retry_axios = _this2.retry_axios + 1;
                    _this2.save_business_card();
                } else {
                    _this2.$router.push('/dashboard/edit-business-card/' + response.data); //redirect to business card editor
                    _this2.retry_axios = 1;
                    _this2.creating_business_card = false;
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    mounted: function mounted() {
        this.$emit('updateprops');
        this.load_logos();
    },

    // do not forget this section
    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['propsdata'],
    data: function data() {
        return {
            loading_business_card: true,
            timenow: Date.now(),
            tab: 'information',
            unique_id: '',
            template: '',
            modal_template: false,
            name: '',
            role: '',
            email: '',
            phone: '',
            website: '',
            address: '',
            logo_unique_id: '',
            modal_logo: false,
            loading_logos: true,
            logos: [],
            background_color: '#000000',
            name_color: '#000000',
            role_color: '#000000',
            phone_color: '#000000',
            email_color: '#000000',
            website_color: '#3f83f8',
            address_color: '#000000',
            paid_svglogos_s3: '',
            retry_axios: 1,
            finishing_business_card: false
        };
    },

    components: {
        draggable: window['vuedraggable']
    },
    methods: {
        load_business_card: function load_business_card() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.propsdata[0].paid === '')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return new Promise(function (resolve) {
                                    return setTimeout(resolve, 100);
                                });

                            case 3:
                                _context.next = 0;
                                break;

                            case 5:
                                if (_this.propsdata[0].paid === 'yes') {
                                    axios.post('/dashboard/cargar-business-card.php', {
                                        unique_id: _this.unique_id
                                    }).then(function (response) {
                                        if (response.data === 'volver a intentar el axios para cargar formdata' && _this.retry_axios <= 3) {
                                            _this.retry_axios = _this.retry_axios + 1;
                                        } else if (response.data === 'Business card does not exist') {
                                            _this.$router.push('/dashboard/business-cards'); //redirect to business cards
                                        } else {
                                            _this.logo_unique_id = response.data['logo_unique_id'];
                                            _this.template = response.data['template'];
                                            _this.name = response.data['name'];
                                            _this.role = response.data['role'];
                                            _this.email = response.data['email'];
                                            _this.phone = response.data['phone'];
                                            _this.website = response.data['website'];
                                            _this.address = response.data['address'];
                                            _this.background_color = response.data['background_color'];
                                            _this.name_color = response.data['name_color'];
                                            _this.role_color = response.data['role_color'];
                                            _this.phone_color = response.data['phone_color'];
                                            _this.email_color = response.data['email_color'];
                                            _this.website_color = response.data['website_color'];
                                            _this.address_color = response.data['address_color'];
                                            _this.paid_svglogos_s3 = response.data['paid_svglogos_s3'];
                                            _this.retry_axios = 1;
                                            _this.loading_business_card = false;
                                        }
                                    }).catch(function (error) {
                                        console.log(error);
                                    });
                                } else {
                                    _this.$router.push('/dashboard/business-cards'); //redirect to business cards
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        change_tab: function change_tab(text) {
            this.tab = text;
        },
        show_modal_template: function show_modal_template() {
            this.modal_template = true;
        },
        hide_modal_template: function hide_modal_template() {
            this.modal_template = false;
        },
        update_template: function update_template(num) {
            this.template = num;
            this.modal_template = false; //close modal
        },
        show_modal_logo: function show_modal_logo() {
            this.modal_logo = true;
            if (this.logos.length === 0) {
                this.load_logos();
            }
        },
        hide_modal_logo: function hide_modal_logo() {
            this.modal_logo = false;
        },
        update_logo: function update_logo(unique_id, where_is_file) {
            this.logo_unique_id = unique_id;
            this.paid_svglogos_s3 = where_is_file;
            this.modal_logo = false; //close modal
        },
        load_logos: function load_logos() {
            var _this2 = this;

            axios.post('/dashboard/cargar-logos-unique-id.php', {}).then(function (response) {
                _this2.logos = response.data;
                _this2.loading_logos = false;
            }).catch(function (error) {
                console.log(error);
            });
        },
        save_business_card: function save_business_card() {
            var _this3 = this;

            this.finishing_business_card = true;
            axios.post('/dashboard/save-business-card.php', {
                unique_id: this.unique_id,
                logo_unique_id: this.logo_unique_id,
                template: this.template,
                name: this.name,
                role: this.role,
                email: this.email,
                phone: this.phone,
                website: this.website,
                address: this.address,
                background_color: this.background_color,
                name_color: this.name_color,
                role_color: this.role_color,
                phone_color: this.phone_color,
                email_color: this.email_color,
                website_color: this.website_color,
                address_color: this.address_color
            }).then(function (response) {
                if (response.data === 'volver a intentar el axios para cargar formdata' && _this3.retry_axios <= 3) {
                    _this3.retry_axios = _this3.retry_axios + 1;
                    _this3.save_business_card();
                } else {
                    _this3.finishing_business_card = false;
                    _this3.retry_axios = 1;
                    _this3.$router.push('/dashboard/business-cards'); //redirect to business card editor
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        calculateFontSize: function calculateFontSize(text, initialFontSize) {
            if (this.template === '1') {
                var maxTextWidth = 230; // Maximum width for the text elements
            } else if (this.template === '2') {
                var maxTextWidth = 255; // Maximum width for the text elements
            } else if (this.template === '3') {
                var maxTextWidth = 180; // Maximum width for the text elements
            }
            var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            var tempText = document.createElementNS("http://www.w3.org/2000/svg", "text");
            tempText.setAttribute("font-family", "Arial");
            tempText.setAttribute("font-size", initialFontSize);
            tempText.textContent = text;
            svg.appendChild(tempText);
            document.body.appendChild(svg);

            var textWidth = tempText.getBBox().width;
            document.body.removeChild(svg);

            if (textWidth > maxTextWidth) {
                return initialFontSize * maxTextWidth / textWidth;
            } else {
                return initialFontSize;
            }
        },
        calculateGroupTransform: function calculateGroupTransform(index) {
            var _this4 = this;

            this.$nextTick(function () {
                var group = _this4.$refs['textGroup-' + index];
                if (group) {
                    var svgHeight = 250;
                    var bbox = group.getBBox();
                    var offsetY = (svgHeight - bbox.height) / 2 - bbox.y;
                    group.setAttribute('transform', 'translate(0, ' + offsetY + ')');
                }
            });

            // Return a neutral or default value to avoid issues
            return 'translate(0, 0)';
        },
        getYPosition: function getYPosition(field) {
            var yPosition = 0;

            if (field === 'name') {
                return yPosition;
            }

            if (field === 'role') {
                if (this.name) {
                    yPosition += 30;
                }
                return yPosition;
            }

            if (field === 'phone') {
                if (this.name) {
                    yPosition += 30;
                }
                if (this.role) {
                    yPosition += 50;
                }
                return yPosition;
            }

            if (field === 'email') {
                if (this.name) {
                    yPosition += 30;
                }
                if (this.role) {
                    yPosition += 50;
                }
                if (this.phone) {
                    yPosition += 25;
                }
                return yPosition;
            }

            if (field === 'website') {
                if (this.name) {
                    yPosition += 30;
                }
                if (this.role) {
                    yPosition += 50;
                }
                if (this.phone) {
                    yPosition += 25;
                }
                if (this.email) {
                    yPosition += 25;
                }
                return yPosition;
            }

            if (field === 'address') {
                if (this.name) {
                    yPosition += 30;
                }
                if (this.role) {
                    yPosition += 50;
                }
                if (this.phone) {
                    yPosition += 25;
                }
                if (this.email) {
                    yPosition += 25;
                }
                if (this.website) {
                    yPosition += 25;
                }
                return yPosition;
            }

            return yPosition;
        }
    },
    mounted: function mounted() {
        this.unique_id = this.$route.params.business_card_id;
        this.$emit('updateprops');
        this.load_business_card();
    },

    // do not forget this section
    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      timenow: Date.now(),
      loading_email_signatures: true,
      email_signatures: [],
      copied: '',
      dropdown: 'closed',
      email_signature_to_delete: ''
    };
  },

  methods: {
    copySignature: function copySignature(index) {
      var _this = this;

      var signature = document.getElementById('signature-' + index);
      var range = document.createRange();
      range.selectNode(signature);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      this.copied = index;
      setTimeout(function () {
        _this.copied = '';
      }, 1000);
    },
    open_dropdown: function open_dropdown(index) {
      this.dropdown = index;
    },
    close_dropdown: function close_dropdown() {
      this.dropdown = 'closed';
    },
    open_modal_delete: function open_modal_delete(index) {
      this.email_signature_to_delete = index;
    },
    close_modal_delete: function close_modal_delete() {
      this.email_signature_to_delete = '';
    },
    delete_email_signature: function delete_email_signature() {
      axios.post('/dashboard/delete-email-signature.php', {
        unique_id: this.email_signatures[this.email_signature_to_delete].unique_id
      });
      this.email_signatures.splice(this.email_signature_to_delete, 1);
      if (this.email_signatures.length === 0) {
        this.email_signatures = null;
      }
      this.email_signature_to_delete = '';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$emit('updatepath');
    axios.post('/dashboard/cargar-email-signatures.php', {}).then(function (response) {
      _this2.email_signatures = response.data;
      _this2.loading_email_signatures = false;
    }).catch(function (error) {
      console.log(error);
    });
  },

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['propsdata'],
    data: function data() {
        return {
            loading_logos: true,
            timenow: Date.now(),
            step: '1',
            logos: [],
            logo_unique_id: '',
            logo_paid_svglogos_s3: '',
            template: '',
            creating_email_signature: false,
            retry_axios: 1
        };
    },

    methods: {
        load_logos: function load_logos() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.propsdata[0].paid === '')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return new Promise(function (resolve) {
                                    return setTimeout(resolve, 100);
                                });

                            case 3:
                                _context.next = 0;
                                break;

                            case 5:
                                if (_this.propsdata[0].paid === 'yes') {
                                    axios.post('/dashboard/cargar-logos-unique-id.php', {}).then(function (response) {
                                        _this.logos = response.data;
                                        _this.loading_logos = false;
                                    }).catch(function (error) {
                                        console.log(error);
                                    });
                                } else {
                                    _this.$router.push('/dashboard/email-signatures'); //redirect to email signatures
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        back: function back() {
            if (this.step === '1') {
                this.$router.push('/dashboard/email-signatures'); //redirect to email signatures
            } else if (this.step === '2') {
                this.step = '1';
            }
        },
        choose_logo: function choose_logo(unique_id, paid_svglogos_s3) {
            this.logo_unique_id = unique_id;
            this.logo_paid_svglogos_s3 = paid_svglogos_s3;
            this.step = '2';
        },
        choose_template: function choose_template(num) {
            if (!this.creating_email_signature) {
                this.creating_email_signature = true;
                this.template = num;
                this.save_email_signature();
            }
        },
        save_email_signature: function save_email_signature() {
            var _this2 = this;

            axios.post('/dashboard/save-email-signature.php', {
                logo_unique_id: this.logo_unique_id,
                template: this.template,
                name: 'John Doe',
                role: 'CEO',
                email: 'hello@website.com',
                phone: '555 555-5555',
                website: 'https://example.com',
                company: 'Company Name',
                address: '123 Main Street Los Angeles',
                name_color: '#000000',
                subtitle_color: '#000000',
                links_color: '#3f83f8',
                powered_by: 'yes'
            }).then(function (response) {
                if (response.data === 'volver a intentar el axios para cargar formdata' && _this2.retry_axios <= 3) {
                    _this2.retry_axios = _this2.retry_axios + 1;
                    _this2.save_email_signature();
                } else {
                    _this2.$router.push('/dashboard/edit-email-signature/' + response.data); //redirect to email signature editor
                    _this2.retry_axios = 1;
                    _this2.creating_email_signature = false;
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    mounted: function mounted() {
        this.$emit('updateprops');
        this.load_logos();
    },

    // do not forget this section
    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['propsdata'],
    data: function data() {
        return {
            loading_email_signature: true,
            timenow: Date.now(),
            tab: 'information',
            unique_id: '',
            template: '',
            modal_template: false,
            name: '',
            role: '',
            email: '',
            phone: '',
            website: '',
            company: '',
            address: '',
            logo_unique_id: '',
            modal_logo: false,
            loading_logos: true,
            logos: [],
            social_links: [{ media: '', url: '' }],
            socialMediaBaseUrls: {
                ArtStation: 'https://artstation.com/',
                Behance: 'https://behance.net/',
                Discord: 'https://discord.com/',
                Facebook: 'https://facebook.com/',
                GitHub: 'https://github.com/',
                Instagram: 'https://instagram.com/',
                LinkedIn: 'https://linkedin.com/',
                Medium: 'https://medium.com/',
                Patreon: 'https://patreon.com/',
                Pinterest: 'https://pinterest.com/',
                Reddit: 'https://reddit.com/',
                Snapchat: 'https://snapchat.com/',
                TikTok: 'https://tiktok.com/',
                Tumblr: 'https://tumblr.com/',
                Twitch: 'https://twitch.tv/',
                Twitter: 'https://twitter.com/',
                Vimeo: 'https://vimeo.com/',
                Weibo: 'https://weibo.com/',
                WhatsApp: 'https://whatsapp.com/',
                X: 'https://x.com/',
                YouTube: 'https://youtube.com/'
            },
            name_color: '#000000',
            subtitle_color: '#000000',
            links_color: '#3f83f8',
            powered_by: '',
            paid_svglogos_s3: '',
            retry_axios: 1,
            finishing_email_signature: false
        };
    },

    components: {
        draggable: window['vuedraggable']
    },
    computed: {
        poweredByYesOrNo: function poweredByYesOrNo() {
            if (this.powered_by) {
                return 'yes';
            } else {
                return 'no';
            }
        }
    },
    methods: {
        load_email_signature: function load_email_signature() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.propsdata[0].paid === '')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return new Promise(function (resolve) {
                                    return setTimeout(resolve, 100);
                                });

                            case 3:
                                _context.next = 0;
                                break;

                            case 5:
                                if (_this.propsdata[0].paid === 'yes') {
                                    axios.post('/dashboard/cargar-email-signature.php', {
                                        unique_id: _this.unique_id
                                    }).then(function (response) {
                                        if (response.data === 'volver a intentar el axios para cargar formdata' && _this.retry_axios <= 3) {
                                            _this.retry_axios = _this.retry_axios + 1;
                                        } else if (response.data === 'Email signature does not exist') {
                                            _this.$router.push('/dashboard/email-signatures'); //redirect to email signatures
                                        } else {
                                            _this.logo_unique_id = response.data['logo_unique_id'];
                                            _this.template = response.data['template'];
                                            _this.name = response.data['name'];
                                            _this.role = response.data['role'];
                                            _this.email = response.data['email'];
                                            _this.phone = response.data['phone'];
                                            _this.website = response.data['website'];
                                            _this.company = response.data['company'];
                                            _this.address = response.data['address'];
                                            if (Array.isArray(response.data['social_links']) && response.data['social_links'].length > 0) {
                                                _this.social_links = response.data['social_links'];
                                            } else {
                                                _this.social_links = [];
                                            }
                                            _this.name_color = response.data['name_color'];
                                            _this.subtitle_color = response.data['subtitle_color'];
                                            _this.links_color = response.data['links_color'];
                                            if (response.data['powered_by'] === 'yes') {
                                                _this.powered_by = true;
                                            } else {
                                                _this.powered_by = false;
                                            }
                                            _this.paid_svglogos_s3 = response.data['paid_svglogos_s3'];
                                            _this.retry_axios = 1;
                                            _this.loading_email_signature = false;
                                        }
                                    }).catch(function (error) {
                                        console.log(error);
                                    });
                                } else {
                                    _this.$router.push('/dashboard/email-signatures'); //redirect to email signatures
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        change_tab: function change_tab(text) {
            this.tab = text;
        },
        addLink: function addLink() {
            this.social_links.push({ media: '', url: '' });
        },
        removeLink: function removeLink(index) {
            this.social_links.splice(index, 1);
        },
        show_modal_template: function show_modal_template() {
            this.modal_template = true;
        },
        hide_modal_template: function hide_modal_template() {
            this.modal_template = false;
        },
        update_template: function update_template(num) {
            this.template = num;
            this.modal_template = false; //close modal
        },
        show_modal_logo: function show_modal_logo() {
            this.modal_logo = true;
            if (this.logos.length === 0) {
                this.load_logos();
            }
        },
        hide_modal_logo: function hide_modal_logo() {
            this.modal_logo = false;
        },
        update_logo: function update_logo(unique_id, where_is_file) {
            this.logo_unique_id = unique_id;
            this.paid_svglogos_s3 = where_is_file;
            this.modal_logo = false; //close modal
        },
        load_logos: function load_logos() {
            var _this2 = this;

            axios.post('/dashboard/cargar-logos-unique-id.php', {}).then(function (response) {
                _this2.logos = response.data;
                _this2.loading_logos = false;
            }).catch(function (error) {
                console.log(error);
            });
        },
        save_email_signature: function save_email_signature() {
            var _this3 = this;

            this.finishing_email_signature = true;
            axios.post('/dashboard/save-email-signature.php', {
                unique_id: this.unique_id,
                logo_unique_id: this.logo_unique_id,
                template: this.template,
                name: this.name,
                role: this.role,
                email: this.email,
                phone: this.phone,
                website: this.website,
                company: this.company,
                address: this.address,
                social_links: this.social_links,
                name_color: this.name_color,
                subtitle_color: this.subtitle_color,
                links_color: this.links_color,
                powered_by: this.poweredByYesOrNo
            }).then(function (response) {
                if (response.data === 'volver a intentar el axios para cargar formdata' && _this3.retry_axios <= 3) {
                    _this3.retry_axios = _this3.retry_axios + 1;
                    _this3.save_email_signature();
                } else {
                    _this3.finishing_email_signature = false;
                    _this3.retry_axios = 1;
                    _this3.$router.push('/dashboard/set-up-email-signature/' + response.data); //redirect to email signature editor
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        updateUrl: function updateUrl(link) {
            // Check if the link has a media type and URL
            if (link.media && link.url) {
                // Get the base URL and domain for the selected social media platform
                var baseUrl = this.socialMediaBaseUrls[link.media];

                if (baseUrl) {
                    var baseDomain = baseUrl.replace('https://', '').replace('http://', '');

                    // If the URL does not start with http:// or https://
                    if (!link.url.startsWith('http://') && !link.url.startsWith('https://')) {
                        // If the URL starts with the base domain (e.g., 'facebook.com/xxxxxx'), prepend 'https://'
                        if (link.url.startsWith(baseDomain)) {
                            link.url = 'https://' + link.url;
                        } else {
                            // Otherwise, prepend the full base URL
                            link.url = '' + baseUrl + link.url;
                        }
                    }
                }
            }
        }
    },
    watch: {
        social_links: {
            handler: function handler() {
                var _this4 = this;

                this.social_links.forEach(function (link) {
                    _this4.updateUrl(link);
                });
            },

            deep: true // This tells Vue to watch for changes not only on the top-level property but also within its nested properties. It’s necessary when you want to watch changes within an array or object deeply.
        }
    },
    mounted: function mounted() {
        this.unique_id = this.$route.params.email_signature_id;
        this.$emit('updateprops');
        this.load_email_signature();
    },

    // do not forget this section
    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['propsdata'],
    data: function data() {
        return {
            loading_email_signature: true,
            timenow: Date.now(),
            unique_id: '',
            template: '',
            name: '',
            role: '',
            email: '',
            phone: '',
            website: '',
            company: '',
            address: '',
            logo_unique_id: '',
            social_links: [{ media: '', url: '' }],
            name_color: '#000000',
            subtitle_color: '#000000',
            links_color: '#3f83f8',
            powered_by: '',
            paid_svglogos_s3: '',
            retry_axios: 1,
            copied: false
        };
    },

    methods: {
        load_email_signature: function load_email_signature() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.propsdata[0].paid === '')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return new Promise(function (resolve) {
                                    return setTimeout(resolve, 100);
                                });

                            case 3:
                                _context.next = 0;
                                break;

                            case 5:
                                if (_this.propsdata[0].paid === 'yes') {
                                    axios.post('/dashboard/cargar-email-signature.php', {
                                        unique_id: _this.unique_id
                                    }).then(function (response) {
                                        if (response.data === 'volver a intentar el axios para cargar formdata' && _this.retry_axios <= 3) {
                                            _this.retry_axios = _this.retry_axios + 1;
                                        } else if (response.data === 'Email signature does not exist') {
                                            _this.$router.push('/dashboard/email-signatures'); //redirect to email signatures
                                        } else {
                                            _this.logo_unique_id = response.data['logo_unique_id'];
                                            _this.template = response.data['template'];
                                            _this.name = response.data['name'];
                                            _this.role = response.data['role'];
                                            _this.email = response.data['email'];
                                            _this.phone = response.data['phone'];
                                            _this.website = response.data['website'];
                                            _this.company = response.data['company'];
                                            _this.address = response.data['address'];
                                            if (Array.isArray(response.data['social_links']) && response.data['social_links'].length > 0) {
                                                _this.social_links = response.data['social_links'];
                                            } else {
                                                _this.social_links = [];
                                            }
                                            _this.name_color = response.data['name_color'];
                                            _this.subtitle_color = response.data['subtitle_color'];
                                            _this.links_color = response.data['links_color'];
                                            _this.powered_by = response.data['powered_by'];
                                            _this.paid_svglogos_s3 = response.data['paid_svglogos_s3'];
                                            _this.retry_axios = 1;
                                            _this.loading_email_signature = false;
                                        }
                                    }).catch(function (error) {
                                        console.log(error);
                                    });
                                } else {
                                    _this.$router.push('/dashboard/email-signatures'); //redirect to email signatures
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        copySignature: function copySignature() {
            var _this2 = this;

            var signature = document.getElementById('signature');
            var range = document.createRange();
            range.selectNode(signature);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
            this.copied = true;
            setTimeout(function () {
                _this2.copied = false;
            }, 1000);
        }
    },
    mounted: function mounted() {
        this.unique_id = this.$route.params.email_signature_id;
        this.$emit('updateprops');
        this.load_email_signature();
    },

    // do not forget this section
    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      timenow: Date.now(),
      loading_link_in_bios: true,
      link_in_bios: [],
      copied: '',
      dropdown: 'closed',
      link_in_bio_to_delete: ''
    };
  },

  methods: {
    copyLink: function copyLink(index) {
      var _this = this;

      var username = this.link_in_bios[index].username;
      navigator.clipboard.writeText('https://brand.bio/' + username).then(function () {
        _this.copied = index;
        // Optionally, you can reset `copied` after a delay
        setTimeout(function () {
          _this.copied = '';
        }, 2000);
      }).catch(function (err) {
        console.error('Failed to copy: ', err);
      });
    },
    open_dropdown: function open_dropdown(index) {
      this.dropdown = index;
    },
    close_dropdown: function close_dropdown() {
      this.dropdown = 'closed';
    },
    open_modal_delete: function open_modal_delete(index) {
      this.link_in_bio_to_delete = index;
    },
    close_modal_delete: function close_modal_delete() {
      this.link_in_bio_to_delete = '';
    },
    delete_link_in_bio: function delete_link_in_bio() {
      axios.post('/dashboard/delete-link-in-bio.php', {
        unique_id: this.link_in_bios[this.link_in_bio_to_delete].unique_id
      });
      this.link_in_bios.splice(this.link_in_bio_to_delete, 1);
      if (this.link_in_bios.length === 0) {
        this.link_in_bios = null;
      }
      this.link_in_bio_to_delete = '';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$emit('updatepath');
    axios.post('/dashboard/cargar-link-in-bios.php', {}).then(function (response) {
      _this2.link_in_bios = response.data;
      _this2.loading_link_in_bios = false;
    }).catch(function (error) {
      console.log(error);
    });
  },

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['propsdata'],
    data: function data() {
        return {
            loading_logos: true,
            timenow: Date.now(),
            step: '1',
            logos: [],
            logo_unique_id: '',
            profile_image: '',
            profile_image_error: '',
            profile_title: '',
            description: '',
            links: [{ media: '', text: '', url: '' }],
            socialMediaBaseUrls: {
                'Apple App Store': 'https://apps.apple.com/',
                ArtStation: 'https://artstation.com/',
                Behance: 'https://behance.net/',
                Discord: 'https://discord.com/',
                Facebook: 'https://facebook.com/',
                GitHub: 'https://github.com/',
                'Google Play Store': 'https://play.google.com/',
                Instagram: 'https://instagram.com/',
                LinkedIn: 'https://linkedin.com/',
                Medium: 'https://medium.com/',
                Patreon: 'https://patreon.com/',
                Pinterest: 'https://pinterest.com/',
                Reddit: 'https://reddit.com/',
                Snapchat: 'https://snapchat.com/',
                TikTok: 'https://tiktok.com/',
                Tumblr: 'https://tumblr.com/',
                Twitch: 'https://twitch.tv/',
                Twitter: 'https://twitter.com/',
                Vimeo: 'https://vimeo.com/',
                Weibo: 'https://weibo.com/',
                WhatsApp: 'https://whatsapp.com/',
                X: 'https://x.com/',
                YouTube: 'https://youtube.com/',
                Email: 'mailto:',
                Globe: 'https://'
            },
            username: '',
            creating_link_in_bio: false,
            retry_axios: 1,
            isButtonFixed: false // Track if the button should be fixed
        };
    },

    components: {
        draggable: window['vuedraggable']
    },
    methods: {
        load_logos: function load_logos() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.propsdata[0].paid === '')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return new Promise(function (resolve) {
                                    return setTimeout(resolve, 100);
                                });

                            case 3:
                                _context.next = 0;
                                break;

                            case 5:
                                if (_this.propsdata[0].paid === 'yes') {
                                    axios.post('/dashboard/cargar-logos-unique-id.php', {}).then(function (response) {
                                        _this.logos = response.data;
                                        if (response.data === null || response.data.length <= 0) {
                                            //check if user has logos
                                            _this.step = '2';
                                        }
                                        _this.loading_logos = false;
                                        _this.checkContentHeight(); //re-run follow function to re-arrange height
                                    }).catch(function (error) {
                                        console.log(error);
                                    });
                                } else {
                                    _this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        back: function back() {
            if (this.step === '1') {
                this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio
            } else if (this.step === '2') {
                if (this.logos === null || this.logos.length <= 0) {
                    //check if user has logos
                    this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio
                } else {
                    this.step = '1';
                    this.checkContentHeight(); //re-run follow function to re-arrange height
                }
            } else if (this.step === '3') {
                this.step = '2';
                this.checkContentHeight(); //re-run follow function to re-arrange height
            }
        },
        choose_logo: function choose_logo(unique_id, paid_svglogos_s3) {
            this.logo_unique_id = unique_id;
            this.paid_svglogos_s3 = paid_svglogos_s3;
            this.profile_image = '';
            this.step = '2';
            this.checkContentHeight(); //re-run follow function to re-arrange height
        },
        UploadProfileImage: function UploadProfileImage(e) {
            var _this2 = this;

            this.profile_image_error = '';
            var file = e.target.files[0]; // Get the first file
            var reader = new FileReader();
            if (file['size'] < 2000000) {
                reader.onloadend = function (file) {
                    var landing = reader.result;
                    // console.log(reader.result);
                    _this2.profile_image = landing;
                    _this2.logo_unique_id = '';
                };
                reader.readAsDataURL(file);
            } else {
                this.profile_image_error = 'File is too big, please submit an image smaller than 2MB.';
            }
        },
        updateMediaAndText: function updateMediaAndText(index) {
            this.links[index].text = this.links[index].media;
        },
        addLink: function addLink() {
            this.links.push({ media: '', text: '', url: '' });
        },
        removeLink: function removeLink(index) {
            this.links.splice(index, 1);
        },
        continue_method: function continue_method() {
            if (this.step === '1') {
                this.step = '2';
                this.checkContentHeight(); //re-run follow function to re-arrange height
            } else if (this.step === '2') {
                this.step = '3';
            } else if (this.step === '3') {
                if (!this.creating_link_in_bio) {
                    this.creating_link_in_bio = true;
                    this.save_link_in_bio();
                }
            }
        },
        save_link_in_bio: function save_link_in_bio() {
            var _this3 = this;

            this.username_unavailable = false;
            this.username_invalid_characters = false;
            axios.post('/dashboard/save-link-in-bio.php', {
                username: this.username,
                profile_image: this.profile_image,
                logo_unique_id: this.logo_unique_id,
                profile_title: this.profile_title,
                description: this.description,
                links: this.links,
                background_color: '#ffffff',
                button_color: '#000000',
                button_text_color: '#ffffff',
                button_icon_color: '#ffffff',
                button_shadow_color: '#dddddd',
                button_style: '1',
                button_shape: '1',
                icon_color: '#000000',
                font_color: '#000000',
                powered_by: 'yes'
            }).then(function (response) {
                if (response.data === 'volver a intentar el axios para cargar formdata' && _this3.retry_axios <= 3) {
                    _this3.retry_axios = _this3.retry_axios + 1;
                    _this3.save_link_in_bio();
                } else {
                    if (response.data === 'username unavailable') {
                        _this3.username_unavailable = true;
                        _this3.retry_axios = 1;
                        _this3.creating_link_in_bio = false;
                    } else if (response.data === 'username contains invalid characters') {
                        _this3.username_invalid_characters = true;
                        _this3.retry_axios = 1;
                        _this3.creating_link_in_bio = false;
                    } else {
                        _this3.$router.push('/dashboard/edit-link-in-bio/' + response.data); //redirect to link in bio editor
                        _this3.retry_axios = 1;
                        _this3.creating_link_in_bio = false; // Set to false after navigation completes
                    }
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        checkContentHeight: function checkContentHeight() {
            var _this4 = this;

            this.$nextTick(function () {
                var contentHeight = document.body.scrollHeight;
                var windowHeight = window.innerHeight;

                // console.log('contentHeight: '+contentHeight+', windowHeight: '+windowHeight);

                if (contentHeight > windowHeight) {
                    _this4.isButtonFixed = true;
                } else {
                    _this4.isButtonFixed = false;
                }
            });
        }
    },
    watch: {
        links: {
            handler: function handler() {
                this.checkContentHeight();
            },

            deep: true // This tells Vue to watch for changes not only on the top-level property but also within its nested properties. It’s necessary when you want to watch changes within an array or object deeply.
        },
        username: function username() {
            this.username_unavailable = false;
            this.username_invalid_characters = false;
        }
    },
    mounted: function mounted() {
        this.$emit('updateprops');
        this.load_logos();
        window.addEventListener('resize', this.checkContentHeight);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.checkContentHeight);
    },

    // do not forget this section
    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['propsdata'],
    data: function data() {
        return {
            loading_link_in_bio: true,
            timenow: Date.now(),
            tab: 'content',
            unique_id: '',
            username: '',
            new_username: '',
            updating_username: false,
            username_unavailable: false,
            username_invalid_characters: false,
            username_updated: false,
            username_already_yours: false,
            sections: [],
            modal_sections: false,
            modal_logo: false,
            loading_logos: true,
            logos: [],
            logo_unique_id: '',
            paid_svglogos_s3: '',
            profile_image_error: false,
            profile_image_s3: '',
            socialMediaBaseUrls: {
                'Apple App Store': 'https://apps.apple.com/',
                ArtStation: 'https://artstation.com/',
                Behance: 'https://behance.net/',
                Discord: 'https://discord.com/',
                Facebook: 'https://facebook.com/',
                GitHub: 'https://github.com/',
                'Google Play Store': 'https://play.google.com/',
                Instagram: 'https://instagram.com/',
                LinkedIn: 'https://linkedin.com/',
                Medium: 'https://medium.com/',
                Patreon: 'https://patreon.com/',
                Pinterest: 'https://pinterest.com/',
                Reddit: 'https://reddit.com/',
                Snapchat: 'https://snapchat.com/',
                TikTok: 'https://tiktok.com/',
                Tumblr: 'https://tumblr.com/',
                Twitch: 'https://twitch.tv/',
                Twitter: 'https://twitter.com/',
                Vimeo: 'https://vimeo.com/',
                Weibo: 'https://weibo.com/',
                WhatsApp: 'https://whatsapp.com/',
                X: 'https://x.com/',
                YouTube: 'https://youtube.com/',
                Email: 'mailto:',
                Globe: 'https://'
            },
            background_color: '',
            button_color: '',
            button_text_color: '',
            button_icon_color: '',
            button_shadow_color: '',
            button_style: '',
            button_shape: '',
            icon_color: '',
            font_color: '',
            powered_by: '',
            retry_axios: 1,
            publishing_link_in_bio: false
        };
    },

    components: {
        draggable: window['vuedraggable']
    },
    computed: {
        poweredByYesOrNo: function poweredByYesOrNo() {
            if (this.powered_by) {
                return 'yes';
            } else {
                return 'no';
            }
        }
    },
    methods: {
        load_link_in_bio: function load_link_in_bio() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.propsdata[0].paid === '')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return new Promise(function (resolve) {
                                    return setTimeout(resolve, 100);
                                });

                            case 3:
                                _context.next = 0;
                                break;

                            case 5:
                                if (_this.propsdata[0].paid === 'yes') {
                                    axios.post('/dashboard/cargar-link-in-bio.php', {
                                        unique_id: _this.unique_id
                                    }).then(function (response) {
                                        if (response.data === 'volver a intentar el axios para cargar formdata' && _this.retry_axios <= 3) {
                                            _this.retry_axios = _this.retry_axios + 1;
                                        } else if (response.data === 'Link in bio does not exist') {
                                            _this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio
                                        } else {
                                            _this.username = response.data['username'];
                                            _this.new_username = response.data['username'];
                                            if (Array.isArray(response.data['json_column']) && response.data['json_column'].length > 0) {
                                                _this.sections = response.data['json_column'];
                                            } else {
                                                _this.sections = [{ type: 'Profile Information', profile_image: '', profile_title: '', description: '' }, { type: 'Social Icons', social_icons: [{ media: '', url: '' }] }, { type: 'Your Links', links: [{ media: '', text: '', url: '' }] }];
                                            }
                                            // design
                                            _this.background_color = response.data['background_color'];
                                            _this.button_color = response.data['button_color'];
                                            _this.button_text_color = response.data['button_text_color'];
                                            _this.button_icon_color = response.data['button_icon_color'];
                                            _this.button_shadow_color = response.data['button_shadow_color'];
                                            _this.button_style = response.data['button_style'];
                                            _this.button_shape = response.data['button_shape'];
                                            _this.icon_color = response.data['icon_color'];
                                            _this.font_color = response.data['font_color'];
                                            if (response.data['powered_by'] === 'yes') {
                                                _this.powered_by = true;
                                            } else {
                                                _this.powered_by = false;
                                            }
                                            _this.profile_image_s3 = response.data['profile_image_s3'];
                                            _this.logo_unique_id = response.data['logo_unique_id'];
                                            _this.paid_svglogos_s3 = response.data['paid_svglogos_s3'];
                                            _this.retry_axios = 1;
                                            _this.loading_link_in_bio = false;
                                        }
                                    }).catch(function (error) {
                                        console.log(error);
                                    });
                                } else {
                                    _this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        change_tab: function change_tab(text) {
            this.tab = text;
        },
        addSocialIcon: function addSocialIcon(section_index) {
            this.sections[section_index].social_icons.push({ media: '', url: '' });
        },
        removeSocialIcon: function removeSocialIcon(section_index, social_icons_index) {
            this.sections[section_index].social_icons.splice(social_icons_index, 1);
        },
        addLink: function addLink(section_index) {
            this.sections[section_index].links.push({ media: '', text: '', url: '' });
        },
        removeLink: function removeLink(section_index, links_index) {
            this.sections[section_index].links.splice(links_index, 1);
        },
        show_modal_sections: function show_modal_sections() {
            this.modal_sections = true;
        },
        hide_modal_sections: function hide_modal_sections() {
            this.modal_sections = false;
        },
        addSection: function addSection(section) {
            if (section === 'Social Icons') {
                this.sections.push({ type: 'Social Icons', social_icons: [] });
            } else if (section === 'Your Links') {
                this.sections.push({ type: 'Your Links', links: [] });
            } else if (section === 'Text') {
                this.sections.push({ type: 'Text', text: '' });
            } else if (section === 'Address') {
                this.sections.push({ type: 'Address', address_line_1: '', address_line_2: '', city: '', state_province: '', zip: '', country: '' });
            }
            this.modal_sections = false;
            // Scroll to the bottom of the sidebar
            this.$nextTick(function () {
                if (window.innerWidth <= 991) {
                    //sidebar mobile se esta mostrando
                    var sidebar = document.querySelector('.scroll_to_last_item_sidebar_mobile');
                    sidebar.scrollTo({ top: sidebar.scrollHeight, behavior: 'smooth' });
                } else {
                    //sidebar desktop se esta mostrando
                    var _sidebar = document.querySelector('.scroll_to_last_item_sidebar');
                    _sidebar.scrollTo({ top: _sidebar.scrollHeight, behavior: 'smooth' });
                }
            });
        },
        deleteSection: function deleteSection(section_index) {
            this.sections.splice(section_index, 1);
        },
        UploadProfileImage: function UploadProfileImage(e) {
            var _this2 = this;

            this.profile_image_error = '';
            var file = e.target.files[0]; // Get the first file
            var reader = new FileReader();
            if (file['size'] < 2000000) {
                reader.onloadend = function (file) {
                    var landing = reader.result;
                    // console.log(reader.result);
                    // Find the object where type is 'Profile Information'
                    var profileInfo = _this2.sections.find(function (section) {
                        return section.type === 'Profile Information';
                    });
                    // Update the profile_image property if the object is found
                    if (profileInfo) {
                        profileInfo.profile_image = landing;
                    }
                    _this2.profile_image_s3 = 'data:image';
                    _this2.logo_unique_id = '';
                };
                reader.readAsDataURL(file);
            } else {
                this.profile_image_error = 'File is too big, please submit an image smaller than 2MB.';
            }
        },
        show_modal_logo: function show_modal_logo() {
            this.modal_logo = true;
            if (this.logos.length === 0) {
                this.load_logos();
            }
        },
        hide_modal_logo: function hide_modal_logo() {
            this.modal_logo = false;
        },
        update_logo: function update_logo(unique_id, where_is_file) {
            this.logo_unique_id = unique_id;
            this.paid_svglogos_s3 = where_is_file;
            // Find the object where type is 'Profile Information'
            var profileInfo = this.sections.find(function (section) {
                return section.type === 'Profile Information';
            });
            // Update the profile_image property if the object is found
            if (profileInfo) {
                profileInfo.profile_image = '';
            }
            this.profile_image_s3 = '';
            this.modal_logo = false; //close modal
        },
        load_logos: function load_logos() {
            var _this3 = this;

            axios.post('/dashboard/cargar-logos-unique-id.php', {}).then(function (response) {
                _this3.logos = response.data;
                _this3.loading_logos = false;
            }).catch(function (error) {
                console.log(error);
            });
        },
        update_username: function update_username() {
            var _this4 = this;

            this.username_unavailable = false;
            this.username_invalid_characters = false;
            this.username_already_yours = false;
            this.username_updated = false;
            //update only if new_username is different
            if (this.username === this.new_username) {
                this.username_already_yours = true;
                setTimeout(function () {
                    _this4.username_already_yours = false;
                }, 4000); // 4000 milliseconds = 4 second
            } else {
                this.updating_username = true;
                axios.post('/dashboard/update-username-link-in-bio.php', {
                    unique_id: this.unique_id,
                    new_username: this.new_username
                }).then(function (response) {
                    if (response.data === 'volver a intentar el axios para cargar formdata' && _this4.retry_axios <= 3) {
                        _this4.retry_axios = _this4.retry_axios + 1;
                        _this4.update_username();
                    } else {
                        if (response.data === 'username unavailable') {
                            _this4.username_unavailable = true;
                        } else if (response.data === 'username contains invalid characters') {
                            _this4.username_invalid_characters = true;
                        } else {
                            _this4.username_updated = true;
                            _this4.username = response.data;
                            setTimeout(function () {
                                _this4.username_updated = false;
                            }, 4000); // 4000 milliseconds = 4 second
                        }
                        _this4.updating_username = false;
                        _this4.retry_axios = 1;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        },
        save_link_in_bio: function save_link_in_bio() {
            var _this5 = this;

            this.publishing_link_in_bio = true;
            axios.post('/dashboard/save-link-in-bio.php', {
                unique_id: this.unique_id,
                username: this.username,
                profile_image: this.profile_image,
                profile_image_s3: this.profile_image_s3,
                logo_unique_id: this.logo_unique_id,
                sections: this.sections,
                background_color: this.background_color,
                button_color: this.button_color,
                button_text_color: this.button_text_color,
                button_icon_color: this.button_icon_color,
                button_shadow_color: this.button_shadow_color,
                button_style: this.button_style,
                button_shape: this.button_shape,
                icon_color: this.icon_color,
                font_color: this.font_color,
                powered_by: this.poweredByYesOrNo
            }).then(function (response) {
                if (response.data === 'volver a intentar el axios para cargar formdata' && _this5.retry_axios <= 3) {
                    _this5.retry_axios = _this5.retry_axios + 1;
                    _this5.save_link_in_bio();
                } else {
                    _this5.publishing_link_in_bio = false;
                    _this5.retry_axios = 1;
                    _this5.$router.push('/dashboard/link-in-bio'); //redirect to link in bio editor
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    watch: {
        new_username: function new_username() {
            this.username_unavailable = false;
            this.username_invalid_characters = false;
        }
    },
    mounted: function mounted() {
        this.unique_id = this.$route.params.link_in_bio_id;
        this.$emit('updateprops');
        this.load_link_in_bio();
        this.load_logos();
    },

    // do not forget this section
    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {};
  },

  methods: {},
  mounted: function mounted() {},

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      loading: true,
      changepassword_toggle: false,
      password: '',
      savingpassword: false,
      shortpassword: false,
      saving: false,
      cancelling: false,
      canceled: false,
      cancellation_error: false
    };
  },

  methods: {
    guardarname: function guardarname() {
      var _this = this;

      this.saving = true;
      axios.post('/dashboard/enviar-account.php', {
        name: this.propsdata[0].name
      }).then(function (response) {
        _this.saving = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    guardarpassword: function guardarpassword() {
      var _this2 = this;

      this.savingpassword = true;
      axios.post('/dashboard/edit-password.php', {
        password: this.password
      }).then(function (response) {
        if (response.data == 'Password must be at least 6 characters') {
          _this2.shortpassword = true;
        } else {
          _this2.shortpassword = false;
          _this2.propsdata[0].password = 'submitted';
          _this2.password = '';
          _this2.changepassword_toggle = false;
        }
        _this2.savingpassword = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    changepassword: function changepassword() {
      this.changepassword_toggle = true;
    },
    cancel_changepassword: function cancel_changepassword() {
      this.changepassword_toggle = false;
    }
  },
  mounted: function mounted() {
    this.loading = false;
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      loading: true,
      billing: [],
      cards: [],
      invoices: [],
      moreinformation: false
    };
  },

  methods: {
    cargarcards: function cargarcards() {
      var _this = this;

      //CARGAR CARDS
      axios.post('/dashboard/cargar-cards.php', {}).then(function (response) {
        _this.cards = response.data;
        _this.cargarinvoices();
      }).catch(function (error) {
        console.log(error);
      });
    },
    cargarinvoices: function cargarinvoices() {
      var _this2 = this;

      //CARGAR INVOICES
      axios.post('/dashboard/cargar-invoices.php', {}).then(function (response) {
        _this2.invoices = response.data;
        _this2.loading = false;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    this.$emit('updateprops');
    this.cargarcards(); //METHOD cargarinvoices EXECUTES AFTER cargarcards HAS A RESPOND
  },

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      loading_edit: false,
      clientname: '',
      streetaddress: '',
      location: '',
      zipcode: '',
      phonenumber: '',
      required: false
    };
  },

  methods: {
    guardarbilling: function guardarbilling() {
      var _this = this;

      this.loading_edit = true;
      axios.post('/dashboard/edit-billing.php', {
        clientname: this.clientname,
        streetaddress: this.streetaddress,
        location: this.location,
        zipcode: this.zipcode,
        phonenumber: this.phonenumber
      }).then(function (response) {
        if (response.data == 'required') {
          _this.required = true;
        } else {
          _this.required = false;
          _this.$router.push('/dashboard/billing');
        }
        _this.loading_edit = false;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$emit('updateprops');
    //BILLING
    axios.post('/dashboard/cargar-billing.php', {}).then(function (response) {
      _this2.clientname = response.data[0].clientname;
      _this2.streetaddress = response.data[0].streetaddress;
      _this2.location = response.data[0].location;
      _this2.zipcode = response.data[0].zipcode;
      _this2.phonenumber = response.data[0].phonenumber;
      _this2.loading = false;
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['propsdata'],
  data: function data() {
    return {
      reason: '',
      other_reason: '',
      saving: false,
      select_reason: false,
      fill_reason: false,
      are_you_sure: false,
      cancelling: false,
      canceled: false,
      cancellation_error: false
    };
  },

  methods: {
    save_reason: function save_reason() {
      var _this = this;

      if (this.reason == '') {
        this.select_reason = true;
      } else {
        if (this.reason == '4' && this.other_reason == '') {
          this.fill_reason = true;
        } else {
          this.select_reason = false;
          this.fill_reason = false;
          this.saving = true;
          axios.post('/dashboard/save-reason.php', {
            token: lukastoken,
            reason: this.reason,
            other_reason: this.other_reason
          }).then(function (response) {
            _this.are_you_sure = true;
          }).catch(function (error) {
            console.log(error);
          });
        }
      }
    },
    cancel: function cancel() {
      var _this2 = this;

      this.cancellation_error = false;
      this.cancelling = true;
      axios.post('https://logo.app/user-cancel-subscription', {
        token: lukastoken
      }).then(function (response) {
        _this2.cancelling = false;
        _this2.canceled = true;
      }).catch(function (error) {
        console.log(error);
        _this2.cancelling = false;
        _this2.cancellation_error = true;
      });
    }
  },
  mounted: function mounted() {
    this.$emit('updateprops');
  },

  // do not forget this section
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidebar_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__manage_bar_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bookmarked_logos_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__get_logo_files_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logo_files_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__get_profiles_and_covers_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__profiles_and_covers_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__exclusive_deals_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__business_cards_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__create_business_card_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__edit_business_card_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__email_signatures_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__create_email_signature_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__edit_email_signature_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__set_up_email_signature_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__link_in_bio_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__create_link_in_bio_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__edit_link_in_bio_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__account_tabs_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__account_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__billing_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__edit_billing_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__cancel_reasons_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_headful__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_headful___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_headful__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_cookies__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_regenerator_runtime_runtime__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_regenerator_runtime_runtime__);






























//issues with async await methods


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_29_vue_cookies___default.a);

var routes = [{ name: 'index', path: '/dashboard/', component: __WEBPACK_IMPORTED_MODULE_6__index_vue__["a" /* default */] }, { name: 'index', path: '/dashboard/index', component: __WEBPACK_IMPORTED_MODULE_6__index_vue__["a" /* default */] }, { name: 'bookmarked-logos', path: '/dashboard/bookmarked-logos', component: __WEBPACK_IMPORTED_MODULE_7__bookmarked_logos_vue__["a" /* default */] }, { name: 'get-logo-files', path: '/dashboard/get-logo-files', component: __WEBPACK_IMPORTED_MODULE_8__get_logo_files_vue__["a" /* default */] }, { name: 'logo-files', path: '/dashboard/logo-files/:logo_unique_id', component: __WEBPACK_IMPORTED_MODULE_9__logo_files_vue__["a" /* default */] }, { name: 'get-profiles-and-covers', path: '/dashboard/get-profiles-and-covers', component: __WEBPACK_IMPORTED_MODULE_10__get_profiles_and_covers_vue__["a" /* default */] }, { name: 'profiles-and-covers', path: '/dashboard/profiles-and-covers/:logo_unique_id', component: __WEBPACK_IMPORTED_MODULE_11__profiles_and_covers_vue__["a" /* default */] }, { name: 'exclusive-deals', path: '/dashboard/exclusive-deals', component: __WEBPACK_IMPORTED_MODULE_12__exclusive_deals_vue__["a" /* default */] }, { name: 'business-cards', path: '/dashboard/business-cards', component: __WEBPACK_IMPORTED_MODULE_13__business_cards_vue__["a" /* default */] }, { name: 'create-business-card', path: '/dashboard/create-business-card', component: __WEBPACK_IMPORTED_MODULE_14__create_business_card_vue__["a" /* default */] }, { name: 'edit-business-card', path: '/dashboard/edit-business-card/:business_card_id', component: __WEBPACK_IMPORTED_MODULE_15__edit_business_card_vue__["a" /* default */] }, { name: 'email-signatures', path: '/dashboard/email-signatures', component: __WEBPACK_IMPORTED_MODULE_16__email_signatures_vue__["a" /* default */] }, { name: 'create-email-signature', path: '/dashboard/create-email-signature', component: __WEBPACK_IMPORTED_MODULE_17__create_email_signature_vue__["a" /* default */] }, { name: 'edit-email-signature', path: '/dashboard/edit-email-signature/:email_signature_id', component: __WEBPACK_IMPORTED_MODULE_18__edit_email_signature_vue__["a" /* default */] }, { name: 'set-up-email-signature', path: '/dashboard/set-up-email-signature/:email_signature_id', component: __WEBPACK_IMPORTED_MODULE_19__set_up_email_signature_vue__["a" /* default */] }, { name: 'link-in-bio', path: '/dashboard/link-in-bio', component: __WEBPACK_IMPORTED_MODULE_20__link_in_bio_vue__["a" /* default */] }, { name: 'create-link-in-bio', path: '/dashboard/create-link-in-bio', component: __WEBPACK_IMPORTED_MODULE_21__create_link_in_bio_vue__["a" /* default */] }, { name: 'edit-link-in-bio', path: '/dashboard/edit-link-in-bio/:link_in_bio_id', component: __WEBPACK_IMPORTED_MODULE_22__edit_link_in_bio_vue__["a" /* default */] }, { name: 'account', path: '/dashboard/account', component: __WEBPACK_IMPORTED_MODULE_24__account_vue__["a" /* default */] }, { name: 'billing', path: '/dashboard/billing', component: __WEBPACK_IMPORTED_MODULE_25__billing_vue__["a" /* default */] }, { name: 'edit-billing', path: '/dashboard/edit-billing', component: __WEBPACK_IMPORTED_MODULE_26__edit_billing_vue__["a" /* default */] }, { name: 'cancel-reasons', path: '/dashboard/cancel-reasons', component: __WEBPACK_IMPORTED_MODULE_27__cancel_reasons_vue__["a" /* default */] }];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: routes,
  mode: 'history'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-header', __WEBPACK_IMPORTED_MODULE_3__Header_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('sidebar-header', __WEBPACK_IMPORTED_MODULE_4__sidebar_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('manage-bar', __WEBPACK_IMPORTED_MODULE_5__manage_bar_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('account-header', __WEBPACK_IMPORTED_MODULE_23__account_tabs_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('vue-headful', __WEBPACK_IMPORTED_MODULE_28_vue_headful___default.a);

var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: router,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */]);
  }
});
window.vm = vm;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.16
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.16';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(33).setImmediate))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(34);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(35)))

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43fe6b1a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(41);
function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43fe6b1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43fe6b1a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(39);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("baa6beda", content, true, {});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".anima-enter[data-v-43fe6b1a]{opacity:0}.anima-enter-active[data-v-43fe6b1a]{transition:opacity .2s;animation:slidein-data-v-43fe6b1a .2s ease-out forwards}.anima-leave-active[data-v-43fe6b1a]{transition:opacity .2s;opacity:0;animation:slideout-data-v-43fe6b1a .2s ease-out forwards}@keyframes slidein-data-v-43fe6b1a{0%{transform:translateY(-20px)}to{transform:translateY(0)}}@keyframes slideout-data-v-43fe6b1a{0%{transform:translateY(0)}to{transform:translateY(20px)}}", ""]);

// exports


/***/ }),
/* 40 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.propsdata[0]['account'] && _vm.propsdata[0]['verified'] && _vm.propsdata[0]['verified'].length === 50 && ['index','bookmarked-logos','exclusive-deals','email-signatures','link-in-bio','account','billing','edit-billing','cancel-reasons','logo-files','profiles-and-covers','business-cards'].includes(_vm.$route.name))?_c('app-header',{attrs:{"propsdata":_vm.propsdata}}):_vm._e(),_vm._v(" "),(_vm.propsdata[0]['account'] && _vm.propsdata[0]['verified'] && _vm.propsdata[0]['verified'].length === 50 && ['index','bookmarked-logos','exclusive-deals','email-signatures','link-in-bio','logo-files','profiles-and-covers','business-cards'].includes(_vm.$route.name))?_c('sidebar-header',{attrs:{"propsdata":_vm.propsdata},on:{"togglesidebar":_vm.togglesidebar}}):_vm._e(),_vm._v(" "),(_vm.propsdata[0]['account'] && _vm.propsdata[0]['verified'] && _vm.propsdata[0]['verified'].length === 50 && ['index','bookmarked-logos','email-signatures','link-in-bio','business-cards'].includes(_vm.$route.name))?_c('manage-bar',{attrs:{"propsdata":_vm.propsdata}}):_vm._e(),_vm._v(" "),(_vm.propsdata[0]['account'] && _vm.propsdata[0]['verified'] && _vm.propsdata[0]['verified'].length === 50 && ['account','billing'].includes(_vm.$route.name))?_c('account-header',{attrs:{"propsdata":_vm.propsdata}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"mode":"out-in","name":"anima"}},[(_vm.propsdata[0]['account'] && _vm.propsdata[0]['verified'] && _vm.propsdata[0]['verified'].length === 50)?_c('router-view',{key:_vm.$route.fullPath,attrs:{"propsdata":_vm.propsdata},on:{"updatepath":_vm.update,"open_modal_signup":_vm.open_modal_signup}}):_vm._e(),_vm._v(" "),(_vm.propsdata[0]['account'] && !_vm.propsdata[0]['verified'])?_c('div',{staticStyle:{"text-align":"center","padding-top":"100px"}},[_c('img',{staticStyle:{"width":"400px","max-width":"100%","margin-bottom":"15px"},attrs:{"src":"/assets/img/deliver.svg"}}),_vm._v(" "),_c('h1',[_vm._v("Please verify your account")]),_vm._v(" "),_c('p',[_vm._v("We just emailed a confirmation link to "),_c('strong',[_vm._v(_vm._s(_vm.propsdata[0]['email']))]),_vm._v("."),_c('br'),_vm._v("Click the link and you will be signed in")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',[_vm._v("Not your email? "),_c('a',{attrs:{"href":"/login"}},[_vm._v("Try again")])]),_vm._v(" "),_c('p',[_vm._v("Didn't receive an email? wait a few more seconds or "),_c('a',{attrs:{"href":"mailto:support@logo.app"}},[_vm._v("Contact support")])])]):_vm._e()],1),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('div',{staticClass:"modal fade",attrs:{"id":"modal-exclusive-deals","tabindex":"-1","role":"dialog","aria-labelledby":"modal-exclusive-deals","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"modal-icon display-1-lg"},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"204","height":"140","fill":"#f4bd00","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})])]),_vm._v(" "),_c('h4',{staticClass:"modal-title my-2"},[_vm._v("Unlock all exclusive deals now")]),_vm._v(" "),_c('p',[_vm._v("Get access to all exclusive deals for all your brands")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('a',{staticClass:"btn btn-block btn-info",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?utm_campaign=unlock_exclusive_deals'}},[_vm._v("Upgrade Now")])])])])])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('div',{staticClass:"modal fade",attrs:{"id":"modal-business-cards","tabindex":"-1","role":"dialog","aria-labelledby":"modal-business-cards","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"modal-icon display-1-lg"},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"204","height":"140","fill":"#f4bd00","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})])]),_vm._v(" "),_c('h4',{staticClass:"modal-title my-2"},[_vm._v("Promote your brand with business cards")]),_vm._v(" "),_c('p',[_vm._v("Get access to all premium features for all your brands")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('a',{staticClass:"btn btn-block btn-info",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?utm_campaign=unlock_business_cards'}},[_vm._v("Upgrade Now")])])])])])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('div',{staticClass:"modal fade",attrs:{"id":"modal-email-signatures","tabindex":"-1","role":"dialog","aria-labelledby":"modal-email-signatures","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"modal-icon display-1-lg"},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"204","height":"140","fill":"#f4bd00","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})])]),_vm._v(" "),_c('h4',{staticClass:"modal-title my-2"},[_vm._v("Promote your brand with email signatures")]),_vm._v(" "),_c('p',[_vm._v("Get access to all premium features for all your brands")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('a',{staticClass:"btn btn-block btn-info",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?utm_campaign=unlock_email_signatures'}},[_vm._v("Upgrade Now")])])])])])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('div',{staticClass:"modal fade",attrs:{"id":"modal-link-in-bio","tabindex":"-1","role":"dialog","aria-labelledby":"modal-link-in-bio","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"modal-icon display-1-lg"},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"204","height":"140","fill":"#f4bd00","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})])]),_vm._v(" "),_c('h4',{staticClass:"modal-title my-2"},[_vm._v("Promote your brand with your own link in bio")]),_vm._v(" "),_c('p',[_vm._v("Get access to all premium features for all your brands")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('a',{staticClass:"btn btn-block btn-info",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?utm_campaign=unlock_link_in_bio'}},[_vm._v("Upgrade Now")])])])])])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('div',{staticClass:"modal fade",attrs:{"id":"modal-logo-files","tabindex":"-1","role":"dialog","aria-labelledby":"modal-logo-files","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"modal-icon display-1-lg"},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"204","height":"140","fill":"#f4bd00","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})])]),_vm._v(" "),_c('h4',{staticClass:"modal-title my-2"},[_vm._v("Get high resolution logo files now")]),_vm._v(" "),_c('p',[_vm._v("Get access to all premium files for all your brands")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('a',{staticClass:"btn btn-block btn-info",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?utm_campaign=unlock_logo_files'}},[_vm._v("Upgrade Now")])])])])])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('div',{staticClass:"modal fade",attrs:{"id":"modal-profiles-and-covers","tabindex":"-1","role":"dialog","aria-labelledby":"modal-profiles-and-covers","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"modal-icon display-1-lg"},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"204","height":"140","fill":"#f4bd00","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})])]),_vm._v(" "),_c('h4',{staticClass:"modal-title my-2"},[_vm._v("Get high resolution logo files now")]),_vm._v(" "),_c('p',[_vm._v("Get access to all Profile and cover images for all your brands")]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('a',{staticClass:"btn btn-block btn-info",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?utm_campaign=unlock_profile_and_covers'}},[_vm._v("Upgrade Now")])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header mx-auto"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Upgrade To Premium")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group mb-4"},[_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Save up to $9,300")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Access to all exclusive deals")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Create unlimited logos")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Full rights and ownership")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header mx-auto"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Upgrade To Premium")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group mb-4"},[_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Unlimited Business Cards")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Customize Your Brand Identity")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Diverse Template Selection")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Access To All Premium Features")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header mx-auto"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Upgrade To Premium")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group mb-4"},[_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Unlimited Email Signatures")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Customize Your Brand Identity")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Diverse Template Selection")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Access To All Premium Features")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header mx-auto"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Upgrade To Premium")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group mb-4"},[_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Unlimited Links In Bio")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Customize Your Brand Identity")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Diverse Template Selection")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Access To All Premium Features")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header mx-auto"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Upgrade To Premium")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group mb-4"},[_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Create Unlimited Logos")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Get Your Font & Logo Files")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Full Ownership")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Access To All Premium Features")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header mx-auto"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Upgrade To Premium")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group mb-4"},[_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Create Unlimited Logos")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Profile and cover images")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Full Ownership")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('i',{staticClass:"fas fa-check-circle mr-1 text-success"}),_vm._v(" Access To All Premium Features")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c4d4c9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(45);
function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c4d4c9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(44);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("59459ffa", content, true, {});

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "@media (max-width:991px){.megamenu-item{max-width:none!important;width:100%!important}.featuresdiv{max-width:100%!important}.sinmargin{margin:0 auto!important;width:100%!important}.elmaildash{float:unset!important;margin-top:10px}}@media (max-width:399px){.fiumfiummcqueen{padding-top:15px}}@media (min-width:992px){.p-none{display:none!important}}.navbar-brand img{max-width:120px;width:100%}.navbar{background-color:#6ca7ff}.navimg{width:30px}.megamenu-item{display:inline-block!important;max-width:250px}.megamenu-item2{display:inline-block!important;max-width:1000px;margin-bottom:-30px}.list2{font-size:18px}.list3{font-size:14px!important;color:#000;font-weight:500}.featuresdiv{width:758px!important}.list-style-none{display:flex}.mb90{margin-bottom:-10px!important}.wwa{background-color:#fff;border:2px solid #0948b3;color:#0948b3!important}.divnav{margin:0 auto!important}@media (min-width:991px){.mindesktopwidth{width:500px!important}.webkitinlinedesktop{display:-webkit-inline-box}.paddingendesktop1{padding:0 0 0 10px}.paddingendesktop2{padding:0 10px 0 0}}.login-button{color:#fff;font-weight:600;background-color:transparent;padding:15px}.login-button-hov:hover{background-color:transparent!important;color:#c7c7c7!important}.jwoEpG{display:block;width:100%;background-color:#f2f5fa;padding:110px 20px 0}.jPMoWD{max-width:1120px;margin:0 auto}.cbHCIC{font-size:32px;line-height:34px;margin-bottom:2px}.iQGrHz{-webkit-box-align:baseline;align-items:baseline;-webkit-box-pack:justify;justify-content:space-between;border-bottom:1px solid #dde3f0}.iQGrHz,.VvJwP{position:relative;display:flex}.VvJwP{width:80%;-webkit-box-align:center;align-items:center;height:100%}.ceBpjv{color:#262b33}.ceBpjv,.goxPqP{margin-right:24px;cursor:pointer;transition:color .1s ease 0s;padding:10px 0;text-align:center}.goxPqP{color:#292e35}.faWvy{display:block;position:absolute;left:0;bottom:-1px;width:100px;height:2px;background-color:#2196f3;transform-origin:0 0;transform:translateX(0) scaleX(.67);transition:transform .3s ease 0s}.dqUEtJ{display:inline-flex;-webkit-box-align:center;align-items:center;position:static;bottom:15px;right:0;padding:8px 12px 8px 4px}.cTABXS,.dqUEtJ{-webkit-appearance:none;text-align:center;color:#fff;background-color:#6ca7ff;cursor:pointer;user-select:none;pointer-events:auto;font-size:16px;line-height:20px;font-weight:600;outline:none;border-radius:4px;transition:background-color .1s ease 0s,box-shadow .1s ease 0s;border-width:0}.cTABXS{width:100%;margin-bottom:32px;display:none;padding:12px 24px}.WflZx{width:100%;flex-flow:wrap}.jmKqRE{width:100%;display:inline-flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:start;justify-content:flex-start;max-width:524px}.cxEQKQ{margin-right:30px}.haTfuX{position:relative;width:278px;height:390px;background-color:#fff;background-size:cover;cursor:pointer;overflow:hidden;border-radius:4px;transition:box-shadow .2s ease 0s}.haTfuX:hover{box-shadow:0 16px 36px -8px rgba(186,200,227,.48),0 24px 60px -8px rgba(186,200,227,.2)}.kImuof{position:absolute;left:calc(50% - 18px);top:calc(50% - 18px);display:none;width:36px;height:36px;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;color:#fff;background-color:#7a85997a;border-radius:50%}.hCpORs{width:100%}@media(min-width:576px){.hCpORs{padding-right:1.5rem}}.fBHvCq{display:flex;align-items:flex-start;padding-right:26px;flex-flow:row nowrap}.cLFOMf,.eRizKN{position:relative;max-width:100%}.eRizKN{font-size:22px;line-height:28px;height:32px;min-width:1px}.kkRCtf{display:block;white-space:nowrap;text-overflow:ellipsis;max-width:100%;overflow:hidden}.gQXEKA{position:absolute;top:2px;left:calc(100% + 2px);-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}.leOORe{position:relative}.dsceFE{font-weight:400;white-space:nowrap;left:50%;transform:translate(-50%);position:absolute;z-index:10;font-size:14px;line-height:16px;letter-spacing:.3px;color:#fff;width:auto;background-color:#262b33;user-select:none;pointer-events:none;opacity:0;bottom:calc(100% + 6px);padding:5px 8px;border-radius:3px;transition:opacity .2s ease 0s,transform .2s ease 0s}.jxPiur{cursor:pointer;color:#b8becc;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.hsJJHO{position:absolute;bottom:0;left:0;right:0;height:2px;background-color:#2196f3;pointer-events:none;z-index:1;opacity:0;transform:scale(.5,0);transition:transform .1s ease 0s}.jaiNr{display:flex;-webkit-box-align:center;align-items:center;margin-bottom:16px}.dXstwa:last-child{margin-bottom:0}.dXstwa{font-size:16px;line-height:20px;color:#98a1b3;margin-bottom:8px}.dHZVB{position:relative}.cNyPHU{margin-bottom:12px;cursor:pointer;user-select:none;color:#262b33;pointer-events:all}.bWbDhC,.cNyPHU{display:flex;-webkit-box-align:center;align-items:center}.bWbDhC{-webkit-box-pack:center;justify-content:center;color:#2196f3;margin-right:5px}.cNyPHU:hover{color:#6ca7ff}@media (max-width:767px){.jwoEpG{padding:160px 20px 0}}@media (max-width:767px){.cbHCIC{margin-bottom:13px}}@media (max-width:767px){.iQGrHz{margin-bottom:20px}}@media (max-width:767px){.VvJwP{-webkit-box-pack:justify;justify-content:space-between}}@media (max-width:767px){.ceBpjv,.goxPqP,.VvJwP{width:100%}}@media (max-width:767px){.dqUEtJ{display:none}}@media (max-width:767px){.cTABXS{display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}}@media (max-width:767px){.jmKqRE{align-items:flex-start;margin-right:0;margin-bottom:32px}}@media (max-width:767px){.cxEQKQ{margin-right:20px}}@media (max-width:767px){.haTfuX{width:108px;height:151px}}@media (max-width:767px){.kImuof{display:flex}}.loader{--background:linear-gradient(135deg,#23c4f8,#275efe);--shadow:rgba(39,94,254,.28);--text:#6c7486;--page:hsla(0,0%,100%,.36);--page-fold:hsla(0,0%,100%,.52);--duration:3s;width:200px;height:140px;position:relative}.loader:after,.loader:before{--r:-6deg;content:\"\";position:absolute;bottom:8px;width:120px;top:80%;box-shadow:0 16px 12px var(--shadow);-webkit-transform:rotate(var(--r));transform:rotate(var(--r))}.loader:before{left:4px}.loader:after{--r:6deg;right:4px}.loader div{width:100%;height:100%;border-radius:13px;position:relative;z-index:1;-webkit-perspective:600px;perspective:600px;box-shadow:0 4px 6px var(--shadow);background-image:var(--background)}.loader div ul{margin:0;padding:0;list-style:none;position:relative}.loader div ul li{--r:180deg;--o:0;--c:var(--page);position:absolute;top:10px;left:10px;-webkit-transform-origin:100% 50%;transform-origin:100% 50%;color:var(--c);opacity:var(--o);-webkit-transform:rotateY(var(--r));transform:rotateY(var(--r));-webkit-animation:var(--duration) ease infinite;animation:var(--duration) ease infinite}.loader div ul li:nth-child(2){--c:var(--page-fold);-webkit-animation-name:page-2;animation-name:page-2}.loader div ul li:nth-child(3){--c:var(--page-fold);-webkit-animation-name:page-3;animation-name:page-3}.loader div ul li:nth-child(4){--c:var(--page-fold);-webkit-animation-name:page-4;animation-name:page-4}.loader div ul li:nth-child(5){--c:var(--page-fold);-webkit-animation-name:page-5;animation-name:page-5}.loader div ul li svg{width:90px;height:120px;display:block}.loader div ul li:first-child{--r:0deg;--o:1}.loader div ul li:last-child{--o:1}.loader span{display:block;left:0;right:0;top:100%;margin-top:20px;text-align:center;color:var(--text)}@-webkit-keyframes page-2{0%{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);opacity:0}20%{opacity:1}35%,to{opacity:0}50%,to{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}}@keyframes page-2{0%{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);opacity:0}20%{opacity:1}35%,to{opacity:0}50%,to{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}}@-webkit-keyframes page-3{15%{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);opacity:0}35%{opacity:1}50%,to{opacity:0}65%,to{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}}@keyframes page-3{15%{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);opacity:0}35%{opacity:1}50%,to{opacity:0}65%,to{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}}@-webkit-keyframes page-4{30%{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);opacity:0}50%{opacity:1}65%,to{opacity:0}80%,to{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}}@keyframes page-4{30%{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);opacity:0}50%{opacity:1}65%,to{opacity:0}80%,to{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}}@-webkit-keyframes page-5{45%{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);opacity:0}65%{opacity:1}80%,to{opacity:0}95%,to{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}}@keyframes page-5{45%{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);opacity:0}65%{opacity:1}80%,to{opacity:0}95%,to{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}}@media (max-width:767px){.mcqueen_desktop{display:none!important}.mcqueen_mobile,.navbar>.container,.navbar>.container-fluid{display:initial!important}}.active_create_type,.active_sidebar_dropdowns{background:#f3f5f9;color:#2a354f!important}.scrollbar_choosedocument::-webkit-scrollbar{width:.5rem}.scrollbar_choosedocument::-webkit-scrollbar-thumb{background:#b5babd;border-radius:1rem}@media(max-width:767px){.classdefranco{justify-content:center!important;flex-wrap:wrap!important}.textoenmobilemodal{font-size:15px!important;line-height:26px!important;margin-bottom:16px!important}.modal-content-enmobile{margin-top:40px!important;margin-bottom:40px!important}}.document_preview::-webkit-scrollbar{width:.5rem}.document_preview::-webkit-scrollbar-thumb{background:#b5babd;border-radius:1rem}", ""]);

// exports


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-main navbar-expand-lg navbar-dark navbar-theme-primary headroom",staticStyle:{"padding-bottom":"0.8rem !important","padding-top":"0.8rem!important","position":"fixed","height":"71px","background-color":"#ed1d62!important"},attrs:{"id":"navbar-main"}},[_c('div',{staticStyle:{"width":"100%","display":"flex","flex-wrap":"wrap","align-items":"center","justify-content":"space-between","padding-left":"1rem","padding-right":"1rem"}},[_c('router-link',{staticClass:"navbar-brand",staticStyle:{"background":"none!important"},attrs:{"to":"/dashboard/"}},[_c('div',{staticClass:"d-flex align-items-center"},[_c('img',{staticClass:"mcqueen_desktop",staticStyle:{"max-width":"195px","height":"auto"},attrs:{"src":"https://logo.app/logo/logo-dark-bg.png","alt":"LogoDesign Logo"}}),_vm._v(" "),_c('img',{staticClass:"mcqueen_mobile",staticStyle:{"display":"none","max-width":"35px","height":"auto"},attrs:{"src":"https://logo.app/logo/icon-white.png","alt":"LogoDesign Logo"}})])]),_vm._v(" "),_c('div',{staticClass:"d-lg-block fiumfiummcqueen mcqueen_desktop"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].cargado),expression:"propsdata[0].paid !== 'yes' && propsdata[0].cargado"}],staticClass:"btn btn-md btn-pricing-plan animate-up-2",staticStyle:{"color":"#000000","background-color":"#ffffff","border-color":"#ffffff","display":"none"},attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?utm_campaign=dashboard_header_button'}},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"24","height":"24","fill":"#f4bd00","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})]),_vm._v("\n                Upgrade Now")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.propsdata[0].paid === 'yes' && _vm.propsdata[0].cargado),expression:"propsdata[0].paid === 'yes' && propsdata[0].cargado"}],staticClass:"btn btn-md btn-pricing-plan",staticStyle:{"color":"#f4bd00","background-color":"#ffffff","border-color":"#f4bd00","cursor":"initial","display":"none"}},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"24","height":"24","fill":"#f4bd00","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})]),_vm._v("\n                  Premium")]),_vm._v(" "),_c('div',{staticClass:"dropdown mb-lg-0",staticStyle:{"display":"inline-block","padding":"0 0 0 20px"}},[_c('a',{staticClass:"dropdown-toggle footer-language-link pb-2",staticStyle:{"color":"#fff"},attrs:{"id":"langsDropdown","href":"#","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                      "+_vm._s(_vm.propsdata[0].email)+" "),_c('i',{staticClass:"fas fa-chevron-down ml-1"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-center mt-0",staticStyle:{"left":"unset!important","right":"0"},attrs:{"aria-labelledby":"langsDropdown"}},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item text-sm",staticStyle:{"border-bottom":"none"},attrs:{"to":"/dashboard/"}},[_c('i',{staticClass:"fas fa-file mr-2"}),_vm._v(" Dashboard")]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item text-sm",staticStyle:{"border-bottom":"none"},attrs:{"to":"/dashboard/account"}},[_c('i',{staticClass:"fas fa-cog mr-2"}),_vm._v(" Account Settings")]),_vm._v(" "),_vm._m(1)],1)])]),_vm._v(" "),_c('div',{staticClass:"mcqueen_mobile",staticStyle:{"display":"none"}},[_c('div',{staticClass:"dropdown mb-lg-0",staticStyle:{"display":"block","text-align":"right"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-center mt-0",staticStyle:{"left":"unset!important","right":"0"},attrs:{"aria-labelledby":"langsDropdown"}},[_vm._m(3),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item text-sm",staticStyle:{"border-bottom":"none"},attrs:{"to":"/dashboard/"}},[_c('i',{staticClass:"fas fa-file mr-2"}),_vm._v(" Dashboard")]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item text-sm",staticStyle:{"border-bottom":"none"},attrs:{"to":"/dashboard/account"}},[_c('i',{staticClass:"fas fa-cog mr-2"}),_vm._v(" Account Settings")]),_vm._v(" "),_vm._m(4)],1)])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-item text-sm",staticStyle:{"border-bottom":"none"},attrs:{"href":"/"}},[_c('i',{staticClass:"fas fa-home mr-2"}),_vm._v(" Home")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-item text-sm",attrs:{"href":"/logout"}},[_c('i',{staticClass:"fas fa-sign-out-alt mr-2"}),_vm._v(" Log Out")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle footer-language-link pb-2",staticStyle:{"color":"#fff"},attrs:{"id":"langsDropdown","href":"#","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                  My Account "),_c('i',{staticClass:"fas fa-chevron-down ml-1"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-item text-sm",staticStyle:{"border-bottom":"none"},attrs:{"href":"/"}},[_c('i',{staticClass:"fas fa-home mr-2"}),_vm._v(" Home")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-item text-sm",attrs:{"href":"/logout"}},[_c('i',{staticClass:"fas fa-sign-out-alt mr-2"}),_vm._v(" Log Out")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf504cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__(49);
function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf504cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(48);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("432a2419", content, true, {});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".router-link-active-manipulated,.router-link-active-manipulated:hover,.router-link-exact-active,.router-link-exact-active:hover{background:#f3f5f9;color:#2a354f!important}#quesedeslice::-webkit-scrollbar{width:5px}#quesedeslice::-webkit-scrollbar-thumb{background:#ccc;border:0 none #fff;border-radius:50px}#quesedeslice::-webkit-scrollbar-track{background:#e7e7e7;border:0 none #fff;border-radius:7px}@media (max-width:767px){.dropdown_folders{left:unset!important}}[v-cloak]{display:none}", ""]);

// exports


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-dark navbar-theme-primary px-4 col-12 d-md-none829",staticStyle:{"background-color":"#ffffff!important","z-index":"99","padding":"10px","position":"fixed","top":"71px"}},[_c('div',{staticClass:"d-flex align-items-center"}),_vm._v(" "),(!_vm.propsdata[0].sidebar_mobile)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticStyle:{"font-size":"20px","background":"#2a354f","border-radius":"4px","padding":"0 4px 0 4px"},on:{"click":function($event){_vm.$emit('togglesidebar')}}},[_c('span',{staticClass:"navbar-toggler-icon"})])]):_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticStyle:{"font-size":"20px"},on:{"click":function($event){_vm.$emit('togglesidebar')}}},[_c('i',{staticClass:"fas fa-times",staticStyle:{"color":"#2a354f","font-size":"1.5em"}})])])]),_vm._v(" "),_c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.propsdata[0].sidebar_mobile),expression:"propsdata[0].sidebar_mobile"}],staticClass:"sidebar d-md-block829 bg-dark text-white",staticStyle:{"background-color":"#ffffff!important","border-right":"1px solid #dde1ed!important","display":"none"},attrs:{"id":"sidebarMenu"}},[_c('div',{staticClass:"sidebar-inner px-4 pt-3"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"nav flex-column mt-endesktop sidebar-top-mobile",staticStyle:{"margin-top":"62px"}},[_c('p',{staticStyle:{"margin-left":"11px","margin-bottom":"0.8rem","font-weight":"900","color":"#2a354f","font-size":"15px"}},[_c('i',{staticClass:"fa-solid fa-icons",staticStyle:{"margin-right":"7px"}}),_vm._v("Logos\n               "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].cargado),expression:"propsdata[0].paid !== 'yes' && propsdata[0].cargado"}],staticStyle:{"display":"none","float":"right"}},[_c('span',{staticClass:"badge badge-md bg-success ms-1",staticStyle:{"display":"block","color":"#ffffff!important"}},[_vm._v("UPGRADE")])])]),_vm._v(" "),_c('li',{staticClass:"nav-item",on:{"click":function($event){_vm.$emit('togglesidebar')}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/dashboard/","active-class":"selected"}},[_c('i',{staticClass:"fa-solid fa-icons",staticStyle:{"margin-right":"7px"}}),_vm._v(" "),_c('span',{staticClass:"sidebar-text"},[_vm._v("My Logos")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.$emit('togglesidebar')}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/dashboard/bookmarked-logos"}},[_c('i',{staticClass:"fa-solid fa-bookmark",staticStyle:{"margin-right":"11px"}}),_vm._v(" "),_c('span',[_vm._v("Bookmarked Logos")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.$emit('togglesidebar')}}},[_c('router-link',{staticClass:"nav-link",class:{'router-link-active-manipulated': _vm.$route.path === '/dashboard/get-logo-files' || _vm.$route.path.startsWith('/dashboard/logo-files/') },attrs:{"to":"/dashboard/get-logo-files"}},[_c('i',{staticClass:"fa-solid fa-paperclip",staticStyle:{"margin-right":"9px"}}),_vm._v(" "),_c('span',[_vm._v("Logo Files")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.$emit('togglesidebar')}}},[_c('router-link',{staticClass:"nav-link",class:{'router-link-active-manipulated': _vm.$route.path === '/dashboard/get-profiles-and-covers' || _vm.$route.path.startsWith('/dashboard/profiles-and-covers/') },attrs:{"to":"/dashboard/get-profiles-and-covers"}},[_c('i',{staticClass:"fa-solid fa-user-circle",staticStyle:{"margin-right":"7px"}}),_vm._v(" "),_c('span',[_vm._v("Profiles and Covers")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.$emit('togglesidebar')}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/dashboard/business-cards"}},[_c('i',{staticClass:"fa-regular fa-address-card",staticStyle:{"margin-right":"5px"}}),_vm._v(" "),_c('span',[_vm._v("Business Cards")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.$emit('togglesidebar')}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/dashboard/email-signatures"}},[_c('i',{staticClass:"fa-solid fa-signature",staticStyle:{"margin-right":"3px"}}),_vm._v(" "),_c('span',[_vm._v("Email Signatures")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.$emit('togglesidebar')}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/dashboard/link-in-bio"}},[_c('i',{staticClass:"fa-solid fa-mobile-screen-button",staticStyle:{"margin-right":"11px"}}),_vm._v(" "),_c('span',[_vm._v("Link In Bio")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.$emit('togglesidebar')}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/dashboard/exclusive-deals"}},[_c('i',{staticClass:"fa-solid fa-gift",staticStyle:{"margin-right":"7px"}}),_vm._v(" "),_c('span',[_vm._v("Exclusive Deals")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"height":"70px","display":"flex","justify-content":"center"}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].cargado),expression:"propsdata[0].paid !== 'yes' && propsdata[0].cargado"}],staticClass:"btn btn-md btn-pricing-plan animate-up-2",staticStyle:{"display":"none","color":"rgb(0, 0, 0)","background-color":"rgb(255, 255, 255)","border-color":"#0a4ab4","position":"fixed","bottom":"15px","width":"212px"},attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?utm_campaign=dashboard_sidebar_button'}},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"24","height":"24","fill":"#f4bd00","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})]),_vm._v("\n               Upgrade Now\n              ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].cargado),expression:"propsdata[0].paid !== 'yes' && propsdata[0].cargado"}],staticClass:"nopagonav content2",staticStyle:{"position":"relative","top":"68.5px","padding":"0","display":"none"}},[_c('div',{staticStyle:{"color":"#15a97c","background-color":"rgb(255, 255, 255)","border-color":"#15a97c","width":"100%","display":"inline-block","font-weight":"600","text-align":"center","border":"0.0625rem solid","padding":"0.55rem 0.95rem"}},[_vm._v("Create & Download Unlimited Logos. "),_c('a',{staticStyle:{"text-decoration":"underline!important","color":"#15a97c","font-weight":"600"},attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?utm_campaign=dashboard_top_banner'}},[_vm._v("Upgrade Now")]),_vm._v(".")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-card d-flex align-items-center justify-content-between justify-content-md-center pb-5"},[_c('div',{staticClass:"collapse-close",staticStyle:{"position":"absolute","right":"20px","top":"15px","font-size":"25px"}},[_c('a',{staticClass:"fas fa-times",staticStyle:{"color":"rgb(255, 255, 255) !important"},attrs:{"href":"#sidebarMenu"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manage_bar_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c73db13_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_bar_vue__ = __webpack_require__(53);
function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manage_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c73db13_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(52);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("33e4284d", content, true, {});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".router-link-exact-active,.router-link-exact-active:hover{background:#f3f5f9;color:#2a354f!important}#quesedeslice::-webkit-scrollbar{width:5px}#quesedeslice::-webkit-scrollbar-thumb{background:#ccc;border:0 none #fff;border-radius:50px}#quesedeslice::-webkit-scrollbar-track{background:#e7e7e7;border:0 none #fff;border-radius:7px}@media (max-width:767px){.dropdown_folders{left:unset!important}}[v-cloak]{display:none}", ""]);

// exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content2 setmargin"},[_c('div',{staticClass:"sc-kAdXeD jwoEpG",staticStyle:{"padding":"40px 20px 0px 20px!important"}},[(_vm.propsdata[0]['path'] === '/dashboard/' || _vm.propsdata[0]['path'] === '/dashboard/bookmarked-logos')?_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"mb-4 sinpaddingmobile",staticStyle:{"display":"flex","justify-content":"space-between","padding-top":"60px"}},[(_vm.propsdata[0]['path'] === '/dashboard/')?_c('h4',{staticClass:"f342fdw",staticStyle:{"color":"#4a5073"}},[_c('i',{staticClass:"fa-solid fa-icons mr-2"}),_vm._v(" My Logos")]):(_vm.propsdata[0]['path'] === '/dashboard/bookmarked-logos')?_c('h4',{staticClass:"f342fdw",staticStyle:{"color":"#4a5073"}},[_c('i',{staticClass:"fa-solid fa-bookmark mr-2"}),_vm._v(" Bookmarked Logos")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"href":"/create/"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n             Create New Logo\n          ")])]),_vm._v(" "),_c('a',{staticClass:"sc-kkGfuU sc-guztPN cTABXS",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"href":"/create/"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n            Create New Logo\n         ")]),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),(_vm.propsdata[0]['path'] === '/dashboard/business-cards')?_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"mb-4 sinpaddingmobile",staticStyle:{"display":"flex","justify-content":"space-between","padding-top":"60px"}},[_vm._m(0),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"data-toggle":"modal","data-target":"#modal-business-cards"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n             Create Business Card\n          ")]):_c('router-link',{staticClass:"sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"to":"/dashboard/create-business-card"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n             Create Business Card\n          ")])],1),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"sc-kkGfuU sc-guztPN cTABXS",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"data-toggle":"modal","data-target":"#modal-business-cards"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n            Create Business Card\n          ")]):_c('router-link',{staticClass:"sc-kkGfuU sc-guztPN cTABXS",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"to":"/dashboard/create-business-card"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n            Create Business Card\n         ")]),_vm._v(" "),_c('hr')],1):_vm._e(),_vm._v(" "),(_vm.propsdata[0]['path'] === '/dashboard/email-signatures')?_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"mb-4 sinpaddingmobile",staticStyle:{"display":"flex","justify-content":"space-between","padding-top":"60px"}},[_vm._m(1),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"data-toggle":"modal","data-target":"#modal-email-signatures"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n             Create Email Signature\n          ")]):_c('router-link',{staticClass:"sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"to":"/dashboard/create-email-signature"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n             Create Email Signature\n          ")])],1),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"sc-kkGfuU sc-guztPN cTABXS",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"data-toggle":"modal","data-target":"#modal-email-signatures"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n            Create Email Signature\n          ")]):_c('router-link',{staticClass:"sc-kkGfuU sc-guztPN cTABXS",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"to":"/dashboard/create-email-signature"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n            Create Email Signature\n         ")]),_vm._v(" "),_c('hr')],1):_vm._e(),_vm._v(" "),(_vm.propsdata[0]['path'] === '/dashboard/link-in-bio')?_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"mb-4 sinpaddingmobile",staticStyle:{"display":"flex","justify-content":"space-between","padding-top":"60px"}},[_vm._m(2),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"data-toggle":"modal","data-target":"#modal-link-in-bio"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n             Create Link In Bio\n          ")]):_c('router-link',{staticClass:"sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"to":"/dashboard/create-link-in-bio"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n             Create Link In Bio\n          ")])],1),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"sc-kkGfuU sc-guztPN cTABXS",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"data-toggle":"modal","data-target":"#modal-link-in-bio"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n            Create Link In Bio\n          ")]):_c('router-link',{staticClass:"sc-kkGfuU sc-guztPN cTABXS",staticStyle:{"color":"#fff","background-color":"#ed1d62!important"},attrs:{"to":"/dashboard/create-link-in-bio"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n            Create Link In Bio\n         ")]),_vm._v(" "),_c('hr')],1):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"f342fdw",staticStyle:{"color":"#4a5073"}},[_c('i',{staticClass:"fa-solid fa-signature mr-2"}),_vm._v(" Business Cards")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"f342fdw",staticStyle:{"color":"#4a5073"}},[_c('i',{staticClass:"fa-solid fa-signature mr-2"}),_vm._v(" Email Signatures")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"f342fdw",staticStyle:{"color":"#4a5073"}},[_c('i',{staticClass:"fa-solid fa-mobile-screen-button mr-2"}),_vm._v(" Link In Bio")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014b68c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(57);
function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014b68c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(56);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ca65dd98", content, true, {});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "a{color:#515151}.delete_btnhover:hover{color:#ee5150!important}.downloads_btnhover:hover,.preview_btnhover:hover{color:#073482!important}", ""]);

// exports


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content2"},[_c('vue-headful',{attrs:{"title":"Dashboard | My Logos","description":"Dashboard | My Logos"}}),_vm._v(" "),(_vm.propsdata[0].loading_logos)?_c('div',{staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.propsdata[0].loading_logos)?_c('div',{staticClass:"sc-bvTASY jPMoWD"},[(_vm.propsdata[0].logos !== null)?_c('div',{staticClass:"sc-cFlXAS WflZx"},[_c('div',{staticClass:"row"},_vm._l((_vm.propsdata[0].logos),function(logos,num){return _c('div',{key:logos.unique_id,staticClass:"col-md-12 col-lg-6-franco mb-4"},[_c('div',{staticClass:"pricing-card"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"row no-gutters align-items-center"},[_c('div',{staticClass:"col-sm-7"},[_c('header',{staticClass:"card-header text-center"},[_c('span',{staticClass:"d-block"},[_c('div',{staticClass:"sc-cmIlrE haTfuX dashboard-display-logo drag_disabled",style:('height: fit-content;width: -webkit-fill-available;background:'+logos.background+';'),attrs:{"data-toggle":"modal","data-target":"#modal-default"},on:{"click":function($event){_vm.logo_number(num)}}},[(_vm.propsdata[0].paid !== 'yes' && logos.one_time_payment !== 'yes')?_c('div',[(logos.svglogos_s3 === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/svglogos/'+logos.unique_id+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://svglogos.s3.amazonaws.com/'+logos.unique_id+'.svg?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || logos.one_time_payment === 'yes')?_c('div',[(logos.paid_svglogos_s3 === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-svglogos/'+logos.unique_id+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+logos.unique_id+'.svg?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5 elpaddingdelmobileversion",staticStyle:{"padding-top":"1.5rem","padding-bottom":"1.5rem"}},[_c('div',{staticClass:"sc-dBaXSw hCpORs"},[_c('div',{staticClass:"sc-ccLTTT fBHvCq"},[_c('div',{staticClass:"sc-hlILIN cLFOMf"},[_c('div',{staticClass:"sc-jQMNup eRizKN"},[(_vm.numeroedit !== num)?_c('a',{staticClass:"sc-bJHhxl kkRCtf",on:{"click":function($event){_vm.lapicito(num)}}},[_vm._v(_vm._s(logos.titulo))]):_vm._e(),_vm._v(" "),(_vm.edit && _vm.numeroedit === num)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide),expression:"hide"}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(logos.titulo),expression:"logos.titulo"}],staticStyle:{"background":"transparent","border":"transparent","outline":"none","border-bottom":"2px solid #0949b3","color":"#515151","width":"169px","padding":"0","font-weight":"300"},attrs:{"type":"text","placeholder":"Untitled","autofocus":"autofocus","onfocus":"this.select()"},domProps:{"value":(logos.titulo)},on:{"keyup":[function($event){_vm.edittitulo(num)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.hide($event)}],"input":function($event){if($event.target.composing){ return; }_vm.$set(logos, "titulo", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.numeroedit !== num)?_c('div',{staticClass:"sc-gAmQfK gQXEKA",on:{"click":function($event){_vm.lapicito(num)}}},[_c('div',{staticClass:"sc-hwwEjo leOORe"},[_c('div',{staticClass:"sc-hAXbOi jxPiur simptip-position-top simptip-smooth",attrs:{"data-tooltip":"Rename"}},[_c('svg',{staticStyle:{"margin-bottom":"10px"},attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"#0949b3","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sc-dphlzf hsJJHO",attrs:{"in":"exited"}})])]),_vm._v(" "),_c('div',{staticClass:"sc-bNQFlB jaiNr"},[_c('div',{staticClass:"sc-hizQCF dXstwa"},[_vm._v("Created "+_vm._s(logos.datetime))])]),_vm._v(" "),_c('div',{staticClass:"border-light border-bottom pb-1 mb-3"},[_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('a',{attrs:{"href":'/create/edit-logo/'+logos.unique_id+'?ref=edit'}},[_c('div',{staticStyle:{"display":"inline"}},[_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"#0949b3","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z"}})])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Edit")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('a',{staticClass:"preview_btnhover",attrs:{"data-toggle":"modal","data-target":"#modal-default"},on:{"click":function($event){_vm.logo_number(num)}}},[_c('div',{staticStyle:{"display":"inline"}},[_c('svg',{staticStyle:{"margin-right":"2px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","width":"22","height":"22","fill":"#0949b3"}},[_c('path',{attrs:{"d":"M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"}})])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Preview")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('a',{staticClass:"preview_btnhover",on:{"click":function($event){_vm.show_duplicate_modal(num)}}},[_c('i',{staticClass:"fa-solid fa-copy",staticStyle:{"color":"#0a49b3","margin-right":"5px","margin-left":"3px"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Duplicate")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('router-link',{staticClass:"preview_btnhover",attrs:{"to":'/dashboard/logo-files/'+logos.unique_id}},[_c('i',{staticClass:"fa-solid fa-paperclip",staticStyle:{"color":"#0a49b3","margin-right":"7px","margin-left":"3px"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Logo Files")])])],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('a',{staticClass:"delete_btnhover",on:{"click":function($event){_vm.el_sure(num)}}},[_c('div',{staticStyle:{"display":"inline"}},[_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"#ee5150","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8,19 L16,19 L16,13 L8,13 L8,19 Z M16,7 L20,7 L20,9 L4,9 L4,7 L8,7 L8,3 L16,3 L16,7 Z M14,7 L14,5 L10,5 L10,7 L14,7 Z M6,11 L18,11 L18,21 L6,21 L6,11 Z","fill-rule":"nonzero"}})])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Delete")])])]),_vm._v(" "),(_vm.sure && _vm.numerosure === num)?_c('p',[_vm._v("Are you sure? "),_c('a',{staticStyle:{"color":"#5dba00"},on:{"click":function($event){_vm.delete_draft(num)}}},[_vm._v("YES")]),_vm._v(" / "),_c('a',{staticStyle:{"color":"#ee5150"},on:{"click":function($event){_vm.el_sure(num)}}},[_vm._v("NO")])]):_vm._e()]),_vm._v(" "),(_vm.propsdata[0].paid !== 'yes' && logos.one_time_payment !== 'yes')?_c('div',{staticStyle:{"display":"flex"}},[_c('a',{staticClass:"btn btn-success w-100",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?uil='+logos.unique_id+'&utm_campaign=dashboard_buy_logo'}},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"24","height":"24","fill":"#ffffff","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})]),_vm._v(" Download Logo\n                          ")])]):_c('div',{staticStyle:{"display":"flex"}},[_c('router-link',{staticClass:"btn btn-success w-100",attrs:{"to":'/dashboard/logo-files/'+logos.unique_id}},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"24","height":"24","fill":"#ffffff","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})]),_vm._v(" Download Logo\n                          ")])],1)])])])])])])}))]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.propsdata[0].logos === null || _vm.propsdata[0].logos.length === 0) && _vm.propsdata[0].logos_cargados)?_c('div',{staticClass:"padding_dsp_de_1435"},[_c('div',{staticClass:"sc-hcnlBt kVTXUr",staticStyle:{"max-width":"1120px","margin":"0 auto"}},[_c('h2',{staticClass:"sc-jRhVzh exltuq"},[_vm._v("Create Beautiful Logos")]),_vm._v(" "),_c('p',{staticClass:"sc-iHhHRJ iUpXMa"},[_vm._v("Our platform allows you to create, edit and download beautiful logos in just a few simple steps.")]),_vm._v(" "),_c('a',{staticClass:"sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ",staticStyle:{"color":"rgb(255, 255, 255)","display":"initial!important","background-color":"#ed1d62!important"},attrs:{"href":"/create/"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n  Create Logos Now")])])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].logos !== null && _vm.propsdata[0].logos_cargados)?_c('div',{staticClass:"modal fade",attrs:{"id":"modal-default","tabindex":"-1","role":"dialog","aria-labelledby":"modal-default","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"850px","height":"-webkit-fill-available"}},[_c('div',{staticClass:"modal-content modal-content-enmobile",staticStyle:{"height":"-webkit-fill-available"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body document_preview",staticStyle:{"overflow":"hidden auto","margin":"20px","padding":"0"}},[_c('div',[_c('div',{staticClass:"d-flex justify-content-center",style:('width: 100%; height: 404px; background: '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+'; font-size: 25px; font-weight: 600; text-align: center; vertical-align: middle; line-height: 400px; color: rgb(255, 255, 255); border-radius: 0.5rem;')},[_c('div',{staticClass:"less_scale_preview_mobile drag_disabled",staticStyle:{"transform":"scale(1)"}},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/svglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://svglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.svg?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.svg?'+_vm.timenow}})])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row mt-4 para-ponerlos-en-el-medio"},[_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-9.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-9"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-2.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-2"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-13.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-13"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-14.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-14"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-10.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-10"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-4.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-4"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"alert alert-secondary alert-dismissible fade show mb-0 classdefranco",staticStyle:{"border-radius":"0px","display":"flex","justify-content":"space-between","background-color":"#1266c9","border-color":"#1266c9"},attrs:{"role":"alert"}},[_c('span',{staticClass:"alert-inner--text textoenmobilemodal",staticStyle:{"font-size":"18px","line-height":"42px"}},[_vm._v("This is just a preview of your logo. Download it now and get the svg & png format.")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview].one_time_payment === 'yes')?_c('a',{staticClass:"btn btn-white btn_del_continue",attrs:{"href":'/svg-download/'+_vm.propsdata[0].logos[_vm.logo_preview].unique_id+'/'+_vm.propsdata[0].logos[_vm.logo_preview].titulo_specialchars_out}},[_vm._v("Download")]):(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview].one_time_payment !== 'yes')?_c('a',{staticClass:"btn btn-white btn_del_continue",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?uil='+_vm.propsdata[0].logos[_vm.logo_preview].unique_id+'&utm_campaign=dashboard_preview_modal'}},[_vm._v("Download")]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.modal_duplicate)?_c('div',{staticClass:"modal",staticStyle:{"display":"block","padding-left":"0px","background-color":"rgba(103, 103, 103, 0.26)"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide_duplicate_modal),expression:"hide_duplicate_modal"}],staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"850px","height":"-webkit-fill-available"}},[_c('div',{staticClass:"modal-content modal-content-enmobile",staticStyle:{"max-height":"-webkit-fill-available"}},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Duplicate Logo")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.hide_duplicate_modal}},[(!_vm.duplicating_logo)?_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")]):_c('span',{staticClass:"spinner-border spinner-border-sm"})])]),_vm._v(" "),_c('div',{staticClass:"modal-body document_preview",staticStyle:{"overflow":"hidden auto","margin":"20px","padding":"0"}},[_c('h3',{staticClass:"text-center mb-3"},[_vm._v("Would you like to duplicate this logo?")]),_vm._v(" "),(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.numeroduplicate]['one_time_payment'] !== 'yes')?_c('div',{staticClass:"text-center"},[(_vm.propsdata[0].logos[_vm.numeroduplicate]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{staticStyle:{"width":"233px","border-radius":"5px"},attrs:{"src":'https://logo.app/svglogos/'+_vm.propsdata[0].logos[_vm.numeroduplicate]['unique_id']+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{staticStyle:{"width":"233px","border-radius":"5px"},attrs:{"src":'https://svglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.numeroduplicate]['unique_id']+'.svg?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.numeroduplicate]['one_time_payment'] === 'yes')?_c('div',{staticClass:"text-center"},[(_vm.propsdata[0].logos[_vm.numeroduplicate]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{staticStyle:{"width":"233px","border-radius":"5px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.propsdata[0].logos[_vm.numeroduplicate]['unique_id']+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{staticStyle:{"width":"233px","border-radius":"5px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.numeroduplicate]['unique_id']+'.svg?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py-3 text-center"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"d-sm-flex flex-column flex-sm-row mb-3 justify-content-center"},[(!_vm.duplicating_logo)?_c('button',{staticClass:"ml-sm-1 btn btn-success",staticStyle:{"min-width":"30%"},on:{"click":_vm.duplicate_logo}},[_vm._v("Yes, duplicate")]):_vm._e(),_vm._v(" "),(_vm.duplicating_logo)?_c('button',{staticClass:"ml-sm-1 btn btn-success",staticStyle:{"min-width":"30%"}},[_vm._v("Duplicating "),_c('span',{staticClass:"spinner-border spinner-border-sm"})]):_vm._e(),_vm._v(" "),(!_vm.duplicating_logo)?_c('button',{staticClass:"ml-sm-1 btn btn-danger",staticStyle:{"min-width":"30%"},on:{"click":_vm.hide_duplicate_modal}},[_vm._v("No, don't duplicate")]):_vm._e()]),_vm._v(" "),(_vm.duplicate_error)?_c('p',{staticClass:"lead"},[_vm._v("There was an error, please try again.")]):_vm._e()])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h6',{staticClass:"modal-title"},[_vm._v("Logo Preview")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bookmarked_logos_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55981ef6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bookmarked_logos_vue__ = __webpack_require__(61);
function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bookmarked_logos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55981ef6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bookmarked_logos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(60);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("04af41f7", content, true, {});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "a{color:#515151}.delete_btnhover:hover{color:#ee5150!important}.downloads_btnhover:hover,.preview_btnhover:hover{color:#073482!important}", ""]);

// exports


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content2"},[_c('vue-headful',{attrs:{"title":"Dashboard | Bookmarked Logos","description":"Dashboard | Bookmarked Logos"}}),_vm._v(" "),(_vm.propsdata[0].loading_logos)?_c('div',{staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.propsdata[0].loading_logos)?_c('div',{staticClass:"sc-bvTASY jPMoWD"},[(_vm.propsdata[0].logos !== null)?_c('div',{staticClass:"sc-cFlXAS WflZx"},[_c('div',{staticClass:"row"},_vm._l((_vm.propsdata[0].logos),function(logos,num){return _c('div',{key:logos.unique_id,staticClass:"col-md-12 col-lg-6-franco mb-4"},[_c('div',{staticClass:"pricing-card"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"row no-gutters align-items-center"},[_c('div',{staticClass:"col-sm-7"},[_c('header',{staticClass:"card-header text-center"},[_c('span',{staticClass:"d-block"},[_c('div',{staticClass:"sc-cmIlrE haTfuX dashboard-display-logo drag_disabled",style:('height: fit-content;width: -webkit-fill-available;background:'+logos.background+';'),attrs:{"data-toggle":"modal","data-target":"#modal-default"},on:{"click":function($event){_vm.logo_number(num)}}},[(_vm.propsdata[0].paid !== 'yes' && logos.one_time_payment !== 'yes')?_c('div',[(logos.svglogos_s3 === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/svglogos/'+logos.unique_id+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://svglogos.s3.amazonaws.com/'+logos.unique_id+'.svg?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || logos.one_time_payment === 'yes')?_c('div',[(logos.paid_svglogos_s3 === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-svglogos/'+logos.unique_id+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+logos.unique_id+'.svg?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5 elpaddingdelmobileversion",staticStyle:{"padding-top":"1.5rem","padding-bottom":"1.5rem"}},[_c('div',{staticClass:"sc-dBaXSw hCpORs"},[_c('div',{staticClass:"sc-ccLTTT fBHvCq"},[_c('div',{staticClass:"sc-hlILIN cLFOMf"},[_c('div',{staticClass:"sc-jQMNup eRizKN"},[(_vm.numeroedit !== num)?_c('a',{staticClass:"sc-bJHhxl kkRCtf",on:{"click":function($event){_vm.lapicito(num)}}},[_vm._v(_vm._s(logos.titulo))]):_vm._e(),_vm._v(" "),(_vm.edit && _vm.numeroedit === num)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide),expression:"hide"}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(logos.titulo),expression:"logos.titulo"}],staticStyle:{"background":"transparent","border":"transparent","outline":"none","border-bottom":"2px solid #0949b3","color":"#515151","width":"169px","padding":"0","font-weight":"300"},attrs:{"type":"text","placeholder":"Untitled","autofocus":"autofocus","onfocus":"this.select()"},domProps:{"value":(logos.titulo)},on:{"keyup":[function($event){_vm.edittitulo(num)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.hide($event)}],"input":function($event){if($event.target.composing){ return; }_vm.$set(logos, "titulo", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.numeroedit !== num)?_c('div',{staticClass:"sc-gAmQfK gQXEKA",on:{"click":function($event){_vm.lapicito(num)}}},[_c('div',{staticClass:"sc-hwwEjo leOORe"},[_c('div',{staticClass:"sc-hAXbOi jxPiur simptip-position-top simptip-smooth",attrs:{"data-tooltip":"Rename"}},[_c('svg',{staticStyle:{"margin-bottom":"10px"},attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"#0949b3","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sc-dphlzf hsJJHO",attrs:{"in":"exited"}})])]),_vm._v(" "),_c('div',{staticClass:"sc-bNQFlB jaiNr"},[_c('div',{staticClass:"sc-hizQCF dXstwa"},[_vm._v("Created "+_vm._s(logos.datetime))])]),_vm._v(" "),_c('div',{staticClass:"border-light border-bottom pb-1 mb-3"},[_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('a',{attrs:{"href":'/create/edit-logo/'+logos.unique_id+'?ref=edit'}},[_c('div',{staticStyle:{"display":"inline"}},[_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"#0949b3","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z"}})])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Edit")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('a',{staticClass:"preview_btnhover",attrs:{"data-toggle":"modal","data-target":"#modal-default"},on:{"click":function($event){_vm.logo_number(num)}}},[_c('div',{staticStyle:{"display":"inline"}},[_c('svg',{staticStyle:{"margin-right":"2px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","width":"22","height":"22","fill":"#0949b3"}},[_c('path',{attrs:{"d":"M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"}})])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Preview")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('a',{staticClass:"preview_btnhover",on:{"click":function($event){_vm.show_duplicate_modal(num)}}},[_c('i',{staticClass:"fa-solid fa-copy",staticStyle:{"color":"#0a49b3","margin-right":"5px","margin-left":"3px"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Duplicate")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('router-link',{staticClass:"preview_btnhover",attrs:{"to":'/dashboard/logo-files/'+logos.unique_id}},[_c('i',{staticClass:"fa-solid fa-paperclip",staticStyle:{"color":"#0a49b3","margin-right":"7px","margin-left":"3px"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Logo Files")])])],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('a',{staticClass:"preview_btnhover",on:{"click":function($event){_vm.el_sure2(num)}}},[_c('div',{staticStyle:{"display":"inline"}},[_c('svg',{staticClass:"icon icon-tabler icon-tabler-replace-filled",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 24 24","fill":"#0949b3"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8 2h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z","stroke-width":"0"}}),_vm._v(" "),_c('path',{attrs:{"d":"M20 14h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z","stroke-width":"0"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16.707 2.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.293 1.293h3.586a3 3 0 0 1 2.995 2.824l.005 .176v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-3a1 1 0 0 0 -.883 -.993l-.117 -.007h-3.585l1.292 1.293a1 1 0 0 1 -1.32 1.497l-.094 -.083l-3 -3a.98 .98 0 0 1 -.28 -.872l.036 -.146l.04 -.104c.058 -.126 .14 -.24 .245 -.334l2.959 -2.958a1 1 0 0 1 1.414 0z","stroke-width":"0"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3 12a1 1 0 0 1 .993 .883l.007 .117v3a1 1 0 0 0 .883 .993l.117 .007h3.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083l.094 .083l3 3a.98 .98 0 0 1 .28 .872l-.036 .146l-.04 .104a1.02 1.02 0 0 1 -.245 .334l-2.959 2.958a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.291 -1.293h-3.584a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-3a1 1 0 0 1 1 -1z","stroke-width":"0"}})])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Move to 'My Logos'")])])]),_vm._v(" "),(_vm.sure2 && _vm.numerosure2 === num)?_c('p',[_vm._v("Are you sure? "),_c('a',{staticStyle:{"color":"#5dba00"},on:{"click":function($event){_vm.move_to_my_logos(num)}}},[_vm._v("YES")]),_vm._v(" / "),_c('a',{staticStyle:{"color":"#ee5150"},on:{"click":function($event){_vm.el_sure2(num)}}},[_vm._v("NO")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-bottom":"12px"}},[_c('a',{staticClass:"delete_btnhover",on:{"click":function($event){_vm.el_sure(num)}}},[_c('div',{staticStyle:{"display":"inline"}},[_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"#ee5150","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8,19 L16,19 L16,13 L8,13 L8,19 Z M16,7 L20,7 L20,9 L4,9 L4,7 L8,7 L8,3 L16,3 L16,7 Z M14,7 L14,5 L10,5 L10,7 L14,7 Z M6,11 L18,11 L18,21 L6,21 L6,11 Z","fill-rule":"nonzero"}})])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline"}},[_vm._v("Delete")])])]),_vm._v(" "),(_vm.sure && _vm.numerosure === num)?_c('p',[_vm._v("Are you sure? "),_c('a',{staticStyle:{"color":"#5dba00"},on:{"click":function($event){_vm.delete_draft(num)}}},[_vm._v("YES")]),_vm._v(" / "),_c('a',{staticStyle:{"color":"#ee5150"},on:{"click":function($event){_vm.el_sure(num)}}},[_vm._v("NO")])]):_vm._e()]),_vm._v(" "),(_vm.propsdata[0].paid !== 'yes' && logos.one_time_payment !== 'yes')?_c('div',{staticStyle:{"display":"flex"}},[_c('a',{staticClass:"btn btn-success w-100",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?uil='+logos.unique_id+'&utm_campaign=dashboard_buy_logo'}},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"24","height":"24","fill":"#ffffff","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})]),_vm._v(" Download Logo\n                          ")])]):_c('div',{staticStyle:{"display":"flex"}},[_c('router-link',{staticClass:"btn btn-success w-100",attrs:{"to":'/dashboard/logo-files/'+logos.unique_id}},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"24","height":"24","fill":"#ffffff","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})]),_vm._v(" Download Logo\n                          ")])],1)])])])])])])}))]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.propsdata[0].logos === null || _vm.propsdata[0].logos.length === 0) && _vm.propsdata[0].logos_cargados)?_c('div',{staticClass:"padding_dsp_de_1435"},[_c('div',{staticClass:"sc-hcnlBt kVTXUr",staticStyle:{"max-width":"1120px","margin":"0 auto"}},[_c('h2',{staticClass:"sc-jRhVzh exltuq"},[_vm._v("Create Beautiful Logos")]),_vm._v(" "),_c('p',{staticClass:"sc-iHhHRJ iUpXMa"},[_vm._v("Our platform allows you to create, edit and download beautiful logos in just a few simple steps.")]),_vm._v(" "),_c('a',{staticClass:"sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ",staticStyle:{"color":"rgb(255, 255, 255)","display":"initial!important","background-color":"#ed1d62!important"},attrs:{"href":"/create/"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n  Create Logos Now")])])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].logos !== null && _vm.propsdata[0].logos_cargados)?_c('div',{staticClass:"modal fade",attrs:{"id":"modal-default","tabindex":"-1","role":"dialog","aria-labelledby":"modal-default","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"850px","height":"-webkit-fill-available"}},[_c('div',{staticClass:"modal-content modal-content-enmobile",staticStyle:{"height":"-webkit-fill-available"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body document_preview",staticStyle:{"overflow":"hidden auto","margin":"20px","padding":"0"}},[_c('div',[_c('div',{staticClass:"d-flex justify-content-center",style:('width: 100%; height: 404px; background: '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+'; font-size: 25px; font-weight: 600; text-align: center; vertical-align: middle; line-height: 400px; color: rgb(255, 255, 255); border-radius: 0.5rem;')},[_c('div',{staticClass:"less_scale_preview_mobile drag_disabled",staticStyle:{"transform":"scale(1)"}},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/svglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://svglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.svg?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.svg?'+_vm.timenow}})])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row mt-4 para-ponerlos-en-el-medio"},[_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-9.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-9"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-2.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-2"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-13.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-13"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-14.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-14"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-10.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-10"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4 para-que-no-se-achiquen-tanto"},[_c('div',{staticClass:"d-flex justify-content-center",style:('background: url("https://logo.app/create/mockups/mockup-4.png") center center / cover no-repeat, '+_vm.propsdata[0].logos[_vm.logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;')},[_c('div',[_c('div',{staticClass:"dashboard-arrange-svg-inside-mockup-4"},[(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] !== 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview]['one_time_payment'] === 'yes')?_c('div',[(_vm.propsdata[0].logos[_vm.logo_preview]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{attrs:{"src":'https://logo.app/paid-pnglogos/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})]):_c('div',[_c('img',{attrs:{"src":'https://paid-pnglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.logo_preview]['unique_id']+'.png?'+_vm.timenow}})])]):_vm._e()])])])])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"alert alert-secondary alert-dismissible fade show mb-0 classdefranco",staticStyle:{"border-radius":"0px","display":"flex","justify-content":"space-between","background-color":"#1266c9","border-color":"#1266c9"},attrs:{"role":"alert"}},[_c('span',{staticClass:"alert-inner--text textoenmobilemodal",staticStyle:{"font-size":"18px","line-height":"42px"}},[_vm._v("This is just a preview of your logo. Download it now and get the svg & png format.")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.logo_preview].one_time_payment === 'yes')?_c('a',{staticClass:"btn btn-white btn_del_continue",attrs:{"href":'/svg-download/'+_vm.propsdata[0].logos[_vm.logo_preview].unique_id+'/'+_vm.propsdata[0].logos[_vm.logo_preview].titulo_specialchars_out}},[_vm._v("Download")]):(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.logo_preview].one_time_payment !== 'yes')?_c('a',{staticClass:"btn btn-white btn_del_continue",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id+'?uil='+_vm.propsdata[0].logos[_vm.logo_preview].unique_id+'&utm_campaign=dashboard_preview_modal'}},[_vm._v("Download")]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.modal_duplicate)?_c('div',{staticClass:"modal",staticStyle:{"display":"block","padding-left":"0px","background-color":"rgba(103, 103, 103, 0.26)"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide_duplicate_modal),expression:"hide_duplicate_modal"}],staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"850px","height":"-webkit-fill-available"}},[_c('div',{staticClass:"modal-content modal-content-enmobile",staticStyle:{"max-height":"-webkit-fill-available"}},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Duplicate Logo")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.hide_duplicate_modal}},[(!_vm.duplicating_logo)?_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")]):_c('span',{staticClass:"spinner-border spinner-border-sm"})])]),_vm._v(" "),_c('div',{staticClass:"modal-body document_preview",staticStyle:{"overflow":"hidden auto","margin":"20px","padding":"0"}},[_c('h3',{staticClass:"text-center mb-3"},[_vm._v("Would you like to duplicate this logo?")]),_vm._v(" "),(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].logos[_vm.numeroduplicate]['one_time_payment'] !== 'yes')?_c('div',{staticClass:"text-center"},[(_vm.propsdata[0].logos[_vm.numeroduplicate]['svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{staticStyle:{"width":"233px","border-radius":"5px"},attrs:{"src":'https://logo.app/svglogos/'+_vm.propsdata[0].logos[_vm.numeroduplicate]['unique_id']+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{staticStyle:{"width":"233px","border-radius":"5px"},attrs:{"src":'https://svglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.numeroduplicate]['unique_id']+'.svg?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].logos[_vm.numeroduplicate]['one_time_payment'] === 'yes')?_c('div',{staticClass:"text-center"},[(_vm.propsdata[0].logos[_vm.numeroduplicate]['paid_svglogos_s3'] === 'needs_update')?_c('div',[_c('img',{staticStyle:{"width":"233px","border-radius":"5px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.propsdata[0].logos[_vm.numeroduplicate]['unique_id']+'.svg?'+_vm.timenow}})]):_c('div',[_c('img',{staticStyle:{"width":"233px","border-radius":"5px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.propsdata[0].logos[_vm.numeroduplicate]['unique_id']+'.svg?'+_vm.timenow}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py-3 text-center"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"d-sm-flex flex-column flex-sm-row mb-3 justify-content-center"},[(!_vm.duplicating_logo)?_c('button',{staticClass:"ml-sm-1 btn btn-success",staticStyle:{"min-width":"30%"},on:{"click":_vm.duplicate_logo}},[_vm._v("Yes, duplicate")]):_vm._e(),_vm._v(" "),(_vm.duplicating_logo)?_c('button',{staticClass:"ml-sm-1 btn btn-success",staticStyle:{"min-width":"30%"}},[_vm._v("Duplicating "),_c('span',{staticClass:"spinner-border spinner-border-sm"})]):_vm._e(),_vm._v(" "),(!_vm.duplicating_logo)?_c('button',{staticClass:"ml-sm-1 btn btn-danger",staticStyle:{"min-width":"30%"},on:{"click":_vm.hide_duplicate_modal}},[_vm._v("No, don't duplicate")]):_vm._e()]),_vm._v(" "),(_vm.duplicate_error)?_c('p',{staticClass:"lead"},[_vm._v("There was an error, please try again.")]):_vm._e()])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h6',{staticClass:"modal-title"},[_vm._v("Logo Preview")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_get_logo_files_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4f58f0c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_get_logo_files_vue__ = __webpack_require__(63);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_get_logo_files_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4f58f0c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_get_logo_files_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Select Brand","description":"Dashboard | Select Brand"}}),_vm._v(" "),_c('div',[_c('nav',{staticStyle:{"position":"fixed","width":"100%","height":"71px","background":"#ffffff","border-bottom":"1px solid #dde1ed","z-index":"99"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","height":"100%","justify-content":"space-between","margin-left":"20px","margin-right":"20px"}},[_c('router-link',{staticClass:"btn btn-light",attrs:{"to":"/dashboard/"}},[_c('i',{staticClass:"fa-solid fa-chevron-left mr-2"}),_vm._v(" Back")])],1)]),_vm._v(" "),(_vm.loading_logos)?_c('div',{staticClass:"pt-7",staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_c('div',{staticClass:"container"},[_c('div',{staticClass:"pt-7"},[_c('h1',[_vm._v("Select your brand")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Select the brand you want to use to get the logo files.")]),_vm._v(" "),(_vm.logos !== null && _vm.logos.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.logos),function(logo,index){return _c('router-link',{staticClass:"col-6 col-md-4 col-lg-3",staticStyle:{"margin-bottom":"20px"},attrs:{"to":'/dashboard/logo-files/'+logo.unique_id}},[_c('div',{staticClass:"aumentarscale_btn",staticStyle:{"width":"100%","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"}},[(logo.paid_svglogos_s3 === 'needs_update')?_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+_vm.timenow}})]):_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+_vm.timenow}})])])])})):_c('div',[_c('p',{staticClass:"lead"},[_vm._v("No logos created in this account.")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"/create/"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n                Create Logos Now")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logo_files_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9a6f15_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logo_files_vue__ = __webpack_require__(67);
function injectStyle (ssrContext) {
  __webpack_require__(65)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logo_files_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9a6f15_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logo_files_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(66);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("a1fbdf9e", content, true, {});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".offscreen{position:absolute;visibility:hidden;width:1px;height:1px;overflow:hidden;left:0;top:0}", ""]);

// exports


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content2 setmargin"},[_c('vue-headful',{attrs:{"title":"Dashboard | Logo Files","description":"Dashboard | Logo Files"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticStyle:{"margin":"0 auto","padding":"70px 0px 0px !important"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"sc-kAdXeD jwoEpG",staticStyle:{"padding":"40px 0px 0px !important"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.high_res_color_logo_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("High Resolution Color Logo")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.high_res_color_logo_svgcode, 'High-Resolution-Color-Logo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.high_res_color_logo_svgcode, 'High-Resolution-Color-Logo')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.high_res_black_white_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: #ffffff;')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("High Resolution Logo Black on White Background")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.high_res_black_white_svgcode, 'High-Resolution-Logo-Black-on-White-Background')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.high_res_black_white_svgcode, 'High-Resolution-Logo-Black-on-White-Background')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.high_res_white_black_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: #000000;')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("High Resolution Logo White on Black Background")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.high_res_white_black_svgcode, 'High-Resolution-Logo-White-on-Black-Background')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.high_res_white_black_svgcode, 'High-Resolution-Logo-White-on-Black-Background')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.high_res_color_logo_transparent_bg_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("High Resolution Color Logo on Transparent Background")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.high_res_color_logo_transparent_bg_svgcode, 'High-Resolution-Color-Logo-on-Transparent-Background')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.high_res_color_logo_transparent_bg_svgcode, 'High-Resolution-Color-Logo-on-Transparent-Background')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.high_res_black_transparent_bg_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("High Resolution Logo Black on Transparent Background")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.high_res_black_transparent_bg_svgcode, 'High-Resolution-Logo-Black-on-Transparent-Background')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.high_res_black_transparent_bg_svgcode, 'High-Resolution-Logo-Black-on-Transparent-Background')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.high_res_white_transparent_bg_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("High Resolution Logo White on Transparent Background")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.high_res_white_transparent_bg_svgcode, 'High-Resolution-Logo-White-on-Transparent-Background')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.high_res_white_transparent_bg_svgcode, 'High-Resolution-Logo-White-on-Transparent-Background')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.icononly_original_color_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("Icon Only - Color")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.icononly_original_color_svgcode, 'Icon-Only-Color')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.icononly_original_color_svgcode, 'Icon-Only-Color')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.icononly_black_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("Icon Only - Black")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.icononly_black_svgcode, 'Icon-Only-Black')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.icononly_black_svgcode, 'Icon-Only-Black')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.icononly_white_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("Icon Only - White")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.icononly_white_svgcode, 'Icon-Only-White')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.icononly_white_svgcode, 'Icon-Only-White')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.only_business_slogan_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("Without Icon - Color")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.only_business_slogan_svgcode, 'Without-Icon-Color')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.only_business_slogan_svgcode, 'Without-Icon-Color')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.only_business_slogan_black_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("Without Icon - Black")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.only_business_slogan_black_svgcode, 'Without-Icon-Black')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.only_business_slogan_black_svgcode, 'Without-Icon-Black')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.only_business_slogan_white_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("Without Icon - White")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.only_business_slogan_white_svgcode, 'Without-Icon-White')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.only_business_slogan_white_svgcode, 'Without-Icon-White')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.favicon_original_color_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px; scale: 0.3;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("Website Favicon - Color")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.favicon_original_color_svgcode, 'Website-Favicon-Color')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.favicon_original_color_svgcode, 'Website-Favicon-Color')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.favicon_black_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px; scale: 0.3;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("Website Favicon - Black")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.favicon_black_svgcode, 'Website-Favicon-Black')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.favicon_black_svgcode, 'Website-Favicon-Black')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticStyle:{"background-position":"0px 0px, 10px 10px","background-size":"20px 20px","background-image":"linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%)"}},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.favicon_white_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px; scale: 0.3;')})]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-3"},[_vm._v("Website Favicon - White")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.favicon_white_svgcode, 'Website-Favicon-White')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.favicon_white_svgcode, 'Website-Favicon-White')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"d-block d-lg-flex",staticStyle:{"border":"1px solid rgb(221, 221, 221)"}},[_c('div',{staticClass:"w-100",style:('background: ' + 
      (_vm.logo.background_gradient > 0 
        ? this.gradients[_vm.logo.background_gradient].css 
        : _vm.logo.background_color) + 
      ';font-size: 18px;font-weight: 600;text-align: center;vertical-align: middle;line-height: 102px;color: rgb(255, 255, 255);text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000;')},[_vm._v(_vm._s(_vm.logo.background_gradient > 0 ? 'GRADIENT' : _vm.logo.background_color))]),_vm._v(" "),(_vm.logo.container_num !== '0')?_c('div',{staticClass:"w-100",style:('background: ' + 
      (_vm.logo.container_gradient > 0 
        ? this.gradients[_vm.logo.container_gradient].css 
        : _vm.logo.container_color) + 
      ';font-size: 18px;font-weight: 600;text-align: center;vertical-align: middle;line-height: 102px;color: rgb(255, 255, 255);text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000;')},[_vm._v(_vm._s(_vm.logo.container_gradient > 0 ? 'GRADIENT' : _vm.logo.container_color))]):_vm._e(),_vm._v(" "),(_vm.logo.layout !== '3')?_c('div',{staticClass:"w-100",style:('background: ' + 
      (_vm.logo.icon_gradient > 0 
        ? this.gradients[_vm.logo.icon_gradient].css 
        : _vm.logo.icon_color) + 
      ';font-size: 18px;font-weight: 600;text-align: center;vertical-align: middle;line-height: 102px;color: rgb(255, 255, 255);text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000;')},[_vm._v(_vm._s(_vm.logo.icon_gradient > 0 ? 'GRADIENT' : _vm.logo.icon_color))]):_vm._e(),_vm._v(" "),(_vm.logo.business_name_color)?_c('div',{staticClass:"w-100",style:('background: ' + 
      (_vm.logo.business_name_gradient > 0 
        ? this.gradients[_vm.logo.business_name_gradient].css 
        : _vm.logo.business_name_color) + 
      ';font-size: 18px;font-weight: 600;text-align: center;vertical-align: middle;line-height: 102px;color: rgb(255, 255, 255);text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000;')},[_vm._v(_vm._s(_vm.logo.business_name_gradient > 0 ? 'GRADIENT' : _vm.logo.business_name_color))]):_vm._e(),_vm._v(" "),(_vm.logo.slogan)?_c('div',{staticClass:"w-100",style:('background: ' + 
      (_vm.logo.slogan_gradient > 0 
        ? this.gradients[_vm.logo.slogan_gradient].css 
        : _vm.logo.slogan_color) + 
      ';font-size: 18px;font-weight: 600;text-align: center;vertical-align: middle;line-height: 102px;color: rgb(255, 255, 255);text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000;')},[_vm._v(_vm._s(_vm.logo.slogan_gradient > 0 ? 'GRADIENT' : _vm.logo.slogan_color))]):_vm._e()]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"mb-4 bg-white",staticStyle:{"border":"1px solid rgb(221, 221, 221)","border-radius":"0.5rem"}},[_c('div',{staticClass:"d-block d-lg-flex"},[(_vm.logo.monogram === 'yes')?_c('div',{staticClass:"p-3 w-100"},[_c('p',{staticClass:"text-gray mb-2"},[_vm._v("Monogram Font")]),_vm._v(" "),_c('h4',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.logo.monogram_font_name))]),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"btn btn-blue w-100",staticStyle:{"color":"#ffffff"},attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('a',{staticClass:"btn btn-blue w-100",staticStyle:{"color":"#ffffff"},attrs:{"href":'https://logo.app/fonts/'+_vm.logo.monogram_font_ttf,"download":_vm.logo.monogram_font_ttf}},[_vm._v(" Download ")])]):_vm._e(),_vm._v(" "),(_vm.logo.business_name)?_c('div',{staticClass:"p-3 w-100"},[_c('p',{staticClass:"text-gray mb-2"},[_vm._v("Business Name Font")]),_vm._v(" "),_c('h4',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.logo.business_name_font_name))]),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"btn btn-blue w-100",staticStyle:{"color":"#ffffff"},attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('a',{staticClass:"btn btn-blue w-100",staticStyle:{"color":"#ffffff"},attrs:{"href":'https://logo.app/fonts/'+_vm.logo.business_name_font_ttf,"download":_vm.logo.monogram_fobusiness_name_font_ttfnt_ttf}},[_vm._v(" Download ")])]):_vm._e(),_vm._v(" "),(_vm.logo.slogan)?_c('div',{staticClass:"p-3 w-100"},[_c('p',{staticClass:"text-gray mb-2"},[_vm._v("Slogan Font")]),_vm._v(" "),_c('h4',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.logo.slogan_font_name))]),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"btn btn-blue w-100",staticStyle:{"color":"#ffffff"},attrs:{"data-toggle":"modal","data-target":"#modal-logo-files"}},[_vm._v(" Download ")]):_c('a',{staticClass:"btn btn-blue w-100",staticStyle:{"color":"#ffffff"},attrs:{"href":'https://logo.app/fonts/'+_vm.logo.slogan_font_ttf,"download":_vm.logo.slogan_font_ttf}},[_vm._v(" Download ")])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"offscreen",attrs:{"id":"svgContainer-edit"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"mb-4 sinpaddingmobile",staticStyle:{"padding-top":"60px"}},[_c('h2',{staticClass:"f342fdw",staticStyle:{"color":"#4a5073"}},[_vm._v("Your Logo Files")]),_vm._v(" "),_c('p',[_vm._v("Access your logo in the most common formats and sizes. Easily download all your files and view the details of the colors and fonts used in your logo.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("High Resolution Logo")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("Essentials")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("Favicon")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("Color Palette")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("Typography")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_get_profiles_and_covers_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31142ea9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_get_profiles_and_covers_vue__ = __webpack_require__(69);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_get_profiles_and_covers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31142ea9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_get_profiles_and_covers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Select Brand","description":"Dashboard | Select Brand"}}),_vm._v(" "),_c('div',[_c('nav',{staticStyle:{"position":"fixed","width":"100%","height":"71px","background":"#ffffff","border-bottom":"1px solid #dde1ed","z-index":"99"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","height":"100%","justify-content":"space-between","margin-left":"20px","margin-right":"20px"}},[_c('router-link',{staticClass:"btn btn-light",attrs:{"to":"/dashboard/"}},[_c('i',{staticClass:"fa-solid fa-chevron-left mr-2"}),_vm._v(" Back")])],1)]),_vm._v(" "),(_vm.loading_logos)?_c('div',{staticClass:"pt-7",staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_c('div',{staticClass:"container"},[_c('div',{staticClass:"pt-7"},[_c('h1',[_vm._v("Select your brand")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Select the brand you want to get rhe Profiles and Covers.")]),_vm._v(" "),(_vm.logos !== null && _vm.logos.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.logos),function(logo,index){return _c('router-link',{staticClass:"col-6 col-md-4 col-lg-3",staticStyle:{"margin-bottom":"20px"},attrs:{"to":'/dashboard/profiles-and-covers/'+logo.unique_id}},[_c('div',{staticClass:"aumentarscale_btn",staticStyle:{"width":"100%","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"}},[(logo.paid_svglogos_s3 === 'needs_update')?_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+_vm.timenow}})]):_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+_vm.timenow}})])])])})):_c('div',[_c('p',{staticClass:"lead"},[_vm._v("No logos created in this account.")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"/create/"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n                Create Logos Now")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profiles_and_covers_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ade38e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profiles_and_covers_vue__ = __webpack_require__(73);
function injectStyle (ssrContext) {
  __webpack_require__(71)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profiles_and_covers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ade38e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profiles_and_covers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(72);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("cbb79742", content, true, {});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".offscreen{position:absolute;visibility:hidden;width:1px;height:1px;overflow:hidden;left:0;top:0}", ""]);

// exports


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content2 setmargin"},[_c('vue-headful',{attrs:{"title":"Dashboard | Profiles and Covers","description":"Dashboard | Profiles and Covers"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticStyle:{"margin":"0 auto","padding":"70px 0px 0px !important"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"sc-kAdXeD jwoEpG",staticStyle:{"padding":"40px 0px 0px !important"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.instagram_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Instagram Profile Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(1000x1000)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.instagram_profile_photo_svgcode, 'Instagram-Profile-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.instagram_profile_photo_svgcode, 'Instagram-Profile-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.instagram_story_photo_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Instagram Story Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(1080x1920)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.instagram_story_photo_svgcode, 'Instagram-Story-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.instagram_story_photo_svgcode, 'Instagram-Story-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.instagram_post_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Instagram Post Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(1080x1080)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.instagram_post_photo_svgcode, 'Instagram-Post-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.instagram_post_photo_svgcode, 'Instagram-Post-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.facebook_cover_image_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Facebook Cover Image")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(2460x936)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.facebook_cover_image_svgcode, 'Facebook-Cover-Image')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.facebook_cover_image_svgcode, 'Facebook-Cover-Image')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.facebook_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Facebook Profile Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(1500x1500)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.facebook_profile_photo_svgcode, 'Facebook-Profile-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.facebook_profile_photo_svgcode, 'Facebook-Profile-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.x_header_photo_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("X Header Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(1500x500)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.x_header_photo_svgcode, 'X-Header-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.x_header_photo_svgcode, 'X-Header-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.x_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("X Profile Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(800x800)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.x_profile_photo_svgcode, 'X-Profile-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.x_profile_photo_svgcode, 'X-Profile-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.linkedin_cover_image_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("LinkedIn Cover Image")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(1584x396)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.linkedin_cover_image_svgcode, 'LinkedIn-Cover-Image')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.linkedin_cover_image_svgcode, 'LinkedIn-Cover-Image')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.linkedin_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("LinkedIn Profile Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(1200x1200)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.linkedin_profile_photo_svgcode, 'LinkedIn-Profile-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.linkedin_profile_photo_svgcode, 'LinkedIn-Profile-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.youtube_channel_art_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("YouTube Channel Art")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(2048x1152)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.youtube_channel_art_svgcode, 'YouTube-Channel-Art')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.youtube_channel_art_svgcode, 'YouTube-Channel-Art')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.youtube_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("YouTube Profile Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(800x800)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.youtube_profile_photo_svgcode, 'YouTube-Profile-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.youtube_profile_photo_svgcode, 'YouTube-Profile-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.tiktok_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("TikTok Profile Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(800x800)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.tiktok_profile_photo_svgcode, 'TikTok-Profile-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.tiktok_profile_photo_svgcode, 'TikTok-Profile-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.etsy_cover_image_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Etsy Cover Image")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(2990x747)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.etsy_cover_image_svgcode, 'Etsy-Cover-Image')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.etsy_cover_image_svgcode, 'Etsy-Cover-Image')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.etsy_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Etsy Profile Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(800x800)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.etsy_profile_photo_svgcode, 'Etsy-Profile-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.etsy_profile_photo_svgcode, 'Etsy-Profile-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.etsy_shop_photo_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Etsy Shop Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(1520x200)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.etsy_shop_photo_svgcode, 'Etsy-Shop-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.etsy_shop_photo_svgcode, 'Etsy-Shop-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.pinterest_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Pinterest Profile Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(720x720)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.pinterest_profile_photo_svgcode, 'Pinterest-Profile-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.pinterest_profile_photo_svgcode, 'Pinterest-Profile-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.pinterest_cover_image_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Pinterest Cover Image")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(1200x1200)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.pinterest_cover_image_svgcode, 'Pinterest-Cover-Image')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.pinterest_cover_image_svgcode, 'Pinterest-Cover-Image')}}},[_vm._v("SVG")])]):_vm._e()])])])])]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"blog-card col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body px-0",style:('background-image: url('+_vm.files.whatsapp_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+_vm.logo.background_color+';')}),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('h5',{staticClass:"mb-2"},[_vm._v("WhatsApp Profile Photo")]),_vm._v(" "),_c('p',{staticClass:"small text-gray"},[_vm._v("(1000x1000)")]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-profiles-and-covers"}},[_vm._v(" Download ")]):_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Download ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(_vm.files.whatsapp_profile_photo_svgcode, 'WhatsApp-Profile-Photo')}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(_vm.files.whatsapp_profile_photo_svgcode, 'WhatsApp-Profile-Photo')}}},[_vm._v("SVG")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"offscreen",attrs:{"id":"svgContainer-edit"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"mb-4 sinpaddingmobile",staticStyle:{"padding-top":"60px"}},[_c('h2',{staticClass:"f342fdw",staticStyle:{"color":"#4a5073"}},[_vm._v("Profiles and Covers")]),_vm._v(" "),_c('p',[_vm._v("Profile and cover images for Facebook, Instagram, LinkedIn, Twitter, YouTube, Etsy, Pinterest, Zoom, and more.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("Instagram")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("Facebook")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("X (Formerly Twitter)")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("LinkedIn")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("YouTube")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("TikTok")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("Etsy")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("Pinterest")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0",staticStyle:{"color":"#4a5073"}},[_vm._v("WhatsApp")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#e9ebee!important"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exclusive_deals_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a108e46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exclusive_deals_vue__ = __webpack_require__(77);
function injectStyle (ssrContext) {
  __webpack_require__(75)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exclusive_deals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a108e46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exclusive_deals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(76);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("15fb9a45", content, true, {});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "a{color:#515151}.delete_btnhover:hover{color:#ee5150!important}.downloads_btnhover:hover,.preview_btnhover:hover{color:#073482!important}", ""]);

// exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content2"},[_c('vue-headful',{attrs:{"title":"Dashboard | My Logos","description":"Dashboard | My Logos"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/stripe-atlas.png","alt":"image"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://stripe.com/atlas"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/intuit-quickbooks.png","alt":"image"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://refer.quickbooks.ca/s/franco"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/wix.webp","alt":"image"}}),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://www.wix.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/google-ads.png","alt":"image"}}),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://ads.google.com/home/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/microsoft-advertising.webp","alt":"image"}}),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://ads.microsoft.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/1password.webp","alt":"image"}}),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://1password.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/xero.png","alt":"image"}}),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://www.xero.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/hubspot.png","alt":"image"}}),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://www.hubspot.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/typeform.png","alt":"image"}}),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://typeform.cello.so/bgMcrt6kaQl"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/sprout-social.webp","alt":"image"}}),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://sproutsocial.pxf.io/c/5556004/1970543/19698"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/deel.png","alt":"image"}}),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://www.deel.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/zoom.png","alt":"image"}}),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://zoom.us/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/squarespace.webp","alt":"image"}}),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://www.squarespace.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/shopify.webp","alt":"image"}}),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://shopify.pxf.io/logodesign"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/google-cloud.webp","alt":"image"}}),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://cloud.google.com"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/convertkit.png","alt":"image"}}),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://convertkit.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/mercury.png","alt":"image"}}),_vm._v(" "),_vm._m(33),_vm._v(" "),_vm._m(34),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://mercury.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/godaddy.png","alt":"image"}}),_vm._v(" "),_vm._m(35),_vm._v(" "),_vm._m(36),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://www.godaddy.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/square.webp","alt":"image"}}),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://squareup.com/signup"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/hostinger.webp","alt":"image"}}),_vm._v(" "),_vm._m(39),_vm._v(" "),_vm._m(40),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://www.hostinger.com/"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4 d-flex"},[_c('div',{staticClass:"blog-card w-100"},[_c('div',{staticClass:"card shadow-soft border-light h-100"},[_c('img',{staticClass:"card-img-top",staticStyle:{"height":"120px"},attrs:{"src":"/exclusive-deals/bluehost.png","alt":"image"}}),_vm._v(" "),_vm._m(41),_vm._v(" "),_vm._m(42),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-success w-100",attrs:{"data-toggle":"modal","data-target":"#modal-exclusive-deals"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")]):_c('a',{staticClass:"btn btn-success w-100",attrs:{"target":"_blank","href":"https://bluehost.sjv.io/logodesign"}},[_c('span',{staticClass:"fas fa-award mr-2"}),_vm._v("Claim Offer\n            ")])])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-kAdXeD jwoEpG",staticStyle:{"padding":"40px 20px 0px !important"}},[_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"sinpaddingmobile",staticStyle:{"display":"flex","justify-content":"space-between","padding-top":"60px"}},[_c('h4',{staticClass:"f342fdw",staticStyle:{"color":"rgb(74, 80, 115)"}},[_c('i',{staticClass:"fa-solid fa-icons mr-2"}),_vm._v(" Exclusive Deals")])]),_vm._v(" "),_c('p',[_vm._v("Save up to $4,500 while growing your business through our exclusive deals.")]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Gain Access")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Stripe Atlas")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Incorporate your startup")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Stripe Atlas streamlines the process of starting a global business, providing tools for company formation, banking, and payment processing.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Save $144")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Intuit QuickBooks")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Save 75% for 6 months")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Intuit QuickBooks simplifies accounting and financial management for small businesses with powerful tools and intuitive interfaces.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Gain Access")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Wix")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Create a website without limits")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Create your website and grow with confidence. From an intuitive website builder to advanced business solutions & powerful SEO tools")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Save $500")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Google Ads")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Get $500 in free ad credit")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Google Ads helps businesses attract more customers by displaying ads in Google search results and across the web.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Save $250")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Microsoft Advertising")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Receive $250 in credits when you spend $50")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Microsoft Advertising connects businesses with potential customers through targeted ads on Bing, Yahoo, and partner sites.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Gain Access")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("1Password")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Password Manager")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("1Password securely stores and manages your passwords, ensuring easy access and robust protection for your digital life.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Try for FREE")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Xero")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Accounting software to do your to-do")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Xero offers cloud-based accounting software designed for small businesses, simplifying financial management and bookkeeping.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Try for FREE")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("HubSpot")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Free 30-day trial")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("HubSpot provides comprehensive marketing, sales, and customer service software to help businesses grow and enhance customer relationships.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Free Access")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Typeform")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Free 30-day trial")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Typeform creates engaging, conversational forms and surveys, enhancing user experience and boosting response rates.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Save up to 25%")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Sprout Social")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Powerful solution for social media management")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Sprout Social offers powerful social media management tools to streamline content planning, publishing, and analytics.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Free")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Deel")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Payroll for global teams")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Deel simplifies global payroll and compliance for remote teams, making international hiring and payments easy and efficient.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Free")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Zoom")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("One platform to connect")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Zoom offers reliable video conferencing and communication tools for virtual meetings, webinars, and online collaboration.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Free trial")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Squarespace")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Get your free website trial today")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Squarespace provides an all-in-one platform for building beautiful websites, online stores, and portfolios with ease.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("$1 Access")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Shopify")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Enjoy your first month for just $1")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Shopify enables businesses to create, customize, and manage online stores, offering tools for e-commerce success.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Start for free")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Google Cloud")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Get $300 in free credits")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Google Cloud provides scalable, secure cloud solutions for businesses, enhancing infrastructure, data management, and application development.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Free trial")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("ConvertKit")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Sustainable growth tools for creators")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("ConvertKit offers powerful email marketing tools for creators, helping to grow audiences and increase engagement.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Gain Access")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Mercury")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Smart banking")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Mercury provides modern banking solutions tailored for startups and small businesses, offering seamless financial management.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Discounted extensions")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Godaddy")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Register your new domain")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("GoDaddy offers domain registration, website hosting, and online business solutions to help individuals and businesses establish their online presence.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Free sign up")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Square")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Sell anywhere easily, quickly, and seamlessly")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Square provides versatile payment solutions and business tools to streamline sales, from in-person transactions to online stores.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("2 Months Free")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Hostinger")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("Everything You Need to Create a Website")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Hostinger offers affordable web hosting solutions with robust features, ensuring fast and reliable website performance.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"post-meta d-block d-sm-flex justify-content-between"},[_c('h6',{staticClass:"icon-success mb-0"},[_vm._v("Free Domain for 1st Year")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body pt-0"},[_c('h4',[_vm._v("Bluehost")]),_vm._v(" "),_c('p',{staticClass:"card-text my-2"},[_vm._v("The Best Web Hosting")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Bluehost provides reliable web hosting services with comprehensive tools for building and managing websites effortlessly.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_business_cards_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d64bd1c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_business_cards_vue__ = __webpack_require__(81);
function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_business_cards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d64bd1c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_business_cards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(80);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2c090e78", content, true, {});

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "a{color:#515151}.delete_btnhover:hover{color:#ee5150!important}.downloads_btnhover:hover,.preview_btnhover:hover{color:#073482!important}.offscreen{position:absolute;visibility:hidden;width:1px;height:1px;overflow:hidden;left:0;top:0}", ""]);

// exports


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content2"},[_c('vue-headful',{attrs:{"title":"Dashboard | Business Cards","description":"Dashboard | Business Cards"}}),_vm._v(" "),(_vm.loading_business_cards)?_c('div',{staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.loading_business_cards)?_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"sc-cFlXAS WflZx"},[(_vm.business_cards !== null && _vm.business_cards.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.business_cards),function(business_card,index){return _c('div',{staticClass:"blog-card col-12 col-lg-6"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"show",staticStyle:{"position":"absolute","right":"0px"}},[_c('button',{staticClass:"btn btn-sm btn-light",staticStyle:{"border-radius":"0px"},on:{"click":function($event){_vm.open_dropdown(index)}}},[_vm._m(0,true),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Toggle Dropdown")])]),_vm._v(" "),(_vm.dropdown === index)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close_dropdown),expression:"close_dropdown"}],staticStyle:{"position":"absolute","will-change":"transform","top":"-12px","left":"-68px","transform":"translate3d(0px, 42px, 0px)","background-color":"#ffffff","padding":"0.7rem 0","margin":"0.125rem 0 0","font-size":"0.875rem","z-index":"1000","border":"0 solid rgba(36, 38, 43, 0.15)","border-radius":"0.2rem","box-shadow":"0 1rem 3rem rgba(13, 20, 49, 0.175)","line-height":"1.5"}},[_c('a',{staticClass:"dropdown-item text-danger",staticStyle:{"padding":".5rem 1rem","font-size":"0.875rem"},on:{"click":function($event){_vm.open_modal_delete(index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can mr-2"}),_vm._v(" Delete\n                    ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-body p-0 pb-3",attrs:{"id":'businesscard-'+index}},[(business_card.template === '1')?_c('svg',{staticClass:"svg-card",attrs:{"id":'svgFront-'+business_card.unique_id,"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"222","height":"250","fill":"white"}}),_vm._v(" "),_c('rect',{attrs:{"x":"222","y":"0","width":"278","height":"250","fill":business_card.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"roundedClip"}},[_c('rect',{attrs:{"x":"16","y":"30","width":"190","height":"190","rx":"5","ry":"5"}})])]),_vm._v(" "),_c('image',{attrs:{"href":business_card.logo_base64,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip)"}}),_vm._v(" "),_c('g',{ref:'textGroup-'+index,refInFor:true,attrs:{"transform":_vm.calculateGroupTransform(index)}},[(business_card.name)?_c('text',{attrs:{"x":"235","y":"0","font-family":"Arial","font-size":_vm.calculateFontSize(business_card.name, 24),"fill":business_card.name_color}},[_vm._v(_vm._s(business_card.name))]):_vm._e(),_vm._v(" "),(business_card.role)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition(index, 'role'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.role, 18),"fill":business_card.role_color}},[_vm._v(_vm._s(business_card.role))]):_vm._e(),_vm._v(" "),(business_card.phone)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition(index, 'phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.phone, 14),"fill":business_card.phone_color}},[_vm._v(_vm._s(business_card.phone))]):_vm._e(),_vm._v(" "),(business_card.email)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition(index, 'email'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.email, 14),"fill":business_card.email_color}},[_vm._v(_vm._s(business_card.email))]):_vm._e(),_vm._v(" "),(business_card.website)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition(index, 'website'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.website, 14),"fill":business_card.website_color}},[_vm._v(_vm._s(business_card.website))]):_vm._e(),_vm._v(" "),(business_card.address)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition(index, 'address'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.address, 14),"fill":business_card.address_color}},[_vm._v(_vm._s(business_card.address))]):_vm._e()])]):_vm._e(),_vm._v(" "),(business_card.template === '2')?_c('svg',{staticClass:"svg-card",attrs:{"id":'svgFront-'+business_card.unique_id,"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":business_card.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"circleClip2"}},[_c('ellipse',{attrs:{"cx":"400","cy":"125","rx":"73.5","ry":"73.5"}})])]),_vm._v(" "),_c('image',{attrs:{"href":business_card.logo_base64,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip2)"}}),_vm._v(" "),_c('g',{ref:'textGroup-'+index,refInFor:true,attrs:{"transform":_vm.calculateGroupTransform(index)}},[(business_card.name)?_c('text',{attrs:{"x":"30","y":"0","font-family":"Arial","font-size":_vm.calculateFontSize(business_card.name, 24),"fill":business_card.name_color}},[_vm._v(_vm._s(business_card.name))]):_vm._e(),_vm._v(" "),(business_card.role)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition(index, 'role'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.role, 18),"fill":business_card.role_color}},[_vm._v(_vm._s(business_card.role))]):_vm._e(),_vm._v(" "),(business_card.phone)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition(index, 'phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.phone, 14),"fill":business_card.phone_color}},[_vm._v(_vm._s(business_card.phone))]):_vm._e(),_vm._v(" "),(business_card.email)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition(index, 'email'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.email, 14),"fill":business_card.email_color}},[_vm._v(_vm._s(business_card.email))]):_vm._e(),_vm._v(" "),(business_card.website)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition(index, 'website'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.website, 14),"fill":business_card.website_color}},[_vm._v(_vm._s(business_card.website))]):_vm._e(),_vm._v(" "),(business_card.address)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition(index, 'address'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.address, 14),"fill":business_card.address_color}},[_vm._v(_vm._s(business_card.address))]):_vm._e()])]):_vm._e(),_vm._v(" "),(business_card.template === '3')?_c('svg',{staticClass:"svg-card",attrs:{"id":'svgFront-'+business_card.unique_id,"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":business_card.background_color}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(470, 0) rotate(90)"}},[_c('defs',[_c('clipPath',{attrs:{"id":"circleClip3"}},[_c('ellipse',{attrs:{"cx":"125","cy":"100","rx":"70","ry":"70"}})])]),_vm._v(" "),_c('image',{attrs:{"href":business_card.logo_base64,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip3)"}}),_vm._v(" "),_c('g',{ref:'textGroup-'+index,refInFor:true,attrs:{"transform":"translate(0, 240)"}},[(business_card.name)?_c('text',{attrs:{"x":"125","y":"0","font-family":"Cursive","font-size":_vm.calculateFontSize(business_card.name, 24),"fill":business_card.name_color,"text-anchor":"middle"}},[_vm._v(_vm._s(business_card.name))]):_vm._e(),_vm._v(" "),(business_card.role)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition(index, 'role'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.role, 18),"fill":business_card.role_color,"text-anchor":"middle"}},[_vm._v(_vm._s(business_card.role))]):_vm._e(),_vm._v(" "),(business_card.phone)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition(index, 'phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.phone, 14),"fill":business_card.phone_color,"text-anchor":"middle"}},[_vm._v(_vm._s(business_card.phone))]):_vm._e(),_vm._v(" "),(business_card.email)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition(index, 'email'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.email, 14),"fill":business_card.email_color,"text-anchor":"middle"}},[_vm._v(_vm._s(business_card.email))]):_vm._e(),_vm._v(" "),(business_card.website)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition(index, 'website'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.website, 14),"fill":business_card.website_color,"text-anchor":"middle"}},[_vm._v(_vm._s(business_card.website))]):_vm._e(),_vm._v(" "),(business_card.address)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition(index, 'address'),"font-family":"Arial","font-size":_vm.calculateFontSize(business_card.address, 14),"fill":business_card.address_color,"text-anchor":"middle"}},[_vm._v(_vm._s(business_card.address))]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"offscreen"},[_c('svg',{attrs:{"id":'svgBack-'+business_card.unique_id,"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 250","preserveAspectRatio":"xMidYMid meet"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":business_card.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"circleClip1"}},[_c('ellipse',{attrs:{"cx":"250","cy":"125","rx":"73.5","ry":"73.5"}})])]),_vm._v(" "),_c('image',{attrs:{"href":business_card.logo_base64,"height":"147","width":"147","y":"51.5","x":"176.5","clip-path":"url(#circleClip1)"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[_c('div',{staticClass:"d-flex justify-content-center"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('div',{staticClass:"col-6 mr-2 p-0"},[_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-business-cards"}},[_vm._v("\n                            Download\n                        ")])]):_c('div',{staticClass:"col-6 mr-2 p-0"},[_c('button',{staticClass:"btn btn-blue w-100 dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                            Download\n                        ")]),_vm._v(" "),(_vm.propsdata[0].paid === 'yes')?_c('div',{staticClass:"dropdown-menu w-100 text-center"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPngFile(business_card.unique_id)}}},[_vm._v("PNG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadSvgFile(business_card.unique_id)}}},[_vm._v("SVG")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.downloadPdfFile(business_card.unique_id)}}},[_vm._v("PDF")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-6 ml-2 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-light w-100",attrs:{"data-toggle":"modal","data-target":"#modal-business-cards"}},[_vm._v("\n                            Edit business card\n                        ")]):_c('router-link',{staticClass:"btn btn-light w-100",attrs:{"to":'/dashboard/edit-business-card/'+business_card.unique_id}},[_vm._v("\n                            Edit business card\n                        ")])],1)])])])])})):_c('div',[_c('div',{staticClass:"row row-grid align-items-center"},[_c('div',{staticClass:"col-12 col-lg-5"},[_c('h2',{staticClass:"font-weight-bolder mb-4"},[_vm._v("Business Card Maker")]),_vm._v(" "),_c('p',[_vm._v("Get custom business card designs that are already branded with your logo and business information.")]),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-primary mt-3 animate-up-2",attrs:{"data-toggle":"modal","data-target":"#modal-business-cards"}},[_vm._v("\n                Create your business card\n            ")]):_c('router-link',{staticClass:"btn btn-primary mt-3 animate-up-2",attrs:{"to":"/dashboard/create-business-card"}},[_vm._v("Create your business card")])],1),_vm._v(" "),_vm._m(1)])])])]):_vm._e(),_vm._v(" "),(_vm.business_card_to_delete !== '')?_c('div',{staticClass:"modal",staticStyle:{"display":"block !important","background":"rgba(147, 152, 165, 0.35)","overflow":"auto"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close_modal_delete),expression:"close_modal_delete"}],staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header w-100"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Delete business card")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button"},on:{"click":_vm.close_modal_delete}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-light mr-auto",on:{"click":_vm.close_modal_delete}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.delete_business_card}},[_vm._v("Delete")])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon icon-sm"},[_c('span',{staticClass:"fas fa-ellipsis-h icon-dark"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6 ml-lg-auto"},[_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":"https://logo.app/assets/img/business-card-maker.png","alt":"image"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"mb-0"},[_vm._v("Are you sure you want to delete your business card?"),_c('br'),_vm._v("This action is irreversible and cannot be undone.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_business_card_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_341d3b1b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_business_card_vue__ = __webpack_require__(83);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_business_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_341d3b1b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_business_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Create Business Card","description":"Dashboard | Create Business Card"}}),_vm._v(" "),_c('div',[_c('nav',{staticStyle:{"position":"fixed","width":"100%","height":"71px","background":"#ffffff","border-bottom":"1px solid #dde1ed","z-index":"99"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","height":"100%","justify-content":"space-between","margin-left":"20px","margin-right":"20px"}},[_c('button',{staticClass:"btn btn-light",on:{"click":_vm.back}},[_c('i',{staticClass:"fa-solid fa-chevron-left mr-2"}),_vm._v(" Back")])])]),_vm._v(" "),(_vm.loading_logos)?_c('div',{staticClass:"pt-7",staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_c('div',{staticClass:"container"},[(_vm.step === '1')?_c('div',{staticClass:"pt-7"},[_c('progress',{staticClass:"w-100 mb-3",attrs:{"value":"1","max":"3"}},[_vm._v("Step 1 of 3")]),_vm._v(" "),_c('h1',[_vm._v("Select your brand")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Select the brand you want to use for your Business Card.")]),_vm._v(" "),(_vm.logos !== null && _vm.logos.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.logos),function(logo,index){return _c('div',{staticClass:"col-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.logo_unique_id === logo.unique_id },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.choose_logo(logo.unique_id, logo.paid_svglogos_s3);}}},[(logo.paid_svglogos_s3 === 'needs_update')?_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+_vm.timenow}})]):_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+_vm.timenow}})])])])})):_c('div',[_c('p',{staticClass:"lead"},[_vm._v("No logos created in this account.")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"/create/"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n                  Create Logos Now")])])]):_vm._e(),_vm._v(" "),(_vm.step === '2')?_c('div',{staticClass:"pt-7"},[_c('progress',{staticClass:"w-100 mb-3",attrs:{"value":"2","max":"3"}},[_vm._v("Step 2 of 3")]),_vm._v(" "),_c('h1',[_vm._v("Pick a template")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Select a professional template. You can always customize it later.")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"justify-content":"center"}},[_c('div',{staticClass:"col-12 col-lg-4 col-md-6"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '1' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.choose_template('1');}}},[_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","justify-content":"center","align-items":"center"}},[(_vm.creating_business_card && _vm.template === '1')?_c('div',{staticClass:"spinner-border text-gray",staticStyle:{"position":"absolute","top":"65px","left":"43%","width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"222","y":"0","width":"278","height":"250","fill":"white"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"0","width":"222","height":"250","fill":"white"}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"roundedClip"}},[_c('rect',{attrs:{"x":"16","y":"30","width":"190","height":"190","rx":"5","ry":"5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip)"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(0, 56.75)"}},[_c('text',{attrs:{"x":"235","y":"0","font-family":"Arial","font-size":"24","fill":"#000000"}},[_vm._v("John Doe")]),_vm._v(" "),_c('text',{attrs:{"x":"235","y":"30","font-family":"Arial","font-size":"18","fill":"#000000"}},[_vm._v("CEO")]),_vm._v(" "),_c('text',{attrs:{"x":"235","y":"80","font-family":"Arial","font-size":"14","fill":"#000000"}},[_vm._v("555 555-5555")]),_vm._v(" "),_c('text',{attrs:{"x":"235","y":"105","font-family":"Arial","font-size":"14","fill":"#000000"}},[_vm._v("hello@website.com")]),_vm._v(" "),_c('text',{attrs:{"x":"235","y":"130","font-family":"Arial","font-size":"14","fill":"#3f83f8"}},[_vm._v("www.mybrand.com")]),_vm._v(" "),_c('text',{attrs:{"x":"235","y":"155","font-family":"Arial","font-size":"14","fill":"#000000"}},[_vm._v("123 Main Street Los Angeles")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 col-md-6"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '2' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.choose_template('2');}}},[_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","justify-content":"center","align-items":"center"}},[(_vm.creating_business_card && _vm.template === '2')?_c('div',{staticClass:"spinner-border text-gray",staticStyle:{"position":"absolute","top":"65px","left":"43%","width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":"white"}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"circleClip2"}},[_c('ellipse',{attrs:{"cx":"400","cy":"125","rx":"73.5","ry":"73.5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip2)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip2)"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(0, 56.75)"}},[_c('text',{attrs:{"x":"30","y":"0","font-family":"Arial","font-size":"24","fill":"#000000"}},[_vm._v("John Doe")]),_vm._v(" "),_c('text',{attrs:{"x":"30","y":"30","font-family":"Arial","font-size":"18","fill":"#000000"}},[_vm._v("CEO")]),_vm._v(" "),_c('text',{attrs:{"x":"30","y":"80","font-family":"Arial","font-size":"14","fill":"#000000"}},[_vm._v("555 555-5555")]),_vm._v(" "),_c('text',{attrs:{"x":"30","y":"105","font-family":"Arial","font-size":"14","fill":"#000000"}},[_vm._v("hello@website.com")]),_vm._v(" "),_c('text',{attrs:{"x":"30","y":"130","font-family":"Arial","font-size":"14","fill":"#3f83f8"}},[_vm._v("www.mybrand.com")]),_vm._v(" "),_c('text',{attrs:{"x":"30","y":"155","font-family":"Arial","font-size":"14","fill":"#000000"}},[_vm._v("123 Main Street Los Angeles")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 col-md-6"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '3' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.choose_template('3');}}},[_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","justify-content":"center","align-items":"center"}},[(_vm.creating_business_card && _vm.template === '3')?_c('div',{staticClass:"spinner-border text-gray",staticStyle:{"position":"absolute","top":"65px","left":"43%","width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":"white"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(470, 0) rotate(90)"}},[_c('defs',[_c('clipPath',{attrs:{"id":"circleClip3"}},[_c('ellipse',{attrs:{"cx":"125","cy":"100","rx":"70","ry":"70"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip3)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip3)"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(0, 240)"}},[_c('text',{attrs:{"x":"125","y":"0","font-family":"Cursive","font-size":"24","fill":"#000000","text-anchor":"middle"}},[_vm._v("John Doe")]),_vm._v(" "),_c('text',{attrs:{"x":"125","y":"30","font-family":"Arial","font-size":"18","fill":"#000000","text-anchor":"middle"}},[_vm._v("CEO")]),_vm._v(" "),_c('text',{attrs:{"x":"125","y":"80","font-family":"Arial","font-size":"14","fill":"#000000","text-anchor":"middle"}},[_vm._v("555 555-5555")]),_vm._v(" "),_c('text',{attrs:{"x":"125","y":"105","font-family":"Arial","font-size":"14","fill":"#000000","text-anchor":"middle"}},[_vm._v("hello@website.com")]),_vm._v(" "),_c('text',{attrs:{"x":"125","y":"130","font-family":"Arial","font-size":"14","fill":"#3f83f8","text-anchor":"middle"}},[_vm._v("www.mybrand.com")]),_vm._v(" "),_c('text',{attrs:{"x":"125","y":"155","font-family":"Arial","font-size":"14","fill":"#000000","text-anchor":"middle"}},[_vm._v("123 Main Street Los Angeles")])])])])])])])])]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_business_card_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8d1a812_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_business_card_vue__ = __webpack_require__(85);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_business_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8d1a812_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_business_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Edit Business Card","description":"Dashboard | Edit Business Card"}}),_vm._v(" "),_c('div',[_c('nav',{staticStyle:{"position":"fixed","width":"100%","height":"71px","background":"#ffffff","border-bottom":"1px solid #dde1ed","z-index":"99"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","height":"100%","justify-content":"space-between","margin-left":"20px","margin-right":"20px"}},[_c('router-link',{staticClass:"btn btn-light",attrs:{"to":"/dashboard/business-cards"}},[_c('i',{staticClass:"fa-solid fa-chevron-left mr-2"}),_vm._v(" Back")]),_vm._v(" "),(!_vm.finishing_business_card)?_c('button',{staticClass:"btn btn-success",on:{"click":_vm.save_business_card}},[_vm._v("Finish")]):_vm._e(),_vm._v(" "),(_vm.finishing_business_card)?_c('button',{staticClass:"btn btn-success"},[_vm._v("Finishing...")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"d-lg-none",staticStyle:{"position":"fixed","bottom":"-1px","left":"0px","background":"rgb(255, 255, 255)","width":"-webkit-fill-available","box-shadow":"rgba(170, 170, 170, 0.18) 10px 10px 10px 10px !important","z-index":"2"}},[(_vm.tab !== '')?_c('div',{staticStyle:{"padding":"10px 10px 0 10px"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-between",staticStyle:{"border-bottom":"1px solid #e8e8e8"}},[(_vm.tab === 'information' || _vm.tab === '')?_c('p',{staticClass:"display-4 mb-0"},[_vm._v("Information")]):_vm._e(),_vm._v(" "),(_vm.tab === 'design')?_c('p',{staticClass:"display-4 mb-0"},[_vm._v("Design")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn d-flex align-items-center pt-2 pb-2 pl-2 pr-0",staticStyle:{"font-size":"23px"},on:{"click":function($event){_vm.change_tab('')}}},[_c('i',{staticClass:"fa-solid fa-square-xmark ml-1"})])]),_vm._v(" "),_c('div',{staticClass:"overflow-auto col-12 height-navigation-mobile_emailsignature",staticStyle:{"width":"100%","padding-top":"15px"}},[_c('div',{staticClass:"pt-2"},[(_vm.loading_business_card)?_c('div',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]):_c('div',[(_vm.tab === 'information' || _vm.tab === '')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"John Doe"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Role")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.role),expression:"role"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CEO"},domProps:{"value":(_vm.role)},on:{"input":function($event){if($event.target.composing){ return; }_vm.role=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control",attrs:{"type":"tel","placeholder":"555 555-5555"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"hello@website.com"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website),expression:"website"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(_vm.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"123 Main Street"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(5),_vm._v(" "),(_vm.logo_unique_id !== '')?_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"col"},[(_vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow}}):_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow}})]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('button',{staticClass:"btn btn-danger mt-2",on:{"click":function($event){_vm.logo_unique_id = ''}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.show_modal_logo}},[_vm._v("Change Logo")])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"text-center mb-3"},[(_vm.template === '1')?_c('div',[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"222","height":"250","fill":"white"}}),_vm._v(" "),_c('rect',{attrs:{"x":"222","y":"0","width":"278","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"roundedClip2"}},[_c('rect',{attrs:{"x":"16","y":"30","width":"190","height":"190","rx":"5","ry":"5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip2)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip2)"}}),_vm._v(" "),_c('g',{ref:"textGroup-1",attrs:{"transform":_vm.calculateGroupTransform('1')}},[(_vm.name)?_c('text',{attrs:{"x":"235","y":"0","font-family":"Arial","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.template === '2')?_c('div',[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"circleClip3"}},[_c('ellipse',{attrs:{"cx":"400","cy":"125","rx":"73.5","ry":"73.5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip3)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip3)"}}),_vm._v(" "),_c('g',{ref:"textGroup-2",attrs:{"transform":_vm.calculateGroupTransform('2')}},[(_vm.name)?_c('text',{attrs:{"x":"30","y":"0","font-family":"Arial","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.template === '3')?_c('div',[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(470, 0) rotate(90)"}},[_c('defs',[_c('clipPath',{attrs:{"id":"circleClip4"}},[_c('ellipse',{attrs:{"cx":"125","cy":"100","rx":"70","ry":"70"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip4)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip4)"}}),_vm._v(" "),_c('g',{ref:"textGroup-3",attrs:{"transform":"translate(0, 240)"}},[(_vm.name)?_c('text',{attrs:{"x":"125","y":"0","font-family":"Cursive","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])])]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.show_modal_template}},[_vm._v("Change Template")])])]):_vm._e(),_vm._v(" "),(_vm.tab === 'design')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Background Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.background_color),expression:"background_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.background_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.background_color),expression:"background_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.background_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Name Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name_color),expression:"name_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.name_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name_color),expression:"name_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.name_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Role Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.role_color),expression:"role_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.role_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.role_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.role_color),expression:"role_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.role_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.role_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Phone Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone_color),expression:"phone_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.phone_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone_color),expression:"phone_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.phone_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Email Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email_color),expression:"email_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.email_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email_color),expression:"email_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.email_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Website Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website_color),expression:"website_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.website_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website_color),expression:"website_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.website_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Address Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address_color),expression:"address_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.address_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address_color),expression:"address_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.address_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address_color=$event.target.value}}})])])])])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex",staticStyle:{"white-space":"nowrap","overflow":"scroll","border-top":"1px solid #dfe0e6","padding":"8px"}},[_c('a',{staticClass:"d-flex flex-column align-items-center p-2 col-6",class:{ 'active-tab-sidebar-create': _vm.tab === 'information' },staticStyle:{"border-radius":"0.5rem","min-width":"80px"},on:{"click":function($event){_vm.change_tab('information')}}},[_c('i',{staticClass:"fa-solid fa-a mb-2",staticStyle:{"color":"rgb(223, 224, 230)"}}),_vm._v(" "),_c('span',{staticClass:"text-center"},[_vm._v("Information")])]),_vm._v(" "),_c('a',{staticClass:"d-flex flex-column align-items-center p-2 col-6",class:{ 'active-tab-sidebar-create': _vm.tab === 'design' },staticStyle:{"border-radius":"0.5rem","min-width":"80px"},on:{"click":function($event){_vm.change_tab('design')}}},[_c('i',{staticClass:"fa-solid fa-palette mb-2",staticStyle:{"color":"rgb(223, 224, 230)"}}),_vm._v(" "),_c('span',{staticClass:"text-center"},[_vm._v("Design")])])])]),_vm._v(" "),_c('nav',{staticClass:"sidebar-create d-lg-block bg-dark text-white",staticStyle:{"background-color":"#ffffff!important","border-right":"1px solid #dde1ed!important","display":"none"},attrs:{"id":"sidebarMenu"}},[_c('div',{staticClass:"sidebar-inner px-4 pt-6"},[_c('ul',{staticClass:"nav flex-column sidebar-top-mobile"},[_vm._m(8),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.change_tab('information')}}},[_c('a',{staticClass:"nav-link collapsed d-flex align-items-center",class:{ 'active-tab-sidebar-create': _vm.tab === 'information' }},[_c('i',{staticClass:"fa-solid fa-a mr-3",staticStyle:{"color":"rgb(223, 224, 230)"}}),_vm._v(" "),_c('span',[_vm._v("Information")])])]),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.change_tab('design')}}},[_c('a',{staticClass:"nav-link collapsed d-flex align-items-center",class:{ 'active-tab-sidebar-create': _vm.tab === 'design' }},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(223, 224, 230)","margin-right":"12px"}}),_vm._v(" "),_c('span',[_vm._v("Design")])])])])])]),_vm._v(" "),_c('div',{staticClass:"sidebar-create px-4 pt-6 d-lg-block secondary-sidebar",staticStyle:{"display":"none"}},[_c('div',{staticClass:"pt-2"},[(_vm.loading_business_card)?_c('div',[_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12)]):_c('div',[(_vm.tab === 'information' || _vm.tab === '')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"John Doe"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Role")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.role),expression:"role"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CEO"},domProps:{"value":(_vm.role)},on:{"input":function($event){if($event.target.composing){ return; }_vm.role=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control",attrs:{"type":"tel","placeholder":"555 555-5555"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"hello@website.com"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website),expression:"website"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(_vm.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"123 Main Street"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(14),_vm._v(" "),(_vm.logo_unique_id !== '')?_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"col"},[(_vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow}}):_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow}})]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('button',{staticClass:"btn btn-danger mt-2",on:{"click":function($event){_vm.logo_unique_id = ''}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.show_modal_logo}},[_vm._v("Change Logo")])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(15),_vm._v(" "),_c('div',{staticClass:"text-center mb-3"},[(_vm.template === '1')?_c('div',[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"222","height":"250","fill":"white"}}),_vm._v(" "),_c('rect',{attrs:{"x":"222","y":"0","width":"278","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"roundedClip2"}},[_c('rect',{attrs:{"x":"16","y":"30","width":"190","height":"190","rx":"5","ry":"5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip2)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip2)"}}),_vm._v(" "),_c('g',{ref:"textGroup-4",attrs:{"transform":_vm.calculateGroupTransform('4')}},[(_vm.name)?_c('text',{attrs:{"x":"235","y":"0","font-family":"Arial","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.template === '2')?_c('div',[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"circleClip3"}},[_c('ellipse',{attrs:{"cx":"400","cy":"125","rx":"73.5","ry":"73.5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip3)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip3)"}}),_vm._v(" "),_c('g',{ref:"textGroup-5",attrs:{"transform":_vm.calculateGroupTransform('5')}},[(_vm.name)?_c('text',{attrs:{"x":"30","y":"0","font-family":"Arial","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.template === '3')?_c('div',[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(470, 0) rotate(90)"}},[_c('defs',[_c('clipPath',{attrs:{"id":"circleClip4"}},[_c('ellipse',{attrs:{"cx":"125","cy":"100","rx":"70","ry":"70"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip4)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip4)"}}),_vm._v(" "),_c('g',{ref:"textGroup-6",attrs:{"transform":"translate(0, 240)"}},[(_vm.name)?_c('text',{attrs:{"x":"125","y":"0","font-family":"Cursive","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])])]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.show_modal_template}},[_vm._v("Change Template")])])]):_vm._e(),_vm._v(" "),(_vm.tab === 'design')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(16),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Background Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.background_color),expression:"background_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.background_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.background_color),expression:"background_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.background_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Name Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name_color),expression:"name_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.name_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name_color),expression:"name_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.name_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Role Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.role_color),expression:"role_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.role_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.role_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.role_color),expression:"role_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.role_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.role_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Phone Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone_color),expression:"phone_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.phone_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone_color),expression:"phone_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.phone_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Email Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email_color),expression:"email_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.email_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email_color),expression:"email_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.email_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Website Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website_color),expression:"website_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.website_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website_color),expression:"website_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.website_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Address Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address_color),expression:"address_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.address_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address_color),expression:"address_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.address_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address_color=$event.target.value}}})])])])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"margin-espacio-del-sidebar-create pt-6 pt-lg-0"},[(_vm.loading_business_card)?_c('div',{staticClass:"pt-0 pt-lg-6 mb-6 ml-3 mr-3"},[_vm._m(17)]):_c('div',[_c('div',{staticClass:"container pt-2 vertically-centered-on-desktop",staticStyle:{"overflow-x":"hidden"}},[_c('div',{staticClass:"blog-card col-12 m-auto p-0 pt-lg-6",staticStyle:{"max-width":"500px"}},[(_vm.template === '1')?_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"222","height":"250","fill":"white"}}),_vm._v(" "),_c('rect',{attrs:{"x":"222","y":"0","width":"278","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"roundedClip3"}},[_c('rect',{attrs:{"x":"16","y":"30","width":"190","height":"190","rx":"5","ry":"5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip3)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip3)"}}),_vm._v(" "),_c('g',{ref:"textGroup-7",attrs:{"transform":_vm.calculateGroupTransform('7')}},[(_vm.name)?_c('text',{attrs:{"x":"235","y":"0","font-family":"Arial","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.template === '2')?_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"circleClip5"}},[_c('ellipse',{attrs:{"cx":"400","cy":"125","rx":"73.5","ry":"73.5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip5)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip5)"}}),_vm._v(" "),_c('g',{ref:"textGroup-8",attrs:{"transform":_vm.calculateGroupTransform('8')}},[(_vm.name)?_c('text',{attrs:{"x":"30","y":"0","font-family":"Arial","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.template === '3')?_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(470, 0) rotate(90)"}},[_c('defs',[_c('clipPath',{attrs:{"id":"circleClip6"}},[_c('ellipse',{attrs:{"cx":"125","cy":"100","rx":"70","ry":"70"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip6)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip6)"}}),_vm._v(" "),_c('g',{ref:"textGroup-9",attrs:{"transform":"translate(0, 240)"}},[(_vm.name)?_c('text',{attrs:{"x":"125","y":"0","font-family":"Cursive","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 250","preserveAspectRatio":"xMidYMid meet"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"circleClip7"}},[_c('ellipse',{attrs:{"cx":"250","cy":"125","rx":"73.5","ry":"73.5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"176.5","clip-path":"url(#circleClip7)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"176.5","clip-path":"url(#circleClip7)"}})])])])])])])]),_vm._v(" "),(_vm.modal_template)?_c('div',{staticClass:"modal",staticStyle:{"display":"block !important","background":"rgba(147, 152, 165, 0.35)","overflow":"auto"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide_modal_template),expression:"hide_modal_template"}],staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"800px"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header w-100"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Choose a different template")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button"},on:{"click":_vm.hide_modal_template}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-4"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '1' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#F5F5F5"},on:{"click":function($event){_vm.update_template('1');}}},[_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex"}},[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"222","height":"250","fill":"white"}}),_vm._v(" "),_c('rect',{attrs:{"x":"222","y":"0","width":"278","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"roundedClip4"}},[_c('rect',{attrs:{"x":"16","y":"30","width":"190","height":"190","rx":"5","ry":"5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip4)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"190","width":"190","y":"30","x":"16","clip-path":"url(#roundedClip4)"}}),_vm._v(" "),_c('g',{ref:"textGroup-10",attrs:{"transform":_vm.calculateGroupTransform('10')}},[(_vm.name)?_c('text',{attrs:{"x":"235","y":"0","font-family":"Arial","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"235","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-4"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '2' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#F5F5F5"},on:{"click":function($event){_vm.update_template('2');}}},[_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex"}},[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"circleClip8"}},[_c('ellipse',{attrs:{"cx":"400","cy":"125","rx":"73.5","ry":"73.5"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip8)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"147","width":"147","y":"51.5","x":"326.5","clip-path":"url(#circleClip8)"}}),_vm._v(" "),_c('g',{ref:"textGroup-11",attrs:{"transform":_vm.calculateGroupTransform('11')}},[(_vm.name)?_c('text',{attrs:{"x":"30","y":"0","font-family":"Arial","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"30","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-4"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '3' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#F5F5F5"},on:{"click":function($event){_vm.update_template('3');}}},[_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex"}},[_c('svg',{staticClass:"svg-card",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 500 250"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"500","height":"250","fill":_vm.background_color}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(470, 0) rotate(90)"}},[_c('defs',[_c('clipPath',{attrs:{"id":"circleClip9"}},[_c('ellipse',{attrs:{"cx":"125","cy":"100","rx":"70","ry":"70"}})])]),_vm._v(" "),(_vm.paid_svglogos_s3 === 'needs_update')?_c('image',{attrs:{"href":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip9)"}}):_c('image',{attrs:{"href":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"height":"140","width":"140","y":"30","x":"55","clip-path":"url(#circleClip9)"}}),_vm._v(" "),_c('g',{ref:"textGroup-12",attrs:{"transform":"translate(0, 240)"}},[(_vm.name)?_c('text',{attrs:{"x":"125","y":"0","font-family":"Cursive","font-size":_vm.calculateFontSize(_vm.name, 24),"fill":_vm.name_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),(_vm.role)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('role'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.role, 18),"fill":_vm.role_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('phone'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.phone, 14),"fill":_vm.phone_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(_vm.email)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('email'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.email, 14),"fill":_vm.email_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.website)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('website'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.website, 14),"fill":_vm.website_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.website))]):_vm._e(),_vm._v(" "),(_vm.address)?_c('text',{attrs:{"x":"125","y":_vm.getYPosition('address'),"font-family":"Arial","font-size":_vm.calculateFontSize(_vm.address, 14),"fill":_vm.address_color,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.address))]):_vm._e()])])])])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.modal_logo)?_c('div',{staticClass:"modal",staticStyle:{"display":"block !important","background":"rgba(147, 152, 165, 0.35)","overflow":"auto"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide_modal_logo),expression:"hide_modal_logo"}],staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"800px"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header w-100"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Choose a different logo")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button"},on:{"click":_vm.hide_modal_logo}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.loading_logos)?_c('div',{staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_c('div',[(_vm.logos !== null && _vm.logos.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.logos),function(logo,index){return _c('div',{staticClass:"col-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.logo_unique_id === logo.unique_id },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.update_logo(logo.unique_id, logo.paid_svglogos_s3);}}},[(logo.paid_svglogos_s3 === 'needs_update')?_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+_vm.timenow}})]):_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+_vm.timenow}})])])])})):_c('div',[_c('p',{staticClass:"lead text-center"},[_vm._v("No logos created in this account.")])])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#dddddd","height":"200px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine200"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-a",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"3px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-image",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Logo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-layer-group",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"-1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Template")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Design")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"margin-left":"11px","margin-bottom":"0.8rem","margin-top":"0.8rem","font-weight":"900","color":"rgb(74 80 115)","font-size":"15px"}},[_c('i',{staticClass:"fas fa-pencil",staticStyle:{"margin-right":"7px"}}),_vm._v("Business Card")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#dddddd","height":"200px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine200"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-a",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"3px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-image",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Logo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-layer-group",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"-1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Template")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Design")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-2"},[_c('div',{staticStyle:{"background":"#ffffff","height":"500px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine500_white"})]),_vm._v(" "),_c('div',{staticClass:"mt-3",staticStyle:{"background":"#ffffff","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20_white"})]),_vm._v(" "),_c('div',{staticClass:"mt-3",staticStyle:{"background":"#ffffff","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20_white"})]),_vm._v(" "),_c('div',{staticClass:"mt-3",staticStyle:{"background":"#ffffff","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20_white"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_email_signatures_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b1c1a7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_email_signatures_vue__ = __webpack_require__(89);
function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_email_signatures_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b1c1a7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_email_signatures_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(88);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ef3c1f78", content, true, {});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "a{color:#515151}.delete_btnhover:hover{color:#ee5150!important}.downloads_btnhover:hover,.preview_btnhover:hover{color:#073482!important}", ""]);

// exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content2"},[_c('vue-headful',{attrs:{"title":"Dashboard | Email Signatures","description":"Dashboard | Email Signatures"}}),_vm._v(" "),(_vm.loading_email_signatures)?_c('div',{staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.loading_email_signatures)?_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"sc-cFlXAS WflZx"},[(_vm.email_signatures !== null && _vm.email_signatures.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.email_signatures),function(email_signature,index){return _c('div',{staticClass:"blog-card col-12 col-lg-6"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"show",staticStyle:{"position":"absolute","right":"0px"}},[_c('button',{staticClass:"btn btn-sm btn-light",staticStyle:{"border-radius":"0px 6px 0px 0px"},on:{"click":function($event){_vm.open_dropdown(index)}}},[_vm._m(0,true),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Toggle Dropdown")])]),_vm._v(" "),(_vm.dropdown === index)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close_dropdown),expression:"close_dropdown"}],staticStyle:{"position":"absolute","will-change":"transform","top":"-12px","left":"-170px","transform":"translate3d(0px, 42px, 0px)","background-color":"#ffffff","padding":"0.7rem 0","margin":"0.125rem 0 0","font-size":"0.875rem","z-index":"1000","border":"0 solid rgba(36, 38, 43, 0.15)","border-radius":"0.2rem","box-shadow":"0 1rem 3rem rgba(13, 20, 49, 0.175)","line-height":"1.5"}},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"dropdown-item",staticStyle:{"padding":".5rem 1rem","font-size":"0.875rem"},attrs:{"data-toggle":"modal","data-target":"#modal-email-signatures"}},[_c('i',{staticClass:"fa-brands fa-readme mr-2"}),_vm._v(" Set up email signature\n                    ")]):_c('router-link',{staticClass:"dropdown-item",staticStyle:{"padding":".5rem 1rem","font-size":"0.875rem"},attrs:{"to":'/dashboard/set-up-email-signature/'+email_signature.unique_id}},[_c('i',{staticClass:"fa-brands fa-readme mr-2"}),_vm._v(" Set up email signature\n                    ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item text-danger",staticStyle:{"padding":".5rem 1rem","font-size":"0.875rem"},on:{"click":function($event){_vm.open_modal_delete(index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can mr-2"}),_vm._v(" Delete\n                    ")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-body px-0",staticStyle:{"margin":"0 auto"},attrs:{"id":'signature-'+index}},[(email_signature.template === '1')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[(email_signature.logo_unique_id !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"4px 16px 0px 0px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0","width":"120px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(email_signature.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"50%"},attrs:{"src":'https://logo.app/paid-svglogos/'+email_signature.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"50%"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+email_signature.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})])])])]),_vm._v(" "),(email_signature.powered_by === 'yes')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin":"6px auto 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(1,true)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","border-left":"1px solid rgb(0, 0, 0)","padding":"0px 0px 0px 16px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 18px; margin: 0px; padding: 0px 20px 0px 0px; color: '+email_signature.name_color+'; white-space: nowrap; font-weight: bold;')},[_vm._v(_vm._s(email_signature.name))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 8px 0px 0px; color: '+email_signature.subtitle_color+'; white-space: nowrap;')},[_vm._v(_vm._s(email_signature.company))]),_vm._v(" "),_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 20px 0px 8px; color: '+email_signature.subtitle_color+'; white-space: nowrap; border-left: 1px solid '+email_signature.subtitle_color+';')},[_vm._v(_vm._s(email_signature.role))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'tel:'+email_signature.phone,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(email_signature.phone))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'mailto:'+email_signature.email,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(email_signature.email))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":email_signature.website,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{style:('font-size: 12px; margin: 0px; padding: 0px 20px 0px 0px; color: '+email_signature.links_color+'; white-space: nowrap;')},[_vm._v(_vm._s(email_signature.website))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'https://www.google.com/maps/search/?api=1&query='+email_signature.address,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(email_signature.address))])])])]),_vm._v(" "),(email_signature.social_links.length > 0)?_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"8px 0px 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',_vm._l((email_signature.social_links),function(link,index){return (link.media !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":link.url,"target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[(link.media === 'ArtStation')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}})]):(link.media === 'Behance')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}})]):(link.media === 'Discord')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}})]):(link.media === 'Facebook')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})]):(link.media === 'GitHub')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}})]):(link.media === 'Instagram')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})]):(link.media === 'LinkedIn')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"}})]):(link.media === 'Medium')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"}})]):(link.media === 'Patreon')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}})]):(link.media === 'Pinterest')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})]):(link.media === 'Reddit')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}})]):(link.media === 'Snapchat')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"}})]):(link.media === 'TikTok')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}})]):(link.media === 'Tumblr')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}})]):(link.media === 'Twitch')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}})]):(link.media === 'Twitter')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"}})]):(link.media === 'Vimeo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}})]):(link.media === 'Weibo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}})]):(link.media === 'WhatsApp')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})]):(link.media === 'X')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M297.751 221.1L461.125 31.5H422.411L280.553 196.127L167.251 31.5H36.5714L207.906 280.445L36.5714 479.27H75.2881L225.094 305.418L344.749 479.27H475.429L297.742 221.1H297.751ZM244.723 282.639L227.363 257.849L89.2383 60.5979H148.705L260.174 219.786L277.533 244.575L422.429 451.495H362.963L244.723 282.648V282.639Z"}})]):(link.media === 'YouTube')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}})]):_vm._e()])])])]):_vm._e()}))])])])]):_vm._e(),_vm._v(" "),(email_signature.powered_by === 'yes' && email_signature.logo_unique_id === '')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin-top":"10px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(2,true)]):_vm._e()])])])])])]):_vm._e(),_vm._v(" "),(email_signature.template === '2')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[(email_signature.logo_unique_id !== '')?_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px"},attrs:{"cellpadding":"0","cellspacing":"0","width":"120px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(email_signature.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://logo.app/paid-svglogos/'+email_signature.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+email_signature.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})])])])])])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 0px 6px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","border-bottom":"1px solid rgb(0, 0, 0)"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px","padding":"0px"}},[_c('span',{style:('font-size: 18px; margin: 0px; padding: 0px; color: '+email_signature.name_color+'; white-space: nowrap; font-weight: bold;')},[_vm._v(_vm._s(email_signature.name))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px","padding":"0px 0px 6px"}},[_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 8px 0px 0px; color: '+email_signature.subtitle_color+'; white-space: nowrap;')},[_vm._v(_vm._s(email_signature.company))]),_vm._v(" "),_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 0px 0px 8px; color: '+email_signature.subtitle_color+'; white-space: nowrap; border-left: 1px solid '+email_signature.subtitle_color+';')},[_vm._v(_vm._s(email_signature.role))])])])])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'tel:'+email_signature.phone,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(email_signature.phone))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'mailto:'+email_signature.email,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(email_signature.email))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":email_signature.website,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{style:('font-size: 12px; margin: 0px; padding: 0px; color: '+email_signature.links_color+'; white-space: nowrap;')},[_vm._v(_vm._s(email_signature.website))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'https://www.google.com/maps/search/?api=1&query='+email_signature.address,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(email_signature.address))])])])]),_vm._v(" "),_c('tr',[(email_signature.social_links.length > 0)?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"8px 0px 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',_vm._l((email_signature.social_links),function(link,index){return (link.media !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":link.url,"target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[(link.media === 'ArtStation')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}})]):(link.media === 'Behance')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}})]):(link.media === 'Discord')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}})]):(link.media === 'Facebook')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})]):(link.media === 'GitHub')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}})]):(link.media === 'Instagram')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})]):(link.media === 'LinkedIn')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"}})]):(link.media === 'Medium')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"}})]):(link.media === 'Patreon')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}})]):(link.media === 'Pinterest')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})]):(link.media === 'Reddit')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}})]):(link.media === 'Snapchat')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"}})]):(link.media === 'TikTok')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}})]):(link.media === 'Tumblr')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}})]):(link.media === 'Twitch')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}})]):(link.media === 'Twitter')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"}})]):(link.media === 'Vimeo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}})]):(link.media === 'Weibo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}})]):(link.media === 'WhatsApp')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})]):(link.media === 'X')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M297.751 221.1L461.125 31.5H422.411L280.553 196.127L167.251 31.5H36.5714L207.906 280.445L36.5714 479.27H75.2881L225.094 305.418L344.749 479.27H475.429L297.742 221.1H297.751ZM244.723 282.639L227.363 257.849L89.2383 60.5979H148.705L260.174 219.786L277.533 244.575L422.429 451.495H362.963L244.723 282.648V282.639Z"}})]):(link.media === 'YouTube')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}})]):_vm._e()])])])]):_vm._e()}))])])]):_vm._e()]),_vm._v(" "),(email_signature.powered_by === 'yes')?_c('tr',[_vm._m(3,true)]):_vm._e()])])])])])]):_vm._e(),_vm._v(" "),(email_signature.template === '3')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[(email_signature.logo_unique_id !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 12px 0px 0px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0","width":"100px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(email_signature.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://logo.app/paid-svglogos/'+email_signature.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+email_signature.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})])])])]),_vm._v(" "),(email_signature.powered_by === 'yes')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(4,true)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding-right":"12px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 18px; margin: 0px; padding: 0px; color: '+email_signature.name_color+'; white-space: nowrap; font-weight: bold;')},[_vm._v(_vm._s(email_signature.name))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 8px 0px 0px; color: '+email_signature.subtitle_color+'; white-space: nowrap;')},[_vm._v(_vm._s(email_signature.company))]),_vm._v(" "),_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 0px 0px 8px; color: '+email_signature.subtitle_color+'; white-space: nowrap; border-left: 1px solid '+_vm.subtitle_color+';')},[_vm._v(_vm._s(email_signature.role))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'tel:'+email_signature.phone,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(email_signature.phone))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'mailto:'+email_signature.email,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(email_signature.email))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":email_signature.website,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{style:('font-size: 12px; margin: 0px; padding: 0px; color: '+email_signature.links_color+'; white-space: nowrap;')},[_vm._v(_vm._s(email_signature.website))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'https://www.google.com/maps/search/?api=1&query='+email_signature.address,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(email_signature.address))])])])]),_vm._v(" "),(email_signature.powered_by === 'yes' && email_signature.logo_unique_id === '')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin-top":"10px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(5,true)]):_vm._e()])])]),_vm._v(" "),(email_signature.social_links.length > 0)?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding-left":"12px","border-left":"1px solid rgb(0, 0, 0)"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',{staticStyle:{"display":"flex","flex-direction":"column"}},_vm._l((email_signature.social_links),function(link,index){return (link.media !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 0px 8px"}},[_c('a',{attrs:{"href":link.url,"target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[(link.media === 'ArtStation')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}})]):(link.media === 'Behance')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}})]):(link.media === 'Discord')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}})]):(link.media === 'Facebook')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})]):(link.media === 'GitHub')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}})]):(link.media === 'Instagram')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})]):(link.media === 'LinkedIn')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"}})]):(link.media === 'Medium')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"}})]):(link.media === 'Patreon')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}})]):(link.media === 'Pinterest')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})]):(link.media === 'Reddit')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}})]):(link.media === 'Snapchat')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"}})]):(link.media === 'TikTok')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}})]):(link.media === 'Tumblr')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}})]):(link.media === 'Twitch')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}})]):(link.media === 'Twitter')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"}})]):(link.media === 'Vimeo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}})]):(link.media === 'Weibo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}})]):(link.media === 'WhatsApp')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})]):(link.media === 'X')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M297.751 221.1L461.125 31.5H422.411L280.553 196.127L167.251 31.5H36.5714L207.906 280.445L36.5714 479.27H75.2881L225.094 305.418L344.749 479.27H475.429L297.742 221.1H297.751ZM244.723 282.639L227.363 257.849L89.2383 60.5979H148.705L260.174 219.786L277.533 244.575L422.429 451.495H362.963L244.723 282.648V282.639Z"}})]):(link.media === 'YouTube')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}})]):_vm._e()])])])]):_vm._e()}))])])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0 pt-0"},[_c('div',{staticClass:"d-flex justify-content-center"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('div',{staticClass:"col-6 mr-2 p-0"},[_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-email-signatures"}},[_vm._v("\n                            Copy\n                        ")])]):_c('div',{staticClass:"col-6 mr-2 p-0"},[(_vm.copied !== index)?_c('button',{staticClass:"btn btn-blue w-100",on:{"click":function($event){_vm.copySignature(index)}}},[_vm._v("\n                            Copy\n                        ")]):_c('button',{staticClass:"btn btn-success w-100"},[_vm._v("\n                            Copied\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 ml-2 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-light w-100",attrs:{"data-toggle":"modal","data-target":"#modal-email-signatures"}},[_vm._v("\n                            Edit signature\n                        ")]):_c('router-link',{staticClass:"btn btn-light w-100",attrs:{"to":'/dashboard/edit-email-signature/'+email_signature.unique_id}},[_vm._v("\n                            Edit signature\n                        ")])],1)])])])])})):_c('div',[_c('div',{staticClass:"row row-grid align-items-center"},[_c('div',{staticClass:"col-12 col-lg-5"},[_c('h2',{staticClass:"font-weight-bolder mb-4"},[_vm._v("Email Signature Maker")]),_vm._v(" "),_c('p',[_vm._v("Get custom email signature designs that are already branded with your logo and business information.")]),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-primary mt-3 animate-up-2",attrs:{"data-toggle":"modal","data-target":"#modal-email-signatures"}},[_vm._v("\n                Create your signature\n            ")]):_c('router-link',{staticClass:"btn btn-primary mt-3 animate-up-2",attrs:{"to":"/dashboard/create-email-signature"}},[_vm._v("Create your signature")])],1),_vm._v(" "),_vm._m(6)])])])]):_vm._e(),_vm._v(" "),(_vm.email_signature_to_delete !== '')?_c('div',{staticClass:"modal",staticStyle:{"display":"block !important","background":"rgba(147, 152, 165, 0.35)","overflow":"auto"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close_modal_delete),expression:"close_modal_delete"}],staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header w-100"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Delete email signature")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button"},on:{"click":_vm.close_modal_delete}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-light mr-auto",on:{"click":_vm.close_modal_delete}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.delete_email_signature}},[_vm._v("Delete")])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon icon-sm"},[_c('span',{staticClass:"fas fa-ellipsis-h icon-dark"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin-top":"10px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6 ml-lg-auto"},[_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":"https://logo.app/assets/img/email-signature-maker.png","alt":"image"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"mb-0"},[_vm._v("Are you sure you want to delete your email signature?"),_c('br'),_vm._v("This action is irreversible and cannot be undone.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_email_signature_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fe6637f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_email_signature_vue__ = __webpack_require__(91);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_email_signature_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fe6637f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_email_signature_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Create Email Signature","description":"Dashboard | Create Email Signature"}}),_vm._v(" "),_c('div',[_c('nav',{staticStyle:{"position":"fixed","width":"100%","height":"71px","background":"#ffffff","border-bottom":"1px solid #dde1ed","z-index":"99"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","height":"100%","justify-content":"space-between","margin-left":"20px","margin-right":"20px"}},[_c('button',{staticClass:"btn btn-light",on:{"click":_vm.back}},[_c('i',{staticClass:"fa-solid fa-chevron-left mr-2"}),_vm._v(" Back")])])]),_vm._v(" "),(_vm.loading_logos)?_c('div',{staticClass:"pt-7",staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_c('div',{staticClass:"container"},[(_vm.step === '1')?_c('div',{staticClass:"pt-7"},[_c('progress',{staticClass:"w-100 mb-3",attrs:{"value":"1","max":"3"}},[_vm._v("Step 1 of 3")]),_vm._v(" "),_c('h1',[_vm._v("Select your brand")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Select the brand you want to use for your Email Signature.")]),_vm._v(" "),(_vm.logos !== null && _vm.logos.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.logos),function(logo,index){return _c('div',{staticClass:"col-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.logo_unique_id === logo.unique_id },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.choose_logo(logo.unique_id, logo.paid_svglogos_s3);}}},[(logo.paid_svglogos_s3 === 'needs_update')?_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+_vm.timenow}})]):_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+_vm.timenow}})])])])})):_c('div',[_c('p',{staticClass:"lead"},[_vm._v("No logos created in this account.")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"/create/"}},[_c('svg',{staticClass:"sc-jhaWeW kclIni",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"}})]),_vm._v("\n                  Create Logos Now")])])]):_vm._e(),_vm._v(" "),(_vm.step === '2')?_c('div',{staticClass:"pt-7"},[_c('progress',{staticClass:"w-100 mb-3",attrs:{"value":"2","max":"3"}},[_vm._v("Step 2 of 3")]),_vm._v(" "),_c('h1',[_vm._v("Pick a template")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Select a professional template. You can always customize it later.")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"justify-content":"center"}},[_c('div',{staticClass:"col-12 col-lg-4 col-md-6"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '1' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.choose_template('1');}}},[_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","justify-content":"center","padding":"12px","height":"250px","align-items":"center"}},[(_vm.creating_email_signature && _vm.template === '1')?_c('div',{staticClass:"spinner-border text-gray",staticStyle:{"position":"absolute","top":"102px","left":"43%","width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap","transform":"scale(0.87)","pointer-events":"none"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"4px 16px 0px 0px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0","width":"120px"}},[_c('tbody',[_c('tr',[(_vm.logo_unique_id)?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(_vm.logo_paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"50%"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"50%"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})]):_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"50%"},attrs:{"src":"https://logo.app/assets/img/placeholder-image.jpg","alt":"logo image"}})])])])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","border-left":"1px solid rgb(0, 0, 0)","padding":"0px 0px 0px 16px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"8px 0px 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":"https://facebook.com/hey","target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})])])])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":"https://instagram.com/hey","target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})])])])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":"https://pinterest.com/hey","target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})])])])])])])])])])])])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 col-md-6"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '2' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.choose_template('2');}}},[_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","justify-content":"center","padding":"12px","height":"250px","align-items":"center"}},[(_vm.creating_email_signature && _vm.template === '2')?_c('div',{staticClass:"spinner-border text-gray",staticStyle:{"position":"absolute","top":"102px","left":"43%","width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap","transform":"scale(0.68)","pointer-events":"none"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px"},attrs:{"cellpadding":"0","cellspacing":"0","width":"120px"}},[_c('tbody',[_c('tr',[(_vm.logo_unique_id)?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(_vm.logo_paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})]):_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":"https://logo.app/assets/img/placeholder-image.jpg","alt":"logo image"}})])])])])])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"8px 0px 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":"https://facebook.com/hey","target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})])])])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":"https://instagram.com/hey","target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})])])])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":"https://pinterest.com/hey","target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})])])])])])])])])])]),_vm._v(" "),_vm._m(12)])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 col-md-6"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '3' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.choose_template('3');}}},[_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","justify-content":"center","padding":"12px","height":"250px","align-items":"center"}},[(_vm.creating_email_signature && _vm.template === '3')?_c('div',{staticClass:"spinner-border text-gray",staticStyle:{"position":"absolute","top":"102px","left":"43%","width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap","transform":"scale(0.87)","pointer-events":"none"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 12px 0px 0px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0","width":"100px"}},[_c('tbody',[_c('tr',[(_vm.logo_unique_id)?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(_vm.logo_paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})]):_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":"https://logo.app/assets/img/placeholder-image.jpg","alt":"logo image"}})])])])]),_vm._v(" "),_vm._m(13)]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding-left":"12px","border-left":"1px solid rgb(0, 0, 0)"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 0px 8px"}},[_c('a',{attrs:{"href":"https://facebook.com/hey","target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})])])])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 0px 8px"}},[_c('a',{attrs:{"href":"https://instagram.com/hey","target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})])])])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 0px 8px"}},[_c('a',{attrs:{"href":"https://pinterest.com/hey","target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})])])])])])])])])])])])])])])])])]):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin":"6px auto 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{staticStyle:{"font-size":"18px","margin":"0px","padding":"0px 20px 0px 0px","color":"#000000","white-space":"nowrap","font-weight":"bold"}},[_vm._v("John Doe")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{staticStyle:{"font-size":"14px","margin":"0px","padding":"0px 8px 0px 0px","color":"#000000","white-space":"nowrap"}},[_vm._v("Company Name")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","margin":"0px","padding":"0px 20px 0px 8px","color":"#000000","white-space":"nowrap","border-left":"1px solid #000000"}},[_vm._v("CEO")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"tel:555 555-5555","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("555 555-5555")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"mailto:hello@website.com","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("hello@website.com")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"https://example.com","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(63, 131, 248)","white-space":"nowrap"}},[_vm._v("https://example.com")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"https://www.google.com/maps/search/?api=1&query=123 Main Street Los Angeles","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("123 Main Street Los Angeles")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 0px 6px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","border-bottom":"1px solid rgb(0, 0, 0)"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px","padding":"0px"}},[_c('span',{staticStyle:{"font-size":"18px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap","font-weight":"bold"}},[_vm._v("John Doe")])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px","padding":"0px 0px 6px"}},[_c('span',{staticStyle:{"font-size":"14px","margin":"0px","padding":"0px 8px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("Company Name")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","margin":"0px","padding":"0px 0px 0px 8px","color":"rgb(0, 0, 0)","white-space":"nowrap","border-left":"1px solid rgb(0, 0, 0)"}},[_vm._v("CEO")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"tel:555 555-5555","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("555 555-5555")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"mailto:hello@website.com","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("hello@website.com")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"https://example.com","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("https://example.com")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"https://www.google.com/maps/search/?api=1&query=123 Main Street Los Angeles","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("123 Main Street Los Angeles")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin-top":"10px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding-right":"12px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{staticStyle:{"font-size":"18px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap","font-weight":"bold"}},[_vm._v("John Doe")])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{staticStyle:{"font-size":"14px","margin":"0px","padding":"0px 8px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("Company Name")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","margin":"0px","padding":"0px 0px 0px 8px","color":"rgb(0, 0, 0)","white-space":"nowrap","border-left":"1px solid rgb(0, 0, 0)"}},[_vm._v("CEO")])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"tel:555 555-5555","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("555 555-5555")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"mailto:hello@website.com","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("hello@website.com")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"https://example.com","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("https://example.com")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":"https://www.google.com/maps/search/?api=1&query=123 Main Street Los Angeles","target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v("123 Main Street Los Angeles")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_email_signature_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b076ec3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_email_signature_vue__ = __webpack_require__(93);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_email_signature_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b076ec3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_email_signature_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Edit Email Signature","description":"Dashboard | Edit Email Signature"}}),_vm._v(" "),_c('div',[_c('nav',{staticStyle:{"position":"fixed","width":"100%","height":"71px","background":"#ffffff","border-bottom":"1px solid #dde1ed","z-index":"99"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","height":"100%","justify-content":"space-between","margin-left":"20px","margin-right":"20px"}},[_c('router-link',{staticClass:"btn btn-light",attrs:{"to":"/dashboard/email-signatures"}},[_c('i',{staticClass:"fa-solid fa-chevron-left mr-2"}),_vm._v(" Back")]),_vm._v(" "),(!_vm.finishing_email_signature)?_c('button',{staticClass:"btn btn-success",on:{"click":_vm.save_email_signature}},[_vm._v("Finish")]):_vm._e(),_vm._v(" "),(_vm.finishing_email_signature)?_c('button',{staticClass:"btn btn-success"},[_vm._v("Finishing...")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"d-lg-none",staticStyle:{"position":"fixed","bottom":"-1px","left":"0px","background":"rgb(255, 255, 255)","width":"-webkit-fill-available","box-shadow":"rgba(170, 170, 170, 0.18) 10px 10px 10px 10px !important","z-index":"2"}},[(_vm.tab !== '')?_c('div',{staticStyle:{"padding":"10px 10px 0 10px"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-between",staticStyle:{"border-bottom":"1px solid #e8e8e8"}},[(_vm.tab === 'information' || _vm.tab === '')?_c('p',{staticClass:"display-4 mb-0"},[_vm._v("Information")]):_vm._e(),_vm._v(" "),(_vm.tab === 'design')?_c('p',{staticClass:"display-4 mb-0"},[_vm._v("Design")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn d-flex align-items-center pt-2 pb-2 pl-2 pr-0",staticStyle:{"font-size":"23px"},on:{"click":function($event){_vm.change_tab('')}}},[_c('i',{staticClass:"fa-solid fa-square-xmark ml-1"})])]),_vm._v(" "),_c('div',{staticClass:"overflow-auto col-12 height-navigation-mobile_emailsignature",staticStyle:{"width":"100%","padding-top":"15px"}},[_c('div',{staticClass:"pt-2"},[(_vm.loading_email_signature)?_c('div',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]):_c('div',[(_vm.tab === 'information' || _vm.tab === '')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"John Doe"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Role")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.role),expression:"role"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CEO"},domProps:{"value":(_vm.role)},on:{"input":function($event){if($event.target.composing){ return; }_vm.role=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"hello@website.com"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control",attrs:{"type":"tel","placeholder":"555 555-5555"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website),expression:"website"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(_vm.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Company")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company),expression:"company"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Company Name"},domProps:{"value":(_vm.company)},on:{"input":function($event){if($event.target.composing){ return; }_vm.company=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"123 Main Street"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(5),_vm._v(" "),(_vm.logo_unique_id !== '')?_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"col"},[(_vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow}}):_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow}})]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('button',{staticClass:"btn btn-danger mt-2",on:{"click":function($event){_vm.logo_unique_id = ''}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.show_modal_logo}},[_vm._v("Change Logo")])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(6),_vm._v(" "),_c('draggable',_vm._b({staticClass:"list-group",model:{value:(_vm.social_links),callback:function ($$v) {_vm.social_links=$$v},expression:"social_links"}},'draggable',{ handle: '.handle' },false),_vm._l((_vm.social_links),function(link,index){return _c('div',{key:index,staticClass:"mb-3 row align-items-center"},[_c('div',{staticClass:"col-auto pr-0"},[_c('div',{staticClass:"handle",staticStyle:{"cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars"})])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(link.media),expression:"link.media"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(link, "media", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Choose Social Media")]),_vm._v(" "),_c('option',[_vm._v("ArtStation")]),_vm._v(" "),_c('option',[_vm._v("Behance")]),_vm._v(" "),_c('option',[_vm._v("Discord")]),_vm._v(" "),_c('option',[_vm._v("Facebook")]),_vm._v(" "),_c('option',[_vm._v("GitHub")]),_vm._v(" "),_c('option',[_vm._v("Instagram")]),_vm._v(" "),_c('option',[_vm._v("LinkedIn")]),_vm._v(" "),_c('option',[_vm._v("Medium")]),_vm._v(" "),_c('option',[_vm._v("Patreon")]),_vm._v(" "),_c('option',[_vm._v("Pinterest")]),_vm._v(" "),_c('option',[_vm._v("Reddit")]),_vm._v(" "),_c('option',[_vm._v("Snapchat")]),_vm._v(" "),_c('option',[_vm._v("TikTok")]),_vm._v(" "),_c('option',[_vm._v("Tumblr")]),_vm._v(" "),_c('option',[_vm._v("Twitch")]),_vm._v(" "),_c('option',[_vm._v("Twitter")]),_vm._v(" "),_c('option',[_vm._v("Vimeo")]),_vm._v(" "),_c('option',[_vm._v("Weibo")]),_vm._v(" "),_c('option',[_vm._v("WhatsApp")]),_vm._v(" "),_c('option',[_vm._v("X")]),_vm._v(" "),_c('option',[_vm._v("YouTube")])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(link.url),expression:"link.url",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(link.url)},on:{"blur":function($event){_vm.updateUrl(link)},"change":function($event){_vm.$set(link, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-auto pl-0"},[_c('button',{staticClass:"btn btn-danger mt-2",on:{"click":function($event){_vm.removeLink(index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])])})),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.addLink}},[_c('i',{staticClass:"fa-solid fa-plus mr-2"}),_vm._v(" Add Link\n                  ")])],1),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"text-center mb-3"},[(_vm.template === '1')?_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"160px"},attrs:{"src":"https://logo.app/email-signature-templates/template-1.svg"}}):_vm._e(),_vm._v(" "),(_vm.template === '2')?_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"160px"},attrs:{"src":"https://logo.app/email-signature-templates/template-2.svg"}}):_vm._e(),_vm._v(" "),(_vm.template === '3')?_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"160px"},attrs:{"src":"https://logo.app/email-signature-templates/template-3.svg"}}):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.show_modal_template}},[_vm._v("Change Template")])])]):_vm._e(),_vm._v(" "),(_vm.tab === 'design')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Name Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name_color),expression:"name_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.name_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name_color),expression:"name_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.name_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Subtitle Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subtitle_color),expression:"subtitle_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.subtitle_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subtitle_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subtitle_color),expression:"subtitle_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.subtitle_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subtitle_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Links Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.links_color),expression:"links_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.links_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.links_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.links_color),expression:"links_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.links_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.links_color=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_c('div',{staticClass:"form-check form-switch m-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.powered_by),expression:"powered_by"}],staticClass:"form-check-input",attrs:{"type":"checkbox","role":"switch","id":"flexSwitchCheckDefault1"},domProps:{"checked":Array.isArray(_vm.powered_by)?_vm._i(_vm.powered_by,null)>-1:(_vm.powered_by)},on:{"change":function($event){var $$a=_vm.powered_by,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.powered_by=$$a.concat([$$v]))}else{$$i>-1&&(_vm.powered_by=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.powered_by=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"flexSwitchCheckDefault1"}},[_vm._v("Powered By")])])])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex",staticStyle:{"white-space":"nowrap","overflow":"scroll","border-top":"1px solid #dfe0e6","padding":"8px"}},[_c('a',{staticClass:"d-flex flex-column align-items-center p-2 col-6",class:{ 'active-tab-sidebar-create': _vm.tab === 'information' },staticStyle:{"border-radius":"0.5rem","min-width":"80px"},on:{"click":function($event){_vm.change_tab('information')}}},[_c('i',{staticClass:"fa-solid fa-a mb-2",staticStyle:{"color":"rgb(223, 224, 230)"}}),_vm._v(" "),_c('span',{staticClass:"text-center"},[_vm._v("Information")])]),_vm._v(" "),_c('a',{staticClass:"d-flex flex-column align-items-center p-2 col-6",class:{ 'active-tab-sidebar-create': _vm.tab === 'design' },staticStyle:{"border-radius":"0.5rem","min-width":"80px"},on:{"click":function($event){_vm.change_tab('design')}}},[_c('i',{staticClass:"fa-solid fa-palette mb-2",staticStyle:{"color":"rgb(223, 224, 230)"}}),_vm._v(" "),_c('span',{staticClass:"text-center"},[_vm._v("Design")])])])]),_vm._v(" "),_c('nav',{staticClass:"sidebar-create d-lg-block bg-dark text-white",staticStyle:{"background-color":"#ffffff!important","border-right":"1px solid #dde1ed!important","display":"none"},attrs:{"id":"sidebarMenu"}},[_c('div',{staticClass:"sidebar-inner px-4 pt-6"},[_c('ul',{staticClass:"nav flex-column sidebar-top-mobile"},[_vm._m(9),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.change_tab('information')}}},[_c('a',{staticClass:"nav-link collapsed d-flex align-items-center",class:{ 'active-tab-sidebar-create': _vm.tab === 'information' }},[_c('i',{staticClass:"fa-solid fa-a mr-3",staticStyle:{"color":"rgb(223, 224, 230)"}}),_vm._v(" "),_c('span',[_vm._v("Information")])])]),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"max-width":"100%"},on:{"click":function($event){_vm.change_tab('design')}}},[_c('a',{staticClass:"nav-link collapsed d-flex align-items-center",class:{ 'active-tab-sidebar-create': _vm.tab === 'design' }},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(223, 224, 230)","margin-right":"12px"}}),_vm._v(" "),_c('span',[_vm._v("Design")])])])])])]),_vm._v(" "),_c('div',{staticClass:"sidebar-create px-4 pt-6 d-lg-block secondary-sidebar",staticStyle:{"display":"none"}},[_c('div',{staticClass:"pt-2"},[(_vm.loading_email_signature)?_c('div',[_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13)]):_c('div',[(_vm.tab === 'information' || _vm.tab === '')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"John Doe"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Role")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.role),expression:"role"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CEO"},domProps:{"value":(_vm.role)},on:{"input":function($event){if($event.target.composing){ return; }_vm.role=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"hello@website.com"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control",attrs:{"type":"tel","placeholder":"555 555-5555"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website),expression:"website"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(_vm.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Company")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company),expression:"company"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Company Name"},domProps:{"value":(_vm.company)},on:{"input":function($event){if($event.target.composing){ return; }_vm.company=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"123 Main Street"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(15),_vm._v(" "),(_vm.logo_unique_id !== '')?_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"col"},[(_vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow}}):_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow}})]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('button',{staticClass:"btn btn-danger mt-2",on:{"click":function($event){_vm.logo_unique_id = ''}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.show_modal_logo}},[_vm._v("Change Logo")])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(16),_vm._v(" "),_c('draggable',_vm._b({staticClass:"list-group",model:{value:(_vm.social_links),callback:function ($$v) {_vm.social_links=$$v},expression:"social_links"}},'draggable',{ handle: '.handle' },false),_vm._l((_vm.social_links),function(link,index){return _c('div',{key:index,staticClass:"mb-3 row align-items-center"},[_c('div',{staticClass:"col-auto pr-0"},[_c('div',{staticClass:"handle",staticStyle:{"cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars"})])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(link.media),expression:"link.media"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(link, "media", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Choose Social Media")]),_vm._v(" "),_c('option',[_vm._v("ArtStation")]),_vm._v(" "),_c('option',[_vm._v("Behance")]),_vm._v(" "),_c('option',[_vm._v("Discord")]),_vm._v(" "),_c('option',[_vm._v("Facebook")]),_vm._v(" "),_c('option',[_vm._v("GitHub")]),_vm._v(" "),_c('option',[_vm._v("Instagram")]),_vm._v(" "),_c('option',[_vm._v("LinkedIn")]),_vm._v(" "),_c('option',[_vm._v("Medium")]),_vm._v(" "),_c('option',[_vm._v("Patreon")]),_vm._v(" "),_c('option',[_vm._v("Pinterest")]),_vm._v(" "),_c('option',[_vm._v("Reddit")]),_vm._v(" "),_c('option',[_vm._v("Snapchat")]),_vm._v(" "),_c('option',[_vm._v("TikTok")]),_vm._v(" "),_c('option',[_vm._v("Tumblr")]),_vm._v(" "),_c('option',[_vm._v("Twitch")]),_vm._v(" "),_c('option',[_vm._v("Twitter")]),_vm._v(" "),_c('option',[_vm._v("Vimeo")]),_vm._v(" "),_c('option',[_vm._v("Weibo")]),_vm._v(" "),_c('option',[_vm._v("WhatsApp")]),_vm._v(" "),_c('option',[_vm._v("X")]),_vm._v(" "),_c('option',[_vm._v("YouTube")])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(link.url),expression:"link.url",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(link.url)},on:{"blur":function($event){_vm.updateUrl(link)},"change":function($event){_vm.$set(link, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-auto pl-0"},[_c('button',{staticClass:"btn btn-danger mt-2",on:{"click":function($event){_vm.removeLink(index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])])})),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.addLink}},[_c('i',{staticClass:"fa-solid fa-plus mr-2"}),_vm._v(" Add Link\n                  ")])],1),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(17),_vm._v(" "),_c('div',{staticClass:"text-center mb-3"},[(_vm.template === '1')?_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"160px"},attrs:{"src":"https://logo.app/email-signature-templates/template-1.svg"}}):_vm._e(),_vm._v(" "),(_vm.template === '2')?_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"160px"},attrs:{"src":"https://logo.app/email-signature-templates/template-2.svg"}}):_vm._e(),_vm._v(" "),(_vm.template === '3')?_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"160px"},attrs:{"src":"https://logo.app/email-signature-templates/template-3.svg"}}):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.show_modal_template}},[_vm._v("Change Template")])])]):_vm._e(),_vm._v(" "),(_vm.tab === 'design')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(18),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Name Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name_color),expression:"name_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.name_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name_color),expression:"name_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.name_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Subtitle Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subtitle_color),expression:"subtitle_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.subtitle_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subtitle_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subtitle_color),expression:"subtitle_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.subtitle_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subtitle_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Links Color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.links_color),expression:"links_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.links_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.links_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.links_color),expression:"links_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.links_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.links_color=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_c('div',{staticClass:"form-check form-switch m-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.powered_by),expression:"powered_by"}],staticClass:"form-check-input",attrs:{"type":"checkbox","role":"switch","id":"flexSwitchCheckDefault2"},domProps:{"checked":Array.isArray(_vm.powered_by)?_vm._i(_vm.powered_by,null)>-1:(_vm.powered_by)},on:{"change":function($event){var $$a=_vm.powered_by,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.powered_by=$$a.concat([$$v]))}else{$$i>-1&&(_vm.powered_by=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.powered_by=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"flexSwitchCheckDefault2"}},[_vm._v("Powered By")])])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"margin-espacio-del-sidebar-create pt-6 pt-lg-0"},[(_vm.loading_email_signature)?_c('div',{staticClass:"pt-0 pt-lg-6 mb-6 ml-3 mr-3"},[_vm._m(19)]):_c('div',[_c('div',{staticClass:"container pt-2 vertically-centered-on-desktop",staticStyle:{"overflow-x":"hidden"}},[_c('div',{staticClass:"blog-card col-12 m-auto p-0 pt-lg-6",staticStyle:{"max-width":"570px"}},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"card-body",staticStyle:{"margin":"0 auto"}},[(_vm.template === '1')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[(_vm.logo_unique_id !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"4px 16px 0px 0px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0","width":"120px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(_vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"50%"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"50%"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})])])])]),_vm._v(" "),(_vm.poweredByYesOrNo === 'yes')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin":"6px auto 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(20)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","border-left":"1px solid rgb(0, 0, 0)","padding":"0px 0px 0px 16px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 18px; margin: 0px; padding: 0px 20px 0px 0px; color: '+_vm.name_color+'; white-space: nowrap; font-weight: bold;')},[_vm._v(_vm._s(_vm.name))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 8px 0px 0px; color: '+_vm.subtitle_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.company))]),_vm._v(" "),_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 20px 0px 8px; color: '+_vm.subtitle_color+'; white-space: nowrap; border-left: 1px solid '+_vm.subtitle_color+';')},[_vm._v(_vm._s(_vm.role))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'tel:'+_vm.phone,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.phone))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'mailto:'+_vm.email,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.email))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":_vm.website,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{style:('font-size: 12px; margin: 0px; padding: 0px 20px 0px 0px; color: '+_vm.links_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.website))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'https://www.google.com/maps/search/?api=1&query='+_vm.address,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.address))])])])]),_vm._v(" "),(_vm.social_links.length > 0)?_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"8px 0px 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',_vm._l((_vm.social_links),function(link,index){return (link.media !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":link.url,"target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[(link.media === 'ArtStation')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}})]):(link.media === 'Behance')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}})]):(link.media === 'Discord')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}})]):(link.media === 'Facebook')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})]):(link.media === 'GitHub')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}})]):(link.media === 'Instagram')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})]):(link.media === 'LinkedIn')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"}})]):(link.media === 'Medium')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"}})]):(link.media === 'Patreon')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}})]):(link.media === 'Pinterest')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})]):(link.media === 'Reddit')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}})]):(link.media === 'Snapchat')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"}})]):(link.media === 'TikTok')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}})]):(link.media === 'Tumblr')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}})]):(link.media === 'Twitch')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}})]):(link.media === 'Twitter')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"}})]):(link.media === 'Vimeo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}})]):(link.media === 'Weibo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}})]):(link.media === 'WhatsApp')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})]):(link.media === 'X')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M297.751 221.1L461.125 31.5H422.411L280.553 196.127L167.251 31.5H36.5714L207.906 280.445L36.5714 479.27H75.2881L225.094 305.418L344.749 479.27H475.429L297.742 221.1H297.751ZM244.723 282.639L227.363 257.849L89.2383 60.5979H148.705L260.174 219.786L277.533 244.575L422.429 451.495H362.963L244.723 282.648V282.639Z"}})]):(link.media === 'YouTube')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}})]):_vm._e()])])])]):_vm._e()}))])])])]):_vm._e(),_vm._v(" "),(_vm.poweredByYesOrNo === 'yes' && _vm.logo_unique_id === '')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin-top":"10px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(21)]):_vm._e()])])])])])]):_vm._e(),_vm._v(" "),(_vm.template === '2')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[(_vm.logo_unique_id !== '')?_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px"},attrs:{"cellpadding":"0","cellspacing":"0","width":"120px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(_vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})])])])])])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 0px 6px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","border-bottom":"1px solid rgb(0, 0, 0)"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px","padding":"0px"}},[_c('span',{style:('font-size: 18px; margin: 0px; padding: 0px; color: '+_vm.name_color+'; white-space: nowrap; font-weight: bold;')},[_vm._v(_vm._s(_vm.name))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px","padding":"0px 0px 6px"}},[_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 8px 0px 0px; color: '+_vm.subtitle_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.company))]),_vm._v(" "),_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 0px 0px 8px; color: '+_vm.subtitle_color+'; white-space: nowrap; border-left: 1px solid '+_vm.subtitle_color+';')},[_vm._v(_vm._s(_vm.role))])])])])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'tel:'+_vm.phone,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.phone))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'mailto:'+_vm.email,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.email))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":_vm.website,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{style:('font-size: 12px; margin: 0px; padding: 0px; color: '+_vm.links_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.website))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'https://www.google.com/maps/search/?api=1&query='+_vm.address,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.address))])])])]),_vm._v(" "),_c('tr',[(_vm.social_links.length > 0)?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"8px 0px 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',_vm._l((_vm.social_links),function(link,index){return (link.media !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":link.url,"target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[(link.media === 'ArtStation')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}})]):(link.media === 'Behance')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}})]):(link.media === 'Discord')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}})]):(link.media === 'Facebook')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})]):(link.media === 'GitHub')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}})]):(link.media === 'Instagram')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})]):(link.media === 'LinkedIn')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"}})]):(link.media === 'Medium')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"}})]):(link.media === 'Patreon')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}})]):(link.media === 'Pinterest')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})]):(link.media === 'Reddit')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}})]):(link.media === 'Snapchat')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"}})]):(link.media === 'TikTok')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}})]):(link.media === 'Tumblr')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}})]):(link.media === 'Twitch')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}})]):(link.media === 'Twitter')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"}})]):(link.media === 'Vimeo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}})]):(link.media === 'Weibo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}})]):(link.media === 'WhatsApp')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})]):(link.media === 'X')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M297.751 221.1L461.125 31.5H422.411L280.553 196.127L167.251 31.5H36.5714L207.906 280.445L36.5714 479.27H75.2881L225.094 305.418L344.749 479.27H475.429L297.742 221.1H297.751ZM244.723 282.639L227.363 257.849L89.2383 60.5979H148.705L260.174 219.786L277.533 244.575L422.429 451.495H362.963L244.723 282.648V282.639Z"}})]):(link.media === 'YouTube')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}})]):_vm._e()])])])]):_vm._e()}))])])]):_vm._e()]),_vm._v(" "),(_vm.poweredByYesOrNo === 'yes')?_c('tr',[_vm._m(22)]):_vm._e()])])])])])]):_vm._e(),_vm._v(" "),(_vm.template === '3')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[(_vm.logo_unique_id !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 12px 0px 0px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0","width":"100px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(_vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})])])])]),_vm._v(" "),(_vm.poweredByYesOrNo === 'yes')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(23)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding-right":"12px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 18px; margin: 0px; padding: 0px; color: '+_vm.name_color+'; white-space: nowrap; font-weight: bold;')},[_vm._v(_vm._s(_vm.name))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 8px 0px 0px; color: '+_vm.subtitle_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.company))]),_vm._v(" "),_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 0px 0px 8px; color: '+_vm.subtitle_color+'; white-space: nowrap; border-left: 1px solid '+_vm.subtitle_color+';')},[_vm._v(_vm._s(_vm.role))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'tel:'+_vm.phone,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.phone))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'mailto:'+_vm.email,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.email))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":_vm.website,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{style:('font-size: 12px; margin: 0px; padding: 0px; color: '+_vm.links_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.website))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'https://www.google.com/maps/search/?api=1&query='+_vm.address,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.address))])])])]),_vm._v(" "),(_vm.poweredByYesOrNo === 'yes' && _vm.logo_unique_id === '')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin-top":"10px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(24)]):_vm._e()])])]),_vm._v(" "),(_vm.social_links.length > 0)?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding-left":"12px","border-left":"1px solid rgb(0, 0, 0)"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',{staticStyle:{"display":"flex","flex-direction":"column"}},_vm._l((_vm.social_links),function(link,index){return (link.media !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 0px 8px"}},[_c('a',{attrs:{"href":link.url,"target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[(link.media === 'ArtStation')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}})]):(link.media === 'Behance')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}})]):(link.media === 'Discord')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}})]):(link.media === 'Facebook')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})]):(link.media === 'GitHub')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}})]):(link.media === 'Instagram')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})]):(link.media === 'LinkedIn')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"}})]):(link.media === 'Medium')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"}})]):(link.media === 'Patreon')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}})]):(link.media === 'Pinterest')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})]):(link.media === 'Reddit')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}})]):(link.media === 'Snapchat')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"}})]):(link.media === 'TikTok')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}})]):(link.media === 'Tumblr')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}})]):(link.media === 'Twitch')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}})]):(link.media === 'Twitter')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"}})]):(link.media === 'Vimeo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}})]):(link.media === 'Weibo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}})]):(link.media === 'WhatsApp')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})]):(link.media === 'X')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M297.751 221.1L461.125 31.5H422.411L280.553 196.127L167.251 31.5H36.5714L207.906 280.445L36.5714 479.27H75.2881L225.094 305.418L344.749 479.27H475.429L297.742 221.1H297.751ZM244.723 282.639L227.363 257.849L89.2383 60.5979H148.705L260.174 219.786L277.533 244.575L422.429 451.495H362.963L244.723 282.648V282.639Z"}})]):(link.media === 'YouTube')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}})]):_vm._e()])])])]):_vm._e()}))])])]):_vm._e()])])]):_vm._e()])])])])])])]),_vm._v(" "),(_vm.modal_template)?_c('div',{staticClass:"modal",staticStyle:{"display":"block !important","background":"rgba(147, 152, 165, 0.35)","overflow":"auto"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide_modal_template),expression:"hide_modal_template"}],staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"800px"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header w-100"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Choose a different template")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button"},on:{"click":_vm.hide_modal_template}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-4"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '1' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#F5F5F5"},on:{"click":function($event){_vm.update_template('1');}}},[_vm._m(25)])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-4"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '2' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#F5F5F5"},on:{"click":function($event){_vm.update_template('2');}}},[_vm._m(26)])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-4"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.template === '3' },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#F5F5F5"},on:{"click":function($event){_vm.update_template('3');}}},[_vm._m(27)])])])])])])]):_vm._e(),_vm._v(" "),(_vm.modal_logo)?_c('div',{staticClass:"modal",staticStyle:{"display":"block !important","background":"rgba(147, 152, 165, 0.35)","overflow":"auto"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide_modal_logo),expression:"hide_modal_logo"}],staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"800px"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header w-100"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Choose a different logo")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button"},on:{"click":_vm.hide_modal_logo}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.loading_logos)?_c('div',{staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_c('div',[(_vm.logos !== null && _vm.logos.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.logos),function(logo,index){return _c('div',{staticClass:"col-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.logo_unique_id === logo.unique_id },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.update_logo(logo.unique_id, logo.paid_svglogos_s3);}}},[(logo.paid_svglogos_s3 === 'needs_update')?_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+_vm.timenow}})]):_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+_vm.timenow}})])])])})):_c('div',[_c('p',{staticClass:"lead text-center"},[_vm._v("No logos created in this account.")])])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#dddddd","height":"200px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine200"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-a",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"3px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-image",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Logo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-link",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"-1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Social Links")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-layer-group",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"-1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Template")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Design")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"margin-left":"11px","margin-bottom":"0.8rem","margin-top":"0.8rem","font-weight":"900","color":"rgb(74 80 115)","font-size":"15px"}},[_c('i',{staticClass:"fas fa-pencil",staticStyle:{"margin-right":"7px"}}),_vm._v("Email Signature")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#dddddd","height":"200px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine200"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-a",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"3px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-image",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Logo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-link",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"-1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Social Links")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-layer-group",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"-1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Template")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Design")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-2"},[_c('div',{staticStyle:{"background":"#ffffff","height":"500px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine500_white"})]),_vm._v(" "),_c('div',{staticClass:"mt-3",staticStyle:{"background":"#ffffff","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20_white"})]),_vm._v(" "),_c('div',{staticClass:"mt-3",staticStyle:{"background":"#ffffff","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20_white"})]),_vm._v(" "),_c('div',{staticClass:"mt-3",staticStyle:{"background":"#ffffff","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20_white"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin-top":"10px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"160px"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","padding":"15px"},attrs:{"src":"https://logo.app/email-signature-templates/template-1.svg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"160px"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","padding":"15px"},attrs:{"src":"https://logo.app/email-signature-templates/template-2.svg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"160px"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","padding":"15px"},attrs:{"src":"https://logo.app/email-signature-templates/template-3.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_set_up_email_signature_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e3d685_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_set_up_email_signature_vue__ = __webpack_require__(95);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_set_up_email_signature_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e3d685_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_set_up_email_signature_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Create Email Signature","description":"Dashboard | Create Email Signature"}}),_vm._v(" "),_c('div',[_c('nav',{staticStyle:{"position":"fixed","width":"100%","height":"71px","background":"#ffffff","border-bottom":"1px solid #dde1ed","z-index":"99"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","height":"100%","justify-content":"space-between","margin-left":"20px","margin-right":"20px"}},[_c('router-link',{staticClass:"btn btn-light",attrs:{"to":"/dashboard/email-signatures"}},[_c('i',{staticClass:"fa-solid fa-chevron-left mr-2"}),_vm._v(" Back")])],1)]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"pt-7 text-center"},[_c('h1',[_vm._v("You made it!")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Your email signature is ready to go live.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"blog-card col-12 m-auto p-0",staticStyle:{"max-width":"570px"}},[_c('div',{staticClass:"card shadow-soft border-light"},[(_vm.loading_email_signature)?_c('div',{staticClass:"card-body",staticStyle:{"margin":"0 auto"}},[_vm._m(1)]):_c('div',{staticClass:"card-body",staticStyle:{"margin":"0 auto"},attrs:{"id":"signature"}},[(_vm.template === '1')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[(_vm.logo_unique_id !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"4px 16px 0px 0px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0","width":"120px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(_vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"50%"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"50%"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})])])])]),_vm._v(" "),(_vm.powered_by === 'yes')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin":"6px auto 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(2)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","border-left":"1px solid rgb(0, 0, 0)","padding":"0px 0px 0px 16px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 18px; margin: 0px; padding: 0px 20px 0px 0px; color: '+_vm.name_color+'; white-space: nowrap; font-weight: bold;')},[_vm._v(_vm._s(_vm.name))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 8px 0px 0px; color: '+_vm.subtitle_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.company))]),_vm._v(" "),_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 20px 0px 8px; color: '+_vm.subtitle_color+'; white-space: nowrap; border-left: 1px solid '+_vm.subtitle_color+';')},[_vm._v(_vm._s(_vm.role))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'tel:'+_vm.phone,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.phone))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'mailto:'+_vm.email,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.email))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":_vm.website,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{style:('font-size: 12px; margin: 0px; padding: 0px 20px 0px 0px; color: '+_vm.links_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.website))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'https://www.google.com/maps/search/?api=1&query='+_vm.address,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.address))])])])]),_vm._v(" "),(_vm.social_links.length > 0)?_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"8px 0px 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',_vm._l((_vm.social_links),function(link,index){return (link.media !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":link.url,"target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[(link.media === 'ArtStation')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}})]):(link.media === 'Behance')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}})]):(link.media === 'Discord')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}})]):(link.media === 'Facebook')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})]):(link.media === 'GitHub')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}})]):(link.media === 'Instagram')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})]):(link.media === 'LinkedIn')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"}})]):(link.media === 'Medium')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"}})]):(link.media === 'Patreon')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}})]):(link.media === 'Pinterest')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})]):(link.media === 'Reddit')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}})]):(link.media === 'Snapchat')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"}})]):(link.media === 'TikTok')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}})]):(link.media === 'Tumblr')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}})]):(link.media === 'Twitch')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}})]):(link.media === 'Twitter')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"}})]):(link.media === 'Vimeo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}})]):(link.media === 'Weibo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}})]):(link.media === 'WhatsApp')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})]):(link.media === 'X')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M297.751 221.1L461.125 31.5H422.411L280.553 196.127L167.251 31.5H36.5714L207.906 280.445L36.5714 479.27H75.2881L225.094 305.418L344.749 479.27H475.429L297.742 221.1H297.751ZM244.723 282.639L227.363 257.849L89.2383 60.5979H148.705L260.174 219.786L277.533 244.575L422.429 451.495H362.963L244.723 282.648V282.639Z"}})]):(link.media === 'YouTube')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}})]):_vm._e()])])])]):_vm._e()}))])])])]):_vm._e(),_vm._v(" "),(_vm.powered_by === 'yes' && _vm.logo_unique_id === '')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin-top":"10px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(3)]):_vm._e()])])])])])]):_vm._e(),_vm._v(" "),(_vm.template === '2')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[(_vm.logo_unique_id !== '')?_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px"},attrs:{"cellpadding":"0","cellspacing":"0","width":"120px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(_vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})])])])])])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 0px 6px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","border-bottom":"1px solid rgb(0, 0, 0)"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px","padding":"0px"}},[_c('span',{style:('font-size: 18px; margin: 0px; padding: 0px; color: '+_vm.name_color+'; white-space: nowrap; font-weight: bold;')},[_vm._v(_vm._s(_vm.name))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px","padding":"0px 0px 6px"}},[_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 8px 0px 0px; color: '+_vm.subtitle_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.company))]),_vm._v(" "),_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 0px 0px 8px; color: '+_vm.subtitle_color+'; white-space: nowrap; border-left: 1px solid '+_vm.subtitle_color+';')},[_vm._v(_vm._s(_vm.role))])])])])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'tel:'+_vm.phone,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.phone))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'mailto:'+_vm.email,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.email))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":_vm.website,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{style:('font-size: 12px; margin: 0px; padding: 0px; color: '+_vm.links_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.website))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'https://www.google.com/maps/search/?api=1&query='+_vm.address,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.address))])])])]),_vm._v(" "),_c('tr',[(_vm.social_links.length > 0)?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"8px 0px 0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',_vm._l((_vm.social_links),function(link,index){return (link.media !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 6px 0px 0px"}},[_c('a',{attrs:{"href":link.url,"target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[(link.media === 'ArtStation')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}})]):(link.media === 'Behance')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}})]):(link.media === 'Discord')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}})]):(link.media === 'Facebook')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})]):(link.media === 'GitHub')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}})]):(link.media === 'Instagram')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})]):(link.media === 'LinkedIn')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"}})]):(link.media === 'Medium')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"}})]):(link.media === 'Patreon')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}})]):(link.media === 'Pinterest')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})]):(link.media === 'Reddit')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}})]):(link.media === 'Snapchat')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"}})]):(link.media === 'TikTok')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}})]):(link.media === 'Tumblr')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}})]):(link.media === 'Twitch')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}})]):(link.media === 'Twitter')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"}})]):(link.media === 'Vimeo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}})]):(link.media === 'Weibo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}})]):(link.media === 'WhatsApp')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})]):(link.media === 'X')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M297.751 221.1L461.125 31.5H422.411L280.553 196.127L167.251 31.5H36.5714L207.906 280.445L36.5714 479.27H75.2881L225.094 305.418L344.749 479.27H475.429L297.742 221.1H297.751ZM244.723 282.639L227.363 257.849L89.2383 60.5979H148.705L260.174 219.786L277.533 244.575L422.429 451.495H362.963L244.723 282.648V282.639Z"}})]):(link.media === 'YouTube')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}})]):_vm._e()])])])]):_vm._e()}))])])]):_vm._e()]),_vm._v(" "),(_vm.powered_by === 'yes')?_c('tr',[_vm._m(4)]):_vm._e()])])])])])]):_vm._e(),_vm._v(" "),(_vm.template === '3')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-family":"Arial","white-space":"nowrap"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[(_vm.logo_unique_id !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 12px 0px 0px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0","width":"100px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[(_vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}}):_c('img',{staticStyle:{"display":"block","max-width":"100%","height":"auto","margin-bottom":"6px","border-radius":"10px"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"logo image"}})])])])]),_vm._v(" "),(_vm.powered_by === 'yes')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(5)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding-right":"12px"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 18px; margin: 0px; padding: 0px; color: '+_vm.name_color+'; white-space: nowrap; font-weight: bold;')},[_vm._v(_vm._s(_vm.name))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"24px"}},[_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 8px 0px 0px; color: '+_vm.subtitle_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.company))]),_vm._v(" "),_c('span',{style:('font-size: 14px; margin: 0px; padding: 0px 0px 0px 8px; color: '+_vm.subtitle_color+'; white-space: nowrap; border-left: 1px solid '+_vm.subtitle_color+';')},[_vm._v(_vm._s(_vm.role))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'tel:'+_vm.phone,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.phone))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'mailto:'+_vm.email,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.email))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":_vm.website,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{style:('font-size: 12px; margin: 0px; padding: 0px; color: '+_vm.links_color+'; white-space: nowrap;')},[_vm._v(_vm._s(_vm.website))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"16px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"href":'https://www.google.com/maps/search/?api=1&query='+_vm.address,"target":"_blank","rel":"nofollow noreferrer"}},[_c('span',{staticStyle:{"font-size":"12px","margin":"0px","padding":"0px","color":"rgb(0, 0, 0)","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.address))])])])]),_vm._v(" "),(_vm.powered_by === 'yes' && _vm.logo_unique_id === '')?_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin-top":"10px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_vm._m(6)]):_vm._e()])])]),_vm._v(" "),(_vm.social_links.length > 0)?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding-left":"12px","border-left":"1px solid rgb(0, 0, 0)"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","display":"table","margin":"0px auto"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',{staticStyle:{"display":"flex","flex-direction":"column"}},_vm._l((_vm.social_links),function(link,index){return (link.media !== '')?_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","padding":"0px 0px 8px"}},[_c('a',{attrs:{"href":link.url,"target":"_blank","rel":"noreferrer"}},[_c('div',{staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","fill":"rgb(255, 255, 255)","padding":"5.5px","background":"rgb(33, 108, 181)","border-radius":"50%","width":"12px","height":"12px"}},[_c('div',{staticClass:"icon_icon__0RD4D",staticStyle:{"display":"grid","place-items":"center","box-sizing":"content-box","width":"100%","height":"100%"}},[(link.media === 'ArtStation')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}})]):(link.media === 'Behance')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}})]):(link.media === 'Discord')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}})]):(link.media === 'Facebook')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"}})]):(link.media === 'GitHub')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}})]):(link.media === 'Instagram')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"}})]):(link.media === 'LinkedIn')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"}})]):(link.media === 'Medium')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"}})]):(link.media === 'Patreon')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}})]):(link.media === 'Pinterest')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}})]):(link.media === 'Reddit')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}})]):(link.media === 'Snapchat')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"}})]):(link.media === 'TikTok')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}})]):(link.media === 'Tumblr')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}})]):(link.media === 'Twitch')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}})]):(link.media === 'Twitter')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"}})]):(link.media === 'Vimeo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}})]):(link.media === 'Weibo')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}})]):(link.media === 'WhatsApp')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})]):(link.media === 'X')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M297.751 221.1L461.125 31.5H422.411L280.553 196.127L167.251 31.5H36.5714L207.906 280.445L36.5714 479.27H75.2881L225.094 305.418L344.749 479.27H475.429L297.742 221.1H297.751ZM244.723 282.639L227.363 257.849L89.2383 60.5979H148.705L260.174 219.786L277.533 244.575L422.429 451.495H362.963L244.723 282.648V282.639Z"}})]):(link.media === 'YouTube')?_c('svg',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}})]):_vm._e()])])])]):_vm._e()}))])])]):_vm._e()])])]):_vm._e()])])]),_vm._v(" "),(!_vm.loading_email_signature)?_c('div',{staticClass:"w-100 row m-auto pt-3 pb-3",staticStyle:{"max-width":"570px"}},[_c('div',{staticClass:"col-12 d-flex p-0",staticStyle:{"gap":"10px"}},[_c('router-link',{staticClass:"btn btn-light flex-fill",attrs:{"to":"/dashboard/email-signatures"}},[_vm._v("Finish")]),_vm._v(" "),(!_vm.copied)?_c('button',{staticClass:"btn btn-primary flex-fill",on:{"click":_vm.copySignature}},[_vm._v("Copy")]):_vm._e(),_vm._v(" "),(_vm.copied)?_c('button',{staticClass:"btn btn-success flex-fill"},[_vm._v("Copied")]):_vm._e()],1)]):_vm._e()])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-light alert-dismissible fade show",staticStyle:{"max-width":"570px","margin":"15px auto","width":"100%"},attrs:{"role":"alert"}},[_c('span',{staticClass:"alert-inner--icon"},[_c('i',{staticClass:"fas fa-warning"})]),_vm._v(" "),_c('span',{staticClass:"text-gray"},[_c('strong',[_vm._v("For Outlook users:")]),_vm._v(" To avoid Outlook compatibility issues, please use the Outlook Web App to add your email signature.")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{staticClass:"text-gray",attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-gray",staticStyle:{"width":"2rem","height":"2rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"text-align":"left","vertical-align":"top"}},[_c('table',{staticStyle:{"border-collapse":"collapse","table-layout":"fixed","font-size":"5.6px","margin-top":"10px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px 20px 0px 0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('a',{attrs:{"href":"https://logo.app/email-signature-maker","target":"_blank"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(63, 131, 248)","white-space":"nowrap","font-weight":"900","text-decoration":"underline","text-align":"left"}},[_vm._v("Get your own signature")])])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","vertical-align":"top","line-height":"12px"}},[_c('span',{staticStyle:{"font-size":"8px","margin":"0px","padding":"0px","color":"rgb(126, 125, 125)","white-space":"nowrap","text-align":"left"}},[_vm._v("Powered by Logo.app")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_link_in_bio_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eeddfe2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_in_bio_vue__ = __webpack_require__(99);
function injectStyle (ssrContext) {
  __webpack_require__(97)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_link_in_bio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eeddfe2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_in_bio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(98);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("287a9df7", content, true, {});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "a{color:#515151}.delete_btnhover:hover{color:#ee5150!important}.downloads_btnhover:hover,.preview_btnhover:hover{color:#073482!important}", ""]);

// exports


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content2"},[_c('vue-headful',{attrs:{"title":"Dashboard | Link In Bio","description":"Dashboard | Link In Bio"}}),_vm._v(" "),(_vm.loading_link_in_bios)?_c('div',{staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.loading_link_in_bios)?_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"sc-cFlXAS WflZx"},[(_vm.link_in_bios !== null && _vm.link_in_bios.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.link_in_bios),function(link_in_bio,index){return _c('div',{staticClass:"blog-card col-12 col-lg-6"},[_c('div',{staticClass:"card shadow-soft border-light"},[_c('div',{staticClass:"show",staticStyle:{"position":"absolute","right":"0px"}},[_c('button',{staticClass:"btn btn-sm btn-light",staticStyle:{"border-radius":"0px 6px 0px 0px"},on:{"click":function($event){_vm.open_dropdown(index)}}},[_vm._m(0,true),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Toggle Dropdown")])]),_vm._v(" "),(_vm.dropdown === index)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close_dropdown),expression:"close_dropdown"}],staticStyle:{"position":"absolute","will-change":"transform","top":"-12px","left":"-123px","transform":"translate3d(0px, 42px, 0px)","background-color":"#ffffff","padding":"0.7rem 0","margin":"0.125rem 0 0","font-size":"0.875rem","z-index":"1000","border":"0 solid rgba(36, 38, 43, 0.15)","border-radius":"0.2rem","box-shadow":"0 1rem 3rem rgba(13, 20, 49, 0.175)","line-height":"1.5"}},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('a',{staticClass:"dropdown-item",staticStyle:{"padding":".5rem 1rem","font-size":"0.875rem"},attrs:{"data-toggle":"modal","data-target":"#modal-link-in-bio"}},[_c('i',{staticClass:"fa-solid fa-link mr-2"}),_vm._v(" Visit link in bio\n                  ")]):_c('a',{staticClass:"dropdown-item",staticStyle:{"padding":".5rem 1rem","font-size":"0.875rem"},attrs:{"href":'https://brand.bio/'+link_in_bio.username,"target":"_blank"}},[_c('i',{staticClass:"fa-solid fa-link mr-2"}),_vm._v(" Visit link in bio\n                  ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item text-danger",staticStyle:{"padding":".5rem 1rem","font-size":"0.875rem"},on:{"click":function($event){_vm.open_modal_delete(index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can mr-2"}),_vm._v(" Delete\n                  ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-body px-0",style:('background: '+link_in_bio.background_color+';border-radius: 0.5rem 0.5rem 0 0;'),attrs:{"id":'link-in-bio-'+index}},[_c('div',{staticClass:"mb-3"},[_c('div',{staticClass:"text-center"},[(link_in_bio.profile_image && link_in_bio.profile_image_s3 === 'needs_update')?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px","object-fit":"cover"},attrs:{"src":'https://logo.app/link-in-bio-profile-images/'+link_in_bio.profile_image+'?'+_vm.timenow,"alt":"Profile Image"}}):(link_in_bio.profile_image && link_in_bio.profile_image_s3 !== 'needs_update')?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px","object-fit":"cover"},attrs:{"src":'https://link-in-bio-profile-images.s3.amazonaws.com/'+link_in_bio.profile_image+'?'+_vm.timenow,"alt":"Profile Image"}}):(link_in_bio.logo_unique_id && link_in_bio.paid_svglogos_s3 === 'needs_update')?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px","object-fit":"cover"},attrs:{"src":'https://logo.app/paid-svglogos/'+link_in_bio.logo_unique_id+'.svg?'+_vm.timenow,"alt":"Profile Image"}}):(link_in_bio.logo_unique_id && link_in_bio.paid_svglogos_s3 !== 'needs_update')?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px","object-fit":"cover"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+link_in_bio.logo_unique_id+'.svg?'+_vm.timenow,"alt":"Profile Image"}}):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"text-center mt-2 mb-1",style:('color:'+link_in_bio.font_color+';')},[_vm._v(_vm._s(link_in_bio.profile_title))]),_vm._v(" "),_c('p',{staticClass:"text-center small",style:('color:'+link_in_bio.font_color+';')},[_vm._v(_vm._s(link_in_bio.description))])]),_vm._v(" "),_c('div',{style:(link_in_bio.button_style === '2' 
                      ? 'background: '+link_in_bio.background_color+'; width: 200px; margin: 0 auto; height: 30px; border-radius: 5px; cursor: pointer;text-align: center; color: '+link_in_bio.button_text_color+';border: 1px solid '+link_in_bio.button_color+';' 
                      : 'background: '+link_in_bio.button_color+'; width: 200px; margin: 0 auto; height: 30px; border-radius: 5px; cursor: pointer;text-align: center; color: '+link_in_bio.button_text_color+';')},[_vm._v("...")])]),_vm._v(" "),_c('div',{staticClass:"card-footer mx-4 px-0"},[_c('div',{staticClass:"d-flex justify-content-center"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('div',{staticClass:"col-6 mr-2 p-0"},[_c('button',{staticClass:"btn btn-blue w-100",attrs:{"data-toggle":"modal","data-target":"#modal-link-in-bio"}},[_vm._v("\n                            Copy link\n                        ")])]):_c('div',{staticClass:"col-6 mr-2 p-0"},[(_vm.copied !== index)?_c('button',{staticClass:"btn btn-blue w-100",on:{"click":function($event){_vm.copyLink(index)}}},[_vm._v("\n                            Copy link\n                        ")]):_c('button',{staticClass:"btn btn-success w-100"},[_vm._v("\n                            Copied\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 ml-2 p-0"},[(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-light w-100",attrs:{"data-toggle":"modal","data-target":"#modal-link-in-bio"}},[_vm._v("\n                            Edit link in bio\n                        ")]):_c('router-link',{staticClass:"btn btn-light w-100",attrs:{"to":'/dashboard/edit-link-in-bio/'+link_in_bio.unique_id}},[_vm._v("\n                            Edit link in bio\n                        ")])],1)])])])])})):_c('div',[_c('div',{staticClass:"row row-grid align-items-center"},[_c('div',{staticClass:"col-12 col-lg-5"},[_c('h2',{staticClass:"font-weight-bolder mb-4"},[_vm._v("Boost your online presence by adding a link in your bio.")]),_vm._v(" "),_c('p',[_vm._v("Whether it’s your portfolio or a small business homepage, a simple link in your bio provides an effortless way for users to discover more about you.")]),_vm._v(" "),(_vm.propsdata[0].canceled === 'yes' || (_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes'))?_c('button',{staticClass:"btn btn-primary mt-3 animate-up-2",attrs:{"data-toggle":"modal","data-target":"#modal-link-in-bio"}},[_vm._v("\n                Create your link in bio\n            ")]):_c('router-link',{staticClass:"btn btn-primary mt-3 animate-up-2",attrs:{"to":"/dashboard/create-link-in-bio"}},[_vm._v("Create your link in bio")])],1),_vm._v(" "),_vm._m(1)])])])]):_vm._e(),_vm._v(" "),(_vm.link_in_bio_to_delete !== '')?_c('div',{staticClass:"modal",staticStyle:{"display":"block !important","background":"rgba(147, 152, 165, 0.35)","overflow":"auto"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close_modal_delete),expression:"close_modal_delete"}],staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header w-100"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Delete link in bio")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button"},on:{"click":_vm.close_modal_delete}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-light mr-auto",on:{"click":_vm.close_modal_delete}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.delete_link_in_bio}},[_vm._v("Delete")])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon icon-sm"},[_c('span',{staticClass:"fas fa-ellipsis-h icon-dark"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6 ml-lg-auto"},[_c('img',{staticStyle:{"border-radius":"5px"},attrs:{"src":"https://logo.app/assets/img/link-in-bio-samples.png","alt":"image"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"mb-0"},[_vm._v("Are you sure you want to delete your link in bio?"),_c('br'),_vm._v("This action is irreversible and cannot be undone.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_link_in_bio_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3526084e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_link_in_bio_vue__ = __webpack_require__(103);
function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_link_in_bio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3526084e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_link_in_bio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(102);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7bac128a", content, true, {});

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".fixed-button{position:fixed;bottom:0;left:0;right:0;z-index:1000}.spacer{height:58px;opacity:0}", ""]);

// exports


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Create Link In Bio","description":"Dashboard | Create Link In Bio"}}),_vm._v(" "),_c('div',[_c('nav',{staticStyle:{"position":"fixed","width":"100%","height":"71px","background":"#ffffff","border-bottom":"1px solid #dde1ed","z-index":"99"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","height":"100%","justify-content":"space-between","margin-left":"20px","margin-right":"20px"}},[_c('button',{staticClass:"btn btn-light",on:{"click":_vm.back}},[_c('i',{staticClass:"fa-solid fa-chevron-left mr-2"}),_vm._v(" Back")])])]),_vm._v(" "),(_vm.loading_logos)?_c('div',{staticClass:"pt-7",staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_c('div',{staticClass:"container"},[(_vm.step === '1')?_c('div',{staticClass:"pt-7"},[_c('progress',{staticClass:"w-100 mb-3",attrs:{"value":"1.5","max":"4"}},[_vm._v("Step 1 of 4")]),_vm._v(" "),_c('h1',[_vm._v("Select your brand")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Select the brand you want to use for your Email Signature.")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.logos),function(logo,index){return _c('div',{staticClass:"col-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.logo_unique_id === logo.unique_id },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.choose_logo(logo.unique_id, logo.paid_svglogos_s3);}}},[(logo.paid_svglogos_s3 === 'needs_update')?_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+_vm.timenow},on:{"load":_vm.checkContentHeight}})]):_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+_vm.timenow},on:{"load":_vm.checkContentHeight}})])])])})),_vm._v(" "),_c('div',{staticClass:"container pb-3",class:{'fixed-button': _vm.isButtonFixed, 'p-0': !_vm.isButtonFixed},attrs:{"id":"continueButton"}},[_c('button',{staticClass:"btn btn-blue w-100",on:{"click":_vm.continue_method}},[_vm._v("\n                      Skip\n                  ")])]),_vm._v(" "),(_vm.isButtonFixed)?_c('div',{staticClass:"spacer"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.step === '2')?_c('div',{staticClass:"container-sm pt-7"},[_c('progress',{staticClass:"w-100 mb-3",attrs:{"value":"2.5","max":"4"}},[_vm._v("Step 2 of 4")]),_vm._v(" "),_c('h2',[_vm._v("Set up your link in bio")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Profile Image")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[(!_vm.profile_image && !_vm.logo_unique_id)?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":"https://logo.app/assets/img/placeholder-image.jpg","alt":"Profile Image","id":"profileImage","width":"80","height":"80"}}):(_vm.profile_image)?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.profile_image,"alt":"Profile Image","id":"profileImage","width":"80","height":"80"}}):(_vm.logo_unique_id && _vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"Profile Image","id":"profileImage","width":"80","height":"80"}}):(_vm.logo_unique_id && _vm.paid_svglogos_s3 !== 'needs_update')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"Profile Image","id":"profileImage","width":"80","height":"80"}}):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"btn btn-blue"},[_c('label',{staticClass:"mb-0 text-white",staticStyle:{"cursor":"pointer"},attrs:{"for":"customFile"}},[_vm._v("Change Image")]),_vm._v(" "),_c('input',{ref:"la_profile_image",staticClass:"d-none",attrs:{"type":"file","accept":".jpg, .jpeg, .png, .svg","name":"image","id":"customFile"},on:{"change":_vm.UploadProfileImage}})]),_vm._v(" "),(_vm.profile_image || _vm.logo_unique_id)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.profile_image = ''; _vm.logo_unique_id = '';}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})]):_vm._e()]),_vm._v(" "),(_vm.profile_image_error)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.profile_image_error))]):_vm._e()]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Recommended Size 500x500")])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0 pr-md-2"},[_c('p',{staticClass:"mb-2"},[_vm._v("Profile Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile_title),expression:"profile_title"}],staticClass:"form-control",attrs:{"type":"text","id":"business-name-input","placeholder":"Your name or brand name"},domProps:{"value":(_vm.profile_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.profile_title=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-md-2"},[_c('p',{staticClass:"mb-2"},[_vm._v("Description")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"type":"text","id":"slogan-input","placeholder":"Brief description"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_c('draggable',_vm._b({staticClass:"list-group",model:{value:(_vm.links),callback:function ($$v) {_vm.links=$$v},expression:"links"}},'draggable',{ handle: '.handle' },false),_vm._l((_vm.links),function(link,index){return _c('div',{key:index,staticClass:"mb-3 row align-items-center"},[_c('div',{staticClass:"col-auto pr-0"},[_c('div',{staticClass:"handle",staticStyle:{"cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars"})])]),_vm._v(" "),_c('div',{staticClass:"col form-group mb-0 pr-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(link.media),expression:"link.media"}],staticClass:"custom-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(link, "media", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateMediaAndText(index)}]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Choose Icon")]),_vm._v(" "),_c('option',[_vm._v("Apple App Store")]),_vm._v(" "),_c('option',[_vm._v("ArtStation")]),_vm._v(" "),_c('option',[_vm._v("Behance")]),_vm._v(" "),_c('option',[_vm._v("Discord")]),_vm._v(" "),_c('option',[_vm._v("Facebook")]),_vm._v(" "),_c('option',[_vm._v("GitHub")]),_vm._v(" "),_c('option',[_vm._v("Google Play Store")]),_vm._v(" "),_c('option',[_vm._v("Instagram")]),_vm._v(" "),_c('option',[_vm._v("LinkedIn")]),_vm._v(" "),_c('option',[_vm._v("Medium")]),_vm._v(" "),_c('option',[_vm._v("Patreon")]),_vm._v(" "),_c('option',[_vm._v("Pinterest")]),_vm._v(" "),_c('option',[_vm._v("Reddit")]),_vm._v(" "),_c('option',[_vm._v("Snapchat")]),_vm._v(" "),_c('option',[_vm._v("TikTok")]),_vm._v(" "),_c('option',[_vm._v("Tumblr")]),_vm._v(" "),_c('option',[_vm._v("Twitch")]),_vm._v(" "),_c('option',[_vm._v("Twitter")]),_vm._v(" "),_c('option',[_vm._v("Vimeo")]),_vm._v(" "),_c('option',[_vm._v("Weibo")]),_vm._v(" "),_c('option',[_vm._v("WhatsApp")]),_vm._v(" "),_c('option',[_vm._v("X")]),_vm._v(" "),_c('option',[_vm._v("YouTube")]),_vm._v(" "),_c('option',[_vm._v("Email")]),_vm._v(" "),_c('option',[_vm._v("Globe")])])]),_vm._v(" "),_c('div',{staticClass:"col pt-md-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(link.url),expression:"link.url"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(link.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(link, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto pl-md-0 pt-3 pt-md-0"},[_c('button',{staticClass:"btn btn-danger w-100",on:{"click":function($event){_vm.removeLink(index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])])})),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-blue w-100",on:{"click":_vm.addLink}},[_c('i',{staticClass:"fa-solid fa-plus mr-2"}),_vm._v(" Add Link\n                  ")])],1),_vm._v(" "),_c('div',{staticClass:"container-sm pb-3",class:{'fixed-button': _vm.isButtonFixed, 'p-0': !_vm.isButtonFixed},attrs:{"id":"continueButton"}},[_c('button',{staticClass:"btn btn-success w-100",on:{"click":_vm.continue_method}},[_vm._v("\n                      Continue\n                  ")])]),_vm._v(" "),(_vm.isButtonFixed)?_c('div',{staticClass:"spacer"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.step === '3')?_c('div',{staticClass:"container-sm pt-7"},[_c('progress',{staticClass:"w-100 mb-3",attrs:{"value":"3.5","max":"4"}},[_vm._v("Step 3 of 4")]),_vm._v(" "),_c('h1',[_vm._v("Publish your link in bio!")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Add a name that represents you, your business, or your brand to publish your page immediately.")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-text",staticStyle:{"border-radius":"0.5rem 0px 0px 0.5rem"}},[_vm._v("brand.bio/")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control form-control-lg p-2",staticStyle:{"border-radius":"0px 0.5rem 0.5rem 0px"},attrs:{"maxlength":"255","type":"text","placeholder":"brandname"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),(!_vm.username)?_c('p',{staticClass:"mt-3 mb-0 text-blue"},[_vm._v("Please set the username for your link")]):_vm._e(),_vm._v(" "),(_vm.username_unavailable && _vm.username)?_c('div',{staticClass:"alert alert-danger border border-danger text-danger bg-white mt-3 mb-0",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa-solid fa-circle-xmark"}),_vm._v(" This username is not available.\n              ")]):_vm._e(),_vm._v(" "),(_vm.username_invalid_characters && _vm.username)?_c('div',{staticClass:"alert alert-danger border border-danger text-danger bg-white mt-3 mb-0",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa-solid fa-circle-xmark"}),_vm._v(" Username can only contain letters, numbers, hyphens, and underscores. Please remove any spaces, dots, or special characters.\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container-sm pt-3 pb-3 px-0"},[(!_vm.creating_link_in_bio)?_c('button',{staticClass:"btn btn-success w-100",attrs:{"disabled":!_vm.username},on:{"click":_vm.continue_method}},[_vm._v("\n                      Continue\n                  ")]):_c('button',{staticClass:"btn btn-success w-100"},[_c('span',{staticClass:"spinner-border spinner-border-sm",staticStyle:{"top":"-2px","position":"relative"},attrs:{"role":"status","aria-hidden":"true"}})])])]):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0"},[_vm._v("Basic information")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#dbdbdb !important"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 mb-3 d-flex align-items-center"},[_c('h4',{staticClass:"m-0"},[_vm._v("Add your links")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 border-top border-2 ml-3",staticStyle:{"border-color":"#dbdbdb !important"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_link_in_bio_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb575c12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_link_in_bio_vue__ = __webpack_require__(105);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_link_in_bio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb575c12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_link_in_bio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Edit link in bio","description":"Dashboard | Edit link in bio"}}),_vm._v(" "),_c('div',[_c('nav',{staticStyle:{"position":"fixed","width":"100%","height":"71px","background":"#ffffff","border-bottom":"1px solid #dde1ed","z-index":"99"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","height":"100%","justify-content":"space-between","margin-left":"20px","margin-right":"20px"}},[_c('router-link',{staticClass:"btn btn-light",attrs:{"to":"/dashboard/link-in-bio"}},[_c('i',{staticClass:"fa-solid fa-chevron-left mr-2"}),_vm._v(" Back")]),_vm._v(" "),(!_vm.publishing_link_in_bio)?_c('button',{staticClass:"btn btn-success",on:{"click":_vm.save_link_in_bio}},[_vm._v("Publish")]):_vm._e(),_vm._v(" "),(_vm.publishing_link_in_bio)?_c('button',{staticClass:"btn btn-success"},[_vm._v("Publishing...")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"d-lg-none",staticStyle:{"position":"fixed","bottom":"-1px","left":"0px","background":"rgb(255, 255, 255)","width":"-webkit-fill-available","box-shadow":"rgba(170, 170, 170, 0.18) 10px 10px 10px 10px !important","z-index":"2"}},[(_vm.tab !== '')?_c('div',{staticStyle:{"padding":"10px 10px 0 10px"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-between",staticStyle:{"border-bottom":"1px solid #e8e8e8"}},[(_vm.tab === 'content' || _vm.tab === '')?_c('p',{staticClass:"display-4 mb-0"},[_vm._v("Content")]):_vm._e(),_vm._v(" "),(_vm.tab === 'design')?_c('p',{staticClass:"display-4 mb-0"},[_vm._v("Design")]):_vm._e(),_vm._v(" "),(_vm.tab === 'settings')?_c('p',{staticClass:"display-4 mb-0"},[_vm._v("Settings")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn d-flex align-items-center pt-2 pb-2 pl-2 pr-0",staticStyle:{"font-size":"23px"},on:{"click":function($event){_vm.change_tab('')}}},[_c('i',{staticClass:"fa-solid fa-square-xmark ml-1"})])]),_vm._v(" "),_c('div',{staticClass:"overflow-auto col-12 height-navigation-mobile_linkinbio scroll_to_last_item_sidebar_mobile",staticStyle:{"width":"100%","padding-top":"15px"}},[_c('div',{staticClass:"pt-2"},[(_vm.loading_link_in_bio)?_c('div',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]):_c('div',[(_vm.tab === 'content' || _vm.tab === '')?_c('div',[_c('h1',[_vm._v("Add your sections")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Add the sections you want to show on your link in bio. You can change the order and edit it at any time.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary w-100 mb-3",on:{"click":_vm.show_modal_sections}},[_c('i',{staticClass:"fa-solid fa-plus mr-2"}),_vm._v(" Add Section\n              ")]),_vm._v(" "),_c('draggable',_vm._b({staticClass:"list-group",model:{value:(_vm.sections),callback:function ($$v) {_vm.sections=$$v},expression:"sections"}},'draggable',{ handle: '.handle' },false),_vm._l((_vm.sections),function(section,section_index){return _c('div',{key:section_index,staticClass:"p-3 mb-3",style:({border: '2px solid rgb(221, 225, 237)', borderRadius: '8px'})},[(section.type === 'Profile Information')?_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light handle",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Profile Information")])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Profile Image")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[(!section.profile_image && !_vm.logo_unique_id)?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":"https://logo.app/assets/img/placeholder-image.jpg","alt":"Profile Image","width":"80","height":"80"}}):(section.profile_image && _vm.profile_image_s3 === 'data:image')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":section.profile_image,"alt":"Profile Image","width":"80","height":"80"}}):(section.profile_image && _vm.profile_image_s3 === 'needs_update')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":'https://logo.app/link-in-bio-profile-images/'+section.profile_image+'?'+_vm.timenow,"alt":"Profile Image","width":"80","height":"80"}}):(section.profile_image && _vm.profile_image_s3 !== 'needs_update')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":'https://link-in-bio-profile-images.s3.amazonaws.com/'+section.profile_image+'?'+_vm.timenow,"alt":"Profile Image","width":"80","height":"80"}}):(_vm.logo_unique_id && _vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"Profile Image","width":"80","height":"80"}}):(_vm.logo_unique_id && _vm.paid_svglogos_s3 !== 'needs_update')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"Profile Image","width":"80","height":"80"}}):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"btn btn-blue"},[_c('label',{staticClass:"mb-0 text-white",staticStyle:{"cursor":"pointer"},attrs:{"for":"customFile1"}},[_vm._v("Change Image")]),_vm._v(" "),_c('input',{staticClass:"d-none",attrs:{"type":"file","accept":".jpg, .jpeg, .png, .svg","name":"image","id":"customFile1"},on:{"change":_vm.UploadProfileImage}})]),_vm._v(" "),(_vm.profile_image || _vm.logo_unique_id)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.profile_image = ''; _vm.logo_unique_id = '';}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})]):_vm._e()]),_vm._v(" "),(_vm.profile_image_error)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.profile_image_error))]):_vm._e()]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Recommended Size 500x500")]),_vm._v(" "),(_vm.logos !== null && _vm.logos.length > 0)?_c('div',[_c('p',{staticClass:"mb-2"},[_vm._v("Or choose profile image from your logos")]),_vm._v(" "),_c('button',{staticClass:"btn btn-blue w-100",on:{"click":_vm.show_modal_logo}},[_vm._v("Choose from your logos")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0 pr-md-2"},[_c('p',{staticClass:"mb-2"},[_vm._v("Profile Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.profile_title),expression:"section.profile_title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Your name or brand name"},domProps:{"value":(section.profile_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "profile_title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-md-2"},[_c('p',{staticClass:"mb-2"},[_vm._v("Description")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.description),expression:"section.description"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Brief description"},domProps:{"value":(section.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "description", $event.target.value)}}})])])]):(section.type === 'Social Icons')?_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light handle",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Social Icons")]),_vm._v(" "),_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"pointer"},on:{"click":function($event){_vm.deleteSection(section_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})])]),_vm._v(" "),_c('div',[_c('draggable',_vm._b({staticClass:"list-group",model:{value:(section.social_icons),callback:function ($$v) {_vm.$set(section, "social_icons", $$v)},expression:"section.social_icons"}},'draggable',{ handle: '.handle_your_social_icons_'+section_index },false),_vm._l((section.social_icons),function(social_icon,social_icons_index){return _c('div',{key:social_icons_index,staticClass:"mb-3 row align-items-center"},[_c('div',{staticClass:"col-auto pr-0"},[_c('div',{class:'handle_your_social_icons_'+section_index,staticStyle:{"cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars"})])]),_vm._v(" "),_c('div',{staticClass:"col form-group mb-0 pr-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(social_icon.media),expression:"social_icon.media"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(social_icon, "media", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Choose Social Media")]),_vm._v(" "),_c('option',[_vm._v("Apple App Store")]),_vm._v(" "),_c('option',[_vm._v("ArtStation")]),_vm._v(" "),_c('option',[_vm._v("Behance")]),_vm._v(" "),_c('option',[_vm._v("Discord")]),_vm._v(" "),_c('option',[_vm._v("Facebook")]),_vm._v(" "),_c('option',[_vm._v("GitHub")]),_vm._v(" "),_c('option',[_vm._v("Google Play Store")]),_vm._v(" "),_c('option',[_vm._v("Instagram")]),_vm._v(" "),_c('option',[_vm._v("LinkedIn")]),_vm._v(" "),_c('option',[_vm._v("Medium")]),_vm._v(" "),_c('option',[_vm._v("Patreon")]),_vm._v(" "),_c('option',[_vm._v("Pinterest")]),_vm._v(" "),_c('option',[_vm._v("Reddit")]),_vm._v(" "),_c('option',[_vm._v("Snapchat")]),_vm._v(" "),_c('option',[_vm._v("TikTok")]),_vm._v(" "),_c('option',[_vm._v("Tumblr")]),_vm._v(" "),_c('option',[_vm._v("Twitch")]),_vm._v(" "),_c('option',[_vm._v("Twitter")]),_vm._v(" "),_c('option',[_vm._v("Vimeo")]),_vm._v(" "),_c('option',[_vm._v("Weibo")]),_vm._v(" "),_c('option',[_vm._v("WhatsApp")]),_vm._v(" "),_c('option',[_vm._v("X")]),_vm._v(" "),_c('option',[_vm._v("YouTube")]),_vm._v(" "),_c('option',[_vm._v("Email")]),_vm._v(" "),_c('option',[_vm._v("Globe")])])]),_vm._v(" "),_c('div',{staticClass:"col pl-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(social_icon.url),expression:"social_icon.url"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(social_icon.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(social_icon, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto pl-md-0 pt-3 pt-md-0"},[_c('button',{staticClass:"btn btn-danger w-100",on:{"click":function($event){_vm.removeSocialIcon(section_index, social_icons_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])])})),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-blue w-100",on:{"click":function($event){_vm.addSocialIcon(section_index)}}},[_c('i',{staticClass:"fa-solid fa-plus mr-2"}),_vm._v(" Add social icon\n                              ")])],1)]):(section.type === 'Your Links')?_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light handle",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Your Links")]),_vm._v(" "),_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"pointer"},on:{"click":function($event){_vm.deleteSection(section_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})])]),_vm._v(" "),_c('div',[_c('draggable',_vm._b({staticClass:"list-group",model:{value:(section.links),callback:function ($$v) {_vm.$set(section, "links", $$v)},expression:"section.links"}},'draggable',{ handle: '.handle_your_links_'+section_index },false),_vm._l((section.links),function(link,links_index){return _c('div',{key:links_index,staticClass:"mb-3 row align-items-center"},[_c('div',{staticClass:"col-auto pr-0"},[_c('div',{class:'handle_your_links_'+section_index,staticStyle:{"cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars"})])]),_vm._v(" "),_c('div',{staticClass:"col-4 form-group mb-0 pr-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(link.media),expression:"link.media"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(link, "media", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Choose Icon")]),_vm._v(" "),_c('option',[_vm._v("Apple App Store")]),_vm._v(" "),_c('option',[_vm._v("ArtStation")]),_vm._v(" "),_c('option',[_vm._v("Behance")]),_vm._v(" "),_c('option',[_vm._v("Discord")]),_vm._v(" "),_c('option',[_vm._v("Facebook")]),_vm._v(" "),_c('option',[_vm._v("GitHub")]),_vm._v(" "),_c('option',[_vm._v("Google Play Store")]),_vm._v(" "),_c('option',[_vm._v("Instagram")]),_vm._v(" "),_c('option',[_vm._v("LinkedIn")]),_vm._v(" "),_c('option',[_vm._v("Medium")]),_vm._v(" "),_c('option',[_vm._v("Patreon")]),_vm._v(" "),_c('option',[_vm._v("Pinterest")]),_vm._v(" "),_c('option',[_vm._v("Reddit")]),_vm._v(" "),_c('option',[_vm._v("Snapchat")]),_vm._v(" "),_c('option',[_vm._v("TikTok")]),_vm._v(" "),_c('option',[_vm._v("Tumblr")]),_vm._v(" "),_c('option',[_vm._v("Twitch")]),_vm._v(" "),_c('option',[_vm._v("Twitter")]),_vm._v(" "),_c('option',[_vm._v("Vimeo")]),_vm._v(" "),_c('option',[_vm._v("Weibo")]),_vm._v(" "),_c('option',[_vm._v("WhatsApp")]),_vm._v(" "),_c('option',[_vm._v("X")]),_vm._v(" "),_c('option',[_vm._v("YouTube")]),_vm._v(" "),_c('option',[_vm._v("Email")]),_vm._v(" "),_c('option',[_vm._v("Globe")])])]),_vm._v(" "),_c('div',{staticClass:"col pl-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(link.text),expression:"link.text"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"Button Text"},domProps:{"value":(link.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(link, "text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto pl-3 pl-md-0  pt-3 pt-md-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(link.url),expression:"link.url"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(link.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(link, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto pl-md-0 pt-3 pt-md-0"},[_c('button',{staticClass:"btn btn-danger w-100",on:{"click":function($event){_vm.removeLink(section_index, links_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])])})),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-blue w-100",on:{"click":function($event){_vm.addLink(section_index)}}},[_c('i',{staticClass:"fa-solid fa-plus mr-2"}),_vm._v(" Add Link\n                              ")])],1)]):(section.type === 'Text')?_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light handle",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Text")]),_vm._v(" "),_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"pointer"},on:{"click":function($event){_vm.deleteSection(section_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('p',{staticClass:"mb-2"},[_vm._v("Express more about your business or yourself.")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(section.text),expression:"section.text"}],staticClass:"form-control",attrs:{"placeholder":"Share details about your business or personal story"},domProps:{"value":(section.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "text", $event.target.value)}}})])]):(section.type === 'Address')?_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light handle",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Address")]),_vm._v(" "),_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"pointer"},on:{"click":function($event){_vm.deleteSection(section_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.address_line_1),expression:"section.address_line_1"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"123 Main Street"},domProps:{"value":(section.address_line_1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "address_line_1", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Address Line 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.address_line_2),expression:"section.address_line_2"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Apt, Unit, Suite..."},domProps:{"value":(section.address_line_2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "address_line_2", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.city),expression:"section.city"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"San Francisco"},domProps:{"value":(section.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "city", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("State / Province")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.state_province),expression:"section.state_province"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"California"},domProps:{"value":(section.state_province)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "state_province", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("ZIP / Postal code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.zip),expression:"section.zip"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"12345"},domProps:{"value":(section.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "zip", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Country")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.country),expression:"section.country"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"United States"},domProps:{"value":(section.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "country", $event.target.value)}}})])])]):_vm._e()])}))],1):_vm._e(),_vm._v(" "),(_vm.tab === 'design')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(4),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-2"},[_vm._v("Background color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.background_color),expression:"background_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.background_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.background_color),expression:"background_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.background_color=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Button color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_color),expression:"button_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.button_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_color),expression:"button_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.button_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Text color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_text_color),expression:"button_text_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.button_text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_text_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_text_color),expression:"button_text_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.button_text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_text_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Icon color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_icon_color),expression:"button_icon_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.button_icon_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_icon_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_icon_color),expression:"button_icon_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.button_icon_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_icon_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Shadow color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_shadow_color),expression:"button_shadow_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.button_shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_shadow_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_shadow_color),expression:"button_shadow_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.button_shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_shadow_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Button style")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_style === '1' },staticStyle:{"background":"#d2d6dc","width":"100%","height":"30px","border-radius":"5px","cursor":"pointer"},on:{"click":function($event){_vm.button_style = '1'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_style === '2' },staticStyle:{"border":"1px solid #d2d6dc","background":"transparent","width":"100%","height":"30px","border-radius":"5px","cursor":"pointer"},on:{"click":function($event){_vm.button_style = '2'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_style === '3' },staticStyle:{"background":"#d2d6dc","filter":"drop-shadow(rgb(55, 65, 81) 0.25rem 0.25rem 0px)","width":"100%","height":"30px","border-radius":"5px","cursor":"pointer"},on:{"click":function($event){_vm.button_style = '3'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_style === '4' },staticStyle:{"background":"#d2d6dc","filter":"drop-shadow(rgb(55, 65, 81) 0px 0.125rem 0.125rem)","width":"100%","height":"30px","border-radius":"5px","cursor":"pointer"},on:{"click":function($event){_vm.button_style = '4'}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Button shape")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_shape === '1' },staticStyle:{"background":"#d2d6dc","width":"100%","height":"30px","border-radius":"5px","cursor":"pointer"},on:{"click":function($event){_vm.button_shape = '1'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_shape === '2' },staticStyle:{"background":"#d2d6dc","width":"100%","height":"30px","cursor":"pointer"},on:{"click":function($event){_vm.button_shape = '2'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_shape === '3' },staticStyle:{"background":"#d2d6dc","width":"100%","height":"30px","border-radius":"10px","cursor":"pointer"},on:{"click":function($event){_vm.button_shape = '3'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_shape === '4' },staticStyle:{"background":"#d2d6dc","width":"100%","height":"30px","border-radius":"15px","cursor":"pointer"},on:{"click":function($event){_vm.button_shape = '4'}}})])])])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(6),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-2"},[_vm._v("Icon color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.icon_color),expression:"icon_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.icon_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.icon_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.icon_color),expression:"icon_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.icon_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.icon_color=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(7),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-2"},[_vm._v("Font color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.font_color),expression:"font_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.font_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.font_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.font_color),expression:"font_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.font_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.font_color=$event.target.value}}})])])])])]):_vm._e(),_vm._v(" "),(_vm.tab === 'settings')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(8),_vm._v(" "),_c('p',[_vm._v("Add a name that represents you, your business, or your brand to publish your page immediately.")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-text",staticStyle:{"border-radius":"0.5rem 0px 0px 0.5rem"}},[_vm._v("brand.bio/")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_username),expression:"new_username"}],staticClass:"form-control form-control-lg p-2",staticStyle:{"border-radius":"0px 0.5rem 0.5rem 0px"},attrs:{"maxlength":"255","type":"text","placeholder":"brandname"},domProps:{"value":(_vm.new_username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.new_username=$event.target.value}}})]),_vm._v(" "),(!_vm.new_username)?_c('p',{staticClass:"mt-3 mb-0 text-blue"},[_vm._v("Please set the username for your link")]):_vm._e(),_vm._v(" "),(_vm.username_unavailable && _vm.new_username)?_c('div',{staticClass:"alert alert-danger border border-danger text-danger bg-white mt-3 mb-0",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa-solid fa-circle-xmark"}),_vm._v(" This username is not available.\n                ")]):_vm._e(),_vm._v(" "),(_vm.username_invalid_characters && _vm.new_username)?_c('div',{staticClass:"alert alert-danger border border-danger text-danger bg-white mt-3 mb-0",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa-solid fa-circle-xmark"}),_vm._v(" Username can only contain letters, numbers, hyphens, and underscores. Please remove any spaces, dots, or special characters.\n                ")]):_vm._e(),_vm._v(" "),(_vm.username_updated && _vm.new_username)?_c('div',{staticClass:"alert alert-success border border-success text-success bg-white mt-3 mb-0",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa-solid fa-check"}),_vm._v(" Username updated successfully.\n                ")]):_vm._e(),_vm._v(" "),(_vm.username_already_yours && _vm.new_username)?_c('div',{staticClass:"alert alert-warning border border-warning text-warning bg-white mt-3 mb-0",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa-solid fa-check"}),_vm._v(" Username already yours.\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container-sm pt-3 pb-3 px-0"},[(!_vm.updating_username)?_c('button',{staticClass:"btn btn-success w-100",attrs:{"disabled":!_vm.new_username},on:{"click":_vm.update_username}},[_vm._v("\n                        Update username\n                    ")]):_c('button',{staticClass:"btn btn-success w-100"},[_c('span',{staticClass:"spinner-border spinner-border-sm",staticStyle:{"top":"-2px","position":"relative"},attrs:{"role":"status","aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_c('div',{staticClass:"form-check form-switch m-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.powered_by),expression:"powered_by"}],staticClass:"form-check-input",attrs:{"type":"checkbox","role":"switch","id":"flexSwitchCheckDefault1"},domProps:{"checked":Array.isArray(_vm.powered_by)?_vm._i(_vm.powered_by,null)>-1:(_vm.powered_by)},on:{"change":function($event){var $$a=_vm.powered_by,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.powered_by=$$a.concat([$$v]))}else{$$i>-1&&(_vm.powered_by=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.powered_by=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"flexSwitchCheckDefault1"}},[_vm._v("Powered By")])])])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex",staticStyle:{"white-space":"nowrap","overflow":"scroll","border-top":"1px solid #dfe0e6","padding":"8px"}},[_c('a',{staticClass:"d-flex flex-column align-items-center p-2 col-4",class:{ 'active-tab-sidebar-link-in-bio-mobile': _vm.tab === 'content' },staticStyle:{"border-radius":"0.5rem","min-width":"80px"},on:{"click":function($event){_vm.change_tab('content')}}},[_c('i',{staticClass:"fa-solid fa-a mb-2",staticStyle:{"color":"rgb(223, 224, 230)"}}),_vm._v(" "),_c('span',{staticClass:"text-center"},[_vm._v("Content")])]),_vm._v(" "),_c('a',{staticClass:"d-flex flex-column align-items-center p-2 col-4",class:{ 'active-tab-sidebar-link-in-bio-mobile': _vm.tab === 'design' },staticStyle:{"border-radius":"0.5rem","min-width":"80px"},on:{"click":function($event){_vm.change_tab('design')}}},[_c('i',{staticClass:"fa-solid fa-palette mb-2",staticStyle:{"color":"rgb(223, 224, 230)"}}),_vm._v(" "),_c('span',{staticClass:"text-center"},[_vm._v("Design")])]),_vm._v(" "),_c('a',{staticClass:"d-flex flex-column align-items-center p-2 col-4",class:{ 'active-tab-sidebar-link-in-bio-mobile': _vm.tab === 'settings' },staticStyle:{"border-radius":"0.5rem","min-width":"80px"},on:{"click":function($event){_vm.change_tab('settings')}}},[_c('i',{staticClass:"fa-solid fa-gear mb-2",staticStyle:{"color":"rgb(223, 224, 230)"}}),_vm._v(" "),_c('span',{staticClass:"text-center"},[_vm._v("Settings")])])])]),_vm._v(" "),_c('div',{staticClass:"sidebar-link-in-bio px-4 pt-6 d-lg-block scroll_to_last_item_sidebar",staticStyle:{"display":"none"}},[_c('div',{staticClass:"pt-2"},[(_vm.loading_link_in_bio)?_c('div',[_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12)]):_c('div',[_c('div',{staticClass:"nav-wrapper position-relative pt-0"},[_c('ul',{staticClass:"nav nav-pills nav-fill flex-column flex-md-row",attrs:{"id":"tabs-link-in-bio"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link mb-sm-3 mb-md-0",class:{ 'active-tab-sidebar-link-in-bio': _vm.tab === 'content' },on:{"click":function($event){_vm.change_tab('content')}}},[_vm._v("Content")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link mb-sm-3 mb-md-0",class:{ 'active-tab-sidebar-link-in-bio': _vm.tab === 'design' },on:{"click":function($event){_vm.change_tab('design')}}},[_vm._v("Design")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link mb-sm-3 mb-md-0",class:{ 'active-tab-sidebar-link-in-bio': _vm.tab === 'settings' },on:{"click":function($event){_vm.change_tab('settings')}}},[_vm._v("Settings")])])])]),_vm._v(" "),(_vm.tab === 'content' || _vm.tab === '')?_c('div',[_c('h1',[_vm._v("Add your sections")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Add the sections you want to show on your link in bio. You can change the order and edit it at any time.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary w-100 mb-3",on:{"click":_vm.show_modal_sections}},[_c('i',{staticClass:"fa-solid fa-plus mr-2"}),_vm._v(" Add Section\n              ")]),_vm._v(" "),_c('draggable',_vm._b({staticClass:"list-group",model:{value:(_vm.sections),callback:function ($$v) {_vm.sections=$$v},expression:"sections"}},'draggable',{ handle: '.handle' },false),_vm._l((_vm.sections),function(section,section_index){return _c('div',{key:section_index,staticClass:"p-3 mb-3",style:({border: '2px solid rgb(221, 225, 237)', borderRadius: '8px'})},[(section.type === 'Profile Information')?_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light handle",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Profile Information")])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Profile Image")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[(!section.profile_image && !_vm.logo_unique_id)?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":"https://logo.app/assets/img/placeholder-image.jpg","alt":"Profile Image","width":"80","height":"80"}}):(section.profile_image && _vm.profile_image_s3 === 'data:image')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":section.profile_image,"alt":"Profile Image","width":"80","height":"80"}}):(section.profile_image && _vm.profile_image_s3 === 'needs_update')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":'https://logo.app/link-in-bio-profile-images/'+section.profile_image+'?'+_vm.timenow,"alt":"Profile Image","width":"80","height":"80"}}):(section.profile_image && _vm.profile_image_s3 !== 'needs_update')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":'https://link-in-bio-profile-images.s3.amazonaws.com/'+section.profile_image+'?'+_vm.timenow,"alt":"Profile Image","width":"80","height":"80"}}):(_vm.logo_unique_id && _vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"Profile Image","width":"80","height":"80"}}):(_vm.logo_unique_id && _vm.paid_svglogos_s3 !== 'needs_update')?_c('img',{staticClass:"rounded mr-3",staticStyle:{"object-fit":"cover"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"Profile Image","width":"80","height":"80"}}):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"btn btn-blue"},[_c('label',{staticClass:"mb-0 text-white",staticStyle:{"cursor":"pointer"},attrs:{"for":"customFile2"}},[_vm._v("Change Image")]),_vm._v(" "),_c('input',{staticClass:"d-none",attrs:{"type":"file","accept":".jpg, .jpeg, .png, .svg","name":"image","id":"customFile2"},on:{"change":_vm.UploadProfileImage}})]),_vm._v(" "),(_vm.profile_image || _vm.logo_unique_id)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.profile_image = ''; _vm.logo_unique_id = '';}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})]):_vm._e()]),_vm._v(" "),(_vm.profile_image_error)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.profile_image_error))]):_vm._e()]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Recommended Size 500x500")]),_vm._v(" "),(_vm.logos !== null && _vm.logos.length > 0)?_c('div',[_c('p',{staticClass:"mb-2"},[_vm._v("Or choose profile image from your logos")]),_vm._v(" "),_c('button',{staticClass:"btn btn-blue w-100",on:{"click":_vm.show_modal_logo}},[_vm._v("Choose from your logos")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0 pr-md-2"},[_c('p',{staticClass:"mb-2"},[_vm._v("Profile Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.profile_title),expression:"section.profile_title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Your name or brand name"},domProps:{"value":(section.profile_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "profile_title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-md-2"},[_c('p',{staticClass:"mb-2"},[_vm._v("Description")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.description),expression:"section.description"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Brief description"},domProps:{"value":(section.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "description", $event.target.value)}}})])])]):(section.type === 'Social Icons')?_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light handle",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Social Icons")]),_vm._v(" "),_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"pointer"},on:{"click":function($event){_vm.deleteSection(section_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})])]),_vm._v(" "),_c('div',[_c('draggable',_vm._b({staticClass:"list-group",model:{value:(section.social_icons),callback:function ($$v) {_vm.$set(section, "social_icons", $$v)},expression:"section.social_icons"}},'draggable',{ handle: '.handle_your_social_icons_'+section_index },false),_vm._l((section.social_icons),function(social_icon,social_icons_index){return _c('div',{key:social_icons_index,staticClass:"mb-3 row align-items-center"},[_c('div',{staticClass:"col-auto pr-0"},[_c('div',{class:'handle_your_social_icons_'+section_index,staticStyle:{"cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars"})])]),_vm._v(" "),_c('div',{staticClass:"col form-group mb-0 pr-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(social_icon.media),expression:"social_icon.media"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(social_icon, "media", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Choose Social Media")]),_vm._v(" "),_c('option',[_vm._v("Apple App Store")]),_vm._v(" "),_c('option',[_vm._v("ArtStation")]),_vm._v(" "),_c('option',[_vm._v("Behance")]),_vm._v(" "),_c('option',[_vm._v("Discord")]),_vm._v(" "),_c('option',[_vm._v("Facebook")]),_vm._v(" "),_c('option',[_vm._v("GitHub")]),_vm._v(" "),_c('option',[_vm._v("Google Play Store")]),_vm._v(" "),_c('option',[_vm._v("Instagram")]),_vm._v(" "),_c('option',[_vm._v("LinkedIn")]),_vm._v(" "),_c('option',[_vm._v("Medium")]),_vm._v(" "),_c('option',[_vm._v("Patreon")]),_vm._v(" "),_c('option',[_vm._v("Pinterest")]),_vm._v(" "),_c('option',[_vm._v("Reddit")]),_vm._v(" "),_c('option',[_vm._v("Snapchat")]),_vm._v(" "),_c('option',[_vm._v("TikTok")]),_vm._v(" "),_c('option',[_vm._v("Tumblr")]),_vm._v(" "),_c('option',[_vm._v("Twitch")]),_vm._v(" "),_c('option',[_vm._v("Twitter")]),_vm._v(" "),_c('option',[_vm._v("Vimeo")]),_vm._v(" "),_c('option',[_vm._v("Weibo")]),_vm._v(" "),_c('option',[_vm._v("WhatsApp")]),_vm._v(" "),_c('option',[_vm._v("X")]),_vm._v(" "),_c('option',[_vm._v("YouTube")])])]),_vm._v(" "),_c('div',{staticClass:"col pl-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(social_icon.url),expression:"social_icon.url"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(social_icon.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(social_icon, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto pl-md-0 pt-3 pt-md-0"},[_c('button',{staticClass:"btn btn-danger w-100",on:{"click":function($event){_vm.removeSocialIcon(section_index, social_icons_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])])})),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-blue w-100",on:{"click":function($event){_vm.addSocialIcon(section_index)}}},[_c('i',{staticClass:"fa-solid fa-plus mr-2"}),_vm._v(" Add social icon\n                              ")])],1)]):(section.type === 'Your Links')?_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light handle",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Your Links")]),_vm._v(" "),_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"pointer"},on:{"click":function($event){_vm.deleteSection(section_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})])]),_vm._v(" "),_c('div',[_c('draggable',_vm._b({staticClass:"list-group",model:{value:(section.links),callback:function ($$v) {_vm.$set(section, "links", $$v)},expression:"section.links"}},'draggable',{ handle: '.handle_your_links_'+section_index },false),_vm._l((section.links),function(link,links_index){return _c('div',{key:links_index,staticClass:"mb-3 row align-items-center"},[_c('div',{staticClass:"col-auto pr-0"},[_c('div',{class:'handle_your_links_'+section_index,staticStyle:{"cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars"})])]),_vm._v(" "),_c('div',{staticClass:"col-2 form-group mb-0 pr-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(link.media),expression:"link.media"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(link, "media", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Choose Icon")]),_vm._v(" "),_c('option',[_vm._v("Apple App Store")]),_vm._v(" "),_c('option',[_vm._v("ArtStation")]),_vm._v(" "),_c('option',[_vm._v("Behance")]),_vm._v(" "),_c('option',[_vm._v("Discord")]),_vm._v(" "),_c('option',[_vm._v("Facebook")]),_vm._v(" "),_c('option',[_vm._v("GitHub")]),_vm._v(" "),_c('option',[_vm._v("Google Play Store")]),_vm._v(" "),_c('option',[_vm._v("Instagram")]),_vm._v(" "),_c('option',[_vm._v("LinkedIn")]),_vm._v(" "),_c('option',[_vm._v("Medium")]),_vm._v(" "),_c('option',[_vm._v("Patreon")]),_vm._v(" "),_c('option',[_vm._v("Pinterest")]),_vm._v(" "),_c('option',[_vm._v("Reddit")]),_vm._v(" "),_c('option',[_vm._v("Snapchat")]),_vm._v(" "),_c('option',[_vm._v("TikTok")]),_vm._v(" "),_c('option',[_vm._v("Tumblr")]),_vm._v(" "),_c('option',[_vm._v("Twitch")]),_vm._v(" "),_c('option',[_vm._v("Twitter")]),_vm._v(" "),_c('option',[_vm._v("Vimeo")]),_vm._v(" "),_c('option',[_vm._v("Weibo")]),_vm._v(" "),_c('option',[_vm._v("WhatsApp")]),_vm._v(" "),_c('option',[_vm._v("X")]),_vm._v(" "),_c('option',[_vm._v("YouTube")]),_vm._v(" "),_c('option',[_vm._v("Email")]),_vm._v(" "),_c('option',[_vm._v("Globe")])])]),_vm._v(" "),_c('div',{staticClass:"col pl-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(link.text),expression:"link.text"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"Button Text"},domProps:{"value":(link.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(link, "text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto pl-3 pl-md-0  pt-3 pt-md-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(link.url),expression:"link.url"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://example.com"},domProps:{"value":(link.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(link, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto pl-md-0 pt-3 pt-md-0"},[_c('button',{staticClass:"btn btn-danger w-100",on:{"click":function($event){_vm.removeLink(section_index, links_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can"})])])])})),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-blue w-100",on:{"click":function($event){_vm.addLink(section_index)}}},[_c('i',{staticClass:"fa-solid fa-plus mr-2"}),_vm._v(" Add Link\n                              ")])],1)]):(section.type === 'Text')?_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light handle",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Text")]),_vm._v(" "),_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"pointer"},on:{"click":function($event){_vm.deleteSection(section_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('p',{staticClass:"mb-2"},[_vm._v("Express more about your business or yourself.")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(section.text),expression:"section.text"}],staticClass:"form-control",attrs:{"placeholder":"Share details about your business or personal story"},domProps:{"value":(section.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "text", $event.target.value)}}})])]):(section.type === 'Address')?_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light handle",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"grab"}},[_c('i',{staticClass:"fa-solid fa-bars",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Address")]),_vm._v(" "),_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px","cursor":"pointer"},on:{"click":function($event){_vm.deleteSection(section_index)}}},[_c('i',{staticClass:"fa-solid fa-trash-can",staticStyle:{"color":"rgb(154, 154, 154)","font-size":"23px","margin-left":"2px"}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.address_line_1),expression:"section.address_line_1"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"123 Main Street"},domProps:{"value":(section.address_line_1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "address_line_1", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Address Line 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.address_line_2),expression:"section.address_line_2"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Apt, Unit, Suite..."},domProps:{"value":(section.address_line_2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "address_line_2", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.city),expression:"section.city"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"San Francisco"},domProps:{"value":(section.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "city", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("State / Province")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.state_province),expression:"section.state_province"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"California"},domProps:{"value":(section.state_province)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "state_province", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("ZIP / Postal code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.zip),expression:"section.zip"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"12345"},domProps:{"value":(section.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "zip", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-md-2 pb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Country")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(section.country),expression:"section.country"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"United States"},domProps:{"value":(section.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(section, "country", $event.target.value)}}})])])]):_vm._e()])}))],1):_vm._e(),_vm._v(" "),(_vm.tab === 'design')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(13),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-2"},[_vm._v("Background color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.background_color),expression:"background_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.background_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.background_color),expression:"background_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.background_color=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Button color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_color),expression:"button_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.button_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_color),expression:"button_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.button_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Text color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_text_color),expression:"button_text_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.button_text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_text_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_text_color),expression:"button_text_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.button_text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_text_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Icon color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_icon_color),expression:"button_icon_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.button_icon_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_icon_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_icon_color),expression:"button_icon_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.button_icon_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_icon_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Shadow color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_shadow_color),expression:"button_shadow_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.button_shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_shadow_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.button_shadow_color),expression:"button_shadow_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.button_shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.button_shadow_color=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Button style")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_style === '1' },staticStyle:{"background":"#d2d6dc","width":"100%","height":"30px","border-radius":"5px","cursor":"pointer"},on:{"click":function($event){_vm.button_style = '1'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_style === '2' },staticStyle:{"border":"1px solid #d2d6dc","background":"transparent","width":"100%","height":"30px","border-radius":"5px","cursor":"pointer"},on:{"click":function($event){_vm.button_style = '2'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_style === '3' },staticStyle:{"background":"#d2d6dc","filter":"drop-shadow(rgb(55, 65, 81) 0.25rem 0.25rem 0px)","width":"100%","height":"30px","border-radius":"5px","cursor":"pointer"},on:{"click":function($event){_vm.button_style = '3'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_style === '4' },staticStyle:{"background":"#d2d6dc","filter":"drop-shadow(rgb(55, 65, 81) 0px 0.125rem 0.125rem)","width":"100%","height":"30px","border-radius":"5px","cursor":"pointer"},on:{"click":function($event){_vm.button_style = '4'}}})])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v("Button shape")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_shape === '1' },staticStyle:{"background":"#d2d6dc","width":"100%","height":"30px","border-radius":"5px","cursor":"pointer"},on:{"click":function($event){_vm.button_shape = '1'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_shape === '2' },staticStyle:{"background":"#d2d6dc","width":"100%","height":"30px","cursor":"pointer"},on:{"click":function($event){_vm.button_shape = '2'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_shape === '3' },staticStyle:{"background":"#d2d6dc","width":"100%","height":"30px","border-radius":"10px","cursor":"pointer"},on:{"click":function($event){_vm.button_shape = '3'}}})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.button_shape === '4' },staticStyle:{"background":"#d2d6dc","width":"100%","height":"30px","border-radius":"15px","cursor":"pointer"},on:{"click":function($event){_vm.button_shape = '4'}}})])])])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(15),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-2"},[_vm._v("Icon color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.icon_color),expression:"icon_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.icon_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.icon_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.icon_color),expression:"icon_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.icon_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.icon_color=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(16),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-2"},[_vm._v("Font color")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.font_color),expression:"font_color"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. #151f42"},domProps:{"value":(_vm.font_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.font_color=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 pl-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.font_color),expression:"font_color"}],staticStyle:{"height":"100%","border":"0.1rem solid rgb(227, 236, 242)","background":"rgb(255, 255, 255)","width":"100%"},attrs:{"type":"color"},domProps:{"value":(_vm.font_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.font_color=$event.target.value}}})])])])])]):_vm._e(),_vm._v(" "),(_vm.tab === 'settings')?_c('div',[_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_vm._m(17),_vm._v(" "),_c('p',[_vm._v("Add a name that represents you, your business, or your brand to publish your page immediately.")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-text",staticStyle:{"border-radius":"0.5rem 0px 0px 0.5rem"}},[_vm._v("brand.bio/")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_username),expression:"new_username"}],staticClass:"form-control form-control-lg p-2",staticStyle:{"border-radius":"0px 0.5rem 0.5rem 0px"},attrs:{"maxlength":"255","type":"text","placeholder":"brandname"},domProps:{"value":(_vm.new_username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.new_username=$event.target.value}}})]),_vm._v(" "),(!_vm.new_username)?_c('p',{staticClass:"mt-3 mb-0 text-blue"},[_vm._v("Please set the username for your link")]):_vm._e(),_vm._v(" "),(_vm.username_unavailable && _vm.new_username)?_c('div',{staticClass:"alert alert-danger border border-danger text-danger bg-white mt-3 mb-0",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa-solid fa-circle-xmark"}),_vm._v(" This username is not available.\n                ")]):_vm._e(),_vm._v(" "),(_vm.username_invalid_characters && _vm.new_username)?_c('div',{staticClass:"alert alert-danger border border-danger text-danger bg-white mt-3 mb-0",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa-solid fa-circle-xmark"}),_vm._v(" Username can only contain letters, numbers, hyphens, and underscores. Please remove any spaces, dots, or special characters.\n                ")]):_vm._e(),_vm._v(" "),(_vm.username_updated && _vm.new_username)?_c('div',{staticClass:"alert alert-success border border-success text-success bg-white mt-3 mb-0",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa-solid fa-check"}),_vm._v(" Username updated successfully.\n                ")]):_vm._e(),_vm._v(" "),(_vm.username_already_yours && _vm.new_username)?_c('div',{staticClass:"alert alert-warning border border-warning text-warning bg-white mt-3 mb-0",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa-solid fa-check"}),_vm._v(" Username already yours.\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container-sm pt-3 pb-3 px-0"},[(!_vm.updating_username)?_c('button',{staticClass:"btn btn-success w-100",attrs:{"disabled":!_vm.new_username},on:{"click":_vm.update_username}},[_vm._v("\n                        Update username\n                    ")]):_c('button',{staticClass:"btn btn-success w-100"},[_c('span',{staticClass:"spinner-border spinner-border-sm",staticStyle:{"top":"-2px","position":"relative"},attrs:{"role":"status","aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"p-3 mb-3",staticStyle:{"border":"2px solid #dde1ed","border-radius":"8px"}},[_c('div',{staticClass:"form-check form-switch m-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.powered_by),expression:"powered_by"}],staticClass:"form-check-input",attrs:{"type":"checkbox","role":"switch","id":"flexSwitchCheckDefault2"},domProps:{"checked":Array.isArray(_vm.powered_by)?_vm._i(_vm.powered_by,null)>-1:(_vm.powered_by)},on:{"change":function($event){var $$a=_vm.powered_by,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.powered_by=$$a.concat([$$v]))}else{$$i>-1&&(_vm.powered_by=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.powered_by=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"flexSwitchCheckDefault2"}},[_vm._v("Powered By")])])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"margin-espacio-del-sidebar-link-in-bio pt-6 pt-lg-0"},[(_vm.loading_link_in_bio)?_c('div',{staticClass:"pt-0 pt-lg-6 mb-6 ml-3 mr-3"},[_vm._m(18)]):_c('div',[_c('div',{staticClass:"phone-container"},[_c('div',{staticClass:"phone"},[_c('div',{staticClass:"phone-screen"},[_c('div',{staticClass:"phone-content",style:('background-color:'+_vm.background_color+';')},[_c('div',{staticClass:"container mt-5 mb-6"},_vm._l((_vm.sections),function(section,section_index){return _c('div',{key:section_index},[(section.type === 'Profile Information')?_c('div',{staticClass:"mt-3 mb-3"},[_c('div',{staticClass:"text-center"},[(!section.profile_image && !_vm.logo_unique_id)?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px","object-fit":"cover"},attrs:{"src":"https://logo.app/assets/img/placeholder-image.jpg","alt":"Profile Image"}}):(section.profile_image && _vm.profile_image_s3 === 'data:image')?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px","object-fit":"cover"},attrs:{"src":section.profile_image,"alt":"Profile Image"}}):(section.profile_image && _vm.profile_image_s3 === 'needs_update')?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px","object-fit":"cover"},attrs:{"src":'https://logo.app/link-in-bio-profile-images/'+section.profile_image+'?'+_vm.timenow,"alt":"Profile Image"}}):(section.profile_image && _vm.profile_image_s3 !== 'needs_update')?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px","object-fit":"cover"},attrs:{"src":'https://link-in-bio-profile-images.s3.amazonaws.com/'+section.profile_image+'?'+_vm.timenow,"alt":"Profile Image"}}):(_vm.logo_unique_id && _vm.paid_svglogos_s3 === 'needs_update')?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px","object-fit":"cover"},attrs:{"src":'https://logo.app/paid-svglogos/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"Profile Image"}}):(_vm.logo_unique_id && _vm.paid_svglogos_s3 !== 'needs_update')?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px","object-fit":"cover"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+_vm.logo_unique_id+'.svg?'+_vm.timenow,"alt":"Profile Image"}}):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"text-center mt-2 mb-1",style:('color:'+_vm.font_color+';')},[_vm._v(_vm._s(section.profile_title))]),_vm._v(" "),_c('p',{staticClass:"text-center small",style:('color:'+_vm.font_color+';')},[_vm._v(_vm._s(section.description))])]):(section.type === 'Social Icons')?_c('div',{staticClass:"d-flex justify-content-center flex-wrap mt-3 mb-3"},_vm._l((section.social_icons),function(icon,index){return _c('a',{key:index,staticClass:"btn btn-md m-1",style:('color:'+_vm.icon_color+';border:1px solid '+_vm.icon_color+';'),attrs:{"href":(icon.url.startsWith('http://') || icon.url.startsWith('https://')) 
                                          ? icon.url 
                                          : (_vm.socialMediaBaseUrls[icon.media] && icon.url.includes(_vm.socialMediaBaseUrls[icon.media].replace(/^https?:\/\//, ''))) 
                                          ? 'https://' + icon.url.replace(/^(https?:\/\/)?(www\.)?/, '') 
                                          : _vm.socialMediaBaseUrls[icon.media] + icon.url.replace(/^(https?:\/\/)?(www\.)?/, ''),"target":"_blank"}},[(icon.media === 'Google Play Store')?_c('i',{staticClass:"fa-brands fa-google-play"}):(icon.media === 'Apple App Store')?_c('i',{staticClass:"fa-brands fa-app-store"}):(icon.media === 'X')?_c('i',{staticClass:"fa-brands fa-x-twitter"}):_c('i',{class:'fa-brands fa-'+icon.media.toLowerCase()})])})):(section.type === 'Your Links')?_c('div',{staticClass:"text-center mt-3 mb-3"},_vm._l((section.links),function(link,index){return _c('a',{key:index,staticClass:"btn btn-lg btn-block mb-2 d-flex flex-column align-items-center justify-content-center position-relative",style:('color:'+_vm.button_text_color+';' +
                                          (_vm.button_shape === '1' ? 'border-radius:5px;' : '') +
                                          (_vm.button_shape === '2' ? 'border-radius:0px;' : '') +
                                          (_vm.button_shape === '3' ? 'border-radius:15px;' : '') +
                                          (_vm.button_shape === '4' ? 'border-radius:28px;' : '') +
                                          (_vm.button_style === '1' ? '' : '') + 
                                          (_vm.button_style === '2' ? 'border:1px solid '+_vm.button_color+';background:transparent;' : 'background-color:'+_vm.button_color+';') +
                                          (_vm.button_style === '3' ? 'filter:drop-shadow('+_vm.button_shadow_color+' 0.25rem 0.25rem 0px);' : '') +
                                          (_vm.button_style === '4' ? 'filter:drop-shadow('+_vm.button_shadow_color+' 0px 0.125rem 0.125rem);' : '') +
                                          'font-size: 17px; padding: 14px;'),attrs:{"href":(link.url.startsWith('http://') || link.url.startsWith('https://')) 
                                          ? link.url 
                                          : (_vm.socialMediaBaseUrls[link.media] && link.url.includes(_vm.socialMediaBaseUrls[link.media].replace(/^https?:\/\//, ''))) 
                                          ? 'https://' + link.url.replace(/^(https?:\/\/)?(www\.)?/, '') 
                                          : _vm.socialMediaBaseUrls[link.media] + link.url.replace(/^(https?:\/\/)?(www\.)?/, ''),"target":"_blank"}},[(link.media === 'Google Play Store')?_c('i',{staticClass:"fa-brands fa-google-play position-absolute",style:('top: 16px;left: 10px;font-size: 22px;color:'+_vm.button_icon_color+';')}):(link.media === 'Apple App Store')?_c('i',{staticClass:"fa-brands fa-app-store position-absolute",style:('top: 16px;left: 10px;font-size: 22px;color:'+_vm.button_icon_color+';')}):(link.media === 'X')?_c('i',{staticClass:"fa-brands fa-x-twitter position-absolute",style:('top: 16px;left: 10px;font-size: 22px;color:'+_vm.button_icon_color+';')}):(link.media === 'Email')?_c('i',{staticClass:"fa-solid fa-envelope position-absolute",style:('top: 16px;left: 10px;font-size: 22px;color:'+_vm.button_icon_color+';')}):(link.media === 'Globe')?_c('i',{staticClass:"fa-solid fa-globe position-absolute",style:('top: 16px;left: 10px;font-size: 22px;color:'+_vm.button_icon_color+';')}):_c('i',{class:'fa-brands fa-'+link.media.toLowerCase()+' position-absolute',style:('top: 16px;left: 10px;font-size: 22px;color:'+_vm.button_icon_color+';')}),_vm._v("\n                                              "+_vm._s(link.text)+"\n                                          ")])})):(section.type === 'Text')?_c('div',{staticClass:"text-center mt-3 mb-3"},[(section.text)?_c('p',{staticClass:"small",style:('color:'+_vm.font_color+';')},[_vm._v(_vm._s(section.text))]):_vm._e()]):(section.type === 'Address')?_c('div',{staticClass:"text-center mt-3 mb-3"},[_c('a',{staticClass:"small",style:('color:'+_vm.font_color+';'),attrs:{"href":'https://www.google.com/maps/search/?api=1&query=' +
                                          (section.address_line_1 ? section.address_line_1 : '') +
                                          (section.address_line_2 ? ', ' + section.address_line_2 : '') +
                                          (section.city ? ', ' + section.city : '') +
                                          (section.state_province ? ', ' + section.state_province : '') +
                                          (section.zip ? ', ' + section.zip : '') +
                                          (section.country ? ', ' + section.country : ''),"target":"_blank"}},[(section.address_line_1)?_c('a',[_vm._v("\n                                                  "+_vm._s(section.address_line_1)+", \n                                              ")]):_vm._e(),_vm._v(" "),(section.address_line_2)?_c('a',[_vm._v("\n                                                  "+_vm._s(section.address_line_2)+", \n                                              ")]):_vm._e(),_vm._v(" "),(section.city)?_c('a',[_vm._v("\n                                                  "+_vm._s(section.city)+", \n                                              ")]):_vm._e(),_vm._v(" "),(section.state_province)?_c('a',[_vm._v("\n                                                  "+_vm._s(section.state_province)+", \n                                              ")]):_vm._e(),_vm._v(" "),(section.zip)?_c('a',[_vm._v("\n                                                  "+_vm._s(section.zip)+", \n                                              ")]):_vm._e(),_vm._v(" "),(section.country)?_c('a',[_vm._v("\n                                                  "+_vm._s(section.country)+", \n                                              ")]):_vm._e()])]):_vm._e()])}))]),_vm._v(" "),(_vm.poweredByYesOrNo === 'yes')?_c('div',{staticClass:"powered-by",style:(_vm.button_style === '2' 
                                      ? 'position: sticky; bottom: 0; left: 0; width: 100%; text-align: center; background-color: '+_vm.background_color+'; color: '+_vm.button_text_color+'; padding: 10px; border: 1px solid '+_vm.button_color+';' 
                                      : 'position: sticky; bottom: 0; left: 0; width: 100%; text-align: center; background-color: '+_vm.button_color+'; color: '+_vm.button_text_color+'; padding: 10px;')},[_vm._v("\n                              Powered by "),_c('a',{style:('color:'+_vm.button_text_color+';'),attrs:{"href":"https://brand.bio","target":"_blank"}},[_vm._v("Brand.Bio")])]):_vm._e()])])])])])]),_vm._v(" "),(_vm.modal_sections)?_c('div',{staticClass:"modal",staticStyle:{"display":"block !important","background":"rgba(147, 152, 165, 0.35)","overflow":"auto"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide_modal_sections),expression:"hide_modal_sections"}],staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"800px"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header w-100"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Choose which section to add")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button"},on:{"click":_vm.hide_modal_sections}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('a',{staticClass:"btn btn-outline-light",staticStyle:{"width":"100%","text-align":"left"},on:{"click":function($event){_vm.addSection('Social Icons')}}},[_vm._m(19),_vm._v(" "),_c('p',{staticClass:"m-0",staticStyle:{"color":"rgb(130, 139, 162)"}},[_vm._v("Add icons with links to your social media channels.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('a',{staticClass:"btn btn-outline-light",staticStyle:{"width":"100%","text-align":"left"},on:{"click":function($event){_vm.addSection('Your Links')}}},[_vm._m(20),_vm._v(" "),_c('p',{staticClass:"m-0",staticStyle:{"color":"rgb(130, 139, 162)"}},[_vm._v("Include links to your important business pages.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('a',{staticClass:"btn btn-outline-light",staticStyle:{"width":"100%","text-align":"left"},on:{"click":function($event){_vm.addSection('Text')}}},[_vm._m(21),_vm._v(" "),_c('p',{staticClass:"m-0",staticStyle:{"color":"rgb(130, 139, 162)"}},[_vm._v("Express more about your business or yourself.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('a',{staticClass:"btn btn-outline-light",staticStyle:{"width":"100%","text-align":"left"},on:{"click":function($event){_vm.addSection('Address')}}},[_vm._m(22),_vm._v(" "),_c('p',{staticClass:"m-0",staticStyle:{"color":"rgb(130, 139, 162)"}},[_vm._v("Detailed information about where your business is located.")])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.modal_logo)?_c('div',{staticClass:"modal",staticStyle:{"display":"block !important","background":"rgba(147, 152, 165, 0.35)","overflow":"auto"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide_modal_logo),expression:"hide_modal_logo"}],staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"800px"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header w-100"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Choose a different logo")]),_vm._v(" "),_c('button',{staticClass:"close ml-auto",staticStyle:{"position":"absolute","right":"21px"},attrs:{"type":"button"},on:{"click":_vm.hide_modal_logo}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.loading_logos)?_c('div',{staticStyle:{"margin":"0 auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_c('div',[(_vm.logos !== null && _vm.logos.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.logos),function(logo,index){return _c('div',{staticClass:"col-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"aumentarscale_btn",class:{ 'selectedcontainer': _vm.logo_unique_id === logo.unique_id },staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"0.5rem","transition":"transform 100ms, box-shadow 150ms","cursor":"pointer","background":"#FFFFFF"},on:{"click":function($event){_vm.update_logo(logo.unique_id, logo.paid_svglogos_s3);}}},[(logo.paid_svglogos_s3 === 'needs_update')?_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+_vm.timenow}})]):_c('div',{staticClass:"logo-list-sin-borde display-logos-created",staticStyle:{"transition":"transform 100ms ease 0s, box-shadow 150ms ease 0s","display":"flex","height":"auto"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"5px","height":"auto"},attrs:{"src":'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+_vm.timenow}})])])])})):_c('div',[_c('p',{staticClass:"lead text-center"},[_vm._v("No logos created in this account.")])])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#dddddd","height":"200px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine200"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Background")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Buttons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Social Icons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Fonts")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-gear",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Settings")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#dddddd","height":"500px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine500"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",staticStyle:{"background":"#dddddd","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Background")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Buttons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Social Icons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-palette",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Fonts")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"p-2 bg-light",staticStyle:{"border-radius":"8px","width":"40px","height":"40px"}},[_c('i',{staticClass:"fa-solid fa-gear",staticStyle:{"color":"rgb(154 154 154)","font-size":"23px","margin-left":"1px"}})]),_vm._v(" "),_c('p',{staticClass:"lead col m-0"},[_vm._v("Settings")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-2"},[_c('div',{staticStyle:{"background":"#ffffff","height":"500px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine500_white"})]),_vm._v(" "),_c('div',{staticClass:"mt-3",staticStyle:{"background":"#ffffff","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20_white"})]),_vm._v(" "),_c('div',{staticClass:"mt-3",staticStyle:{"background":"#ffffff","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20_white"})]),_vm._v(" "),_c('div',{staticClass:"mt-3",staticStyle:{"background":"#ffffff","height":"20px","border-radius":"0.5rem"}},[_c('div',{staticClass:"shine20_white"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between pb-1"},[_c('p',{staticClass:"m-0"},[_c('i',{staticClass:"fa-solid fa-square-share-nodes mr-2",staticStyle:{"font-size":"24px","color":"#ed1d62"}}),_vm._v(" "),_c('strong',{staticStyle:{"font-size":"24px"}},[_vm._v("Social Icons")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between pb-1"},[_c('p',{staticClass:"m-0"},[_c('i',{staticClass:"fa-solid fa-link mr-2",staticStyle:{"font-size":"24px","color":"#ed1d62"}}),_vm._v(" "),_c('strong',{staticStyle:{"font-size":"24px"}},[_vm._v("Your Links")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between pb-1"},[_c('p',{staticClass:"m-0"},[_c('i',{staticClass:"fa-solid fa-rectangle-list mr-2",staticStyle:{"font-size":"24px","color":"#ed1d62"}}),_vm._v(" "),_c('strong',{staticStyle:{"font-size":"24px"}},[_vm._v("Text")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between pb-1"},[_c('p',{staticClass:"m-0"},[_c('i',{staticClass:"fa-solid fa-location-dot mr-2",staticStyle:{"font-size":"24px","color":"#ed1d62"}}),_vm._v(" "),_c('strong',{staticStyle:{"font-size":"24px"}},[_vm._v("Address")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_account_tabs_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1287b988_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_tabs_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_account_tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1287b988_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(108);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("44fa61ba", content, true, {});

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".activetabs{background:#fff!important;border-color:#dde1ed!important;color:#ed1d62!important}.nav-tabs .nav-link:hover{border:none}.editandowebsite{background-color:#f9fafb;border-color:#1e90ff5e;outline:0;box-shadow:inset 0 1px 2px rgb(46 54 80/8%),0 0 0 .2rem rgb(38 43 64/20%)}", ""]);

// exports


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mt-7",staticStyle:{"text-align":"center"}},[_vm._v("Account Settings")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"nav-tabs sc-bvTASY jPMoWD",staticStyle:{"overflow":"scroll","display":"flex"}},[_c('router-link',{staticClass:"nav-item nav-link",staticStyle:{"background":"none","border-radius":".5rem .5rem 0 0!important","border-left":".0625rem solid transparent","border-right":".0625rem solid transparent","border-top":".0625rem solid transparent","border-bottom":"0"},attrs:{"to":"/dashboard/account","exact-active-class":"activetabs"}},[_vm._v("Account Information")]),_vm._v(" "),_c('router-link',{staticClass:"nav-item nav-link",staticStyle:{"background":"none","border-radius":".5rem .5rem 0 0!important","border-left":".0625rem solid transparent","border-right":".0625rem solid transparent","border-top":".0625rem solid transparent","border-bottom":"0"},attrs:{"to":"/dashboard/billing","exact-active-class":"activetabs"}},[_vm._v("Billing (invoices)")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_account_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc37c9b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_vue__ = __webpack_require__(111);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc37c9b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Account Settings","description":"Dashboard | Account Settings"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticStyle:{"margin":"100px auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"sc-kEYyzF grKTOC"},[_c('div',{staticClass:"sc-kAdXeD jwoEpG",staticStyle:{"padding":"0px 0px 30px 0px!important"}},[_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"sc-cFlXAS WflZx"},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',[_c('div',{staticClass:"card border-light shadow-soft",staticStyle:{"margin-bottom":"20px","margin":"0 auto","padding":"10px","border-left":".0625rem solid rgba(243,247,250,.05)","border-right":".0625rem solid rgba(243,247,250,.05)","border-bottom":".0625rem solid rgba(243,247,250,.05)","border-top":"0","border-radius":"0 0 .5rem .5rem"}},[_c('div',{staticClass:"card-body p-4 p-lg-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label text-dark"},[_vm._v("Full Name")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propsdata[0].name),expression:"propsdata[0].name"}],staticClass:"form-control",attrs:{"name":"name","placeholder":"eg. John Doe","type":"text"},domProps:{"value":(_vm.propsdata[0].name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propsdata[0], "name", $event.target.value)}}})]),_vm._v(" "),(!_vm.saving)?_c('button',{staticClass:"btn btn-primary animate-up-2",staticStyle:{"width":"100%"},on:{"click":_vm.guardarname}},[_vm._m(1),_vm._v("Save Name")]):_vm._e(),_vm._v(" "),(_vm.saving)?_c('button',{staticClass:"btn btn-primary animate-up-2",staticStyle:{"width":"100%","background":"#04a677!important","border-color":"#04a677!important"}},[_vm._m(2),_vm._v("Saved")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label text-dark"},[_vm._v("Email Address")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2"},[_vm._m(3),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"name":"name","type":"text","disabled":""},domProps:{"value":_vm.propsdata[0].email}})])]),_vm._v(" "),_c('p',[_vm._v("Use this email to log in to your Logo.app account and receive notifications.")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label text-dark"},[_vm._v("Password")]),_vm._v(" "),(_vm.propsdata[0].password !== 'submitted' || _vm.changepassword_toggle)?_c('div',[_c('div',{staticClass:"input-group mb-2"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"name":"password","placeholder":"Type your new password","type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),(_vm.shortpassword)?_c('span',{staticClass:"small",staticStyle:{"color":"#ff0000"}},[_vm._v("Password must be at least 6 characters")]):_vm._e(),_vm._v(" "),(!_vm.savingpassword)?_c('button',{staticClass:"btn btn-primary animate-up-2",staticStyle:{"width":"100%"},on:{"click":_vm.guardarpassword}},[_vm._m(5),_vm._v("Save Password")]):_vm._e(),_vm._v(" "),(_vm.savingpassword)?_c('button',{staticClass:"btn btn-success animate-up-2",staticStyle:{"width":"100%","background":"#04a677!important","border-color":"#04a677!important"}},[_vm._m(6),_vm._v("Saving...")]):_vm._e(),_vm._v(" "),(_vm.changepassword_toggle)?_c('button',{staticClass:"btn btn-danger animate-up-2",staticStyle:{"width":"100%","background":"#fa5352!important","border-color":"#fa5352!important","margin-top":"10px"},on:{"click":_vm.cancel_changepassword}},[_vm._m(7),_vm._v("Cancel")]):_vm._e()]):_c('div',[_c('button',{staticClass:"btn btn-primary animate-up-2",staticStyle:{"width":"100%"},on:{"click":_vm.changepassword}},[_vm._m(8),_vm._v("Change Password")])])])])])])]),_vm._v(" "),(_vm.propsdata[0].paid !== 'yes')?_c('div',[_c('div',{staticClass:"card bg-white border-light shadow-soft",staticStyle:{"max-width":"800px","margin":"20px auto 20px auto","padding":"10px"}},[_c('div',{staticClass:"card-body p-4 p-lg-3"},[_c('div',{staticClass:"row"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 d-flex align-items-center justify-content-md-end"},[_c('a',{staticClass:"btn btn-md btn-pricing-plan animate-up-2",staticStyle:{"color":"#ffffff","background-color":"#0949b3","border-color":"rgb(255, 255, 255)"},attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id}},[_c('svg',{staticClass:"sc-eNQAEJ bqIowC",attrs:{"width":"24","height":"24","fill":"#ffffff","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"}})]),_vm._v("\n                Upgrade Now")])])])])])]):_vm._e()])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-user-alt"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-paper-plane"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-envelope"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-lock"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-paper-plane"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-times"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-pen"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6 mb-lg-0"},[_c('h3',{staticClass:"mb-3"},[_vm._v("Free Account")]),_vm._v(" "),_c('p',{staticClass:"text-muted mb-4"},[_vm._v("You are on the free plan. You can preview and generate logos with watermark. Upgrade to download all your logos, create unlimited amounts and download high resolution files.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_billing_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233ec88b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_billing_vue__ = __webpack_require__(113);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_billing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233ec88b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_billing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Billing","description":"Dashboard | Billing"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticStyle:{"margin":"100px auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"sc-kEYyzF grKTOC"},[_c('div',{staticClass:"sc-kAdXeD jwoEpG",staticStyle:{"padding":"0px 0px 30px 0px!important"}},[_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"sc-cFlXAS WflZx"},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',[_c('div',{staticClass:"card border-light shadow-soft",staticStyle:{"margin-bottom":"20px","margin":"0 auto","padding":"10px","border-left":".0625rem solid rgba(243,247,250,.05)","border-right":".0625rem solid rgba(243,247,250,.05)","border-bottom":".0625rem solid rgba(243,247,250,.05)","border-top":"0","border-radius":"0 0 .5rem .5rem"}},[_c('div',{staticClass:"card-body p-4 p-lg-3"},[_c('div',{staticClass:"col-12"},[((_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].canceled === 'yes' || _vm.propsdata[0].canceled_due_attempt2 === 'yes') && _vm.cards !== 'no card')?_c('div',[_c('h4',{staticStyle:{"margin-bottom":"1rem"}},[_vm._v("Payment Method")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto"},[(_vm.cards[0].brand.toLowerCase() === 'mastercard')?_c('img',{staticStyle:{"width":"80px"},attrs:{"src":"https://logo.app/assets/img/mastercard.jpg"}}):(_vm.cards[0].brand.toLowerCase() === 'visa')?_c('img',{staticStyle:{"width":"80px"},attrs:{"src":"https://logo.app/assets/img/visa.jpg"}}):(_vm.cards[0].brand.toLowerCase() === 'american express')?_c('img',{staticStyle:{"width":"80px"},attrs:{"src":"https://logo.app/assets/img/amex.jpg"}}):(_vm.cards[0].brand.toLowerCase() === 'discover')?_c('img',{staticStyle:{"width":"80px"},attrs:{"src":"https://logo.app/assets/img/discover.jpg"}}):_c('img',{staticStyle:{"width":"80px"},attrs:{"src":"https://logo.app/assets/img/cc_placeholder.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('p',{staticStyle:{"margin-bottom":"0"}},[_c('strong',[_vm._v(_vm._s(_vm.cards[0].brand)+" **** "+_vm._s(_vm.cards[0].last4))])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Expires "),_c('strong',[_vm._v(_vm._s(_vm.cards[0].expiration_date))])])])]),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),(_vm.invoices !== null)?_c('div',[_c('div',{staticClass:"col-md-12 row m-0 p-0"},[_c('h4',{staticClass:"col-md-9 p-0",staticStyle:{"margin-bottom":"1rem"}},[_vm._v("Invoices")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-success animate-up-2 mb-3 col-md-3",attrs:{"to":"/dashboard/edit-billing"}},[_vm._v("Edit Billing Information "),_c('i',{staticClass:"fas fa-arrow-right"})])],1),_vm._v(" "),_c('ul',{staticClass:"list-group"},_vm._l((_vm.invoices),function(invoice,num){return _c('li',{staticClass:"list-group-item border-bottom",staticStyle:{"border":"1px solid #e1e1e1!important"}},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h3',{staticClass:"h6 mb-1"},[_c('a',{attrs:{"href":'https://logo.app/invoice/'+invoice.unique_id,"target":"_blank"}},[_vm._v("Invoice #"+_vm._s(invoice.unique_id))])]),_vm._v(" "),_c('small',{staticClass:"text-gray-700"},[_vm._v("Billed "+_vm._s(invoice.date))])]),_vm._v(" "),_c('div',{staticClass:"col-md-auto mt-2 mt-md-0"},[_c('a',{staticClass:"btn btn-primary animate-up-2 w-100",attrs:{"href":'https://logo.app/invoice/'+invoice.unique_id,"target":"_blank"}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Download")])])])])}))]):(_vm.propsdata[0].paid !== 'yes' && _vm.propsdata[0].canceled_due_attempt2 !== 'yes' && _vm.propsdata[0].canceled !== 'yes')?_c('div',[_c('h4',{staticClass:"mb-0"},[_vm._v("You need to upgrade your account to edit your billing information and download your invoices/receipts.")])]):_vm._e(),_vm._v(" "),(_vm.propsdata[0].paid === 'yes' || _vm.propsdata[0].canceled_due_attempt2 === 'yes' || _vm.propsdata[0].canceled === 'yes')?_c('div',[(!_vm.moreinformation)?_c('div',{staticClass:"col-12 mt-4 mb-4",staticStyle:{"text-decoration":"underline","cursor":"pointer"},on:{"click":function($event){_vm.moreinformation = true}}},[_vm._v("See more "),_c('i',{staticClass:"fas fa-caret-down"})]):_vm._e(),_vm._v(" "),(_vm.moreinformation)?_c('div',{staticClass:"col-12 mt-4 mb-4",staticStyle:{"text-decoration":"underline","cursor":"pointer"},on:{"click":function($event){_vm.moreinformation = false}}},[_vm._v("See less "),_c('i',{staticClass:"fas fa-caret-up"})]):_vm._e(),_vm._v(" "),(_vm.moreinformation)?_c('div',[_c('div',{staticClass:"col-12"},[(_vm.propsdata[0].paid === 'yes' && _vm.propsdata[0].cancel_at_period_end !== 'yes' && _vm.propsdata[0].canceled !== 'yes')?_c('div',[_vm._m(0)]):((_vm.propsdata[0].paid === 'yes' && _vm.propsdata[0].cancel_at_period_end === 'yes') || _vm.propsdata[0].canceled === 'yes')?_c('div',[_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Subscription Canceled")]),_vm._v(" "),_c('p',[_vm._v("You can subscribe again anytime by clicking the button below.")]),_vm._v(" "),_c('a',{staticClass:"btn btn-success animate-up-2",attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id}},[_vm._v("Subscribe Again")])]):_vm._e()])]):_vm._e()]):_vm._e()])])])])])])])]),_vm._v(" "),_vm._m(1)]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Cancel Subscription")]),_vm._v(" "),_c('p',[_vm._v("You can cancel your subscription whenever you want.")]),_vm._v(" "),_c('div',{staticClass:"alert alert-danger alert-dismissible fade show",attrs:{"role":"alert"}},[_c('span',{staticClass:"alert-inner--icon"},[_c('i',{staticClass:"fas fa-exclamation-circle"})]),_vm._v(" "),_c('span',{staticClass:"alert-inner--text"},[_c('strong',[_vm._v("Note:")]),_vm._v(" You will lose all access and ownership of your logos, including all the premium features.")])]),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"underline","color":"#ff0000"},attrs:{"data-toggle":"modal","data-target":"#modal-cancel"}},[_vm._v("Cancel Subscription")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal-cancel","tabindex":"-1","role":"dialog","aria-labelledby":"modal-cancel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h6',{staticClass:"modal-title"},[_vm._v("Do you really want to cancel your subscription?")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"alert alert-danger alert-dismissible fade show mb-0",attrs:{"role":"alert"}},[_c('span',{staticClass:"alert-inner--icon"},[_c('i',{staticClass:"fas fa-exclamation-circle"})]),_vm._v(" "),_c('span',{staticClass:"alert-inner--text"},[_c('strong',[_vm._v("Note:")]),_vm._v(" You will lose all access and ownership of your logos, including all the premium features.")])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('a',{staticClass:"btn btn-sm btn-success",attrs:{"href":"/dashboard/cancel-reasons"}},[_vm._v("Yes, I want to cancel my subscription.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-link text-danger ml-auto",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_billing_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49186cd4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_billing_vue__ = __webpack_require__(115);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_billing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49186cd4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_billing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Dashboard | Edit Billing Information","description":"Dashboard | Edit Billing Information"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticStyle:{"margin":"100px auto"}},[_c('center',[_c('lottie-player',{staticStyle:{"width":"100%","height":"100%","max-width":"500px","max-height":"500px"},attrs:{"src":"https://logo.app/lottie/logo-design-loading.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Loading...")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"sc-kEYyzF grKTOC"},[_c('div',{staticClass:"sc-kAdXeD jwoEpG",staticStyle:{"padding":"75px 20px 0px 20px!important"}},[_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"sc-cFlXAS WflZx"},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',[_c('br'),_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("Edit Billing Information")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card border-light shadow-soft mb-5",staticStyle:{"max-width":"800px","margin":"0 auto","width":"70%","padding":"10px"}},[_c('div',{staticClass:"card-body p-4 p-lg-3"},[_c('div',{staticClass:"row",staticStyle:{"display":"flex","flex-wrap":"wrap","margin-right":"-15px","margin-left":"-15px"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientname),expression:"clientname"}],staticClass:"form-control",attrs:{"name":"clientname","placeholder":"eg. John Doe","type":"text"},domProps:{"value":(_vm.clientname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientname=$event.target.value}}})]),_vm._v(" "),(_vm.clientname === '' && _vm.required)?_c('span',{staticClass:"small",staticStyle:{"color":"rgb(237, 80, 79)","visibility":"visible","position":"relative","bottom":"15px"}},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.streetaddress),expression:"streetaddress"}],staticClass:"form-control",attrs:{"name":"address","placeholder":"eg. One Infinite Loop","type":"address"},domProps:{"value":(_vm.streetaddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.streetaddress=$event.target.value}}})]),_vm._v(" "),(_vm.streetaddress === '' && _vm.required)?_c('span',{staticClass:"small",staticStyle:{"color":"rgb(237, 80, 79)","visibility":"visible","position":"relative","bottom":"15px"}},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location),expression:"location"}],staticClass:"form-control",attrs:{"name":"location","placeholder":"eg. Cupertino, CA, United States","type":"text"},domProps:{"value":(_vm.location)},on:{"input":function($event){if($event.target.composing){ return; }_vm.location=$event.target.value}}})]),_vm._v(" "),(_vm.location === '' && _vm.required)?_c('span',{staticClass:"small",staticStyle:{"color":"rgb(237, 80, 79)","visibility":"visible","position":"relative","bottom":"15px"}},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zipcode),expression:"zipcode"}],staticClass:"form-control",attrs:{"name":"zip","placeholder":"eg. 95014","type":"text"},domProps:{"value":(_vm.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zipcode=$event.target.value}}})]),_vm._v(" "),(_vm.zipcode === '' && _vm.required)?_c('span',{staticClass:"small",staticStyle:{"color":"rgb(237, 80, 79)","visibility":"visible","position":"relative","bottom":"15px"}},[_vm._v("This field is required.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(9),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phonenumber),expression:"phonenumber"}],staticClass:"form-control",attrs:{"name":"phonenumber","placeholder":"eg. +1 111 1111111","type":"tel"},domProps:{"value":(_vm.phonenumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phonenumber=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin":"0 auto"}},[(!_vm.loading_edit)?_c('button',{staticClass:"btn btn-primary mt-4 animate-up-2",on:{"click":_vm.guardarbilling}},[_vm._m(10),_vm._v("Save Billing Information")]):_vm._e(),_vm._v(" "),(_vm.loading_edit)?_c('button',{staticClass:"btn btn-primary mt-4 animate-up-2"},[_vm._m(11),_vm._v("Loading...")]):_vm._e()])])])])])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-label text-dark"},[_vm._v("Client Name "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-user-alt"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-label text-dark"},[_vm._v("Street Address "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-label text-dark"},[_vm._v("City, State, Country "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-label text-dark"},[_vm._v("Zip Code "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-map-pin"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-label text-dark"},[_vm._v("Phone Number "),_c('span',{staticClass:"text-gray"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-phone"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-paper-plane"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"fas fa-spinner"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancel_reasons_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc2f5e9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cancel_reasons_vue__ = __webpack_require__(119);
function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancel_reasons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc2f5e9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cancel_reasons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(118);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("782ea896", content, true, {});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "a{color:#515151}@media (max-width:991px){.card{width:100%!important}}.card-body{flex:1 1 auto;padding:1.5rem}.col-12{flex:0 0 100%;max-width:100%}.form-group{position:relative;margin-bottom:1rem}.text-dark,.text-dark:hover{color:#0d1431!important}.form-label{font-weight:400;font-size:1rem;display:block}.text-danger,.text-danger:hover{color:#fa5252!important}.input-group{border-radius:.5rem;transition:all .2s ease}.mb-4,.my-4{margin-bottom:1.5rem!important}.input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group-prepend{margin-right:-2px}.input-group-text{font-size:.875rem;transition:all .3s ease-in-out}.fa,.fas{font-weight:900}.fa,.far,.fas{font-family:Font Awesome\\ 5 Free}.input-group>.custom-file,.input-group>.custom-select,.input-group>.form-control,.input-group>.form-control-plaintext{position:relative;flex:1 1 auto;width:1%;margin-bottom:0}.input-group .form-control:not(:first-child){border-left:0;padding-left:0}.text-center{text-align:center!important}.animate-down-2,.animate-left-2,.animate-right-2,.animate-up-2,.scale-down-2,.scale-up-2{transition:all .2s ease}[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled),button:not(:disabled){cursor:pointer}.mr-2,.mx-2{margin-right:.5rem!important}.nav-tabs .nav-link:hover{border:none}.editandowebsite{background-color:#f9fafb;border-color:#1e90ff5e;outline:0;box-shadow:inset 0 1px 2px rgb(46 54 80/8%),0 0 0 .2rem rgb(38 43 64/20%)}.activetabs{background:#fff!important;border-color:#dde1ed!important;color:#ed1d62!important}@media (max-width:786px){.mobilesinfloat{float:none!important}}", ""]);

// exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":_vm._f("Cancel Reasons")(_vm.Dashboard),"description":_vm._f("Cancel Reasons")(_vm.Dashboard)}}),_vm._v(" "),_c('div',[_c('h1',{staticClass:"mt-7",staticStyle:{"text-align":"center"}},[_vm._v("Cancel Subscription")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"nav-tabs sc-bvTASY jPMoWD",staticStyle:{"overflow":"scroll","display":"flex"}},[_c('a',{staticClass:"nav-item nav-link",staticStyle:{"border-radius":".5rem .5rem 0 0!important","border-left":".0625rem solid transparent","border-right":".0625rem solid transparent","border-top":".0625rem solid transparent","border-bottom":"0"},attrs:{"href":"/dashboard/account","exact-active-class":"activetabs"}},[_vm._v("Account Settings")]),_vm._v(" "),_c('router-link',{staticClass:"nav-item nav-link",staticStyle:{"border-radius":".5rem .5rem 0 0!important","border-left":".0625rem solid transparent","border-right":".0625rem solid transparent","border-top":".0625rem solid transparent","border-bottom":"0"},attrs:{"to":"/dashboard/cancel-reasons","exact-active-class":"activetabs"}},[_vm._v("Cancel Subscription")])],1)]),_vm._v(" "),_c('div',{staticClass:"sc-kEYyzF grKTOC"},[_c('div',{staticClass:"sc-kAdXeD jwoEpG",staticStyle:{"padding":"0px 0px 30px 0px!important"}},[_c('div',{staticClass:"sc-bvTASY jPMoWD"},[_c('div',{staticClass:"sc-cFlXAS WflZx"},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',[_c('div',{staticClass:"card border-light shadow-soft",staticStyle:{"margin-bottom":"20px","margin":"0 auto","padding":"10px","border-left":".0625rem solid rgba(243,247,250,.05)","border-right":".0625rem solid rgba(243,247,250,.05)","border-bottom":".0625rem solid rgba(243,247,250,.05)","border-top":"0","border-radius":"0 0 .5rem .5rem"}},[_c('div',{staticClass:"card-body p-4 p-lg-3"},[_c('div',[(_vm.propsdata[0].paid === 'yes' && _vm.propsdata[0].cancel_at_period_end !== 'yes')?_c('div',{staticClass:"col-12"},[(!_vm.are_you_sure && !_vm.canceled)?_c('div',{staticClass:"form-group"},[_c('h5',{staticClass:"mb-2"},[_vm._v("What is your reason for cancelling Logo.app?")]),_vm._v(" "),_c('p',[_vm._v("Select the one that applies")]),_vm._v(" "),(_vm.select_reason)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("You need to select a reason first in order to cancel your subscription.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason),expression:"reason"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"exampleRadios1","value":"1"},domProps:{"checked":_vm._q(_vm.reason,"1")},on:{"change":function($event){_vm.reason="1"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleRadios1"}},[_vm._v("\n                                        No longer using Logo.app\n                                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason),expression:"reason"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"exampleRadios2","value":"2"},domProps:{"checked":_vm._q(_vm.reason,"2")},on:{"change":function($event){_vm.reason="2"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleRadios2"}},[_vm._v("\n                                        Found a better software\n                                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason),expression:"reason"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"exampleRadios3","value":"3"},domProps:{"checked":_vm._q(_vm.reason,"3")},on:{"change":function($event){_vm.reason="3"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleRadios3"}},[_vm._v("\n                                        Prices are too high\n                                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason),expression:"reason"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"exampleRadios4","value":"4"},domProps:{"checked":_vm._q(_vm.reason,"4")},on:{"change":function($event){_vm.reason="4"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleRadios4"}},[_vm._v("\n                                        Other\n                                      ")]),_vm._v(" "),(_vm.fill_reason && _vm.reason === '4')?_c('p',{staticClass:"mt-2",staticStyle:{"color":"#ff0000"}},[_vm._v("Please share with us more details about why you are cancelling your Logo.app subscription.")]):_vm._e(),_vm._v(" "),(_vm.reason === '4')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.other_reason),expression:"other_reason"}],staticClass:"form-control mt-2",attrs:{"type":"text","placeholder":"Please share more details so we can improve"},domProps:{"value":(_vm.other_reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.other_reason=$event.target.value}}}):_vm._e()]),_vm._v(" "),(!_vm.saving)?_c('button',{staticClass:"btn btn-danger mt-4 animate-up-2 mobilesinfloat",staticStyle:{"float":"right!important"},on:{"click":_vm.save_reason}},[_vm._v("Continue & Cancel Subscription")]):_vm._e(),_vm._v(" "),(_vm.saving)?_c('button',{staticClass:"btn btn-danger mt-4 animate-up-2 mobilesinfloat",staticStyle:{"float":"right!important"}},[_c('i',{staticClass:"fas fa-spinner"}),_vm._v(" Loading")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.are_you_sure && !_vm.canceled)?_c('div',[_c('h5',{staticClass:"mb-2"},[_vm._v("You're about to cancel your subscription")]),_vm._v(" "),_c('small',[_vm._v("Your subscription to Logo.app will be canceled immediately, losing all ownership from your logos.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),(!_vm.cancelling)?_c('button',{staticClass:"btn btn-danger mt-4 animate-up-2 mobilesinfloat",staticStyle:{"float":"right!important"},on:{"click":_vm.cancel}},[_vm._v("Cancel my subscription")]):_vm._e(),_vm._v(" "),(_vm.cancelling)?_c('button',{staticClass:"btn btn-danger mt-4 animate-up-2 mobilesinfloat",staticStyle:{"float":"right!important"}},[_c('i',{staticClass:"fas fa-spinner"}),_vm._v(" Cancelling")]):_vm._e(),_vm._v(" "),(_vm.cancellation_error)?_c('p',{staticClass:"mt-3",staticStyle:{"color":"red"}},[_vm._v("Cancellation failed. Please contact us at support@logo.app or in our "),_c('a',{staticStyle:{"color":"red","text-decoration":"underline"},attrs:{"href":"https://logo.app/contact","target":"_blank"}},[_vm._v("contact page")]),_vm._v(".")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.canceled)?_c('div',[_c('h5',{staticClass:"mb-2"},[_vm._v("Your subscription is canceled")]),_vm._v(" "),_c('p',[_vm._v("Your subscription has been canceled and your credit card will not longer be charged. You've no longer access and ownership of your logos.")]),_vm._v(" "),_c('h5',{staticClass:"mb-2"},[_vm._v("Restart subscription")]),_vm._v(" "),_c('p',[_vm._v("Made a mistake? If you want to restart your subscription, just "),_c('a',{staticStyle:{"color":"#00d56d","text-decoration":"underline"},attrs:{"href":'/payment/sub/'+_vm.propsdata[0].unique_id}},[_vm._v("click here")])])]):_vm._e(),_vm._v(" "),_vm._m(1)]):(_vm.propsdata[0].canceled === 'yes' || _vm.propsdata[0].cancel_at_period_end === 'yes')?_c('div',[_vm._m(2)]):_vm._e()])])])])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning alert-dismissible fade show mb-0 mt-3",attrs:{"role":"alert"}},[_c('span',{staticClass:"alert-inner--icon"},[_c('i',{staticClass:"fas fa-exclamation-circle"})]),_vm._v(" "),_c('span',{staticClass:"alert-inner--text"},[_c('strong',[_vm._v("Warning:")]),_vm._v(" You will lose all access and ownership of your logos, including all the premium features.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-success mt-4 animate-up-2",attrs:{"href":"/dashboard/billing"}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v(" Return to billing")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"mb-0"},[_vm._v("You are currently not subscribed.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _headful = __webpack_require__(121);

var _headful2 = _interopRequireDefault(_headful);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handler = function handler(props) {
    return (0, _headful2.default)(getPassedProps(props));
};

exports.default = {
    name: 'vue-headful',
    props: Object.keys(_headful2.default.props),
    watch: {
        '$props': {
            handler: handler,
            deep: true,
            immediate: true
        }
    },
    activated: function activated() {
        // required for keep-alive components https://vuejs.org/v2/api/#keep-alive
        handler(this.$props);
    },
    render: function render() {}
};


function getPassedProps(props) {
    return Object.keys(props).reduce(function (passedProps, propKey) {
        if (props[propKey] !== undefined) {
            passedProps[propKey] = props[propKey];
        }
        return passedProps;
    }, {});
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = headful;


var conf = {
    debug: false
};

var propertySetters = {
    html: function html(obj) {
        obj && Object.keys(obj).forEach(function (selector) {
            return setRootElementAttributes(selector, obj[selector]);
        });
    },
    head: function head(obj) {
        obj && Object.keys(obj).forEach(function (selector) {
            return setHeadElementAttributes(selector, obj[selector]);
        });
    },
    title: function title(val) {
        document.title = isRemoveValue(val) ? '' : val;
        setMetaContent('itemprop="name"', val);
        setMetaContent('property="og:title"', val);
        setMetaContent('name="twitter:title"', val);
    },
    description: function description(val) {
        setMetaContent('name="description"', val);
        setMetaContent('itemprop="description"', val);
        setMetaContent('property="og:description"', val);
        setMetaContent('name="twitter:description"', val);
    },
    keywords: function keywords(val) {
        setMetaContent('name="keywords"', Array.isArray(val) ? val.join(', ') : val);
    },
    image: function image(val) {
        setMetaContent('itemprop="image"', val);
        setMetaContent('property="og:image"', val);
        setMetaContent('name="twitter:image"', val);
    },
    lang: function lang(val, props) {
        setRootElementAttributes('html', { lang: val });
        noProp(props, this.ogLocale) && setOgLocaleIfValid(val);
    },
    ogLocale: function ogLocale(val) {
        setMetaContent('property="og:locale"', val);
    },
    url: function url(val) {
        setHeadElementAttributes('link[rel="canonical"]', { href: val });
        setMetaContent('property="og:url"', val);
        setMetaContent('name="twitter:url"', val);
    }
};

function headful(props, userConf) {
    Object.assign(conf, userConf);
    Object.keys(props).forEach(function (prop) {
        if (!propertySetters.hasOwnProperty(prop)) {
            throw new Error('Headful: Property \'' + prop + '\' is unknown.');
        }
        propertySetters[prop](props[prop], props);
    });
}

headful.props = propertySetters;

/**
 * Tests whether the given `props` object contains a property with the name of `propNameOrFunction`.
 */
function noProp(props, propNameOrFunction) {
    if (!props) {
        throw new Error('Headful: You must pass all declared props when you use headful.props.x() calls.');
    }
    var propName = typeof propNameOrFunction === 'function' ? propNameOrFunction.name : propNameOrFunction;
    return !props.hasOwnProperty(propName);
}

function setMetaContent(attr, val) {
    setHeadElementAttributes('meta[' + attr + ']', { content: val });
}

function setRootElementAttributes(selector, attributes) {
    setElementAttributes(getElement(document, selector), attributes);
}

function setHeadElementAttributes(selector, attributes) {
    setElementAttributes(getElement(document.head, selector), attributes);
}

function setElementAttributes(element, attributes) {
    if (element) {
        Object.keys(attributes).forEach(function (attrName) {
            if (isRemoveValue(attributes[attrName])) {
                element.removeAttribute(attrName);
            } else {
                element.setAttribute(attrName, attributes[attrName]);
            }
        });
    }
}

function getElement(parent, selector) {
    var element = parent.querySelector(selector);
    if (!element && conf.debug) {
        console.error('Headful: Element \'' + selector + '\' was not found.');
    }
    return element;
}

function setOgLocaleIfValid(locale) {
    if (isRemoveValue(locale)) {
        propertySetters.ogLocale(locale);
    } else if (locale.match(/^[a-z]{2}-[a-z]{2}$/i)) {
        var _locale$split = locale.split('-'),
            _locale$split2 = _slicedToArray(_locale$split, 2),
            language = _locale$split2[0],
            region = _locale$split2[1];

        var ogLocale = language + '_' + region.toUpperCase();
        propertySetters.ogLocale(ogLocale);
    }
}

function isRemoveValue(val) {
    return val === undefined || val === null;
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Vue Cookies v1.7.3
 * https://github.com/cmp-cc/vue-cookies
 *
 * Copyright 2016, cmp-cc
 * Released under the MIT license
 */

(function () {

  var defaultConfig = {
    expires: '1d',
    path: '; path=/',
    domain: '',
    secure: '',
    sameSite: '; SameSite=Lax'
  };

  var VueCookies = {
    // install of Vue
    install: function (Vue) {
      Vue.prototype.$cookies = this;
      Vue.$cookies = this;
    },
    config: function (expireTimes, path, domain, secure, sameSite) {
      defaultConfig.expires = expireTimes ? expireTimes : '1d';
      defaultConfig.path = path ? '; path=' + path : '; path=/';
      defaultConfig.domain = domain ? '; domain=' + domain : '';
      defaultConfig.secure = secure ? '; Secure' : '';
      defaultConfig.sameSite = sameSite ? '; SameSite=' + sameSite : '; SameSite=Lax';
    },
    get: function (key) {
      var value = decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;

      if (value && value.substring(0, 1) === '{' && value.substring(value.length - 1, value.length) === '}') {
        try {
          value = JSON.parse(value);
        } catch (e) {
          return value;
        }
      }
      return value;
    },
    set: function (key, value, expireTimes, path, domain, secure, sameSite) {
      if (!key) {
        throw new Error('Cookie name is not find in first argument.');
      } else if (/^(?:expires|max\-age|path|domain|secure|SameSite)$/i.test(key)) {
        throw new Error('Cookie key name illegality, Cannot be set to ["expires","max-age","path","domain","secure","SameSite"]\t current key name: ' + key);
      }
      // support json object
      if (value && value.constructor === Object) {
        value = JSON.stringify(value);
      }
      var _expires = '';
      expireTimes = expireTimes === undefined ? defaultConfig.expires : expireTimes;
      if (expireTimes && expireTimes != 0) {
        switch (expireTimes.constructor) {
          case Number:
            if (expireTimes === Infinity || expireTimes === -1) _expires = '; expires=Fri, 31 Dec 9999 23:59:59 GMT';
            else _expires = '; max-age=' + expireTimes;
            break;
          case String:
            if (/^(?:\d+(y|m|d|h|min|s))$/i.test(expireTimes)) {
              // get capture number group
              var _expireTime = expireTimes.replace(/^(\d+)(?:y|m|d|h|min|s)$/i, '$1');
              // get capture type group , to lower case
              switch (expireTimes.replace(/^(?:\d+)(y|m|d|h|min|s)$/i, '$1').toLowerCase()) {
                  // Frequency sorting
                case 'm':
                  _expires = '; max-age=' + +_expireTime * 2592000;
                  break; // 60 * 60 * 24 * 30
                case 'd':
                  _expires = '; max-age=' + +_expireTime * 86400;
                  break; // 60 * 60 * 24
                case 'h':
                  _expires = '; max-age=' + +_expireTime * 3600;
                  break; // 60 * 60
                case 'min':
                  _expires = '; max-age=' + +_expireTime * 60;
                  break; // 60
                case 's':
                  _expires = '; max-age=' + _expireTime;
                  break;
                case 'y':
                  _expires = '; max-age=' + +_expireTime * 31104000;
                  break; // 60 * 60 * 24 * 30 * 12
                default:
                  new Error('unknown exception of "set operation"');
              }
            } else {
              _expires = '; expires=' + expireTimes;
            }
            break;
          case Date:
            _expires = '; expires=' + expireTimes.toUTCString();
            break;
        }
      }
      document.cookie =
          encodeURIComponent(key) + '=' + encodeURIComponent(value) +
          _expires +
          (domain ? '; domain=' + domain : defaultConfig.domain) +
          (path ? '; path=' + path : defaultConfig.path) +
          (secure === undefined ? defaultConfig.secure : secure ? '; Secure' : '') +
          (sameSite === undefined ? defaultConfig.sameSite : (sameSite ? '; SameSite=' + sameSite : ''));
      return this;
    },
    remove: function (key, path, domain) {
      if (!key || !this.isKey(key)) {
        return false;
      }
      document.cookie = encodeURIComponent(key) +
          '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
          (domain ? '; domain=' + domain : defaultConfig.domain) +
          (path ? '; path=' + path : defaultConfig.path) +
          '; SameSite=Lax';
      return this;
    },
    isKey: function (key) {
      return (new RegExp('(?:^|;\\s*)' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=')).test(document.cookie);
    },
    keys: function () {
      if (!document.cookie) return [];
      var _keys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
      for (var _index = 0; _index < _keys.length; _index++) {
        _keys[_index] = decodeURIComponent(_keys[_index]);
      }
      return _keys;
    }
  };

  if (true) {
    module.exports = VueCookies;
  } else if (typeof define == 'function' && define.amd) {
    define([], function () {
      return VueCookies;
    });
  } else if (window.Vue) {
    Vue.use(VueCookies);
  }
  // vue-cookies can exist independently,no dependencies library
  if (typeof window !== 'undefined') {
    window.$cookies = VueCookies;
  }

})();


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per GeneratorResume behavior specified since ES2015:
        // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
        // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next method, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable != null) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    throw new TypeError(typeof iterable + " is not iterable");
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js